import type { SVGProps } from "react";

export const AlignBottom01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 21h18M12 3v14m-7-7 7 7 7-7"
    />
  </svg>
);

export const AlignBottom02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 18V6c0-.9319 0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C8.3978 3 7.9319 3 7 3s-1.3978 0-1.7654.1522a2 2 0 0 0-1.0824 1.0824C4 4.6022 4 5.0681 4 6v12c0 .9319 0 1.3978.1522 1.7654.203.49.5924.8794 1.0824 1.0824C5.6022 21 6.0681 21 7 21s1.3978 0 1.7654-.1522c.49-.203.8794-.5924 1.0824-1.0824C10 19.3978 10 18.9319 10 18M20 18v-8c0-.9319 0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C18.3978 7 17.9319 7 17 7s-1.3978 0-1.7654.1522c-.49.203-.8794.5924-1.0824 1.0824C14 8.6022 14 9.0681 14 10v8c0 .9319 0 1.3978.1522 1.7654.203.49.5924.8794 1.0824 1.0824C15.6022 21 16.0681 21 17 21s1.3978 0 1.7654-.1522c.49-.203.8794-.5924 1.0824-1.0824C20 19.3978 20 18.9319 20 18"
    />
  </svg>
);

export const AlignHorizontalCentre01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 3v18m10-9h-6.5m4-4-4 4 4 4M2 12h6.5m-4-4 4 4-4 4"
    />
  </svg>
);

export const AlignHorizontalCentre02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 10c.9319 0 1.3978 0 1.7654-.1522.49-.203.8794-.5924 1.0824-1.0824C19 8.3978 19 7.9319 19 7s0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C17.3978 4 16.9319 4 16 4H8c-.9319 0-1.3978 0-1.7654.1522a2 2 0 0 0-1.0824 1.0824C5 5.6022 5 6.0681 5 7s0 1.3978.1522 1.7654a2 2 0 0 0 1.0824 1.0824C6.6022 10 7.0681 10 8 10zM18 20c.9319 0 1.3978 0 1.7654-.1522.49-.203.8794-.5924 1.0824-1.0824C21 18.3978 21 17.9319 21 17s0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C19.3978 14 18.9319 14 18 14H6c-.9319 0-1.3978 0-1.7654.1522-.49.203-.8794.5924-1.0824 1.0824C3 15.6022 3 16.0681 3 17s0 1.3978.1522 1.7654c.203.49.5924.8794 1.0824 1.0824C4.6022 20 5.0681 20 6 20z"
    />
  </svg>
);

export const AlignLeft01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 3v18m18-9H7m7-7-7 7 7 7"
    />
  </svg>
);

export const AlignLeft02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 10c.9319 0 1.3978 0 1.7654-.1522.49-.203.8794-.5924 1.0824-1.0824C17 8.3978 17 7.9319 17 7s0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C15.3978 4 14.9319 4 14 4H6c-.9319 0-1.3978 0-1.7654.1522a2 2 0 0 0-1.0824 1.0824C3 5.6022 3 6.0681 3 7s0 1.3978.1522 1.7654a2 2 0 0 0 1.0824 1.0824C4.6022 10 5.0681 10 6 10zM18 20c.9319 0 1.3978 0 1.7654-.1522.49-.203.8794-.5924 1.0824-1.0824C21 18.3978 21 17.9319 21 17s0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C19.3978 14 18.9319 14 18 14H6c-.9319 0-1.3978 0-1.7654.1522-.49.203-.8794.5924-1.0824 1.0824C3 15.6022 3 16.0681 3 17s0 1.3978.1522 1.7654c.203.49.5924.8794 1.0824 1.0824C4.6022 20 5.0681 20 6 20z"
    />
  </svg>
);

export const AlignRight01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 21V3M3 12h14m-7 7 7-7-7-7"
    />
  </svg>
);

export const AlignRight02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 10c.9319 0 1.3978 0 1.7654-.1522.49-.203.8794-.5924 1.0824-1.0824C21 8.3978 21 7.9319 21 7s0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C19.3978 4 18.9319 4 18 4h-8c-.9319 0-1.3978 0-1.7654.1522a2 2 0 0 0-1.0824 1.0824C7 5.6022 7 6.0681 7 7s0 1.3978.1522 1.7654a2 2 0 0 0 1.0824 1.0824C8.6022 10 9.0681 10 10 10zM18 20c.9319 0 1.3978 0 1.7654-.1522.49-.203.8794-.5924 1.0824-1.0824C21 18.3978 21 17.9319 21 17s0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C19.3978 14 18.9319 14 18 14H6c-.9319 0-1.3978 0-1.7654.1522-.49.203-.8794.5924-1.0824 1.0824C3 15.6022 3 16.0681 3 17s0 1.3978.1522 1.7654c.203.49.5924.8794 1.0824 1.0824C4.6022 20 5.0681 20 6 20z"
    />
  </svg>
);

export const AlignTop01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 3H3m9 18V7m7 7-7-7-7 7"
    />
  </svg>
);

export const AlignTop02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 18V6c0-.9319 0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C8.3978 3 7.9319 3 7 3s-1.3978 0-1.7654.1522a2 2 0 0 0-1.0824 1.0824C4 4.6022 4 5.0681 4 6v12c0 .9319 0 1.3978.1522 1.7654.203.49.5924.8794 1.0824 1.0824C5.6022 21 6.0681 21 7 21s1.3978 0 1.7654-.1522c.49-.203.8794-.5924 1.0824-1.0824C10 19.3978 10 18.9319 10 18M20 14V6c0-.9319 0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C18.3978 3 17.9319 3 17 3s-1.3978 0-1.7654.1522c-.49.203-.8794.5924-1.0824 1.0824C14 4.6022 14 5.0681 14 6v8c0 .9319 0 1.3978.1522 1.7654.203.49.5924.8794 1.0824 1.0824C15.6022 17 16.0681 17 17 17s1.3978 0 1.7654-.1522c.49-.203.8794-.5924 1.0824-1.0824C20 15.3978 20 14.9319 20 14"
    />
  </svg>
);

export const AlignVerticalCenter01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 12h18M12 2v6.5m-4-4 4 4 4-4M12 22v-6.5m-4 4 4-4 4 4"
    />
  </svg>
);

export const AlignVerticalCenter02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 18V6c0-.9319 0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C8.3978 3 7.9319 3 7 3s-1.3978 0-1.7654.1522a2 2 0 0 0-1.0824 1.0824C4 4.6022 4 5.0681 4 6v12c0 .9319 0 1.3978.1522 1.7654.203.49.5924.8794 1.0824 1.0824C5.6022 21 6.0681 21 7 21s1.3978 0 1.7654-.1522c.49-.203.8794-.5924 1.0824-1.0824C10 19.3978 10 18.9319 10 18M20 16V8c0-.9319 0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C18.3978 5 17.9319 5 17 5s-1.3978 0-1.7654.1522c-.49.203-.8794.5924-1.0824 1.0824C14 6.6022 14 7.0681 14 8v8c0 .9319 0 1.3978.1522 1.7654.203.49.5924.8794 1.0824 1.0824C15.6022 19 16.0681 19 17 19s1.3978 0 1.7654-.1522c.49-.203.8794-.5924 1.0824-1.0824C20 17.3978 20 16.9319 20 16"
    />
  </svg>
);

export const Columns01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.8 3h-.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 4.5198 3 5.08 3 6.2v11.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 21 5.08 21 6.2 21h.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C10 19.4802 10 18.9201 10 17.8V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C8.4802 3 7.92 3 6.8 3M17.8 3h-.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C14 4.5198 14 5.08 14 6.2v11.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218h.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.4802 21 18.9201 21 17.8V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C19.4802 3 18.9201 3 17.8 3"
    />
  </svg>
);

export const Columns02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 3v18M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const Columns03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 3v18m6-18v18M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const DistributeSpacingHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 21V3M3 21V3m6 5v8c0 .9319 0 1.3978.1522 1.7654.203.49.5924.8794 1.0824 1.0824C10.6022 19 11.0681 19 12 19s1.3978 0 1.7654-.1522c.49-.203.8794-.5924 1.0824-1.0824C15 17.3978 15 16.9319 15 16V8c0-.9319 0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C13.3978 5 12.9319 5 12 5s-1.3978 0-1.7654.1522a2 2 0 0 0-1.0824 1.0824C9 6.6022 9 7.0681 9 8"
    />
  </svg>
);

export const DistributeSpacingVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 3H3m18 18H3m2-9c0-.9319 0-1.3978.1522-1.7654a2 2 0 0 1 1.0824-1.0824C6.6022 9 7.0681 9 8 9h8c.9319 0 1.3978 0 1.7654.1522.49.203.8794.5924 1.0824 1.0824C19 10.6022 19 11.0681 19 12s0 1.3978-.1522 1.7654c-.203.49-.5924.8794-1.0824 1.0824C17.3978 15 16.9319 15 16 15H8c-.9319 0-1.3978 0-1.7654-.1522a2 2 0 0 1-1.0824-1.0824C5 13.3978 5 12.9319 5 12"
    />
  </svg>
);

export const Divider = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 12h.01m4.49 0h.01m8.99 0h.01M12 12h.01M21 12h.01M21 21v-.8c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C19.4802 17 18.9201 17 17.8 17H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 18.5198 3 19.0799 3 20.2v.8M21 3v.8c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C19.4802 7 18.9201 7 17.8 7H6.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C3 5.4802 3 4.92 3 3.8V3"
    />
  </svg>
);

export const FlexAlignBottom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.5 17.6h-11M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const FlexAlignLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.5 17.5v-11M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const FlexAlignRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.5 17.5v-11M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const FlexAlignTop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.5 6.5h-11M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const Grid01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.4 3H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.76 3 4.04 3 4.6v3.8c0 .56 0 .84.109 1.054.0959.1882.2489.3411.437.437C3.76 10 4.04 10 4.6 10h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 9.24 10 8.96 10 8.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C9.24 3 8.96 3 8.4 3M19.4 3h-3.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C14 3.76 14 4.04 14 4.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109h3.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 9.24 21 8.96 21 8.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.2401 3 19.9601 3 19.4 3M19.4 14h-3.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C14 14.7599 14 15.0399 14 15.6v3.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109h3.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.2401 21 19.9601 21 19.4v-3.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C20.2401 14 19.9601 14 19.4 14M8.4 14H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 14.7599 3 15.0399 3 15.6v3.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 20.2401 10 19.9601 10 19.4v-3.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C9.24 14 8.96 14 8.4 14"
    />
  </svg>
);

export const Grid02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 3H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 4.5198 3 5.08 3 6.2V8m5 13H6.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.4802 3 18.9201 3 17.8V16m18-8V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C19.4802 3 18.9201 3 17.8 3H16m5 13v1.8c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C19.4802 21 18.9201 21 17.8 21H16m-4-4V7m-5 5h10"
    />
  </svg>
);

export const Grid03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 3H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 4.5198 3 5.08 3 6.2V8m5 13H6.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.4802 3 18.9201 3 17.8V16m18-8V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C19.4802 3 18.9201 3 17.8 3H16m5 13v1.8c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C19.4802 21 18.9201 21 17.8 21H16m0-9c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const GridDotsBlank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 3h.01M3 12h.01M3 21h.01M3 16.5h.01M3 7.5h.01M7.5 3h.01m-.01 9h.01m-.01 9h.01M16.5 3h.01m-.01 9h.01m-.01 9h.01M12 3h.01M12 12h.01M12 21h.01M12 16.5h.01m-.01-9h.01M21 3h.01M21 12h.01M21 21h.01M21 16.5h.01m-.01-9h.01"
    />
  </svg>
);

export const GridDotsBottom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 3h.01M3 12h.01M3 16.5h.01M3 7.5h.01M7.5 3h.01m-.01 9h.01m8.99-9h.01m-.01 9h.01M12 3h.01M12 12h.01M12 16.5h.01m-.01-9h.01M21 3h.01M21 12h.01M21 16.5h.01m-.01-9h.01M21 21H3"
    />
  </svg>
);

export const GridDotsHorizontalCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 3h.01M3 12h.01M3 21h.01M3 16.5h.01M3 7.5h.01M7.5 3h.01m-.01 9h.01m-.01 9h.01M16.5 3h.01m-.01 9h.01m-.01 9h.01M21 3h.01M21 12h.01M21 21h.01M21 16.5h.01m-.01-9h.01M12 21V3"
    />
  </svg>
);

export const GridDotsLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.5 3h.01m-.01 9h.01m-.01 9h.01M16.5 3h.01m-.01 9h.01m-.01 9h.01M12 3h.01M12 12h.01M12 21h.01M12 16.5h.01m-.01-9h.01M21 3h.01M21 12h.01M21 21h.01M21 16.5h.01m-.01-9h.01M3 21V3"
    />
  </svg>
);

export const GridDotsOuter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.5 12h.01m8.99 0h.01M12 12h.01M12 16.5h.01m-.01-9h.01M3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8"
    />
  </svg>
);

export const GridDotsRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.5 3h.01m-.01 9h.01m-.01 9h.01M16.5 3h.01m-.01 9h.01m-.01 9h.01M12 3h.01M12 12h.01M12 21h.01M12 16.5h.01m-.01-9h.01M3 3h.01M3 12h.01M3 21h.01M3 16.5h.01M3 7.5h.01M21 21V3"
    />
  </svg>
);

export const GridDotsTop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 21h.01M3 12h.01M3 16.5h.01M3 7.5h.01M7.5 21h.01m-.01-9h.01m8.99 9h.01m-.01-9h.01M12 21h.01M12 12h.01M12 16.5h.01m-.01-9h.01M21 21h.01M21 12h.01M21 16.5h.01m-.01-9h.01M21 3H3"
    />
  </svg>
);

export const GridDotsVerticalCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 3h.01M3 21h.01M3 16.5h.01M3 7.5h.01M7.5 3h.01M7.5 21h.01M16.5 3h.01m-.01 18h.01M12 3h.01M12 21h.01M12 16.5h.01m-.01-9h.01M21 3h.01M21 21h.01M21 16.5h.01m-.01-9h.01M21 12H3"
    />
  </svg>
);

export const IntersectCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 16c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 22c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7"
    />
  </svg>
);

export const IntersectSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 5.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 2 4.08 2 5.2 2h7.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C16 3.5198 16 4.08 16 5.2v7.6c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C14.4802 16 13.9201 16 12.8 16H5.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C2 14.4802 2 13.9201 2 12.8z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 11.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C9.5198 8 10.08 8 11.2 8h7.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C22 9.5198 22 10.08 22 11.2v7.6c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C20.4802 22 19.9201 22 18.8 22h-7.6c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C8 20.4802 8 19.9201 8 18.8z"
    />
  </svg>
);

export const LayerSingle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.3578 7.179c-.1312-.0656-.1968-.0984-.2656-.1113a.5.5 0 0 0-.1844 0c-.0688.0129-.1344.0457-.2656.1113L2 12l9.6422 4.8211c.1312.0656.1968.0984.2656.1113a.5.5 0 0 0 .1844 0c.0688-.0129.1344-.0457.2656-.1113L22 12.0001z"
    />
  </svg>
);

export const LayersThree01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m2 12.0001 9.6422 4.8211c.1312.0656.1968.0984.2656.1113a.5.5 0 0 0 .1844 0c.0688-.0129.1344-.0457.2656-.1113L22 12.0001m-20 5 9.6422 4.8211c.1312.0656.1968.0984.2656.1113a.5.5 0 0 0 .1844 0c.0688-.0129.1344-.0457.2656-.1113L22 17.0001m-20-10 9.6422-4.8211c.1312-.0656.1968-.0984.2656-.1113a.5.5 0 0 1 .1844 0c.0688.0129.1344.0457.2656.1113L22 7l-9.6422 4.8212c-.1312.0656-.1968.0984-.2656.1113a.5.5 0 0 1-.1844 0c-.0688-.0129-.1344-.0457-.2656-.1113z"
    />
  </svg>
);

export const LayersThree02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m7 9.5-5 2.5001 9.6422 4.8211c.1312.0656.1968.0984.2656.1113a.5.5 0 0 0 .1844 0c.0688-.0129.1344-.0457.2656-.1113L22 12.0001l-5-2.5m-10 5-5 2.5 9.6422 4.8211c.1312.0656.1968.0984.2656.1113a.5.5 0 0 0 .1844 0c.0688-.0129.1344-.0457.2656-.1113L22 17.0001l-5-2.5m-15-7.5 9.6422-4.8211c.1312-.0656.1968-.0984.2656-.1113a.5.5 0 0 1 .1844 0c.0688.0129.1344.0457.2656.1113L22 7l-9.6422 4.8212c-.1312.0656-.1968.0984-.2656.1113a.5.5 0 0 1-.1844 0c-.0688-.0129-.1344-.0457-.2656-.1113z"
    />
  </svg>
);

export const LayersTwo01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m2 14.5001 9.6422 4.8211c.1312.0656.1968.0984.2656.1113a.5.5 0 0 0 .1844 0c.0688-.0129.1344-.0457.2656-.1113L22 14.5001m-20-5 9.6422-4.8211c.1312-.0656.1968-.0984.2656-.1113a.5.5 0 0 1 .1844 0c.0688.0129.1344.0457.2656.1113L22 9.5l-9.6422 4.8212c-.1312.0656-.1968.0984-.2656.1113a.5.5 0 0 1-.1844 0c-.0688-.0129-.1344-.0457-.2656-.1113z"
    />
  </svg>
);

export const LayersTwo02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m7 12.0001-5 2.5 9.6422 4.8211c.1312.0656.1968.0984.2656.1113a.5.5 0 0 0 .1844 0c.0688-.0129.1344-.0457.2656-.1113L22 14.5001l-5-2.5m-15-2.5 9.6422-4.8211c.1312-.0656.1968-.0984.2656-.1113a.5.5 0 0 1 .1844 0c.0688.0129.1344.0457.2656.1113L22 9.5l-9.6422 4.8212c-.1312.0656-.1968.0984-.2656.1113a.5.5 0 0 1-.1844 0c-.0688-.0129-.1344-.0457-.2656-.1113z"
    />
  </svg>
);

export const LayoutAlt01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 9h18M9 9v12M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const LayoutAlt02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.5 11h-5m5 4h-5m5-8h-5M9 3v18M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const LayoutAlt03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.5 17h-11m11-4h-11M3 9h18M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const LayoutAlt04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 12h9m-9-9v18M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const LayoutBottom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 15h18M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const LayoutGrid01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 12h18m-9-9v18M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const LayoutGrid02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 9h18M3 15h18M12 3v18M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const LayoutLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 3v18M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const LayoutRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 3v18M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const LayoutTop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 9h18M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const List = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 12H9m12-6H9m12 12H9m-4-6c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1m0-6c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1m0 12c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const Maximize01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m14 10 7-7m0 6V3h-6m-5 11-7 7m0-6v6h6"
    />
  </svg>
);

export const Maximize02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 3h-.2c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8V8m5 13h-.2c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V16m18-8v-.2c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H16m5 13v.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H16"
    />
  </svg>
);

export const Minimize01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 20v-6H4m6 0-7 7M14 4v6h6m-6 0 7-7"
    />
  </svg>
);

export const Minimize02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2.9999 8h.2C4.88 8 5.72 8 6.3619 7.673a3 3 0 0 0 1.311-1.311c.327-.6418.327-1.4818.327-3.162V3m-5 13h.2c1.6801 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311c.327.6418.327 1.4818.327 3.162v.2m8-18v.2c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C18.2796 8 19.1197 8 20.7999 8h.2m-5 13v-.2c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C18.2796 16 19.1197 16 20.7999 16h.2"
    />
  </svg>
);

export const Rows01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.8 10c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 8.4802 21 7.92 21 6.8v-.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C19.4802 3 18.9201 3 17.8 3H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 4.5198 3 5.08 3 6.2v.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 10 5.08 10 6.2 10zM17.8 21c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.4802 21 18.9201 21 17.8v-.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C19.4802 14 18.9201 14 17.8 14H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 15.5198 3 16.0799 3 17.2v.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 21 5.08 21 6.2 21z"
    />
  </svg>
);

export const Rows02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 12h18M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const Rows03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 9h18M3 15h18M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const SpacingHeight01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 18V6m3 10-3 2-3-2m6-8-3-2-3 2m12-5H3m18 18H3"
    />
  </svg>
);

export const SpacingHeight02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 3H3m18 18H3m9-3.5v-11m3.0001 0H9m6.0001 11H9"
    />
  </svg>
);

export const SpacingWidth01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 12h12M8 15l-2-3 2-3m8 6 2-3-2-3m5 12V3M3 21V3"
    />
  </svg>
);

export const SpacingWidth02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 21V3M3 21V3m3.5 9h11m0 3V9m-11 6V9"
    />
  </svg>
);

export const Table = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 9h18M9 3v18M7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3"
    />
  </svg>
);

export const BarChart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 20V10m-6 10V4M6 20v-6"
    />
  </svg>
);

export const BarChart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 20V4M6 20v-4m6 4V10"
    />
  </svg>
);

export const BarChart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 20V4m12 16v-4m-6 4V10"
    />
  </svg>
);

export const BarChart04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 11v10m12-10v10M9 3v18M21 3v18"
    />
  </svg>
);

export const BarChart05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 17v4M15 8v13m-6-8v8M21 3v18"
    />
  </svg>
);

export const BarChart06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 8v13m12-4v4M3 3v18m12-8v8"
    />
  </svg>
);

export const BarChart07 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 21H6.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.4802 3 18.9201 3 17.8V3m4 7.5v7m4.5-12v12m4.5-7v7m4.5-12v12"
    />
  </svg>
);

export const BarChart08 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 21H6.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.4802 3 18.9201 3 17.8V3m4 11.5v3m4.5-6v6m4.5-9v9m4.5-12v12"
    />
  </svg>
);

export const BarChart09 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 21H6.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.4802 3 18.9201 3 17.8V3m4 2.5v12m4.5-9v9m4.5-6v6m4.5-3v3"
    />
  </svg>
);

export const BarChart10 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 7H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 7.76 3 8.04 3 8.6v10.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21H9m0 0h6m-6 0V4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C9.76 3 10.04 3 10.6 3h2.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437C15 3.76 15 4.04 15 4.6V21m0-10h4.4c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054v6.8c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437C20.2401 21 19.9601 21 19.4 21H15"
    />
  </svg>
);

export const BarChart11 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 21H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 20.2401 3 19.9601 3 19.4V4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C3.76 3 4.04 3 4.6 3h2.8c.56 0 .84 0 1.054.109.1882.0959.3411.2489.437.437C9 3.76 9 4.04 9 4.6V7m0 14h6m-6 0V7m0 0h4.4c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437C15 7.76 15 8.04 15 8.6V21m0-10h4.4c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054v6.8c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437C20.2401 21 19.9601 21 19.4 21H15"
    />
  </svg>
);

export const BarChart12 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 12H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 12.7599 3 13.0399 3 13.6v5.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21H9m0 0h6m-6 0V8.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C9.76 7 10.04 7 10.6 7h2.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437C15 7.76 15 8.04 15 8.6V21m0 0h4.4c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.2401 21 19.9601 21 19.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.2401 3 19.9601 3 19.4 3h-2.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C15 3.76 15 4.04 15 4.6V8"
    />
  </svg>
);

export const BarChartCircle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 13v4m8-6v6M12 7v10m10-5c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const BarChartCircle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 15v2m4-6v6m4-10v10m6-5c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const BarChartCircle03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 7v10m4-6v6m4-2v2m6-5c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const BarChartSquare01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 13v4m8-6v6M12 7v10m-4.2 4h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const BarChartSquare02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 15v2m4-6v6m4-10v10m-8.2 4h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const BarChartSquare03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 7v10m4-6v6m4-2v2m-8.2 4h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const BarChartSquareDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 3h4.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V12m5 1v4m8-6v6M12 7v10M8 5 5 8 2 5m3 3V2"
    />
  </svg>
);

export const BarChartSquareMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 3h4.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V12m5 1v4m8-6v6M12 7v10M2 5h6"
    />
  </svg>
);

export const BarChartSquarePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 3h4.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V12m5 1v4m8-6v6M12 7v10M5 8V2M2 5h6"
    />
  </svg>
);

export const BarChartSquareUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 3h4.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V12m5 1v4m8-6v6M12 7v10M8 5 5 2 2 5m3-3v6"
    />
  </svg>
);

export const BarLineChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 20v-7m-8 7V10M4 20v-4m9.4067-10.9725 5.1684 1.9382m-7.7763-1.5648L5.2002 9.6m15.8605-3.1606c.5857.5858.5857 1.5356 0 2.1214s-1.5356.5857-2.1214 0-.5857-1.5356 0-2.1214 1.5356-.5857 2.1214 0m-16 3c.5858.5858.5858 1.5356 0 2.1214s-1.5356.5857-2.1214 0-.5857-1.5356 0-2.1214 1.5356-.5857 2.1214 0m8-6c.5857.5858.5857 1.5356 0 2.1214s-1.5356.5858-2.1214 0-.5857-1.5356 0-2.1214 1.5356-.5857 2.1214 0"
    />
  </svg>
);

export const ChartBreakoutCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.5 3.5V2m3.9393 2.5607L20.5 3.5m.0103 5h1.5m-.0597 4.5c-.5017 5.0533-4.7653 9-9.9506 9-5.5228 0-10-4.4772-10-10 0-5.1853 3.9467-9.4489 9-9.9506M12 8h4v4m-.3803-4C13.2653 11.3276 9.3864 13.5 5 13.5a13.05 13.05 0 0 1-2.917-.3285"
    />
  </svg>
);

export const ChartBreakoutSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V13m-9-5h4v4m-.5-8.5V2m3.9393 2.5607L20.5 3.5m.0103 5h1.5M3 13.3471c.652.1007 1.3199.1529 2 .1529 4.3864 0 8.2653-2.1724 10.6197-5.5"
    />
  </svg>
);

export const HorizontalBarChart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 9.5V6.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C16.2401 4.5 15.9601 4.5 15.4 4.5H3m10 10v3.4c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437c-.2139.109-.4939.109-1.054.109H3M3 2v20m0-7.5h16.4c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 13.7401 21 13.4601 21 12.9v-1.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C20.2401 9.5 19.9601 9.5 19.4 9.5H3z"
    />
  </svg>
);

export const HorizontalBarChart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 9.5v3.4c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437c-.2139.109-.4939.109-1.054.109H3m10 0v3.4c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437c-.2139.109-.4939.109-1.054.109H3M3 2v20M3 9.5h16.4c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 8.74 21 8.46 21 7.9V6.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.2401 4.5 19.9601 4.5 19.4 4.5H3z"
    />
  </svg>
);

export const HorizontalBarChart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13 9.5V6.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C12.2401 4.5 11.9601 4.5 11.4 4.5H3m14 10v-3.4c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C16.2401 9.5 15.9601 9.5 15.4 9.5H3M3 2v20m0-2.5h16.4c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 18.7401 21 18.4601 21 17.9v-1.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437c-.2139-.109-.4939-.109-1.054-.109H3z"
    />
  </svg>
);

export const LineChartDown01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 21H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 20.2401 3 19.9601 3 19.4V3m17 12-3.9189-4.1827c-.1485-.1585-.2227-.2377-.3123-.2787a.5.5 0 0 0-.2528-.0433c-.0981.0089-.1945.0589-.3873.159l-3.2574 1.6914c-.1928.1001-.2892.1501-.3873.159a.5.5 0 0 1-.2528-.0433c-.0896-.041-.1638-.1202-.3123-.2787L7 8"
    />
  </svg>
);

export const LineChartDown02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 21H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 20.2401 3 19.9601 3 19.4V3m18 12-5.4343-5.4343c-.198-.198-.297-.297-.4112-.3341a.5.5 0 0 0-.309 0c-.1142.037-.2132.136-.4112.334l-1.8686 1.8687c-.198.198-.297.297-.4112.3341a.5.5 0 0 1-.309 0c-.1142-.0371-.2132-.1361-.4112-.3341L7 7m14 4v4h-4"
    />
  </svg>
);

export const LineChartDown03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m17 15-5.4343-5.4343c-.198-.198-.297-.297-.4112-.3341a.5.5 0 0 0-.309 0c-.1142.037-.2132.136-.4112.334l-1.8686 1.8687c-.198.198-.297.297-.4112.3341a.5.5 0 0 1-.309 0c-.1142-.0371-.2132-.1361-.4112-.3341L3 7m14 4v4h-4m-5.2 6h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const LineChartDown04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m3 9 6.6553 4.7538a.5.5 0 0 0 .6442-.0533l3.401-3.401a.5.5 0 0 1 .6442-.0533L21 15M6 21h12c1.6569 0 3-1.3431 3-3V6c0-1.6569-1.3431-3-3-3H6C4.3431 3 3 4.3431 3 6v12c0 1.6569 1.3431 3 3 3"
    />
  </svg>
);

export const LineChartDown05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m6 10 3.4343 3.4343c.198.198.297.297.4112.3341a.5.5 0 0 0 .309 0c.1142-.0371.2132-.1361.4112-.3341l2.8686-2.8686c.198-.198.297-.297.4112-.3341a.5.5 0 0 1 .309 0c.1142.0371.2132.1361.4112.3341L18 14m4-2c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const LineChartUp01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 21H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 20.2401 3 19.9601 3 19.4V3m17 5-3.9189 4.1827c-.1485.1585-.2227.2377-.3123.2787a.5.5 0 0 1-.2528.0433c-.0981-.0089-.1945-.0589-.3873-.159l-3.2574-1.6914c-.1928-.1001-.2892-.1501-.3873-.159a.5.5 0 0 0-.2528.0433c-.0896.041-.1638.1202-.3123.2787L7 15"
    />
  </svg>
);

export const LineChartUp02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 21H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 20.2401 3 19.9601 3 19.4V3m18 4-5.4343 5.4343c-.198.198-.297.297-.4112.3341a.5.5 0 0 1-.309 0c-.1142-.0371-.2132-.1361-.4112-.3341l-1.8686-1.8686c-.198-.198-.297-.297-.4112-.3341a.5.5 0 0 0-.309 0c-.1142.0371-.2132.1361-.4112.3341L7 15m14-4V7h-4"
    />
  </svg>
);

export const LineChartUp03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m17 9-5.4343 5.4343c-.198.198-.297.297-.4112.3341a.5.5 0 0 1-.309 0c-.1142-.0371-.2132-.1361-.4112-.3341l-1.8686-1.8686c-.198-.198-.297-.297-.4112-.3341a.5.5 0 0 0-.309 0c-.1142.0371-.2132.1361-.4112.3341L3 17m14-4V9h-4M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const LineChartUp04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m21 9-6.4485 4.6061c-.196.1399-.2939.2099-.3988.231a.5.5 0 0 1-.2765-.0229c-.1-.038-.1852-.1232-.3554-.2934l-3.0416-3.0416c-.1702-.1702-.2554-.2554-.3554-.2934a.5.5 0 0 0-.2765-.0229c-.1049.0211-.2028.0911-.3988.231L3 15m4.8 6h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const LineChartUp05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m18 10-3.4343 3.4343c-.198.198-.297.297-.4112.3341a.5.5 0 0 1-.309 0c-.1142-.0371-.2132-.1361-.4112-.3341l-2.8686-2.8686c-.198-.198-.297-.297-.4112-.3341a.5.5 0 0 0-.309 0c-.1142.0371-.2132.1361-.4112.3341L6 14m16-2c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const PieChart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21.2104 15.8899a10 10 0 0 1-7.2676 5.9148A9.9996 9.9996 0 0 1 2.169 10.1646 10 10 0 0 1 8.0004 2.83M21.2392 8.173a10 10 0 0 1 .7292 3.0277c.0206.2568.0309.3852-.0201.5009a.525.525 0 0 1-.2199.2382c-.1112.06-.2501.06-.528.06h-8.4c-.28 0-.42 0-.527-.0544a.5.5 0 0 1-.2185-.2186c-.0545-.1069-.0545-.2469-.0545-.527v-8.4c0-.2778 0-.4167.0601-.528a.525.525 0 0 1 .2382-.2199c.1157-.051.2441-.0407.5009-.02a10 10 0 0 1 8.4396 6.1411"
    />
  </svg>
);

export const PieChart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.2 14c.277 0 .4155 0 .5278.0615.0926.0507.1787.146.22.2432.05.1178.0374.2432.0122.494a8 8 0 0 1-4.8985 6.5923A8 8 0 1 1 9.2013 6.04c.2508-.0252.3762-.0378.494.0122.0972.0412.1925.1274.2432.22C10 6.3845 10 6.523 10 6.8v6.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C10.38 14 10.52 14 10.8 14zM14 2.8c0-.277 0-.4155.0615-.5278.0507-.0926.146-.1788.2432-.22.1178-.05.2432-.0374.494-.0123a8.0004 8.0004 0 0 1 7.1614 7.1614c.0251.2508.0377.3761-.0123.494-.0412.0972-.1274.1924-.22.2432C21.6155 10 21.477 10 21.2 10h-6.4c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C14 9.62 14 9.48 14 9.2z"
    />
  </svg>
);

export const PieChart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 2a10 10 0 0 1 9.2388 6.1732A10 10 0 0 1 22 12m0 0a10 10 0 0 1-4.1221 8.0902L12 12V2m0 0C6.4772 2 2 6.4772 2 12s4.4772 10 10 10 10-4.4771 10-10M12 2c5.5228 0 10 4.4772 10 10m0 0H12"
    />
  </svg>
);

export const PieChart04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 12 2.3318 9.4455A10 10 0 0 0 8.254 21.2718zm0 0 .1047-9.9994a10 10 0 0 0-9.764 7.4112zm10 0c0 5.5228-4.4771 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const PresentationChart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 16v5m-6 0 6-5 6 5m3-18v8.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 16 17.8802 16 16.2 16H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 13.7202 3 12.8802 3 11.2V3m5 6v3m4-5v5m4-1v1m6-9H2"
    />
  </svg>
);

export const PresentationChart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 16v5m6 0-3.9514-3.2928c-.7288-.6074-1.0932-.911-1.4999-1.0271a2 2 0 0 0-1.0974 0c-.4067.1161-.7711.4197-1.4999 1.0271L6 21m2-10v1m4-3v3m4-5v5m6-9H2m1 0h18v8.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 16 17.8802 16 16.2 16H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 13.7202 3 12.8802 3 11.2z"
    />
  </svg>
);

export const PresentationChart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 16v5m-6 0 6-5 6 5M8 7v5m4-3v3m4-1v1m6-9H2m1 0h18v8.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 16 17.8802 16 16.2 16H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 13.7202 3 12.8802 3 11.2z"
    />
  </svg>
);

export const TrendDown01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 17-7.8686-7.8686c-.396-.396-.5941-.594-.8224-.6682a1 1 0 0 0-.618 0c-.2283.0741-.4264.2721-.8224.6682l-2.7372 2.7372c-.396.396-.594.5941-.8224.6682a1 1 0 0 1-.618 0c-.2283-.0741-.4264-.2722-.8224-.6682L2 7m20 3v7h-7"
    />
  </svg>
);

export const TrendDown02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m7 7 10 10M7 17h10V7"
    />
  </svg>
);

export const TrendUp01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 7-7.8686 7.8686c-.396.396-.5941.5941-.8224.6682a1 1 0 0 1-.618 0c-.2283-.0741-.4264-.2722-.8224-.6682l-2.7372-2.7372c-.396-.396-.594-.5941-.8224-.6682a1 1 0 0 0-.618 0c-.2283.0741-.4264.2722-.8224.6682L2 17m20-3V7h-7"
    />
  </svg>
);

export const TrendUp02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 17 17 7m0 10V7H7"
    />
  </svg>
);

export const FaceId = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 3h-.2c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8V8m5 13h-.2c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V16m18-8v-.2c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H16m5 13v.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H16M7.5 8v1.5m9-1.5v1.5M11 12.6001c.8 0 1.5-.7 1.5-1.5V8m2.7002 7.2c-1.8 1.8-4.7 1.8-6.5 0"
    />
  </svg>
);

export const FaceIdSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.5 8v1.5m9-1.5v1.5M11 12.6001c.8 0 1.5-.7 1.5-1.5V8m2.7002 7.2c-1.8 1.8-4.7 1.8-6.5 0M3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8"
    />
  </svg>
);

export const FileLock01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 10V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h1.7m8.75-5v-1.75c0-.9665-.7835-1.75-1.75-1.75s-1.75.7835-1.75 1.75V17m-.15 4h3.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.2401 21 19.9601 21 19.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C20.2401 17 19.9601 17 19.4 17h-3.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C14 17.7599 14 18.0399 14 18.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109"
    />
  </svg>
);

export const FileLock02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 10V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h1.7M13 11H8m3 4H8m8-8H8m11.25 10v-1.75c0-.9665-.7835-1.75-1.75-1.75s-1.75.7835-1.75 1.75V17m-.15 4h3.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.2401 21 19.9601 21 19.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C20.2401 17 19.9601 17 19.4 17h-3.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C14 17.7599 14 18.0399 14 18.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109"
    />
  </svg>
);

export const FileLock03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m20 8-6-6H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2zm-6-6v6h6m-6.25 6v-1.75c0-.9665-.7835-1.75-1.75-1.75s-1.75.7835-1.75 1.75V14m-.15 4h3.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.2139.109-.4939.109-1.054v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C14.7401 14 14.4601 14 13.9 14h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437c-.109.2139-.109.4939-.109 1.054v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C9.26 18 9.54 18 10.1 18"
    />
  </svg>
);

export const FileShield01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 10V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h3.7m5.5-1s3-1.4299 3-3.5748v-2.5023l-2.1876-.7817a2.41 2.41 0 0 0-1.626 0L15 14.9229v2.5023C15 19.5701 18 21 18 21"
    />
  </svg>
);

export const FileShield02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 11H8m2 4H8m8-8H8m12 3V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h3.7m5.5-1s3-1.4299 3-3.5748v-2.5023l-2.1876-.7817a2.41 2.41 0 0 0-1.626 0L15 14.9229v2.5023C15 19.5701 18 21 18 21"
    />
  </svg>
);

export const FileShield03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m20 8-6-6H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2zm-6-6v6h6m-8 10s3-1.4299 3-3.5748v-2.5023l-2.1876-.7817a2.41 2.41 0 0 0-1.626 0L9 11.9229v2.5023C9 16.5701 12 18 12 18"
    />
  </svg>
);

export const Fingerprint01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.9182 3.3857C8.4074 2.5052 10.1447 2 12 2c5.5228 0 10 4.4772 10 10q0 .0496-.0005.0993M3.3811 6.9259C2.5035 8.4133 2 10.1479 2 12c0 4.6596 3.187 8.5748 7.5 9.685m11.2076-4.7644c-1.3204 2.3316-3.5502 4.0804-6.2076 4.7644m-.4107-15.3112A5.99 5.99 0 0 0 12 6c-3.3137 0-6 2.6863-6 6 0 .7387.1335 1.4463.3777 2.0999m11.2474-4.1922A5.99 5.99 0 0 1 18 12c0 3.3137-2.6863 6-6 6a5.99 5.99 0 0 1-2.0763-.369M12 10v4"
    />
  </svg>
);

export const Fingerprint02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 10v4M7.4471 3.421C8.7394 2.525 10.3084 2 12 2c4.4183 0 8 3.5817 8 8v1.2367M4.4163 7.4461A7.99 7.99 0 0 0 4 10v4c0 3.6349 2.4242 6.7035 5.744 7.6775m9.9148-5.3588c-.7294 2.4127-2.5677 4.3439-4.9221 5.2009M14.325 6.1464A4.48 4.48 0 0 0 12 5.5c-2.4853 0-4.5 2.0147-4.5 4.5v2.95m9-1.91V14c0 2.4853-2.0147 4.5-4.5 4.5a4.48 4.48 0 0 1-2.3199-.6433"
    />
  </svg>
);

export const Fingerprint03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.1 21.221c-1.3898-1.9835-2.2074-4.3967-2.2074-7.0023 0-3.3744 2.7339-6.1093 6.1063-6.1093s6.1062 2.7349 6.1062 6.1093"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.1 21.221c-1.3898-1.9835-2.2074-4.3967-2.2074-7.0023 0-3.3744 2.7339-6.1093 6.1063-6.1093s6.1062 2.7349 6.1062 6.1093"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18.4359 20.3118c-.11.0061-.2179.0163-.3289.0163-3.3723 0-6.1063-2.735-6.1063-6.1093"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18.4361 20.3118c-.1099.0061-.2179.0163-.3288.0163-3.3724 0-6.1063-2.735-6.1063-6.1093"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13.2694 21.9999c-2.5944-1.6179-4.3223-4.4975-4.3223-7.7812 0-1.6872 1.3674-3.0547 3.0536-3.0547s3.0536 1.3675 3.0536 3.0547 1.3675 3.0546 3.0537 3.0546 3.0536-1.3674 3.0536-3.0546c0-5.0616-4.1014-9.164-9.1599-9.164s-9.1599 4.1024-9.1599 9.164c0 1.1282.1263 2.2268.3584 3.2858"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13.2694 21.9999c-2.5944-1.6179-4.3223-4.4975-4.3223-7.7812 0-1.6872 1.3674-3.0547 3.0536-3.0547s3.0536 1.3675 3.0536 3.0547 1.3675 3.0546 3.0537 3.0546 3.0536-1.3674 3.0536-3.0546c0-5.0616-4.1014-9.164-9.1599-9.164s-9.1599 4.1024-9.1599 9.164c0 1.1282.1263 2.2268.3584 3.2858"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20.5257 5.8631C18.4435 3.4978 15.399 2 12.0002 2S5.5569 3.4978 3.4746 5.8631"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20.5257 5.8631C18.4435 3.4978 15.399 2 12.0002 2S5.5569 3.4978 3.4746 5.8631"
    />
  </svg>
);

export const Fingerprint04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5.8069 18.5304a4 4 0 0 1 .0544-.0891C7.2158 16.2881 7.9999 13.7418 7.9999 11c0-2.2091 1.7909-4 4-4s4 1.7909 4 4c0 1.017-.0692 2.0186-.2033 3m-2.1174 6.8436A21.9 21.9 0 0 0 15.1707 17m3.839 1.132C19.6547 15.8657 20 13.4732 20 11c0-4.4183-3.5817-8-8-8-1.4571 0-2.8233.3896-4 1.0703M3 15.364C3.6407 14.0454 4 12.5646 4 11c0-1.4572.3896-2.8233 1.0703-4m6.9296 4c0 3.5172-1.0088 6.7988-2.7528 9.5712"
    />
  </svg>
);

export const FolderShield = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13 7-1.1155-2.231c-.3211-.6422-.4816-.9633-.7211-1.1978a2 2 0 0 0-.7473-.4619C10.0992 3 9.7402 3 9.0223 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2V7m0 0h15.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2zm10 10.5s3-1.4299 3-3.5748v-2.5023l-2.1876-.7817a2.41 2.41 0 0 0-1.626 0L9 11.4229v2.5023C9 16.0701 12 17.5 12 17.5"
    />
  </svg>
);

export const Key01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 9a1.994 1.994 0 0 0-.5858-1.4142A1.994 1.994 0 0 0 15 7m0 8c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6-6 2.6863-6 6c0 .2737.0183.543.0538.807.0584.4342.0876.6513.068.7886-.0206.1431-.0466.2201-.1171.3463-.0677.1211-.187.2404-.4256.479l-5.1105 5.1105c-.173.1729-.2594.2594-.3212.3603a1 1 0 0 0-.1198.2891C3 17.2959 3 17.4182 3 17.6627V19.4c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21H7v-2h2v-2h2l1.5791-1.5791c.2386-.2386.3579-.3579.479-.4256.1262-.0705.2032-.0966.3463-.117.1373-.0197.3544.0095.7886.0679A6.05 6.05 0 0 0 15 15"
    />
  </svg>
);

export const Key02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 9h.01M15 15c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6-6 2.6863-6 6c0 .2737.0183.543.0538.807.0584.4342.0876.6513.068.7886-.0206.1431-.0466.2201-.1171.3463-.0677.1211-.187.2404-.4256.479l-5.1105 5.1105c-.173.1729-.2594.2594-.3212.3603a1 1 0 0 0-.1198.2891C3 17.2959 3 17.4182 3 17.6627V19.4c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21h1.7373c.2446 0 .3668 0 .482-.0276a1 1 0 0 0 .289-.1198c.1009-.0618.1874-.1483.3603-.3212l5.1105-5.1105c.2386-.2386.3579-.3579.479-.4256.1262-.0705.2032-.0966.3463-.117.1373-.0197.3544.0095.7886.0679A6.05 6.05 0 0 0 15 15"
    />
  </svg>
);

export const Lock01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 10V8c0-2.7614-2.2386-5-5-5S7 5.2386 7 8v2m5 4.5v2M8.8 21h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.7202 20 17.8802 20 16.2v-1.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 10 16.8802 10 15.2 10H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 12.2798 4 13.1198 4 14.8v1.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 21 7.1198 21 8.8 21"
    />
  </svg>
);

export const Lock02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 11V8c0-2.7614-2.2386-5-5-5S7 5.2386 7 8v3m.8 10h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2v-.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 11 17.8802 11 16.2 11H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 13.2798 3 14.1198 3 15.8v.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const Lock03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 11V8c0-2.7614-2.2386-5-5-5S7 5.2386 7 8v3m1.8 10h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.7202 20 17.8802 20 16.2v-.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 11 16.8802 11 15.2 11H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 13.2798 4 14.1198 4 15.8v.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 21 7.1198 21 8.8 21"
    />
  </svg>
);

export const Lock04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.101 10H7V8c0-2.7614 2.2386-5 5-5s5 2.2386 5 5v2h-.101M12 14v2m7-1c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7"
    />
  </svg>
);

export const LockKeyholeCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13.7316 13.1947c-.0706-.2116-.1059-.3175-.104-.404.0019-.0911.0141-.1388.056-.2196.0399-.0769.1464-.1761.3596-.3744C14.6318 11.649 15 10.8675 15 10c0-1.6569-1.3431-3-3-3s-3 1.3431-3 3c0 .8675.3682 1.649.9568 2.1967.2132.1983.3197.2975.3596.3744.0419.0808.0541.1285.056.2196.0019.0865-.0334.1924-.104.404L9.351 15.947c-.1185.3555-.1778.5333-.1422.6748a.5.5 0 0 0 .216.2998C9.5478 17 9.7352 17 10.11 17h3.7802c.3747 0 .5621 0 .6851-.0784a.5.5 0 0 0 .216-.2998c.0356-.1415-.0237-.3193-.1422-.6748z"
    />
  </svg>
);

export const LockKeyholeSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.2 21c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13.7316 13.1947c-.0706-.2116-.1059-.3175-.104-.404.0019-.0911.0141-.1388.056-.2196.0399-.0769.1464-.1761.3596-.3744C14.6318 11.6489 15 10.8675 15 10c0-1.6569-1.3431-3-3-3s-3 1.3431-3 3c0 .8675.3682 1.649.9568 2.1967.2132.1983.3197.2975.3596.3744.0419.0808.0541.1285.056.2196.0019.0865-.0334.1924-.104.404L9.351 15.947c-.1185.3555-.1778.5333-.1422.6748a.5.5 0 0 0 .216.2998C9.5478 17 9.7352 17 10.11 17h3.7802c.3747 0 .5621 0 .6851-.0784a.5.5 0 0 0 .216-.2998c.0356-.1415-.0237-.3193-.1422-.6748z"
    />
  </svg>
);

export const LockUnlocked01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 10V8c0-2.7614 2.2386-5 5-5 2.0503 0 3.8124 1.2341 4.584 3M12 14.5v2M8.8 21h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.7202 20 17.8802 20 16.2v-1.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 10 16.8802 10 15.2 10H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 12.2798 4 13.1198 4 14.8v1.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 21 7.1198 21 8.8 21"
    />
  </svg>
);

export const LockUnlocked02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 11V8c0-2.7614 2.2386-5 5-5 2.419 0 4.4367 1.7178 4.9 4M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2v-.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 11 17.8802 11 16.2 11H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 13.2798 3 14.1198 3 15.8v.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const LockUnlocked03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 11V8c0-2.7614 2.2386-5 5-5 2.419 0 4.4367 1.7178 4.9 4M8.8 21h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.7202 20 17.8802 20 16.2v-.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 11 16.8802 11 15.2 11H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 13.2798 4 14.1198 4 15.8v.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 21 7.1198 21 8.8 21"
    />
  </svg>
);

export const LockUnlocked04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 10V8c0-2.7614 2.2386-5 5-5 1.6358 0 3.0882.7856 4.0004 2M12 14v2m7-1c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7"
    />
  </svg>
);

export const Passcode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 12h.005M17 12h.005M7 12h.005M5.2 7h13.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C22 8.5198 22 9.08 22 10.2v3.6c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C20.4802 17 19.9201 17 18.8 17H5.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C2 15.4802 2 14.9201 2 13.8v-3.6c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 7 4.08 7 5.2 7m7.05 5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m5 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m-10 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
    />
  </svg>
);

export const PasscodeLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 11V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2v3.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 15 4.08 15 5.2 15H11m1-5h.005M17 10h.005M7 10h.005m12.245 7v-1.75c0-.9665-.7835-1.75-1.75-1.75s-1.75.7835-1.75 1.75V17m-3.5-7a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m5 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m-10 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m8.35 11h3.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.2401 21 19.9601 21 19.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C20.2401 17 19.9601 17 19.4 17h-3.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C14 17.7599 14 18.0399 14 18.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109"
    />
  </svg>
);

export const Scan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 3h-.2c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8V8m5 13h-.2c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V16m18-8v-.2c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H16m5 13v.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H16M3 12h.01m4.49 0h.01m8.99 0h.01M12 12h.01M21 12h.01"
    />
  </svg>
);

export const Shield03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 2.5001v19m8-9.5c0 4.9085-5.354 8.4784-7.302 9.6149-.2214.1292-.3321.1937-.4883.2272-.1213.026-.2981.026-.4194 0-.1562-.0335-.2669-.098-.4883-.2272C9.354 20.4785 4 16.9086 4 12.0001V7.2177c0-.7995 0-1.1993.1308-1.5429a2 2 0 0 1 .5469-.7892c.2758-.243.6501-.3834 1.3987-.6641l5.3618-2.0107c.2079-.078.3118-.117.4188-.1324a1 1 0 0 1 .286 0c.107.0155.2109.0544.4188.1324l5.3618 2.0107c.7486.2807 1.1229.421 1.3987.6641.2437.2148.4314.4857.5469.7892C20 6.0184 20 6.4182 20 7.2178z"
    />
  </svg>
);

export const ShieldDollar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.213 14.5001c.3122.5945.9356 1 1.6537 1H13c1.1046 0 2-.8954 2-2s-.8954-2-2-2h-2c-1.1046 0-2-.8954-2-2s.8954-2 2-2h2.1333c.7181 0 1.3415.4055 1.6537 1M12 6.0001v1.5m0 8v1.5m8-5c0 4.9085-5.354 8.4784-7.302 9.6149-.2214.1292-.3321.1937-.4883.2272-.1213.026-.2981.026-.4194 0-.1562-.0335-.2669-.098-.4883-.2272C9.354 20.4785 4 16.9086 4 12.0001V7.2177c0-.7995 0-1.1993.1308-1.5429a2 2 0 0 1 .5469-.7892c.2758-.243.6501-.3834 1.3987-.6641l5.3618-2.0107c.2079-.078.3118-.117.4188-.1324a1 1 0 0 1 .286 0c.107.0155.2109.0544.4188.1324l5.3618 2.0107c.7486.2807 1.1229.421 1.3987.6641.2437.2148.4314.4857.5469.7892C20 6.0184 20 6.4182 20 7.2178z"
    />
  </svg>
);

export const ShieldOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m8.8087 3.1966 2.6295-.986c.2079-.078.3118-.117.4188-.1324a1 1 0 0 1 .286 0c.107.0154.2109.0544.4188.1323l5.3618 2.0107c.7486.2808 1.1229.4211 1.3987.6642.2437.2148.4314.4856.5469.7892C20 6.0182 20 6.418 20 7.2175v4.7824c0 .7203-.1153 1.4118-.3182 2.0709m-2.0599 3.5547c-1.6857 1.9604-3.834 3.3533-4.9223 3.9883-.2224.1298-.3336.1947-.4898.2282-.1213.026-.2982.026-.4194 0-.1563-.0335-.267-.0981-.4884-.2273C9.354 20.4783 4 16.9083 4 11.9999V5.7762c0-.467.2897-.885.7269-1.049M3 3l18 18"
    />
  </svg>
);

export const ShieldPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 14.4999v-6m-3 3h6m5 .5c0 4.9084-5.354 8.4784-7.302 9.6148-.2214.1292-.3321.1938-.4883.2273-.1213.026-.2981.026-.4194 0-.1562-.0335-.2669-.0981-.4883-.2273C9.354 20.4783 4 16.9083 4 11.9999V7.2175c0-.7995 0-1.1993.1308-1.543a2 2 0 0 1 .5469-.7891c.2758-.243.6501-.3834 1.3987-.6642l5.3618-2.0107c.2079-.078.3118-.1169.4188-.1324a1 1 0 0 1 .286 0c.107.0155.2109.0545.4188.1324l5.3618 2.0107c.7486.2808 1.1229.4211 1.3987.6642.2437.2148.4314.4856.5469.7892C20 6.0182 20 6.418 20 7.2175z"
    />
  </svg>
);

export const ShieldTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 11.4999 2 2 4.5-4.5m4.5 3c0 4.9084-5.354 8.4784-7.302 9.6148-.2214.1292-.3321.1938-.4883.2273-.1213.026-.2981.026-.4194 0-.1562-.0335-.2669-.0981-.4883-.2273C9.354 20.4783 4 16.9083 4 11.9999V7.2175c0-.7995 0-1.1993.1308-1.543a2 2 0 0 1 .5469-.7891c.2758-.243.6501-.3834 1.3987-.6642l5.3618-2.0107c.2079-.078.3118-.1169.4188-.1324a1 1 0 0 1 .286 0c.107.0155.2109.0545.4188.1324l5.3618 2.0107c.7486.2808 1.1229.4211 1.3987.6642.2437.2148.4314.4856.5469.7892C20 6.0182 20 6.418 20 7.2175z"
    />
  </svg>
);

export const ShieldZap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13 7.4999-3 3 4 2-3 3m9-3.5c0 4.9084-5.354 8.4784-7.302 9.6148-.2214.1292-.3321.1938-.4883.2273-.1213.026-.2981.026-.4194 0-.1562-.0335-.2669-.0981-.4883-.2273C9.354 20.4783 4 16.9083 4 11.9999V7.2175c0-.7995 0-1.1993.1308-1.543a2 2 0 0 1 .5469-.7891c.2758-.243.6501-.3834 1.3987-.6642l5.3618-2.0107c.2079-.078.3118-.1169.4188-.1324a1 1 0 0 1 .286 0c.107.0155.2109.0545.4188.1324l5.3618 2.0107c.7486.2808 1.1229.4211 1.3987.6642.2437.2148.4314.4856.5469.7892C20 6.0182 20 6.418 20 7.2175z"
    />
  </svg>
);

export const Shield01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.302 21.6147c.2214.1292.3321.1938.4883.2273.1213.026.2981.026.4194 0 .1562-.0335.2669-.0981.4883-.2273C14.646 20.4783 20 16.9083 20 11.9999V7.2175c0-.7995 0-1.1993-.1308-1.543a2 2 0 0 0-.5469-.7891c-.2758-.243-.6501-.3834-1.3987-.6642l-5.3618-2.0107c-.2079-.078-.3118-.1169-.4188-.1324a1 1 0 0 0-.286 0c-.107.0155-.2109.0545-.4188.1324L6.0764 4.2212c-.7486.2808-1.1229.4211-1.3987.6642a2 2 0 0 0-.547.7892C4 6.0182 4 6.418 4 7.2175v4.7824c0 4.9084 5.354 8.4784 7.302 9.6148"
    />
  </svg>
);

export const Shield02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.302 21.6149c.2214.1292.3321.1938.4883.2273.1213.026.2981.026.4194 0 .1562-.0335.2669-.0981.4883-.2273C14.646 20.4785 20 16.9085 20 12.0001v-3.8c0-1.074 0-1.6109-.1655-1.992-.1683-.3874-.3359-.5935-.6809-.8371-.3395-.2397-1.005-.3781-2.3359-.655-1.4669-.305-2.5934-.8559-3.6233-1.6526-.4939-.382-.7408-.573-.9341-.6252-.2039-.055-.3167-.055-.5206 0-.1933.0521-.4402.2431-.9341.6252C9.7757 3.86 8.6492 4.411 7.1823 4.716c-1.331.2768-1.9964.4152-2.3358.6549-.345.2436-.5127.4497-.681.837C4 6.5893 4 7.1263 4 8.2v3.8001c0 4.9084 5.354 8.4784 7.302 9.6148"
    />
  </svg>
);

export const Atom01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.9995 12.0001h.01m3.5255 3.5356C10.8488 20.222 5.4669 22.438 3.5142 20.4854c-1.9526-1.9526.2635-7.3345 4.9498-12.0208S18.5322 1.5622 20.4848 3.515c1.9526 1.9526-.2635 7.3345-4.9498 12.0208m0-7.0713c4.6863 4.6863 6.9024 10.0682 4.9498 12.0208s-7.3346-.2634-12.0209-4.9497S1.5616 5.4673 3.5142 3.5147s7.3345.2634 12.0208 4.9497m-3.0355 3.5357a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);

export const Atom02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.1153 15.3582c-.2707.306-.5547.6083-.8518.9053-4.2957 4.2958-9.6776 5.8787-12.0208 3.5356-1.6064-1.6065-1.3675-4.6411.3258-7.7749m2.3212-3.299c.2817-.3202.578-.6364.8885-.947 4.2958-4.2957 9.6777-5.8786 12.0209-3.5355 1.6075 1.6075 1.3671 4.6453-.3293 7.7813m-3.2063-4.2458c4.2958 4.2958 5.8787 9.6777 3.5356 12.0209s-7.7251.7602-12.0209-3.5356S1.8996 6.5859 4.2427 4.2427s7.7251-.7602 12.0208 3.5355M13.0001 12c0 .5523-.4478 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const Award01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.9667 14.7219 7 22l4.5884-2.753c.1497-.0898.2245-.1347.3044-.1523a.5.5 0 0 1 .2144 0c.0799.0176.1547.0625.3044.1523L17 22l-.9657-7.2788M19 9c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7"
    />
  </svg>
);

export const Award02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 15.0903V22l4.7029-1.8812c.1097-.0439.1646-.0658.2213-.0745a.5.5 0 0 1 .1516 0c.0567.0087.1116.0306.2213.0745L17 22v-6.9097M19.5 9.5c0 4.1421-3.3579 7.5-7.5 7.5s-7.5-3.3579-7.5-7.5S7.8579 2 12 2s7.5 3.3579 7.5 7.5"
    />
  </svg>
);

export const Award03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.8687 15.4599 7 22l4.5884-2.753c.1497-.0898.2245-.1347.3044-.1523a.5.5 0 0 1 .2144 0c.0799.0176.1547.0625.3044.1523L17 22l-.8681-6.5429m.294-11.2082c.1544.3735.4509.6704.8241.8254l1.3089.5422a1.5246 1.5246 0 0 1 .8251 1.9919l-.5418 1.308a1.522 1.522 0 0 0 .0005 1.1673l.5408 1.3076a1.5247 1.5247 0 0 1-.8253 1.9926l-1.3079.5417a1.525 1.525 0 0 0-.8254.8242l-.5422 1.309a1.5244 1.5244 0 0 1-1.9918.825l-1.3079-.5418a1.525 1.525 0 0 0-1.1664.0009l-1.3089.5414a1.5244 1.5244 0 0 1-1.9906-.8245l-.5423-1.3094a1.525 1.525 0 0 0-.8242-.8254l-1.3089-.5422a1.524 1.524 0 0 1-.8254-1.9909l.5418-1.308a1.525 1.525 0 0 0-.0009-1.1664l-.541-1.31a1.5246 1.5246 0 0 1 .8253-1.9924l1.308-.5418a1.525 1.525 0 0 0 .825-.8233l.5421-1.3089a1.5245 1.5245 0 0 1 1.9918-.825l1.308.5417c.3735.1544.7931.154 1.1664-.0008l1.3094-.5401a1.5245 1.5245 0 0 1 1.9915.825l.5423 1.3093z"
    />
  </svg>
);

export const Award04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m8.8763 13.0953-4.175-5.2188c-.26-.3248-.39-.4873-.4823-.6682a2 2 0 0 1-.1782-.5078C4 6.5015 4 6.2935 4 5.8775V5.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C5.5198 2 6.08 2 7.2 2h9.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C20 3.5198 20 4.08 20 5.2v.6775c0 .416 0 .624-.0408.823a2 2 0 0 1-.1782.5078c-.0924.181-.2223.3434-.4822.6682l-4.175 5.2188M5.0001 3l7 9L19 3m-3.4645 10.4645c1.9527 1.9526 1.9527 5.1184 0 7.071-1.9526 1.9527-5.1184 1.9527-7.071 0-1.9526-1.9526-1.9526-5.1184 0-7.071 1.9526-1.9527 5.1184-1.9527 7.071 0"
    />
  </svg>
);

export const Award05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.1352 11.189 3.3304 4.3805c-.4375-.7828-.6562-1.1743-.6194-1.4948a1 1 0 0 1 .4091-.6972C3.3819 2 3.8303 2 4.7271 2H6.962c.3333 0 .5 0 .6494.0481.1323.0426.2543.1123.358.2047.1174.1043.202.2479.3712.535L12.0001 9l3.6596-6.2121c.1692-.2872.2538-.4308.3711-.5351a1 1 0 0 1 .3581-.2047C16.5383 2 16.705 2 17.0383 2h2.2348c.8968 0 1.3452 0 1.607.1885.2284.1645.3769.4176.4091.6972.0368.3205-.1819.712-.6194 1.4948l-3.8047 6.8085M10.5001 14l1.5-1v5m-1.25 0h2.5m3.3462-7.0962c2.5384 2.5384 2.5384 6.654 0 9.1924s-6.654 2.5384-9.1924 0-2.5384-6.654 0-9.1924 6.654-2.5384 9.1924 0"
    />
  </svg>
);

export const Backpack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 13v4.8c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C18.4802 21 17.9201 21 16.8 21H7.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C4 19.4802 4 18.9201 4 17.8V13m5-3h6m-5.7143 4h5.4286c2.1324 0 3.1987 0 4.0212-.3961a4 4 0 0 0 1.8684-1.8684C21 10.913 21 9.8467 21 7.7143c0-1.5994 0-2.399-.2971-3.016a3 3 0 0 0-1.4012-1.4012C18.6847 3 17.8851 3 16.2857 3H7.7143c-1.5994 0-2.399 0-3.016.297a3 3 0 0 0-1.4012 1.4013C3 5.3153 3 6.115 3 7.7144c0 2.1324 0 3.1987.3961 4.0212a4 4 0 0 0 1.8684 1.8684C6.087 14 7.1533 14 9.2857 14"
    />
  </svg>
);

export const Beaker01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 2v4.6605c0 .2172 0 .3258-.0331.4121a.47.47 0 0 1-.1383.198c-.0697.0608-.1827.1022-.4085.185C6.5489 8.5072 4.5 11.2643 4.5 14.5c0 4.1421 3.3579 7.5 7.5 7.5s7.5-3.3579 7.5-7.5c0-3.2356-2.0489-5.9927-4.9201-7.0445-.2258-.0827-.3388-.124-.4085-.1849a.47.47 0 0 1-.1383-.198C14 6.9863 14 6.8776 14 6.6605V2.0001M8.5 2h7"
    />
  </svg>
);

export const Beaker02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 6v4.5012c0 .5509 0 .8264-.0687 1.0817a2 2 0 0 1-.2957.6314c-.1522.2162-.3638.3925-.787.7452l-3.6972 3.081c-.4232.3527-.6348.529-.787.7452a2 2 0 0 0-.2957.6314C3 17.6724 3 17.9479 3 18.4988V18.8c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 22 5.08 22 6.2 22h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 20.4802 21 19.9201 21 18.8v-.3012c0-.5509 0-.8264-.0687-1.0817a2 2 0 0 0-.2957-.6314c-.1522-.2162-.3638-.3925-.787-.7452l-3.6972-3.081c-.4232-.3527-.6348-.529-.787-.7452a2 2 0 0 1-.2957-.6314C15 11.3276 15 11.0521 15 10.5012V6M8.3 6h7.4c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C16.5 5.62 16.5 5.48 16.5 5.2V2.8c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C16.12 2 15.98 2 15.7 2H8.3c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C7.5 2.38 7.5 2.52 7.5 2.8v2.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C7.88 6 8.02 6 8.3 6M5.5 17h13c.4647 0 .697 0 .8902.0384a2 2 0 0 1 1.5714 1.5714C21 18.803 21 19.0353 21 19.5s0 .697-.0384.8902a2 2 0 0 1-1.5714 1.5714C19.197 22 18.9647 22 18.5 22h-13c-.4647 0-.697 0-.8902-.0384a2 2 0 0 1-1.5714-1.5714C3 20.197 3 19.9647 3 19.5s0-.697.0384-.8902a2 2 0 0 1 1.5714-1.5714C4.803 17 5.0353 17 5.5 17"
    />
  </svg>
);

export const BookClosed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 19v-3H7c-1.6569 0-3 1.3431-3 3m4.8 3h8c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.4802 20 19.9201 20 18.8V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C18.4802 2 17.9201 2 16.8 2h-8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22"
    />
  </svg>
);

export const BookOpen01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 9.4c0-2.2402 0-3.3603.436-4.216a4 4 0 0 1 1.748-1.748C15.0397 3 16.1598 3 18.4 3h.4c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C22 4.5198 22 5.08 22 6.2v8.6c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C20.4802 18 19.9201 18 18.8 18h-1.3748c-1.2523 0-1.8785 0-2.4468.1726a4 4 0 0 0-1.3775.7372c-.4589.3772-.8062.8982-1.5008 1.9401L12 21l-.1001-.1501c-.6946-1.0419-1.0419-1.5629-1.5008-1.9401a4 4 0 0 0-1.3775-.7372C8.4533 18 7.8271 18 6.5748 18H5.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.4802 2 15.9201 2 14.8V6.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 3 4.08 3 5.2 3h.4c2.2402 0 3.3603 0 4.216.436a4 4 0 0 1 1.748 1.748C12 6.0397 12 7.1598 12 9.4M12 21V9.4"
    />
  </svg>
);

export const BookOpen02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 20H5.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C2 18.4802 2 17.9201 2 16.8V7.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 4 4.08 4 5.2 4h.4c2.2402 0 3.3603 0 4.216.436a4 4 0 0 1 1.748 1.748C12 7.0397 12 8.1598 12 10.4m0 9.6v-9.6m0 9.6h6.8c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 18.4802 22 17.9201 22 16.8V7.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 4 19.9201 4 18.8 4h-.4c-2.2402 0-3.3603 0-4.216.436a4 4 0 0 0-1.748 1.748C12 7.0397 12 8.1598 12 10.4"
    />
  </svg>
);

export const Briefcase01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 7c0-.93 0-1.395-.1022-1.7765a3 3 0 0 0-2.1213-2.1213C13.395 3 12.93 3 12 3s-1.395 0-1.7765.1022a3 3 0 0 0-2.1213 2.1213C8 5.605 8 6.07 8 7M5.2 21h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 19.4802 22 18.9201 22 17.8v-7.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 7 19.9201 7 18.8 7H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 8.5198 2 9.08 2 10.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 21 4.08 21 5.2 21"
    />
  </svg>
);

export const Briefcase02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 21V7c0-.93 0-1.395.1022-1.7765a3 3 0 0 1 2.1213-2.1213C10.605 3 11.07 3 12 3s1.395 0 1.7765.1022a3 3 0 0 1 2.1213 2.1213C16 5.605 16 6.07 16 7v14M5.2 21h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 19.4802 22 18.9201 22 17.8v-7.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 7 19.9201 7 18.8 7H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 8.5198 2 9.08 2 10.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 21 4.08 21 5.2 21"
    />
  </svg>
);

export const Calculator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m17.5 6.5-11 11m2-7v-4m-2 2h4m3 7h4M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const Certificate01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.5 20H5c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2h14c1.1046 0 2 .8954 2 2v14c0 1.1046-.8954 2-2 2h-1.5M12 19c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3m0 0 .0214-.0002-3.1927 3.1928-2.8285-2.8285 3.0195-3.0194M12 19l3.1928 3.1926 2.8284-2.8285-3.0194-3.0194M9 6h6M7 9.5h10"
    />
  </svg>
);

export const Certificate02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 18.5h6M7 15h10M5 2h14c1.1046 0 2 .995 2 2.2222v15.5556C21 21.0051 20.1046 22 19 22H5c-1.1046 0-2-.9949-2-2.2222V4.2222C3 2.995 3.8954 2 5 2m6.9976 4.212c-.6998-.7792-1.8667-.9888-2.7435-.2753S8.254 7.843 8.9425 8.6868 11.9976 11.5 11.9976 11.5s2.3666-1.9694 3.0551-2.8132c.6886-.8438.5802-2.0442-.3116-2.7501s-2.0437-.5039-2.7435.2752"
    />
  </svg>
);

export const Compass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 4c-1.3807 0-2.5 1.1193-2.5 2.5S10.6193 9 12 9s2.5-1.1193 2.5-2.5S13.3807 4 12 4m0 0V2m9 12.9375C18.8012 17.4287 15.5841 19 12 19c-3.584 0-6.8012-1.5713-9-4.0625m7.7448-6.2758L3 22M13.2552 8.6617 21 22"
    />
  </svg>
);

export const Glasses01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 11.5347c1.2335-.7129 2.7663-.7129 3.9999 0M8.8284 9.1716c1.5621 1.5621 1.5621 4.0947 0 5.6568s-4.0947 1.5621-5.6568 0-1.5621-4.0947 0-5.6568 4.0947-1.5621 5.6568 0m12 0c1.5621 1.5621 1.5621 4.0947 0 5.6568s-4.0947 1.5621-5.6568 0-1.5621-4.0947 0-5.6568 4.0947-1.5621 5.6568 0"
    />
  </svg>
);

export const Glasses02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 14.5347c1.2335-.7129 2.7663-.7129 3.9999 0M2 15l.7015-7.0149c.0266-.266.0399-.399.0603-.513.2404-1.345 1.3594-2.3577 2.7217-2.4632C5.5991 5 5.7327 5 6 5m16 10-.7015-7.0149c-.0266-.266-.0399-.399-.0603-.513-.2404-1.345-1.3594-2.3577-2.7217-2.4632C18.4009 5 18.2673 5 18 5m-9.1716 7.1716c1.5621 1.5621 1.5621 4.0947 0 5.6568s-4.0947 1.5621-5.6568 0-1.5621-4.0947 0-5.6568 4.0947-1.5621 5.6568 0m12 0c1.5621 1.5621 1.5621 4.0947 0 5.6568s-4.0947 1.5621-5.6568 0-1.5621-4.0947 0-5.6568 4.0947-1.5621 5.6568 0"
    />
  </svg>
);

export const GlobeSlated01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18.6317 2.3682c4.491 4.491 4.491 11.7724 0 16.2634-4.3009 4.3009-11.1608 4.483-15.6783.5464-.197-.1716-.2956-.2575-.34-.3748a.52.52 0 0 1-.011-.3219c.0362-.1201.1347-.2185.3315-.4154l2.2152-2.2152M18 10.4999c0 4.1421-3.3578 7.5-7.5 7.5s-7.5-3.3579-7.5-7.5 3.3579-7.5 7.5-7.5 7.5 3.3579 7.5 7.5"
    />
  </svg>
);

export const GlobeSlated02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m2.6611 18.3391 4.5939-4.5939M18.2175 2.7827c3.71 3.71 3.71 9.7251 0 13.435s-9.725 3.71-13.435 0M17 22.0002H7m5 0v-3m5.5-9.5c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6 2.6863-6 6-6 6 2.6863 6 6"
    />
  </svg>
);

export const GraduationHat01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 10.0001v6.0111c0 .359 0 .5384.0546.6969a1 1 0 0 0 .231.3736c.1173.1198.2778.2001.5989.3606l5.4 2.7c.2623.1312.3935.1968.5311.2226.1219.0228.2469.0228.3688 0 .1376-.0258.2688-.0914.5311-.2226l5.4-2.7c.3211-.1605.4816-.2408.5989-.3606a1 1 0 0 0 .2309-.3736C19 16.5496 19 16.3702 19 16.0112v-6.0111m-17-1.5 9.6422-4.8211c.1312-.0656.1968-.0984.2656-.1113a.5.5 0 0 1 .1844 0c.0688.0129.1344.0457.2656.1113L22 8.5l-9.6422 4.8212c-.1312.0656-.1968.0984-.2656.1113a.5.5 0 0 1-.1844 0c-.0688-.0129-.1344-.0457-.2656-.1113z"
    />
  </svg>
);

export const GraduationHat02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 14.5001v-3.0056c0-.1795 0-.2692-.0273-.3485a.5.5 0 0 0-.1155-.1868c-.0586-.0599-.1389-.1-.2994-.1802L12 8.5m-8 1v6.8067c0 .3719 0 .5578.058.7207.0513.1439.1349.2742.2444.3808.1238.1205.2929.198.631.353l6.4 2.9333c.2452.1124.3678.1686.4955.1908.1132.0196.229.0196.3422 0 .1277-.0222.2503-.0784.4955-.1908l6.4-2.9333c.3381-.155.5072-.2325.631-.353a1 1 0 0 0 .2444-.3808c.058-.1629.058-.3488.058-.7207V9.5001m-18-1 9.6422-4.8211c.1312-.0656.1968-.0984.2656-.1113a.5.5 0 0 1 .1844 0c.0688.0129.1344.0457.2656.1113L22 8.5l-9.6422 4.8212c-.1312.0656-.1968.0984-.2656.1113a.5.5 0 0 1-.1844 0c-.0688-.0129-.1344-.0457-.2656-.1113z"
    />
  </svg>
);

export const Microscope = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 22h9M11 6.252A8.01 8.01 0 0 1 13 6c4.4183 0 8 3.5817 8 8 0 3.3574-2.0682 6.2317-5 7.4185M5.5 13h4c.4647 0 .697 0 .8902.0384a2 2 0 0 1 1.5714 1.5714C12 14.803 12 15.0353 12 15.5s0 .697-.0384.8902a2 2 0 0 1-1.5714 1.5714C10.197 18 9.9647 18 9.5 18h-4c-.4647 0-.697 0-.8902-.0384a2 2 0 0 1-1.5714-1.5714C3 16.197 3 15.9647 3 15.5s0-.697.0384-.8902a2 2 0 0 1 1.5714-1.5714C4.803 13 5.0353 13 5.5 13M4 5.5V13h7V5.5C11 3.567 9.433 2 7.5 2S4 3.567 4 5.5"
    />
  </svg>
);

export const Ruler = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m14.5 5.4999 1.5 1.5m-4.5 1.5 1.5 1.5m-4.5 1.5 1.5 1.5m-4.5 1.5 1.5 1.5m-4.4344 1.5657 3.8686 3.8686c.198.198.297.2971.4112.3341a.5.5 0 0 0 .309 0c.1142-.037.2132-.1361.4112-.3341L21.4342 7.5656c.198-.198.2971-.297.3341-.4112a.5.5 0 0 0 0-.309c-.037-.1141-.1361-.2131-.3341-.4112l-3.8686-3.8686c-.198-.198-.297-.297-.4112-.3341a.5.5 0 0 0-.309 0c-.1141.0371-.2132.1361-.4112.3341L2.5656 16.4342c-.198.198-.297.2971-.3341.4112a.5.5 0 0 0 0 .309c.0371.1142.1361.2132.3341.4112"
    />
  </svg>
);

export const Stand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 17-5 5m11-5 5 5M12 2v2m0 18v-5m-6.8 0h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 15.4802 22 14.9201 22 13.8V7.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 4 19.9201 4 18.8 4H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 5.5198 2 6.08 2 7.2v6.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 17 4.08 17 5.2 17"
    />
  </svg>
);

export const Telescope = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13.1218 14.8446 4.8786 7.1553m-7.1214-7.1553-4.8786 7.1553m8-8.7999c0 1.1045-.8954 2-2 2s-2-.8955-2-2 .8954-2 2-2 2 .8954 2 2m3.1485-8.6677L5.3646 7.6898c-.2705.0725-.4057.1087-.495.189a.5.5 0 0 0-.1544.2677c-.025.1174.0113.2527.0837.5231l.88 3.2842c.0725.2705.1087.4057.189.4949a.5.5 0 0 0 .2677.1545c.1174.025.2526-.0113.5231-.0837L18.443 9.3619zm4.6439 4.9673c-1.0819.2899-1.6229.4348-2.0926.335a2 2 0 0 1-1.0704-.618c-.3213-.3568-.4663-.8978-.7562-1.9798l-.1553-.5795c-.2899-1.082-.4348-1.623-.335-2.0926a2 2 0 0 1 .618-1.0705c.3569-.3212.8978-.4662 1.9798-.7561.2704-.0725.4057-.1087.5231-.0838.1033.022.197.076.2676.1545.0803.0893.1166.2245.1891.495l1.3976 5.216c.0725.2705.1087.4057.0837.5231a.5.5 0 0 1-.1545.2676c-.0892.0804-.2244.1166-.4949.189M3.5021 12.33l1.3523-.3623c.2705-.0725.4057-.1088.495-.1891a.5.5 0 0 0 .1545-.2676c.025-.1174-.0113-.2527-.0838-.5231l-.3623-1.3523c-.0725-.2705-.1088-.4058-.189-.495a.5.5 0 0 0-.2677-.1545c-.1174-.025-.2527.0113-.5231.0838l-1.3523.3623c-.2705.0725-.4058.1087-.495.189a.5.5 0 0 0-.1545.2677c-.025.1174.0113.2526.0838.5231l.3623 1.3523c.0725.2705.1087.4057.189.4949a.5.5 0 0 0 .2677.1546c.1174.0249.2526-.0113.5231-.0838"
    />
  </svg>
);

export const Trophy01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 15c-3.3137 0-6-2.6863-6-6V3.4444c0-.4138 0-.6207.0603-.7864a1 1 0 0 1 .5977-.5977C6.8237 2 7.0306 2 7.4444 2h9.1112c.4138 0 .6207 0 .7864.0603a1 1 0 0 1 .5977.5977C18 2.8237 18 3.0306 18 3.4444V9c0 3.3137-2.6863 6-6 6m0 0v3m6-14h2.5c.4659 0 .6989 0 .8827.0761.245.1015.4397.2962.5412.5412C22 4.8011 22 5.0341 22 5.5V6c0 .93 0 1.395-.1022 1.7765a3 3 0 0 1-2.1213 2.1213C19.395 10 18.93 10 18 10M6 4H3.5c-.466 0-.699 0-.8827.0761a1 1 0 0 0-.5412.5412C2 4.8011 2 5.0341 2 5.5V6c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C4.605 10 5.07 10 6 10m1.4444 12h9.1112A.4444.4444 0 0 0 17 21.5556C17 19.5919 15.4081 18 13.4444 18h-2.8888C8.5919 18 7 19.5919 7 21.5556c0 .2454.199.4444.4444.4444"
    />
  </svg>
);

export const Trophy02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 17c-3.5898 0-6.5-2.9101-6.5-6.5V4.5556c0-.5182 0-.7773.0937-.9782a1 1 0 0 1 .4837-.4837C6.2784 3 6.5374 3 7.0556 3h9.8888c.5182 0 .7773 0 .9782.0937.2131.0993.3843.2706.4837.4837.0937.201.0937.46.0937.9782V10.5c0 3.5899-2.9101 6.5-6.5 6.5m0 0v4m5 0H7M22 5v5M2 5v5"
    />
  </svg>
);

export const Brackets = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.5708 20c1.262 0 2.286-1.023 2.286-2.286v-4.571L21.9998 12l-1.143-1.143V6.286c0-1.263-1.023-2.286-2.286-2.286M5.429 4C4.166 4 3.143 5.023 3.143 6.286v4.571L2 12l1.143 1.143v4.571C3.143 18.977 4.166 20 5.429 20"
    />
  </svg>
);

export const BracketsCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.5708 20c1.262 0 2.286-1.023 2.286-2.286v-4.571L21.9998 12l-1.143-1.143V6.286c0-1.263-1.023-2.286-2.286-2.286M5.429 4C4.166 4 3.143 5.023 3.143 6.286v4.571L2 12l1.143 1.143v4.571C3.143 18.977 4.166 20 5.429 20M7.5 12l2.4343 2.4343c.198.198.297.297.4112.3341a.5.5 0 0 0 .309 0c.1142-.0371.2132-.1361.4112-.3341L16.5 9"
    />
  </svg>
);

export const BracketsEllipses = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.5708 20c1.262 0 2.286-1.023 2.286-2.286v-4.571L21.9998 12l-1.143-1.143V6.286c0-1.263-1.023-2.286-2.286-2.286M5.429 4C4.166 4 3.143 5.023 3.143 6.286v4.571L2 12l1.143 1.143v4.571C3.143 18.977 4.166 20 5.429 20M7.5 12h.01M12 12h.01m4.49 0h.01M8 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.5 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 12.5 12m4.5 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 17 12"
    />
  </svg>
);

export const BracketsMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.5708 20c1.262 0 2.286-1.023 2.286-2.286v-4.571L21.9998 12l-1.143-1.143V6.286c0-1.263-1.023-2.286-2.286-2.286M5.429 4C4.166 4 3.143 5.023 3.143 6.286v4.571L2 12l1.143 1.143v4.571C3.143 18.977 4.166 20 5.429 20M8 12h8"
    />
  </svg>
);

export const BracketsPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.5708 20c1.262 0 2.286-1.023 2.286-2.286v-4.571L21.9998 12l-1.143-1.143V6.286c0-1.263-1.023-2.286-2.286-2.286M5.429 4C4.166 4 3.143 5.023 3.143 6.286v4.571L2 12l1.143 1.143v4.571C3.143 18.977 4.166 20 5.429 20M12 8v8m-4-4h8"
    />
  </svg>
);

export const BracketsSlash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.5708 20c1.262 0 2.286-1.023 2.286-2.286v-4.571L21.9998 12l-1.143-1.143V6.286c0-1.263-1.023-2.286-2.286-2.286M5.429 4C4.166 4 3.143 5.023 3.143 6.286v4.571L2 12l1.143 1.143v4.571C3.143 18.977 4.166 20 5.429 20M9 17l6-10"
    />
  </svg>
);

export const BracketsX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.5708 20c1.262 0 2.286-1.023 2.286-2.286v-4.571L21.9998 12l-1.143-1.143V6.286c0-1.263-1.023-2.286-2.286-2.286M5.429 4C4.166 4 3.143 5.023 3.143 6.286v4.571L2 12l1.143 1.143v4.571C3.143 18.977 4.166 20 5.429 20M15 9l-6 6m0-6 6 6"
    />
  </svg>
);

export const Browser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M22 9H2m0-1.2v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 21 5.1198 21 6.8 21h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.7202 22 17.8802 22 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 3 18.8802 3 17.2 3H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.2798 2 6.1198 2 7.8"
    />
  </svg>
);

export const Code01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m16 18 6-6-6-6M8 6l-6 6 6 6"
    />
  </svg>
);

export const Code02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m17 17 5-5-5-5M7 7l-5 5 5 5m7-14-4 18"
    />
  </svg>
);

export const CodeBrowser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M22 9H2m12 8.5 2.5-2.5-2.5-2.5m-4 0L7.5 15l2.5 2.5M2 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 21 5.1198 21 6.8 21h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.7202 22 17.8802 22 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 3 18.8802 3 17.2 3H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.2798 2 6.1198 2 7.8"
    />
  </svg>
);

export const CodeCircle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m14.5 15 3-3-3-3m-5 0-3 3 3 3M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const CodeCircle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m14 17 3-3-3-3m-4-4-3 3 3 3m12-1c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const CodeCircle03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m15.5 15 3-3-3-3m-7 0-3 3 3 3M13 7l-2 10m11-5c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const CodeSquare01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m14.5 15 3-3-3-3m-5 0-3 3 3 3m-1.7 6h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const CodeSquare02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m14 17 3-3-3-3m-4-4-3 3 3 3m-2.2 8h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const Codepen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m12 9-7.9361 5.1584c-.6879.4471-1.0318.6707-1.151.9542a1 1 0 0 0 0 .7747M12 8.9999l7.9361 5.1585c.6879.4471 1.0318.6707 1.1509.9542a1 1 0 0 1 0 .7747M12 8.9999V2.5M12 15 4.0639 9.8415c-.6879-.4472-1.0318-.6707-1.151-.9542a1 1 0 0 1 0-.7747M12 14.9999l7.9361-5.1584c.6879-.4472 1.0318-.6707 1.1509-.9542a1 1 0 0 0 0-.7747M12 14.9999v6.5m9.272-5.5267-8.4 5.46c-.3156.2051-.4735.3077-.6435.3476a1 1 0 0 1-.457 0c-.17-.0399-.3279-.1425-.6435-.3476l-8.4-5.46c-.266-.173-.399-.2594-.4954-.3747a1 1 0 0 1-.1884-.3473C2 15.1075 2 14.9489 2 14.6316V9.3682c0-.3172 0-.4758.0442-.6195a1 1 0 0 1 .1885-.3473c.0963-.1153.2293-.2018.4953-.3747l8.4-5.46c.3156-.2051.4735-.3077.6435-.3476a1 1 0 0 1 .457 0c.17.0399.3279.1425.6435.3476l8.4 5.46c.266.173.399.2594.4954.3747a1 1 0 0 1 .1884.3473C22 8.8924 22 9.051 22 9.3682v5.2634c0 .3173 0 .4759-.0442.6196a1 1 0 0 1-.1884.3473c-.0964.1153-.2294.2017-.4954.3747"
    />
  </svg>
);

export const Container = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.5 7.2778 12 12.0001m0 0L3.5 7.2778m8.5 4.7223v9.5m9-5.4415v-8.117c0-.3427 0-.514-.0505-.6668a1 1 0 0 0-.2141-.364c-.1091-.1183-.2588-.2015-.5584-.368l-7.4-4.111c-.2836-.1576-.4254-.2364-.5755-.2673a1 1 0 0 0-.4029 0c-.1502.031-.292.1097-.5756.2673l-7.4 4.111c-.2995.1665-.4493.2497-.5584.368a1 1 0 0 0-.2141.364C3 7.4276 3 7.5988 3 7.9415v8.1171c0 .3427 0 .514.0505.6668a1 1 0 0 0 .2141.3639c.109.1184.2588.2016.5584.368l7.4 4.1111c.2836.1576.4254.2363.5756.2672a1 1 0 0 0 .4029 0c.1501-.0309.2919-.1096.5755-.2672l7.4-4.1111c.2996-.1664.4493-.2496.5584-.368a1 1 0 0 0 .2141-.3639C21 16.5726 21 16.4013 21 16.0586"
    />
  </svg>
);

export const CpuChip01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 2v2m6-2v2M9 20v2m6-2v2m5-13h2m-2 5h2M2 9h2m-2 5h2m4.8 6h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 17.7202 20 16.8802 20 15.2V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 4 16.8802 4 15.2 4H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 6.2798 4 7.1198 4 8.8v6.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 20 7.1198 20 8.8 20m1.8-5h2.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C15 14.2401 15 13.9601 15 13.4v-2.8c0-.5601 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.2401 9 13.9601 9 13.4 9h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 9.76 9 10.04 9 10.6v2.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C9.76 15 10.04 15 10.6 15"
    />
  </svg>
);

export const CpuChip02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 2v3m6-3v3M9 19v3m6-3v3m4-13h3m-3 5h3M2 9h3m-3 5h3m4.8 5h4.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 16.7202 19 15.8802 19 14.2V9.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C16.7202 5 15.8802 5 14.2 5H9.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C5 7.2798 5 8.1198 5 9.8v4.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C7.2798 19 8.1198 19 9.8 19"
    />
  </svg>
);

export const Data = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.2 22c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C22 21.62 22 21.48 22 21.2V10.8c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C21.62 10 21.48 10 21.2 10h-2.4c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C18 10.38 18 10.52 18 10.8v2.4c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C17.62 14 17.48 14 17.2 14h-2.4c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C14 14.38 14 14.52 14 14.8v2.4c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C13.62 18 13.48 18 13.2 18h-2.4c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C10 18.38 10 18.52 10 18.8v2.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C10.38 22 10.52 22 10.8 22zM10 6.8c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185C10.38 6 10.52 6 10.8 6h2.4c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185C14 6.38 14 6.52 14 6.8v2.4c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C13.62 10 13.48 10 13.2 10h-2.4c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C10 9.62 10 9.48 10 9.2zM3 12.8c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185C3.38 12 3.52 12 3.8 12h2.4c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185C7 12.38 7 12.52 7 12.8v2.4c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C6.62 16 6.48 16 6.2 16H3.8c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C3 15.62 3 15.48 3 15.2zM2 2.8c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185C2.38 2 2.52 2 2.8 2h2.4c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185C6 2.38 6 2.52 6 2.8v2.4c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C5.62 6 5.48 6 5.2 6H2.8c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C2 5.62 2 5.48 2 5.2z"
    />
  </svg>
);

export const Database01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 5c0 1.6569-4.0294 3-9 3S3 6.6569 3 5m18 0c0-1.6568-4.0294-3-9-3S3 3.3432 3 5m18 0v14c0 1.66-4 3-9 3s-9-1.34-9-3V5m18 7c0 1.66-4 3-9 3s-9-1.34-9-3"
    />
  </svg>
);

export const Database02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 5c0 1.6569-4.0294 3-9 3S3 6.6569 3 5m18 0c0-1.6568-4.0294-3-9-3S3 3.3432 3 5m18 0v14c0 1.66-4 3-9 3s-9-1.34-9-3V5m18 4.7202c0 1.66-4 3-9 3s-9-1.34-9-3M21 14.44c0 1.66-4 3-9 3s-9-1.34-9-3"
    />
  </svg>
);

export const Database03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14 20c0 1.1046-.8954 2-2 2s-2-.8954-2-2m4 0c0-1.1046-.8954-2-2-2m2 2h7m-11 0c0-1.1046.8954-2 2-2m-2 2H3m9-2v-4m9-9c0 1.6569-4.0294 3-9 3S3 6.6569 3 5m18 0c0-1.6568-4.0294-3-9-3S3 3.3432 3 5m18 0v6c0 1.66-4 3-9 3M3 5v6c0 1.66 4 3 9 3"
    />
  </svg>
);

export const Dataflow01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17 20h-.2c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C12 17.7202 12 16.8802 12 15.2V8.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C14.2798 4 15.1198 4 16.8 4h.2m0 16c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2m0-16c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2M7 12h10M7 12c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m10 0c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2"
    />
  </svg>
);

export const Dataflow02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 4v11.2c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C14.2798 20 15.1198 20 16.8 20h.2m0 0c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2M7 4h10M7 4c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m10 0c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2m-5 8h5m0 0c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2"
    />
  </svg>
);

export const Dataflow03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11 4.5h7.3c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874.218.4278.218.9879.218 2.108V9c0 .9319 0 1.3978-.1522 1.7654-.203.49-.5924.8794-1.0824 1.0824C19.8978 12 19.4319 12 18.5 12M13 19.5H5.7c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C2.5 17.9802 2.5 17.4201 2.5 16.3V15c0-.9319 0-1.3978.1522-1.7654.203-.49.5924-.8794 1.0824-1.0824C4.1022 12 4.5681 12 5.5 12m4.8 2.5h3.4c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527v-3.4c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C14.12 9.5 13.98 9.5 13.7 9.5h-3.4c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C9.5 9.88 9.5 10.02 9.5 10.3v3.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545m7.5 7.5h3.4c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C22 21.62 22 21.48 22 21.2v-3.4c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C21.62 17 21.48 17 21.2 17h-3.4c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C17 17.38 17 17.52 17 17.8v3.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C17.38 22 17.52 22 17.8 22M2.8 7h3.4c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C7 6.62 7 6.48 7 6.2V2.8c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C6.62 2 6.48 2 6.2 2H2.8c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C2 2.38 2 2.52 2 2.8v3.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C2.38 7 2.52 7 2.8 7"
    />
  </svg>
);

export const Dataflow04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 18v-.2c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C6.2798 13 7.1198 13 8.8 13h6.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C20 15.2798 20 16.1198 20 17.8v.2M4 18c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2m16 0c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2m-8 0c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2m0 0V8M6 8h12c.9319 0 1.3978 0 1.7654-.1522.49-.203.8794-.5924 1.0824-1.0824C21 6.3978 21 5.9319 21 5s0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C19.3978 2 18.9319 2 18 2H6c-.9319 0-1.3978 0-1.7654.1522a2 2 0 0 0-1.0824 1.0824C3 3.6022 3 4.0681 3 5s0 1.3978.1522 1.7654a2 2 0 0 0 1.0824 1.0824C4.6022 8 5.0681 8 6 8"
    />
  </svg>
);

export const FileCode01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14 2.2695v4.1306c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305M14 17.5l2.5-2.5-2.5-2.5m-4 0L7.5 15l2.5 2.5m10-7.5118V17.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C6.2798 2 7.1198 2 8.8 2h3.2118c.7337 0 1.1006 0 1.4459.0829.3061.0735.5987.1947.8672.3592.3027.1855.5621.445 1.081.9638l3.1882 3.1882c.5189.5189.7783.7783.9638 1.081.1645.2685.2857.5611.3592.8672C20 8.8876 20 9.2545 20 9.9883"
    />
  </svg>
);

export const FileCode02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 18.5c0 .4644 0 .6966.0257.8916.1772 1.3462 1.2365 2.4055 2.5827 2.5827C7.8034 22 8.0356 22 8.5 22h7.7c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.7202 21 18.8802 21 17.2V9.9882c0-.7338 0-1.1006-.0829-1.4459a3 3 0 0 0-.3592-.8671c-.1855-.3028-.4449-.5622-.9638-1.081l-3.1882-3.1883c-.5189-.5189-.7783-.7783-1.081-.9638a3 3 0 0 0-.8672-.3592C14.1124 2 13.7455 2 13.0118 2H8.5c-.4644 0-.6966 0-.8916.0257-1.3462.1772-2.4055 1.2365-2.5827 2.5827C5 4.8034 5 5.0356 5 5.5m4 9 2.5-2.5L9 9.5m-4 0L2.5 12 5 14.5"
    />
  </svg>
);

export const FolderCode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m13 7-1.1155-2.231c-.3211-.6422-.4816-.9633-.7211-1.1978a2 2 0 0 0-.7473-.4619C10.0992 3 9.7402 3 9.0223 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2V7m0 0h15.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2zm12 9.5 2.5-2.5-2.5-2.5m-4 0L7.5 14l2.5 2.5"
    />
  </svg>
);

export const GitBranch01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 3v10.2c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 18 6.1198 18 7.8 18H15m0 0c0 1.6569 1.3431 3 3 3s3-1.3431 3-3-1.3431-3-3-3-3 1.3431-3 3M3 8h12m0 0c0 1.6569 1.3431 3 3 3s3-1.3431 3-3-1.3431-3-3-3-3 1.3431-3 3"
    />
  </svg>
);

export const GitBranch02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 3v12m0 0c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3m-3-3c1.6569 0 3 1.3431 3 3m9-9c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3m0 0a9 9 0 0 1-2.636 6.364A9 9 0 0 1 9 18"
    />
  </svg>
);

export const GitCommit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 12c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4m8 0c0-2.2091-1.7909-4-4-4s-4 1.7909-4 4m8 0h6M8 12H2.0002"
    />
  </svg>
);

export const GitMerge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 18c0 1.6569 1.3431 3 3 3s3-1.3431 3-3-1.3431-3-3-3-3 1.3431-3 3m0 0a9 9 0 0 1-9-9m0 0c1.6569 0 3-1.3431 3-3S7.6569 3 6 3 3 4.3431 3 6s1.3431 3 3 3m0 0v12"
    />
  </svg>
);

export const GitPullRequest = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18 15c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3-1.3431-3-3-3m0 0V8a2 2 0 0 0-2-2h-3M6 9c1.6569 0 3-1.3431 3-3S7.6569 3 6 3 3 4.3431 3 6s1.3431 3 3 3m0 0v12"
    />
  </svg>
);

export const Package = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.5 7.2778 12 12.0001m0 0L3.5 7.2778m8.5 4.7223v9.5m9-5.4415v-8.117c0-.3427 0-.514-.0505-.6668a1 1 0 0 0-.2141-.364c-.1091-.1183-.2588-.2015-.5584-.368l-7.4-4.111c-.2836-.1576-.4254-.2364-.5755-.2673a1 1 0 0 0-.4029 0c-.1502.031-.292.1097-.5756.2673l-7.4 4.111c-.2995.1665-.4493.2497-.5584.368a1 1 0 0 0-.2141.364C3 7.4276 3 7.5988 3 7.9415v8.1171c0 .3427 0 .514.0505.6668a1 1 0 0 0 .2141.3639c.109.1184.2588.2016.5584.368l7.4 4.1111c.2836.1576.4254.2363.5756.2672a1 1 0 0 0 .4029 0c.1501-.0309.2919-.1096.5755-.2672l7.4-4.1111c.2996-.1664.4493-.2496.5584-.368a1 1 0 0 0 .2141-.3639C21 16.5726 21 16.4013 21 16.0586M16.5 9.5l-9-5"
    />
  </svg>
);

export const PackageMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.5 7.2778 12 12.0001m0 0L3.5 7.2778m8.5 4.7223v9.5m2-.6111-1.223.6794c-.2836.1576-.4254.2363-.5755.2672a1 1 0 0 1-.4029 0c-.1502-.0309-.292-.1096-.5756-.2672l-7.4-4.1111c-.2995-.1664-.4493-.2496-.5584-.368a1 1 0 0 1-.2141-.3639C3 16.5726 3 16.4013 3 16.0586v-8.117c0-.3427 0-.514.0505-.6668a1 1 0 0 1 .2141-.364c.109-.1183.2588-.2015.5584-.368l7.4-4.111c.2836-.1576.4254-.2364.5756-.2673a1 1 0 0 1 .4029 0c.1501.031.2919.1097.5755.2673l7.4 4.111c.2996.1665.4493.2497.5584.368a1 1 0 0 1 .2141.364c.0505.1528.0505.324.0505.6667v5.0586m-13.5-8.5 9 5M16 18h6"
    />
  </svg>
);

export const PackageCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.5 7.2778 12 12.0001m0 0L3.5 7.2778m8.5 4.7223v9.5m2-.6111-1.223.6794c-.2836.1576-.4254.2363-.5755.2672a1 1 0 0 1-.4029 0c-.1502-.0309-.292-.1096-.5756-.2672l-7.4-4.1111c-.2995-.1664-.4493-.2496-.5584-.368a1 1 0 0 1-.2141-.3639C3 16.5726 3 16.4013 3 16.0586v-8.117c0-.3427 0-.514.0505-.6668a1 1 0 0 1 .2141-.364c.109-.1183.2588-.2015.5584-.368l7.4-4.111c.2836-.1576.4254-.2364.5756-.2673a1 1 0 0 1 .4029 0c.1501.031.2919.1097.5755.2673l7.4 4.111c.2996.1665.4493.2497.5584.368a1 1 0 0 1 .2141.364c.0505.1528.0505.324.0505.6667v4.5586m-13.5-8 9 5M16 18l2 2 4-4"
    />
  </svg>
);

export const PackagePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.5 7.2778 12 12.0001m0 0L3.5 7.2778m8.5 4.7223v9.5m2-.6111-1.223.6794c-.2836.1576-.4254.2363-.5755.2672a1 1 0 0 1-.4029 0c-.1502-.0309-.292-.1096-.5756-.2672l-7.4-4.1111c-.2995-.1664-.4493-.2496-.5584-.368a1 1 0 0 1-.2141-.3639C3 16.5726 3 16.4013 3 16.0586v-8.117c0-.3427 0-.514.0505-.6668a1 1 0 0 1 .2141-.364c.109-.1183.2588-.2015.5584-.368l7.4-4.111c.2836-.1576.4254-.2364.5756-.2673a1 1 0 0 1 .4029 0c.1501.031.2919.1097.5755.2673l7.4 4.111c.2996.1665.4493.2497.5584.368a1 1 0 0 1 .2141.364c.0505.1528.0505.324.0505.6667v4.5586m-13.5-8 9 5M19 21v-6m-3 3h6"
    />
  </svg>
);

export const PackageSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.5 7.2778 12 12.0001m0 0L3.5 7.2778m8.5 4.7223v9.5m9-9.5V7.9415c0-.3426 0-.514-.0505-.6667a1 1 0 0 0-.2141-.364c-.1091-.1183-.2588-.2015-.5584-.368l-7.4-4.111c-.2836-.1576-.4254-.2364-.5755-.2673a1 1 0 0 0-.4029 0c-.1502.031-.292.1097-.5756.2673l-7.4 4.111c-.2995.1665-.4493.2497-.5584.368a1 1 0 0 0-.2141.364C3 7.4276 3 7.5988 3 7.9415v8.1171c0 .3427 0 .514.0505.6668a1 1 0 0 0 .2141.3639c.109.1184.2589.2016.5584.368l7.4 4.1111c.2836.1576.4254.2363.5756.2672a1 1 0 0 0 .4029 0c.1501-.0309.2919-.1096.5755-.2672l.223-.1239M7.5 4.5001l9 5m5.5 12-1-1m1-2.5c0 1.6568-1.3431 3-3 3s-3-1.3432-3-3 1.3431-3 3-3 3 1.3431 3 3"
    />
  </svg>
);

export const PackageX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.5 7.2778 12 12.0001m0 0L3.5 7.2778m8.5 4.7223v9.5m9-9V7.9415c0-.3426 0-.514-.0505-.6667a1 1 0 0 0-.2141-.364c-.1091-.1183-.2588-.2015-.5584-.368l-7.4-4.111c-.2836-.1576-.4254-.2364-.5755-.2673a1 1 0 0 0-.4029 0c-.1502.031-.292.1097-.5756.2673l-7.4 4.111c-.2995.1665-.4493.2497-.5584.368a1 1 0 0 0-.2141.364C3 7.4276 3 7.5988 3 7.9415v8.1171c0 .3427 0 .514.0505.6668a1 1 0 0 0 .2141.3639c.109.1184.2589.2016.5584.368l7.4 4.1111c.2836.1576.4254.2363.5756.2672a1 1 0 0 0 .4029 0c.1501-.0309.2919-.1096.5755-.2672l.223-.1239M7.5 4.5001l9 5m0 6.5 5 5m0-5-5 5"
    />
  </svg>
);

export const PuzzlePiece01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.5 4.5C7.5 3.1193 8.6193 2 10 2s2.5 1.1193 2.5 2.5V6h1c1.3978 0 2.0967 0 2.6481.2284a3 3 0 0 1 1.6235 1.6236C18 8.4033 18 9.1022 18 10.5h1.5c1.3807 0 2.5 1.1193 2.5 2.5s-1.1193 2.5-2.5 2.5H18v1.7c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C15.7202 22 14.8802 22 13.2 22h-.7v-1.75c0-1.2426-1.0074-2.25-2.25-2.25S8 19.0074 8 20.25V22H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.7202 2 18.8802 2 17.2v-1.7h1.5C4.8807 15.5 6 14.3807 6 13s-1.1193-2.5-2.5-2.5H2c0-1.3978 0-2.0967.2284-2.648a3 3 0 0 1 1.6235-1.6236C4.4034 6 5.1023 6 6.5 6h1z"
    />
  </svg>
);

export const PuzzlePiece02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m12 2 3.6 3.6c2.4-6.3 9.1.4 2.8 2.8L22 12l-3.6 3.6c-2.4-6.3-9.1.4-2.8 2.8L12 22l-3.6-3.6C6 24.7-.7 18 5.6 15.6L2 12l3.6-3.6C8 14.7 14.7 8 8.4 5.6z"
    />
  </svg>
);

export const QrCode01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7 12h5v5m-8.99-5H3m5.01 5H8m4.01 4H12m9.01-9H21M3 17h1.5m11-5h2M3 21h5m4-19v6m5.6 13h1.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.2401 21 19.9601 21 19.4v-1.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C20.2401 16 19.9601 16 19.4 16h-1.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C16 16.7599 16 17.0399 16 17.6v1.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109m0-13h1.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 7.24 21 6.96 21 6.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.2401 3 19.9601 3 19.4 3h-1.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C16 3.76 16 4.04 16 4.6v1.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C16.7599 8 17.0399 8 17.6 8m-13 0h1.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 7.24 8 6.96 8 6.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.24 3 6.96 3 6.4 3H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.76 3 4.04 3 4.6v1.8c0 .56 0 .84.109 1.054.0959.1882.2489.3411.437.437C3.76 8 4.04 8 4.6 8"
    />
  </svg>
);

export const QrCode02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6.5 6.5h.01m10.99 0h.01M6.5 17.5h.01M13 13h.01m4.49 4.5h.01M17 21h4v-4m-7-.5V21m7-7h-4.5m-.9-4h3.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 9.24 21 8.96 21 8.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.2401 3 19.9601 3 19.4 3h-3.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C14 3.76 14 4.04 14 4.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109m-11 0h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 9.24 10 8.96 10 8.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C9.24 3 8.96 3 8.4 3H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.76 3 4.04 3 4.6v3.8c0 .56 0 .84.109 1.054.0959.1882.2489.3411.437.437C3.76 10 4.04 10 4.6 10m0 11h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C10 20.2401 10 19.9601 10 19.4v-3.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C9.24 14 8.96 14 8.4 14H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 14.7599 3 15.0399 3 15.6v3.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21"
    />
  </svg>
);

export const Server01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 6h.01M6 18h.01m-.81-8h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 8.4802 22 7.92 22 6.8V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 2 19.9201 2 18.8 2H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 3.5198 2 4.08 2 5.2v1.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 10 4.08 10 5.2 10m0 12h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.4802 22 19.9201 22 18.8v-1.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 14 19.9201 14 18.8 14H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 15.5198 2 16.0799 2 17.2v1.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 22 4.08 22 5.2 22"
    />
  </svg>
);

export const Server02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 8h.01M6 16h.01M6 12h12M6 12c-2.2091 0-4-1.7909-4-4s1.7909-4 4-4h12c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4M6 12c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4h12c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4"
    />
  </svg>
);

export const Server03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m22 17.5-.6917-10.0302c-.1086-1.5748-.1629-2.3621-.5042-2.959a3 3 0 0 0-1.2979-1.2114C18.8873 3 18.0981 3 16.5196 3H7.4804c-1.5785 0-2.3677 0-2.9866.2994a3 3 0 0 0-1.2979 1.2114c-.3413.5969-.3956 1.3842-.5042 2.959L2 17.5m20 0c0 1.933-1.567 3.5-3.5 3.5h-13C3.567 21 2 19.433 2 17.5m20 0c0-1.933-1.567-3.5-3.5-3.5h-13C3.567 14 2 15.567 2 17.5m4 0h.01m5.99 0h6"
    />
  </svg>
);

export const Server04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m22 10.5-.4744-3.7954c-.1861-1.4886-.2791-2.233-.6295-2.7938A3 3 0 0 0 19.613 2.778c-.6-.278-1.3501-.278-2.8504-.278H7.2374c-1.5003 0-2.2504 0-2.8504.278A3 3 0 0 0 3.104 3.9108c-.3504.5609-.4434 1.3052-.6295 2.7938L2 10.5m3.5 4h13m-13 0C3.567 14.5 2 12.933 2 11s1.567-3.5 3.5-3.5h13c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5m-13 0C3.567 14.5 2 16.067 2 18s1.567 3.5 3.5 3.5h13c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5M6 11h.01M6 18h.01M12 11h6m-6 7h6"
    />
  </svg>
);

export const Server05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 9c0 3.866-3.134 7-7 7m7-7c0-3.866-3.134-7-7-7m7 7H5m7 7c-3.866 0-7-3.134-7-7m7 7a10.71 10.71 0 0 0 2.8009-7A10.71 10.71 0 0 0 12 2m0 14a10.71 10.71 0 0 1-2.799-7A10.71 10.71 0 0 1 12 2m0 14v2M5 9c0-3.866 3.134-7 7-7m2 18c0 1.1046-.8954 2-2 2s-2-.8954-2-2m4 0c0-1.1046-.8954-2-2-2m2 2h7m-11 0c0-1.1046.8954-2 2-2m-2 2H3"
    />
  </svg>
);

export const Server06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20 12c0 4.4183-3.5817 8-8 8m8-8c0-4.4183-3.5817-8-8-8m8 8H4m8 8c-4.4183 0-8-3.5817-8-8m8 8a12.24 12.24 0 0 0 3.2006-8A12.24 12.24 0 0 0 12 4m0 16a12.24 12.24 0 0 1-3.1995-8A12.24 12.24 0 0 1 12 4m-8 8c0-4.4183 3.5817-8 8-8M6 20c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m16 0c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2M6 4c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m16 0c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2"
    />
  </svg>
);

export const Terminal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m4 17 6-6-6-6m8 14h8"
    />
  </svg>
);

export const TerminalBrowser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M22 9H2m4 8.5L8.5 15 6 12.5m5 5h4M2 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 21 5.1198 21 6.8 21h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.7202 22 17.8802 22 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 3 18.8802 3 17.2 3H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.2798 2 6.1198 2 7.8"
    />
  </svg>
);

export const TerminalCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m7 15 3-3-3-3m6 6h4m5-3c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const TerminalSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m7 15 3-3-3-3m6 6h4m-9.2 6h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const Variable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19.9061 21C21.2464 18.2888 22 15.2329 22 12s-.7536-6.2888-2.0939-9M4.0939 3C2.7536 5.7112 2 8.7671 2 12s.7536 6.2888 2.094 9M16.5485 8.625h-.0896c-.6534 0-1.2742.287-1.6994.7857l-5.3749 6.3036a2.233 2.233 0 0 1-1.6994.7857h-.0897m1.1192-7.875h1.3941c.4997 0 .9388.333 1.0761.816l1.7744 6.2431c.1373.4829.5764.8159 1.0761.8159h1.3941"
    />
  </svg>
);

export const ArrowBlockDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 3.8c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185C9.38 3 9.52 3 9.8 3h4.4c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185C15 3.38 15 3.52 15 3.8V14h4l-7 7-7-7h4z"
    />
  </svg>
);

export const ArrowBlockLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m3 12 7-7v4h10.2c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185C21 9.38 21 9.52 21 9.8v4.4c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C20.62 15 20.48 15 20.2 15H10v4z"
    />
  </svg>
);

export const ArrowBlockRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m21 12-7-7v4H3.8c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C3 9.38 3 9.52 3 9.8v4.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C3.38 15 3.52 15 3.8 15H14v4z"
    />
  </svg>
);

export const ArrowBlockUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.8 21c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C9 20.62 9 20.48 9 20.2V10H5l7-7 7 7h-4v10.2c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C14.62 21 14.48 21 14.2 21z"
    />
  </svg>
);

export const ArrowCircleBrokenDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 3.3378c2.989 1.729 5 4.9608 5 8.6622 0 5.5228-4.4772 10-10 10S2 17.5228 2 12c0-3.7014 2.011-6.9331 5-8.6622M16 12l-4 4-4-4m4 4V2"
    />
  </svg>
);

export const ArrowCircleBrokenDownLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.0002 15.0001h-6v-6m0 6 9.9998-10m2.6606 4.4104c.8909 3.3362.0278 7.0433-2.5895 9.6606-3.9053 3.9053-10.237 3.9053-14.1422 0-3.9052-3.9052-3.9052-10.2369 0-14.1421 2.6173-2.6173 6.3245-3.4805 9.6607-2.5896"
    />
  </svg>
);

export const ArrowCircleBrokenDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.4105 2.3394c3.3361-.8909 7.0433-.0277 9.6606 2.5896 3.9052 3.9052 3.9052 10.2369 0 14.1421-3.9053 3.9053-10.237 3.9053-14.1422 0-2.6173-2.6173-3.4804-6.3244-2.5895-9.6606M9 15.0001h6v-6m0 6L5 5.0001"
    />
  </svg>
);

export const ArrowCircleBrokenLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20.6621 17c-1.7291 2.989-4.9608 5-8.6622 5-5.5229 0-10-4.4772-10-10s4.4771-10 10-10c3.7014 0 6.9331 2.011 8.6622 5m-8.6622 9-4-4 4-4m-4 4h14"
    />
  </svg>
);

export const ArrowCircleBrokenRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3.3379 7C5.0669 4.011 8.2987 2 12 2c5.5228 0 10 4.4772 10 10s-4.4772 10-10 10c-3.7014 0-6.9332-2.011-8.6622-5M12 8l4 4-4 4m4-4H2"
    />
  </svg>
);

export const ArrowCircleBrokenUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 20.6621c-2.989-1.7291-5-4.9608-5-8.6622 0-5.5229 4.4772-10 10-10s10 4.4771 10 10c0 3.7014-2.011 6.9331-5 8.6622m-9-8.6622 4-4 4 4m-4-4v14"
    />
  </svg>
);

export const ArrowCircleBrokenUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14.5896 21.6606c-3.3362.8909-7.0434.0278-9.6607-2.5895-3.9052-3.9053-3.9052-10.237 0-14.1422 3.9053-3.9052 10.2369-3.9052 14.1422 0 2.6173 2.6173 3.4804 6.3245 2.5895 9.6607m-6.6604-5.5895h-6v6m0-6L19 19"
    />
  </svg>
);

export const ArrowCircleBrokenUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2.3394 14.5896c-.891-3.3362-.0278-7.0434 2.5895-9.6607 3.9053-3.9052 10.2369-3.9052 14.1422 0 3.9052 3.9053 3.9052 10.2369 0 14.1422-2.6173 2.6173-6.3245 3.4804-9.6606 2.5895M9 9.0001h6v6m0-6L5 19"
    />
  </svg>
);

export const ArrowCircleDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 12-4 4-4-4m4 4V8m10 4c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const ArrowCircleDownLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.0002 15.0001h-6v-6m0 6 6-6.0002M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const ArrowCircleDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.0002 15.0001h6v-6m0 6-6-6.0002M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const ArrowCircleLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m12 16-4-4 4-4m-4 4h8m6 0c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const ArrowCircleRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m12 8 4 4-4 4m4-4H8m14 0c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const ArrowCircleUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m8 12 4-4 4 4m-4-4v8m10-4c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const ArrowCircleUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.0002 9h-6v6.0001m0-6 6 5.9998M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const ArrowCircleUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.0002 9h6v6.0001m0-6-6 5.9998M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 5v14m-7-7 7 7 7-7"
    />
  </svg>
);

export const ArrowDownLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 7 7 17M7 7v10h10"
    />
  </svg>
);

export const ArrowDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m7 7 10 10M7 17h10V7"
    />
  </svg>
);

export const ArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 12H5m7-7-7 7 7 7"
    />
  </svg>
);

export const ArrowNarrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 4v16m-6-6 6 6 6-6"
    />
  </svg>
);

export const ArrowNarrowDownLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 6 6 18m0-8v8h8"
    />
  </svg>
);

export const ArrowNarrowDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m6 6 12 12m-8 0h8v-8"
    />
  </svg>
);

export const ArrowNarrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 12H4m6-6-6 6 6 6"
    />
  </svg>
);

export const ArrowNarrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 12h16m-6 6 6-6-6-6"
    />
  </svg>
);

export const ArrowNarrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 20V4m6 6-6-6-6 6"
    />
  </svg>
);

export const ArrowNarrowUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 18 6 6m8 0H6v8"
    />
  </svg>
);

export const ArrowNarrowUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 18 18 6m0 8V6h-8"
    />
  </svg>
);

export const ArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 12h14m-7 7 7-7-7-7"
    />
  </svg>
);

export const ArrowSquareDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 12-4 4-4-4m4 4V8M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const ArrowSquareDownLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.0002 15.0001h-6v-6m0 6 6-6.0002M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const ArrowSquareDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.0002 15.0001h6v-6m0 6-6-6.0002M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const ArrowSquareLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m12 16-4-4 4-4m-4 4h8m-8.2 9h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const ArrowSquareRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m12 8 4 4-4 4m4-4H8m-.2 9h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const ArrowSquareUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m8 12 4-4 4 4m-4-4v8m-4.2 5h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const ArrowSquareUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.0002 9h-6v6.0001m0-6 6 5.9998M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const ArrowSquareUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.0002 9h6v6.0001m0-6-6 5.9998M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const ArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 19V5m7 7-7-7-7 7"
    />
  </svg>
);

export const ArrowUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 17 7 7m10 0H7v10"
    />
  </svg>
);

export const ArrowUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 17 17 7m0 10V7H7"
    />
  </svg>
);

export const ArrowsDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 4v11m4-4-4 4-4-4M7 4v16m4-4-4 4-4-4"
    />
  </svg>
);

export const ArrowsLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 17H4m4-4-4 4 4 4M20 7H9m4-4L9 7l4 4"
    />
  </svg>
);

export const ArrowsRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 7h11m-4-4 4 4-4 4m-7 6h16m-4-4 4 4-4 4"
    />
  </svg>
);

export const ArrowsTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13 19h4.2942c1.8652 0 2.7978 0 3.3273-.3908a2 2 0 0 0 .8048-1.4349c.0573-.6556-.429-1.4514-1.4016-3.043L19.0278 12.5M6.1301 10.6052l-2.1548 3.5262c-.9726 1.5915-1.459 2.3873-1.4016 3.0429a2 2 0 0 0 .8048 1.4349C3.908 19 4.8405 19 6.7058 19H8.5m8.3889-10-2.1584-3.532c-.9028-1.4772-1.3542-2.2159-1.9353-2.4677a2 2 0 0 0-1.5904 0c-.5811.2518-1.0325.9905-1.9353 2.4678L8.2497 7.1369M18 5l-1.0981 4.098-4.0981-1.098M2 11.598 6.098 10.5l1.0982 4.0981M15.5 22l-3-3 3-3"
    />
  </svg>
);

export const ArrowsUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 20V4m4 4L7 4 3 8m14 12V9m4 4-4-4-4 4"
    />
  </svg>
);

export const ChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m6 9 6 6 6-6"
    />
  </svg>
);

export const ChevronDownDouble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m7 13 5 5 5-5M7 6l5 5 5-5"
    />
  </svg>
);

export const ChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m15 18-6-6 6-6"
    />
  </svg>
);

export const ChevronLeftDouble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m18 17-5-5 5-5m-7 10-5-5 5-5"
    />
  </svg>
);

export const ChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 18 6-6-6-6"
    />
  </svg>
);

export const ChevronRightDouble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m6 17 5-5-5-5m7 10 5-5-5-5"
    />
  </svg>
);

export const ChevronSelectorHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 7-5 5 5 5m6-10 5 5-5 5"
    />
  </svg>
);

export const ChevronSelectorVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m7 15 5 5 5-5M7 9l5-5 5 5"
    />
  </svg>
);

export const ChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m18 15-6-6-6 6"
    />
  </svg>
);

export const ChevronUpDouble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m17 18-5-5-5 5m10-7-5-5-5 5"
    />
  </svg>
);

export const CornerDownLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 4v1.4c0 3.3603 0 5.0405-.654 6.3239a6 6 0 0 1-2.6221 2.6221C15.4405 15 13.7603 15 10.4 15H4m5 5-5-5 5-5"
    />
  </svg>
);

export const CornerDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 4v1.4c0 3.3603 0 5.0405.654 6.3239a6 6 0 0 0 2.622 2.6221C8.5596 15 10.2398 15 13.6 15H20m-5 5 5-5-5-5"
    />
  </svg>
);

export const CornerLeftDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 4h-3.4c-3.3603 0-5.0405 0-6.3239.654A6 6 0 0 0 8.654 7.276C8 8.5596 8 10.2398 8 13.6V20m-5-5 5 5 5-5"
    />
  </svg>
);

export const CornerLeftUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 20h-3.4c-3.3603 0-5.0405 0-6.3239-.654a6 6 0 0 1-2.6221-2.6221C8 15.4405 8 13.7603 8 10.4V4M3 9l5-5 5 5"
    />
  </svg>
);

export const CornerRightDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 4h3.4c3.3603 0 5.0405 0 6.3239.654a6 6 0 0 1 2.6221 2.622C16 8.5596 16 10.2398 16 13.6V20m5-5-5 5-5-5"
    />
  </svg>
);

export const CornerRightUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 20h3.4c3.3603 0 5.0405 0 6.3239-.654a6 6 0 0 0 2.6221-2.6221C16 15.4405 16 13.7603 16 10.4V4m5 5-5-5-5 5"
    />
  </svg>
);

export const CornerUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 4 4 9l5 5M4 9h6.4c3.3603 0 5.0405 0 6.3239.654a6 6 0 0 1 2.6221 2.6221C20 13.5595 20 15.2397 20 18.6V20"
    />
  </svg>
);

export const CornerUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 20v-1.4c0-3.3603 0-5.0405.654-6.3239A6 6 0 0 1 7.276 9.654C8.5596 9 10.2398 9 13.6 9H20m-5-5 5 5-5 5"
    />
  </svg>
);

export const Expand01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m14 10 7-7m0 6V3h-6m-5 11-7 7m0-6v6h6"
    />
  </svg>
);

export const Expand02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 21 21 3M3 15v6h6M21 9V3h-6"
    />
  </svg>
);

export const Expand03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 14v2.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H14M10 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8V10m12-1 6-6m0 6V3h-6M9 15l-6 6m0-6v6h6"
    />
  </svg>
);

export const Expand04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 14v2.8c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C18.4802 20 17.9201 20 16.8 20H14M10 4H7.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C4 5.5198 4 6.08 4 7.2V10m11-1 6-6m0 6V3h-6M9 15l-6 6m0-6v6h6"
    />
  </svg>
);

export const Expand05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m15 9 6-6m0 6V3h-6M9 9 3 3m6 0H3v6m6 6-6 6m0-6v6h6m6-6 6 6m-6 0h6v-6"
    />
  </svg>
);

export const Expand06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 8 5-5m0 5V3h-5M8 8 3 3m5 0H3v5m5 8-5 5m0-5v5h5m8-5 5 5m-5 0h5v-5"
    />
  </svg>
);

export const FlipBackward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 9h13.5c2.4853 0 4.5 2.0147 4.5 4.5S18.9853 18 16.5 18H12m-5-5L3 9l4-4"
    />
  </svg>
);

export const FlipForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 9H7.5C5.0147 9 3 11.0147 3 13.5S5.0147 18 7.5 18H12m5-5 4-4-4-4"
    />
  </svg>
);

export const Infinity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18.1777 8c5.096 0 5.096 8 0 8-5.095 0-7.133-8-12.739-8-4.585 0-4.585 8 0 8 5.606 0 7.6441-8 12.7401-8z"
    />
  </svg>
);

export const RefreshCcw01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 10s2.005-2.7318 3.6338-4.3618S9.5136 3 12 3c4.9706 0 9 4.0294 9 9s-4.0294 9-9 9c-4.103 0-7.5649-2.7457-8.6482-6.5M8 10H2V4"
    />
  </svg>
);

export const RefreshCcw02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 10s.1213-.8492 3.636-4.364c3.5148-3.5147 9.2132-3.5147 12.728 0 1.2452 1.2453 2.0493 2.7647 2.4122 4.364M8 10H2V4m20 10s-.1213.8492-3.636 4.364c-3.5148 3.5147-9.2132 3.5147-12.728 0C4.3908 17.1187 3.5867 15.5993 3.2238 14M16 14h6v6"
    />
  </svg>
);

export const RefreshCcw03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 2s.8492.1213 4.364 3.636c3.5147 3.5148 3.5147 9.2132 0 12.728-1.2453 1.2452-2.7647 2.0493-4.364 2.4122M14 8V2h6M10 21.9998s-.8492-.1213-4.364-3.636c-3.5147-3.5148-3.5147-9.2132 0-12.728C6.8813 4.3906 8.4007 3.5865 10 3.2236M10 16v5.9998L4 22"
    />
  </svg>
);

export const RefreshCcw04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 18.8746c2.1213-1.5456 3.5-4.0491 3.5-6.8746 0-4.6944-3.8056-8.5-8.5-8.5h-.5m.5 17c-4.6944 0-8.5-3.8056-8.5-8.5 0-2.8256 1.3787-5.329 3.5-6.8746M11 22.4l2-2-2-2m2-12.8-2-2 2-2"
    />
  </svg>
);

export const RefreshCcw05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.5466 19.7675c2.3991 1.0644 5.2566 1.0066 7.7036-.4062 4.0655-2.3472 5.4584-7.5457 3.1112-11.6112l-.25-.433M4.6385 16.2502c-2.3472-4.0655-.9543-9.264 3.1112-11.6112 2.447-1.4128 5.3045-1.4706 7.7036-.4062M2.4934 16.3338l2.732.7321.7321-2.7321m12.0851-4.6679.7321-2.732 2.732.732"
    />
  </svg>
);

export const RefreshCw01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 10s-2.005-2.7318-3.6338-4.3618S14.4864 3 12 3c-4.9706 0-9 4.0294-9 9s4.0294 9 9 9c4.1031 0 7.5649-2.7457 8.6482-6.5M16 10h6V4"
    />
  </svg>
);

export const RefreshCw02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 14s.1213.8492 3.636 4.364c3.5148 3.5147 9.2132 3.5147 12.728 0 1.2452-1.2453 2.0493-2.7647 2.4122-4.364M8 14H2v6m20-10s-.1213-.8492-3.636-4.364c-3.5148-3.5147-9.2132-3.5147-12.728 0C4.3908 6.8813 3.5867 8.4007 3.2238 10M16 10h6V4"
    />
  </svg>
);

export const RefreshCw03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 22s.8492-.1213 4.364-3.636c3.5147-3.5148 3.5147-9.2132 0-12.728C17.1187 4.3908 15.5993 3.5867 14 3.2238M14 16v6h6M10 2.0002s-.8492.1213-4.364 3.636c-3.5147 3.5148-3.5147 9.2132 0 12.728 1.2453 1.2452 2.7647 2.0493 4.364 2.4122M10 8V2.0002L4 2"
    />
  </svg>
);

export const RefreshCw04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 5.1254c2.1213 1.5455 3.5 4.049 3.5 6.8746 0 4.6944-3.8056 8.5-8.5 8.5h-.5M7 18.8746C4.8787 17.329 3.5 14.8255 3.5 12c0-4.6944 3.8056-8.5 8.5-8.5h.5m.5 18.9-2-2 2-2M11 5.6l2-2-2-2"
    />
  </svg>
);

export const RefreshCw05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20.453 12.893c-.2778 2.6099-1.7566 5.0557-4.2036 6.4684-4.0655 2.3472-9.264.9543-11.6112-3.1112l-.25-.433m-.842-4.7102c.2777-2.6099 1.7565-5.0556 4.2035-6.4684 4.0655-2.3472 9.264-.9543 11.6112 3.1112l.25.433M3.4932 18.0662l.732-2.7321 2.732.7321m10.0852-8.132 2.732.732.7321-2.732"
    />
  </svg>
);

export const ReverseLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 7h10c3.3137 0 6 2.6863 6 6s-2.6863 6-6 6H4m4-8L4 7l4-4"
    />
  </svg>
);

export const ReverseRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 7H10c-3.3137 0-6 2.6863-6 6s2.6863 6 6 6h10m-4-8 4-4-4-4"
    />
  </svg>
);

export const SwitchHorizontal01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 17H4m4 4-4-4 4-4M4 7h16m-4 4 4-4-4-4"
    />
  </svg>
);

export const SwitchHorizontal02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 17h16m-4 4 4-4-4-4m4-6H4m4 4L4 7l4-4"
    />
  </svg>
);

export const SwitchVertical01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 4v16m4-4-4 4-4-4m-6 4V4m4 4L7 4 3 8"
    />
  </svg>
);

export const SwitchVertical02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 4v16m4-4-4 4-4-4m14 4V4m4 4-4-4-4 4"
    />
  </svg>
);

export const Bank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 9v8m4.5-8v8m5-8v8M19 9v8M3 18.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21h14.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.2401 21 19.9601 21 19.4v-.8c0-.56 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C20.2401 17 19.9601 17 19.4 17H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 17.7599 3 18.04 3 18.6m8.6529-15.5229-7.4 1.6445c-.447.0993-.6706.149-.8374.2692a1 1 0 0 0-.3344.4168C3 5.5966 3 5.8256 3 6.2835V7.4c0 .56 0 .8401.109 1.054.0959.1882.2489.3411.437.437C3.76 9 4.04 9 4.6 9h14.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 8.2401 21 7.96 21 7.4V6.2835c0-.458 0-.687-.0812-.876a1 1 0 0 0-.3343-.4167c-.1668-.1202-.3903-.1699-.8374-.2692l-7.4-1.6444c-.1295-.0288-.1943-.0432-.2597-.049a1 1 0 0 0-.1748 0c-.0654.0058-.1302.0202-.2597.049"
    />
  </svg>
);

export const BankNote01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 11v4m12-6v4m-1-9c2.4487 0 3.7731.3748 4.4321.6654.0878.0388.1317.0581.2583.179.0759.0724.2145.285.2501.3837.0595.1646.0595.2546.0595.4346v10.7484c0 .9088 0 1.3632-.1363 1.5968-.1386.2375-.2723.348-.5318.4393-.255.0897-.7699-.0092-1.7997-.2071A13.45 13.45 0 0 0 17 18c-3 0-6 2-10 2-2.4487 0-3.7731-.3748-4.4321-.6654-.0878-.0388-.1317-.0581-.2583-.179-.076-.0724-.2145-.285-.2501-.3837C2 18.6073 2 18.5173 2 18.3373V7.5889c0-.9088 0-1.3632.1363-1.5968.1386-.2375.2723-.348.5318-.4393.255-.0898.77.0092 1.7997.207A13.44 13.44 0 0 0 7 6c3 0 6-2 10-2m-2.5 8c0 1.3807-1.1193 2.5-2.5 2.5S9.5 13.3807 9.5 12s1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5"
    />
  </svg>
);

export const BankNote02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 10v4m12-4v4M2 8.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.4802 22 16.9201 22 15.8V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2M14.5 12c0 1.3807-1.1193 2.5-2.5 2.5S9.5 13.3807 9.5 12s1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5"
    />
  </svg>
);

export const BankNote03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 9h-2.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5h1c.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5H10m2-7v1m0 6v1m6-4h.01M6 12h.01M2 8.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.4802 22 16.9201 22 15.8V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2M18.5 12a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 18.5 12m-12 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);

export const Coins01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.9377 15.9377C19.3603 15.4795 22 12.548 22 9c0-3.866-3.134-7-7-7-3.548 0-6.4795 2.6397-6.9377 6.0623M16 15c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7"
    />
  </svg>
);

export const Coins02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.9377 15.9377C19.3603 15.4795 22 12.548 22 9c0-3.866-3.134-7-7-7-3.548 0-6.4795 2.6397-6.9377 6.0623M7.5 13 9 12v5.5m-1.5 0h3M16 15c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7"
    />
  </svg>
);

export const Coins03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.101 4C11.3636 2.7628 13.0927 2 15 2c3.866 0 7 3.134 7 7 0 1.9073-.7628 3.6365-2.0001 4.899M16 15c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7"
    />
  </svg>
);

export const Coins04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.101 4C11.3636 2.7628 13.0927 2 15 2c3.866 0 7 3.134 7 7 0 1.9073-.7628 3.6365-2.0001 4.899M7.5 13 9 12v5.5m-1.5 0h3M16 15c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7"
    />
  </svg>
);

export const CoinsHand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13.5295 8.3519A3.484 3.484 0 0 1 11.5 9C9.567 9 8 7.433 8 5.5S9.567 2 11.5 2c1.253 0 2.3522.6584 2.9705 1.6481M6 20.0872h2.6103c.3403 0 .6786.0405 1.0085.1214l2.7581.6703a4.28 4.28 0 0 0 1.8266.0425l3.0495-.5933c.8055-.1569 1.5466-.5427 2.1273-1.1076l2.1576-2.0988c.6161-.5983.6161-1.5693 0-2.1686-.5547-.5397-1.4332-.6004-2.0608-.1428l-2.5145 1.8346c-.3601.2632-.7983.4049-1.2489.4049h-2.4282 1.5456c.8711 0 1.5768-.6865 1.5768-1.5339v-.3068c0-.7036-.4923-1.3171-1.1938-1.4872l-2.3855-.5802A5.03 5.03 0 0 0 11.6431 13c-.9648 0-2.7112.7988-2.7112.7988L6 15.0249M20 6.5c0 1.933-1.567 3.5-3.5 3.5S13 8.433 13 6.5 14.567 3 16.5 3 20 4.567 20 6.5M2 14.6v5.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 22 3.04 22 3.6 22h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 21.2401 6 20.9601 6 20.4v-5.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C5.24 13 4.96 13 4.4 13h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 13.7599 2 14.0399 2 14.6"
    />
  </svg>
);

export const CoinsStacked01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 17c0 2.7614 2.2386 5 5 5s5-2.2386 5-5-2.2386-5-5-5-5 2.2386-5 5m0 0a4.978 4.978 0 0 1 1-3.0005V5m-1 12c0 .8254.2 1.604.5541 2.2901C11.7117 20.0018 9.7658 20.5 7.5 20.5c-3.0376 0-5.5-.8954-5.5-2V5m11 0c0 1.1046-2.4624 2-5.5 2S2 6.1046 2 5m11 0c0-1.1046-2.4624-2-5.5-2S2 3.8954 2 5m0 9c0 1.1046 2.4624 2 5.5 2 2.189 0 4.0793-.465 4.9646-1.1382M13 9.5c0 1.1046-2.4624 2-5.5 2S2 10.6046 2 9.5"
    />
  </svg>
);

export const CoinsStacked02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13 5c0 1.1046-2.4624 2-5.5 2S2 6.1046 2 5m11 0c0-1.1046-2.4624-2-5.5-2S2 3.8954 2 5m11 0v4.4572c-1.2215.3668-2 .9217-2 1.5428M2 5v12c0 1.1046 2.4624 2 5.5 2 1.3296 0 2.5491-.1716 3.5-.4571V11M2 9c0 1.1046 2.4624 2 5.5 2 1.3296 0 2.5491-.1716 3.5-.4571M2 13c0 1.1046 2.4624 2 5.5 2 1.3296 0 2.5491-.1716 3.5-.4571M22 11c0 1.1046-2.4624 2-5.5 2s-5.5-.8954-5.5-2m11 0c0-1.1046-2.4624-2-5.5-2s-5.5.8954-5.5 2m11 0v8c0 1.1046-2.4624 2-5.5 2s-5.5-.8954-5.5-2v-8m11 4c0 1.1046-2.4624 2-5.5 2s-5.5-.8954-5.5-2"
    />
  </svg>
);

export const CoinsStacked03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13 5c0 1.1046-2.4624 2-5.5 2S2 6.1046 2 5m11 0c0-1.1046-2.4624-2-5.5-2S2 3.8954 2 5m11 0v1.5M2 5v12c0 1.1046 2.4624 2 5.5 2m0-8q-.2528 0-.5-.0082C4.1967 10.9 2 10.0433 2 9m5.5 6C4.4624 15 2 14.1046 2 13m20-1.5c0 1.1046-2.4624 2-5.5 2s-5.5-.8954-5.5-2m11 0c0-1.1046-2.4624-2-5.5-2s-5.5.8954-5.5 2m11 0V19c0 1.1046-2.4624 2-5.5 2s-5.5-.8954-5.5-2v-7.5m11 3.75c0 1.1046-2.4624 2-5.5 2s-5.5-.8954-5.5-2"
    />
  </svg>
);

export const CoinsStacked04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 5c0 1.6569-3.5817 3-8 3S4 6.6569 4 5m16 0c0-1.6568-3.5817-3-8-3S4 3.3432 4 5m16 0v14c0 1.6569-3.5817 3-8 3s-8-1.3431-8-3V5m16 4.6666c0 1.6569-3.5817 3-8 3s-8-1.3431-8-3M20 14.33c0 1.6569-3.5817 3-8 3s-8-1.3431-8-3"
    />
  </svg>
);

export const CoinsSwap01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m6 2 2 2-2 2m2-2H6C3.7909 4 2 5.7909 2 8m16 14-2-2 2-2m-2 2h2c2.2091 0 4-1.7909 4-4m-8.5828-2.5828C14.1994 13.7908 15.0753 14 16 14c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6-6 2.6863-6 6c0 .9247.2092 1.8006.5828 2.5828M14 16c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6 2.6863-6 6-6 6 2.6863 6 6"
    />
  </svg>
);

export const CoinsSwap02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m6 2 2 2-2 2m2-2H6C3.7909 4 2 5.7909 2 8m16 14-2-2 2-2m-2 2h2c2.2091 0 4-1.7909 4-4M10.189 6.5C10.8551 3.9122 13.2042 2 16 2c3.3137 0 6 2.6863 6 6 0 2.7957-1.9121 5.1449-4.4999 5.811M14 16c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6 2.6863-6 6-6 6 2.6863 6 6"
    />
  </svg>
);

export const CreditCard01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 10H2m0-1.8v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.4802 22 16.9201 22 15.8V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2"
    />
  </svg>
);

export const CreditCard02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 10H2m9 4H6M2 8.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.4802 22 16.9201 22 15.8V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2"
    />
  </svg>
);

export const CreditCardCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 18 2 2 4-4m0-6H2m20 2V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19H12"
    />
  </svg>
);

export const CreditCardDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 18-3 3-3-3m3 3v-6m3-5H2m20 2V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19H12"
    />
  </svg>
);

export const CreditCardDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m15 17-3 3-3-3m3 3v-7m10-4H2m3.5 9h-.3c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.4802 2 15.9201 2 14.8V7.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 4 4.08 4 5.2 4h13.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C22 5.5198 22 6.08 22 7.2v7.6c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C20.4802 18 19.9201 18 18.8 18h-.3"
    />
  </svg>
);

export const CreditCardEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 10h20V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19H11m3.5 2 2.025-.405c.1765-.0353.2648-.053.3471-.0853a1 1 0 0 0 .2069-.1107c.0726-.0506.1362-.1142.2636-.2416L21.5 16c.5523-.5523.5523-1.4477 0-2s-1.4477-.5523-2 0l-4.1574 4.1574c-.1274.1274-.191.191-.2416.2636a1 1 0 0 0-.1107.2069c-.0323.0823-.05.1706-.0853.3471z"
    />
  </svg>
);

export const CreditCardLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20.25 17.5v-1.75c0-.9665-.7835-1.75-1.75-1.75s-1.75.7835-1.75 1.75v1.75M22 10H2m20 1V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19H11m5.6 2.5h3.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 20.7401 22 20.4601 22 19.9v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437c-.2139-.109-.4939-.109-1.054-.109h-3.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C15 18.2599 15 18.5399 15 19.1v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109"
    />
  </svg>
);

export const CreditCardMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 18h6m0-8H2m20 3.5V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19H12"
    />
  </svg>
);

export const CreditCardPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 21v-6m-3 3h6m0-8H2m20 2V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19H12"
    />
  </svg>
);

export const CreditCardRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 10H2m9 9h7.8c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 17.4802 22 16.9201 22 15.8V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H17m-4 12-2 2 2 2m-6-2H5.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C2 17.4802 2 16.9201 2 15.8V8.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 5 4.08 5 5.2 5H13m-2-2 2 2-2 2"
    />
  </svg>
);

export const CreditCardSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 22-1.5-1.5M22 10H2m20 2V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19h5.3m11-1c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5 1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5"
    />
  </svg>
);

export const CreditCardShield = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 10H2m20 1V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19h6.3m6.5 2s3-1.4299 3-3.5748v-2.5023l-2.1876-.7817a2.41 2.41 0 0 0-1.626 0L15 14.9229v2.5023C15 19.5701 18 21 18 21"
    />
  </svg>
);

export const CreditCardUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 18-3-3-3 3m3-3v6m3-11H2m20 2V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19H12"
    />
  </svg>
);

export const CreditCardUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m15 16-3-3-3 3m3-3v7M22 9H2m3.5 9h-.3c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.4802 2 15.9201 2 14.8V7.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 4 4.08 4 5.2 4h13.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C22 5.5198 22 6.08 22 7.2v7.6c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C20.4802 18 19.9201 18 18.8 18h-.3"
    />
  </svg>
);

export const CreditCardX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16.5 16 5 5m0-5-5 5M22 10H2m20 2V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19H12"
    />
  </svg>
);

export const Cryptocurrency01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.8779 20.0899a10 10 0 0 1-11.7557 0m10.2615-17.078a10 10 0 0 1 5.519 10.3796m-19.8053-.0001a10 10 0 0 1 5.519-10.3797M17.5 11.9998c0 3.0375-2.4624 5.5-5.5 5.5s-5.5-2.4625-5.5-5.5 2.4624-5.5 5.5-5.5 5.5 2.4624 5.5 5.5"
    />
  </svg>
);

export const Cryptocurrency02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.8779 20.0899a10 10 0 0 1-11.7557 0m10.2615-17.078a10 10 0 0 1 5.519 10.3796m-19.8053-.0001a10 10 0 0 1 5.519-10.3797m3.8179 3.5537-4.8686 4.8687c-.198.198-.297.297-.3341.4111a.5.5 0 0 0 0 .3091c.037.1141.136.2131.334.4111l4.8687 4.8687c.198.198.297.297.4112.3341a.5.5 0 0 0 .309 0c.1142-.0371.2132-.1361.4112-.3341l4.8686-4.8687c.198-.198.297-.297.3341-.4111a.5.5 0 0 0 0-.3091c-.0371-.1141-.1361-.2131-.3341-.4111l-4.8686-4.8687c-.198-.198-.297-.297-.4112-.334a.5.5 0 0 0-.309 0c-.1142.037-.2132.136-.4112.334"
    />
  </svg>
);

export const Cryptocurrency03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m2 2 2 2m18-2-2 2m2 18-2-2M2 22l2-2m-2-4h1.5M8 2v1.5M22 8h-1.5M16 22v-1.5m2-4.5h3.5M16 2v4M2 8h4m2 14v-4m8-6c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const Cryptocurrency04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m2 2 2 2m18-2-2 2m2 18-2-2M2 22l2-2m-2-4h1.5M8 2v1.5M22 8h-1.5M16 22v-1.5m2-4.5h3.5M16 2v4M2 8h4m2 14v-4m3.4343-10.4343-3.8686 3.8686c-.198.198-.297.297-.3341.4112a.5.5 0 0 0 0 .309c.037.1142.136.2132.334.4112l3.8687 3.8686c.198.198.297.297.4112.3341a.5.5 0 0 0 .309 0c.1142-.0371.2132-.1361.4112-.3341l3.8686-3.8686c.198-.198.297-.297.3341-.4112a.5.5 0 0 0 0-.309c-.0371-.1142-.1361-.2132-.3341-.4112l-3.8686-3.8686c-.198-.198-.297-.297-.4112-.3341a.5.5 0 0 0-.309 0c-.1142.037-.2132.136-.4112.334"
    />
  </svg>
);

export const CurrencyBitcoin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.5 2v2m0 16v2m4-20v2m0 16v2m-6-18H14c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4H7.5 15c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4H7.5m0-16h-2m2 0v16m0 0h-2"
    />
  </svg>
);

export const CurrencyBitcoinCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.5 7.5h4.25C14.9926 7.5 16 8.5074 16 9.75S14.9926 12 13.75 12H9.5h4.75c1.2426 0 2.25 1.0074 2.25 2.25s-1.0074 2.25-2.25 2.25H9.5m0-9H8m1.5 0v9m0 0H8M10 6v1.5m0 9V18m3-12v1.5m0 9V18m9-6c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const CurrencyDollar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 16c0 2.2091 1.7909 4 4 4h4c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4h-4c-2.2091 0-4-1.7909-4-4s1.7909-4 4-4h4c2.2091 0 4 1.7909 4 4m-6-6v20"
    />
  </svg>
);

export const CurrencyDollarCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.5 14.6667C8.5 15.9553 9.5447 17 10.8333 17H13c1.3807 0 2.5-1.1193 2.5-2.5S14.3807 12 13 12h-2c-1.3807 0-2.5-1.1193-2.5-2.5S9.6193 7 11 7h2.1667C14.4553 7 15.5 8.0447 15.5 9.3333M12 5.5V7m0 10v1.5M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const CurrencyEthereum = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m12 2 8 9-8 2-8-1.9999zm-8 9.0001 8-2M20 11l-8-2m0-7v7m-6.5 6 6.5001 7L18.5 15 12 16.5z"
    />
  </svg>
);

export const CurrencyEthereumCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m6.5 15.5 5.5002 2.5L17.5 15.5M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10m-15.5-.5 5.5002 2.5L17.5 11.5 12.0002 5z"
    />
  </svg>
);

export const CurrencyEuro = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 5.519C17.5176 4.2597 15.5975 3.5 13.5 3.5 8.8056 3.5 5 7.3056 5 12s3.8056 8.5 8.5 8.5c2.0975 0 4.0176-.7597 5.5-2.019M3 14h10M3 10h10"
    />
  </svg>
);

export const CurrencyEuroCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.3333 8.2732C14.4487 7.4814 13.2806 7 12 7c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5c1.2806 0 2.4487-.4814 3.3333-1.2732M6 13.5h5m-5-3h5M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const CurrencyPound = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.5 20.5h-11s3.5-2.7587 3.5-7c0-2.8275-2.0862-3.8388-2.1163-6.195.002-4.6642 5.6168-4.4162 7.5684-2.5624M6.5 13.5H15"
    />
  </svg>
);

export const CurrencyPoundCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 17.5H9s2-2.2556 2-5c0-1.5-1.0852-2.0133-1.1047-3.538.0013-3.018 3.6344-2.8575 4.8973-1.658M9 12.5h5m8-.5c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const CurrencyRuble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.5 11.5h6c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4h-6zm0 0h-2m7 4h-7M8.5 4v16.5"
    />
  </svg>
);

export const CurrencyRubleCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.5 6.5H14c1.3807 0 2.5 1.1193 2.5 2.5s-1.1193 2.5-2.5 2.5H9.5zm0 0v11m.25-6H8m5 3.25H8M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const CurrencyRupeeCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.5 9.9998h7M8.5 6.5h7M14 18.0002l-5.5-4.5L10 13.5c4.4447 0 4.4447-7 0-7M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const CurrencyRupee = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 3h12M6 8h12m-3.5 13L6 13h3c6.667 0 6.667-10 0-10"
    />
  </svg>
);

export const CurrencyYen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 20.5v-9m0 0 6.5001-8M12 11.5l-6.4999-8M18 11.5H6m11 4H7"
    />
  </svg>
);

export const CurrencyYenCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 18v-6m0 0 4-5m-4 5L8 7m8 5H8m7.5 3h-7M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const Diamond01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2.4995 9h19m-11.5-6-2 6 4 11.5 4-11.5-2-6m-1.3854 17.2625 8.9586-10.7503c.1519-.1822.2278-.2734.2568-.375a.5.5 0 0 0 0-.2744c-.029-.1017-.1049-.1928-.2568-.375l-4.3333-5.2c-.0882-.1058-.1322-.1587-.1863-.1967a.5.5 0 0 0-.1578-.074C16.8314 3 16.7626 3 16.6248 3H7.3742c-.1377 0-.2066 0-.2704.0172a.5.5 0 0 0-.1578.074c-.054.038-.0982.0908-.1863.1967l-4.3334 5.2c-.1518.1821-.2277.2732-.2567.375a.5.5 0 0 0 0 .2743c.029.1016.1049.1928.2567.375l8.9587 10.7503c.211.2533.3165.3799.4429.4261a.5.5 0 0 0 .3433 0c.1263-.0462.2319-.1728.4429-.4261"
    />
  </svg>
);

export const Diamond02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5.0003 22h14m-16.5-14h19m-11.5-6-2 6 4 10.5 4-10.5-2-6m-1.408 16.3489 8.9396-9.8336c.166-.1827.2491-.274.2821-.378a.5.5 0 0 0 .0061-.2825c-.0285-.1053-.1076-.2001-.2656-.3898L17.2402 2.288c-.0882-.1059-.1322-.1588-.1863-.1968a.5.5 0 0 0-.1579-.074C16.8322 2 16.7634 2 16.6256 2H7.375c-.1377 0-.2066 0-.2704.0172a.5.5 0 0 0-.1578.074c-.054.038-.0982.0908-.1863.1967L2.4462 7.465c-.158.1896-.237.2845-.2657.3898a.5.5 0 0 0 .0061.2825c.0331.104.1161.1953.2822.378l8.9396 9.8336c.2052.2257.3078.3386.4284.3803a.5.5 0 0 0 .3271 0c.1206-.0417.2232-.1546.4284-.3803"
    />
  </svg>
);

export const Gift01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 6v16m0-16H8.4643c-.521 0-1.0206-.2107-1.389-.5858S6.5 4.5304 6.5 4s.207-1.0391.5753-1.4142S7.9433 2 8.4643 2C11.2143 2 12 6 12 6m0 0h3.5357c.521 0 1.0206-.2107 1.389-.5858.3683-.375.5753-.8838.5753-1.4142s-.207-1.0391-.5753-1.4142S16.0567 2 15.5357 2C12.7857 2 12 6 12 6m8 5v7.8c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C18.4802 22 17.9201 22 16.8 22H7.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C4 20.4802 4 19.9201 4 18.8V11M2 7.6v1.8c0 .56 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 11 3.04 11 3.6 11h16.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 10.2401 22 9.96 22 9.4V7.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.2401 6 20.9601 6 20.4 6H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 6.76 2 7.04 2 7.6"
    />
  </svg>
);

export const Gift02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7m0 0h4.5A2.5003 2.5003 0 0 0 19 4.5 2.5 2.5 0 0 0 16.5 2C13 2 12 7 12 7m0 0v15M2 14h20M2 10.2v8.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 22 4.08 22 5.2 22h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.4802 22 19.9201 22 18.8v-8.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 7 19.9201 7 18.8 7H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 8.5198 2 9.08 2 10.2"
    />
  </svg>
);

export const PiggyBank01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 13c0 1.6484.6647 3.1415 1.7407 4.226.1037.1045.1556.1568.1863.2071a.47.47 0 0 1 .0593.144c.0136.0572.0136.1224.0136.2527V20.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C7.38 21 7.52 21 7.8 21h1.9c.28 0 .4201 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527v-.4c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185c.107-.0545.247-.0545.527-.0545h1.4c.2801 0 .4201 0 .527.0545a.5.5 0 0 1 .2185.2185c.0545.107.0545.247.0545.527v.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545H16.2c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C17 20.62 17 20.48 17 20.2v-.9757c0-.202 0-.3031.0288-.3842a.46.46 0 0 1 .1212-.1899c.0614-.0602.1655-.1085.3737-.2052a6.025 6.025 0 0 0 2.4274-2.0548c.1068-.1556.1601-.2334.2172-.2794a.46.46 0 0 1 .1704-.0898c.0702-.021.1535-.021.32-.021H21.2c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C22 15.62 22 15.48 22 15.2v-3.4143c0-.2665 0-.3998-.0495-.5027a.5.5 0 0 0-.2335-.2335C21.6141 11 21.4808 11 21.2143 11c-.193 0-.2895 0-.3672-.0262a.46.46 0 0 1-.2034-.13c-.0563-.0596-.1024-.1592-.1944-.3583a6.01 6.01 0 0 0-1.19-1.7115c-.1038-.1045-.1557-.1568-.1863-.2071a.46.46 0 0 1-.0593-.144C19 8.3657 19 8.3005 19 8.1702V7.0606c0-.36 0-.54-.075-.661a.5.5 0 0 0-.2885-.2178c-.137-.0388-.3101.0107-.6563.1096l-2.3725.6778c-.0404.0115-.0605.0173-.081.0213a.5.5 0 0 1-.0551.0078C15.4508 7 15.4298 7 15.3879 7h-.4289M5 13c0-2.3041 1.2986-4.3048 3.204-5.3101M5 13H4c-1.1046 0-2-.8954-2-2 0-.7403.4022-1.3866 1-1.7324M15 6.5c0 1.933-1.567 3.5-3.5 3.5S8 8.433 8 6.5 9.567 3 11.5 3 15 4.567 15 6.5"
    />
  </svg>
);

export const PiggyBank02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 13c0-3.3137 2.6862-6 5.9999-6m-6 6c0 1.6484.6648 3.1415 1.7408 4.226.1037.1045.1556.1568.1863.2071a.47.47 0 0 1 .0593.144c.0136.0572.0136.1224.0136.2527V20.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C7.38 21 7.52 21 7.8 21h1.9c.28 0 .4201 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527v-.4c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185c.107-.0545.247-.0545.527-.0545h1.4c.2801 0 .4201 0 .527.0545a.5.5 0 0 1 .2185.2185c.0545.107.0545.247.0545.527v.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545H16.2c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C17 20.62 17 20.48 17 20.2v-.9757c0-.202 0-.3031.0288-.3842a.46.46 0 0 1 .1212-.1899c.0614-.0602.1655-.1085.3737-.2052a6.025 6.025 0 0 0 2.4274-2.0548c.1068-.1556.1601-.2334.2172-.2794a.46.46 0 0 1 .1704-.0898c.0702-.021.1535-.021.32-.021H21.2c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C22 15.62 22 15.48 22 15.2v-3.4143c0-.2665 0-.3998-.0495-.5027a.5.5 0 0 0-.2335-.2335C21.6141 11 21.4808 11 21.2143 11c-.193 0-.2895 0-.3672-.0262a.46.46 0 0 1-.2034-.13c-.0563-.0596-.1024-.1592-.1944-.3583a6.01 6.01 0 0 0-1.19-1.7115c-.1038-.1045-.1557-.1568-.1863-.2071a.46.46 0 0 1-.0593-.144C19 8.3657 19 8.3005 19 8.1702V7.0606c0-.36 0-.54-.075-.661a.5.5 0 0 0-.2885-.2178c-.137-.0388-.3101.0107-.6563.1096l-2.3725.6778c-.0404.0115-.0605.0173-.081.0213a.5.5 0 0 1-.0551.0078C15.4508 7 15.4297 7 15.3874 7h-4.3875m-6 6H4c-1.1046 0-2-.8954-2-2 0-.7403.4022-1.3866 1-1.7324M10.9999 7h3.9647A3.5 3.5 0 0 0 15 6.5C15 4.567 13.433 3 11.5 3S8 4.567 8 6.5c0 .4172.073.8174.207 1.1884C9.041 7.2488 9.9913 7 10.9998 7"
    />
  </svg>
);

export const Receipt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C6.2798 3 7.1198 3 8.8 3h6.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C20 5.2798 20 6.1198 20 7.8V21l-2.75-2-2.5 2L12 19l-2.75 2-2.5-2L4 21z"
    />
  </svg>
);

export const ReceiptCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 10.5 2 2L15.5 8M20 21V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 3 16.8802 3 15.2 3H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 5.2798 4 6.1198 4 7.8V21l2.75-2 2.5 2L12 19l2.75 2 2.5-2z"
    />
  </svg>
);

export const Safe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 21h3m6 0h3m-.5-14.5v8M3 6.2v8.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 18 5.08 18 6.2 18h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 16.4802 21 15.9201 21 14.8V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C19.4802 3 18.9201 3 17.8 3H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 4.5198 3 5.08 3 6.2m8.5 4.3c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5S7.6193 8 9 8s2.5 1.1193 2.5 2.5"
    />
  </svg>
);

export const Sale01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 9h.01M15 15h.01M16 8l-8 8m14-4c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10M9.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m6 6a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 15.5 15"
    />
  </svg>
);

export const Sale02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 9h.01M15 15h.01M16 8l-8 8M7.3338 3.8187a3.832 3.832 0 0 0 2.1807-.9033c1.4322-1.2205 3.5388-1.2205 4.971 0a3.832 3.832 0 0 0 2.1807.9033c1.8759.1497 3.3654 1.6392 3.5151 3.515a3.832 3.832 0 0 0 .9033 2.1808c1.2205 1.4322 1.2205 3.5388 0 4.971a3.832 3.832 0 0 0-.9033 2.1807c-.1497 1.8759-1.6392 3.3654-3.5151 3.5151a3.832 3.832 0 0 0-2.1807.9033c-1.4322 1.2205-3.5388 1.2205-4.971 0a3.832 3.832 0 0 0-2.1807-.9033c-1.8759-.1497-3.3654-1.6392-3.5151-3.5151a3.832 3.832 0 0 0-.9033-2.1807c-1.2205-1.4322-1.2205-3.5388 0-4.971a3.832 3.832 0 0 0 .9033-2.1807c.1497-1.8759 1.6392-3.3654 3.515-3.5151M9.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m6 6a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 15.5 15"
    />
  </svg>
);

export const Sale03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 9h.01M15 15h.01M16 8l-8 8m9.9012-11.0015c.2059.498.6012.8939 1.0989 1.1006l1.7451.7229a2.0326 2.0326 0 0 1 1.1001 2.6558l-.7224 1.744a2.03 2.03 0 0 0 .0007 1.5565l.7211 1.7435a2.033 2.033 0 0 1-1.1004 2.6567l-1.7439.7224a2.033 2.033 0 0 0-1.1006 1.0989l-.7229 1.7452a2.0323 2.0323 0 0 1-2.6557 1.1001l-1.7439-.7224a2.032 2.032 0 0 0-1.5552.0012l-1.7452.7219a2.033 2.033 0 0 1-2.654-1.0994l-.7232-1.7458A2.033 2.033 0 0 0 5.0008 17.9l-1.7451-.7229a2.033 2.033 0 0 1-1.1006-2.6546l.7224-1.7439a2.033 2.033 0 0 0-.0012-1.5553L2.155 9.4768A2.0326 2.0326 0 0 1 3.2554 6.82l1.7439-.7224a2.033 2.033 0 0 0 1.1-1.0976l.7229-1.7453a2.0326 2.0326 0 0 1 2.6557-1.1l1.7439.7223a2.033 2.033 0 0 0 1.5553-.0011l1.7459-.7201a2.0325 2.0325 0 0 1 2.6553 1.0999l.7231 1.7457zM9.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m6 6a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 15.5 15"
    />
  </svg>
);

export const Sale04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 9h.01M15 15h.01M16 8l-8 8m1.2019 4.6009a1.24 1.24 0 0 1 .9199.2466l1.2033.9233a1.105 1.105 0 0 0 1.3476 0l1.2488-.9588a1.105 1.105 0 0 1 .8188-.2189l1.5621.2055a1.108 1.108 0 0 0 1.1677-.6744l.6011-1.4533a1.103 1.103 0 0 1 .5999-.6l1.4532-.6011c.4633-.1911.74-.671.6744-1.1677l-.1977-1.5055a1.24 1.24 0 0 1 .2466-.92l.9233-1.2033a1.1054 1.1054 0 0 0 0-1.3477l-.9589-1.2489a1.105 1.105 0 0 1-.2188-.8189l.2055-1.5621a1.108 1.108 0 0 0-.6744-1.1678l-1.4532-.601a1.103 1.103 0 0 1-.5999-.6l-.6011-1.4533a1.107 1.107 0 0 0-1.1677-.6745l-1.5621.2056a1.1 1.1 0 0 1-.8177-.2167l-1.2488-.9588a1.105 1.105 0 0 0-1.3476 0l-1.2488.9588a1.115 1.115 0 0 1-.8188.219l-1.5621-.2056a1.108 1.108 0 0 0-1.1677.6744l-.6 1.4533a1.117 1.117 0 0 1-.6.6l-1.4531.6c-.4633.1922-.74.671-.6744 1.1677l.2055 1.5622a1.11 1.11 0 0 1-.2188.8177l-.9588 1.2489a1.1054 1.1054 0 0 0 0 1.3477l.9588 1.2489a1.105 1.105 0 0 1 .2188.8188l-.2055 1.5622c-.0656.4967.211.9755.6744 1.1678l1.4532.6011c.2722.1122.4877.3277.6.5999l.601 1.4533c.1911.4634.671.74 1.1677.6745zM9.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m6 6a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 15.5 15"
    />
  </svg>
);

export const Scales01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 15v-.1502c0-.3165 0-.4747-.0242-.6289a2 2 0 0 0-.1064-.4007c-.0555-.1459-.134-.2833-.291-.558L18 7 6 9l-3.5784 6.2622c-.157.2747-.2355.4121-.291.558a2 2 0 0 0-.1064.4007C2 16.3751 2 16.5333 2 16.8498V17m0 0c0 2.2091 1.7909 4 4 4s4-1.7909 4-4m-8 0v-.2c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185C2.38 16 2.52 16 2.8 16h6.4c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185C10 16.38 10 16.52 10 16.8v.2M6 9l3.5784 6.2622c.157.2747.2355.4121.291.558.0492.1295.0849.2638.1064.4007.0242.1542.0242.3124.0242.6289V17m4-2v-.1502c0-.3165 0-.4747.0242-.6289a2 2 0 0 1 .1064-.4007c.0555-.1459.134-.2833.291-.558L18 7m-4 8c0 2.2091 1.7909 4 4 4s4-1.7909 4-4m-8 0v-.2c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185C14.38 14 14.52 14 14.8 14h6.4c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185C22 14.38 22 14.52 22 14.8v.2M12 3v5"
    />
  </svg>
);

export const Scales02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2.5005 13h6m7 0h6m-9.5-6v14m0-14c1.3807 0 2.5-1.1193 2.5-2.5m-2.5 2.5c-1.3807 0-2.5-1.1193-2.5-2.5m-5.5 16.5h16m-16-16.5h5.5m0 0c0-1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5m0 0h5.5M8.8809 14.3364C8.4802 15.8706 7.1186 17 5.5005 17S2.5207 15.8706 2.12 14.3364c-.0327-.1254-.049-.1881-.0507-.4385-.001-.1536.0561-.5075.1053-.653.0802-.2373.167-.3712.3406-.639L5.5005 8l2.9853 4.6059c.1736.2678.2604.4017.3406.639.0491.1455.1062.4994.1052.653-.0016.2504-.018.3131-.0507.4385m13 0C21.4802 15.8706 20.1186 17 18.5005 17s-2.9798-1.1294-3.3805-2.6636c-.0327-.1254-.0491-.1881-.0507-.4385-.0009-.1536.0561-.5075.1053-.653.0802-.2373.167-.3712.3406-.639L18.5005 8l2.9853 4.6059c.1736.2678.2604.4017.3406.639.0491.1455.1062.4994.1052.653-.0016.2504-.0179.3131-.0507.4385"
    />
  </svg>
);

export const ShoppingBag01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18.48 2.64c-.176-.2347-.264-.352-.3755-.4366a1 1 0 0 0-.3299-.165C17.64 2 17.4933 2 17.2 2H6.8c-.2933 0-.44 0-.5746.0385a1 1 0 0 0-.3299.1649c-.1115.0846-.1995.202-.3755.4366L3.96 4.72c-.309.412-.4635.618-.4599.7904a.5.5 0 0 0 .1916.3833C3.8276 6 4.085 6 4.6 6h14.8c.515 0 .7725 0 .9083-.1063a.5.5 0 0 0 .1916-.3833c.0036-.1724-.1509-.3784-.4599-.7904zm-12.96 0L3.64 5.1467c-.2375.3166-.3562.4749-.4405.6492a2 2 0 0 0-.1623.487C3 6.473 3 6.671 3 7.0668V18.8c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 22 5.08 22 6.2 22h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 20.4802 21 19.9201 21 18.8V7.0667c0-.3958 0-.5937-.0372-.7837a2 2 0 0 0-.1623-.487c-.0843-.1744-.203-.3327-.4405-.6493L18.48 2.64M16 10a4 4 0 0 1-1.1716 2.8284 3.9996 3.9996 0 0 1-5.6568 0A4 4 0 0 1 8 10"
    />
  </svg>
);

export const ShoppingBag02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.0004 9V6c0-2.2091-1.7909-4-4-4s-4 1.7909-4 4v3m-4.408 1.352-.6 6.4c-.1706 1.8197-.256 2.7295.046 3.4323a3 3 0 0 0 1.32 1.4495C5.0299 22 5.9437 22 7.7714 22h8.4579c1.8277 0 2.7415 0 3.413-.3662a3 3 0 0 0 1.32-1.4495c.302-.7028.2167-1.6126.0461-3.4323l-.6-6.4c-.1441-1.5366-.2161-2.305-.5617-2.8858a3 3 0 0 0-1.2917-1.1764C17.9444 6 17.1727 6 15.6293 6H8.3714c-1.5433 0-2.315 0-2.9256.2898A3 3 0 0 0 4.154 7.4662c-.3455.5808-.4176 1.3491-.5616 2.8858"
    />
  </svg>
);

export const ShoppingBag03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.9996 8a4 4 0 0 1-1.1716 2.8284 3.9996 3.9996 0 0 1-5.6568 0A4 4 0 0 1 7.9996 8m-4.3668-.5986-.7 8.4c-.1504 1.8045-.2256 2.7068.0795 3.4028a3 3 0 0 0 1.3195 1.434C5 21 5.9054 21 7.7162 21h8.5668c1.8107 0 2.7161 0 3.3844-.3618a3 3 0 0 0 1.3195-1.434c.305-.696.2298-1.5983.0795-3.4028l-.7-8.4c-.1294-1.5526-.1941-2.329-.5379-2.9165a3 3 0 0 0-1.2944-1.191C17.92 3 17.141 3 15.583 3H8.4162c-1.558 0-2.337 0-2.9511.2938a3 3 0 0 0-1.2944 1.191c-.3438.5876-.4085 1.364-.5379 2.9166"
    />
  </svg>
);

export const ShoppingCart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 2h1.3062c.246 0 .369 0 .468.0452a.5.5 0 0 1 .213.1848c.0587.0915.0761.2133.111.4569L4.5713 6m0 0 1.052 7.7314c.1334.9811.2001 1.4717.4347 1.8409.2067.3254.503.5841.8533.7451.3975.1826.8925.1826 1.8827.1826h8.5579c.9425 0 1.4138 0 1.799-.1696a2 2 0 0 0 .8413-.6962c.2386-.3466.3268-.8095.5032-1.7354l1.3236-6.9491c.0621-.3259.0931-.4888.0481-.6162a.5.5 0 0 0-.2197-.2655C21.5308 6 21.365 6 21.0332 6zM10 21c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1m8 0c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const ShoppingCart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.5001 17h10.8293c.9499 0 1.4249 0 1.812-.1716a2 2 0 0 0 .8433-.7038c.2381-.3502.3231-.8175.493-1.7522l1.3508-7.4293c.0589-.324.0884-.4859.0429-.6124a.5.5 0 0 0-.2198-.2633C21.5353 6 21.3707 6 21.0414 6H5.0001M2 2h1.3164c.2427 0 .364 0 .4622.0443a.5.5 0 0 1 .2121.1813c.0591.09.078.21.116.4496l2.7867 17.6496c.0378.2397.0568.3595.1159.4496a.5.5 0 0 0 .2121.1813C7.3196 21 7.441 21 7.6836 21H19"
    />
  </svg>
);

export const ShoppingCart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5.0001 14H18.136c1.0128 0 1.5192 0 1.9223-.1888a2 2 0 0 0 .8581-.768c.2322-.3799.2881-.8832.4-1.8898l.585-5.265c.0342-.3075.0512-.4612.0018-.5802a.5.5 0 0 0-.2201-.246C21.5702 5 21.4155 5 21.1062 5H4.5002M2 2h1.2484c.2647 0 .397 0 .5005.0503a.5.5 0 0 1 .2165.2035c.0567.1001.065.2322.0815.4963l.9062 14.4998c.0165.2641.0248.3962.0815.4963a.5.5 0 0 0 .2165.2035C5.3546 18 5.487 18 5.7516 18H19M7.5 21.5h.01m8.99 0h.01M8 21.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m9 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 17 21.5"
    />
  </svg>
);

export const Tag01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 8h.01M2 5.2v4.4745c0 .4892 0 .7338.0553.964.049.204.1298.3991.2394.5781.1237.2018.2966.3748.6426.7207l7.6686 7.6686c1.188 1.188 1.7821 1.7821 2.467 2.0046a3 3 0 0 0 1.8541 0c.685-.2225 1.2791-.8166 2.4671-2.0046l2.2118-2.2118c1.188-1.188 1.7821-1.7821 2.0046-2.4671a3 3 0 0 0 0-1.8541c-.2225-.6849-.8166-1.279-2.0046-2.467l-7.6686-7.6686c-.3459-.346-.5189-.5189-.7207-.6426a2 2 0 0 0-.5781-.2394C10.4083 2 10.1637 2 9.6745 2H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 3.5198 2 4.08 2 5.2M8.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);

export const Tag02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 8h.01M4.5627 2.9373 2.9373 4.5627c-.346.346-.5189.5189-.6426.7207a2 2 0 0 0-.2394.5781C2 6.0917 2 6.3363 2 6.8255v2.849c0 .4892 0 .7338.0553.964.049.204.1298.3991.2394.5781.1237.2018.2966.3748.6426.7207l7.6686 7.6686c1.188 1.188 1.7821 1.7821 2.467 2.0046a3 3 0 0 0 1.8541 0c.685-.2225 1.2791-.8166 2.4671-2.0046l2.2118-2.2118c1.188-1.188 1.7821-1.7821 2.0046-2.4671a3 3 0 0 0 0-1.8541c-.2225-.6849-.8166-1.279-2.0046-2.467l-7.6686-7.6686c-.3459-.346-.5189-.5189-.7207-.6426a2 2 0 0 0-.5781-.2394C10.4083 2 10.1637 2 9.6745 2h-2.849c-.4892 0-.7338 0-.964.0553a2 2 0 0 0-.578.2394c-.2019.1237-.3749.2966-.7208.6426M8.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);

export const Tag03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m21 11-7.5941-7.5941c-.5189-.5189-.7783-.7783-1.081-.9638a3 3 0 0 0-.8672-.3592C11.1124 2 10.7455 2 10.0118 2H6M3 8.7v1.9745c0 .4892 0 .7338.0553.964.049.204.1298.3991.2394.5781.1237.2018.2967.3748.6426.7207l7.8 7.8c.792.792 1.188 1.188 1.6447 1.3364a2 2 0 0 0 1.236 0c.4567-.1484.8527-.5444 1.6447-1.3364l2.4746-2.4746c.792-.792 1.188-1.188 1.3364-1.6447a2 2 0 0 0 0-1.236c-.1484-.4567-.5444-.8527-1.3364-1.6447l-7.3-7.3c-.3459-.346-.5189-.5189-.7207-.6426a2 2 0 0 0-.5781-.2394C9.9083 5.5 9.6637 5.5 9.1745 5.5H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 7.0198 3 7.58 3 8.7"
    />
  </svg>
);

export const Wallet01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 8.5H2m0 4h3.5467c.5402 0 .8103 0 1.0714.0466.2318.0413.458.1097.6738.204.2431.1061.4679.2559.9173.5556l.5816.3876c.4494.2997.6742.4495.9173.5556.2158.0943.4419.1627.6738.204.2611.0466.5312.0466 1.0714.0466h1.0934c.5402 0 .8103 0 1.0714-.0466a3 3 0 0 0 .6738-.204c.2431-.1061.4679-.2559.9173-.5556l.5816-.3876c.4494-.2997.6742-.4495.9173-.5556a3 3 0 0 1 .6738-.204c.2611-.0466.5312-.0466 1.0714-.0466H22M2 7.2v9.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 20 4.08 20 5.2 20h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 18.4802 22 17.9201 22 16.8V7.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 4 19.9201 4 18.8 4H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 5.5198 2 6.08 2 7.2"
    />
  </svg>
);

export const Wallet02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 7.9998V4.5005c0-.8318 0-1.2476-.1752-1.5032a1 1 0 0 0-.657-.4204c-.3055-.052-.6831.1223-1.4383.4709L4.859 7.1418c-.6735.3109-1.0103.4663-1.2569.7073a2 2 0 0 0-.4866.7606C3 8.9347 3 9.3055 3 10.0473v4.9525m13.5-.5h.01M3 11.1998v6.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.4278.218-.9879.218-2.108v-6.6c0-1.1201 0-1.6801-.218-2.108a2 2 0 0 0-.874-.874c-.4278-.218-.9879-.218-2.108-.218H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 9.5198 3 10.0798 3 11.1999m14 3.3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);

export const Wallet03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.5 14h.01M3 5v14c0 1.1046.8954 2 2 2h14c1.1046 0 2-.8954 2-2V9c0-1.1046-.8954-2-2-2H5c-1.1046 0-2-.8954-2-2m0 0c0-1.1046.8954-2 2-2h12m0 11a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 17 14"
    />
  </svg>
);

export const Wallet04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 9.5V7.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C18.4802 4 17.9201 4 16.8 4H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 5.5198 2 6.08 2 7.2v9.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 20 4.08 20 5.2 20h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C20 18.4802 20 17.9201 20 16.8v-2.3M15 12c0-.4647 0-.697.0384-.8902a2 2 0 0 1 1.5714-1.5714C16.803 9.5 17.0353 9.5 17.5 9.5h2c.4647 0 .697 0 .8902.0384a2 2 0 0 1 1.5714 1.5714C22 11.303 22 11.5353 22 12s0 .697-.0384.8902a2 2 0 0 1-1.5714 1.5714c-.1932.0384-.4255.0384-.8902.0384h-2c-.4647 0-.697 0-.8902-.0384a2 2 0 0 1-1.5714-1.5714C15 12.697 15 12.4647 15 12"
    />
  </svg>
);

export const Wallet05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 10H5m14 0 1.8642 3.1069c.4178.6963.6267 1.0445.7351 1.4193a3 3 0 0 1 .1124 1.0233c-.0246.3894-.153.7745-.4098 1.5449l-.2078.6235c-.3934 1.1802-.5902 1.7703-.955 2.2066a3 3 0 0 1-1.2033.8673C18.4065 21 17.7845 21 16.5404 21H7.4597c-1.2441 0-1.8661 0-2.3954-.2082a3 3 0 0 1-1.2033-.8673c-.3649-.4363-.5616-1.0264-.955-2.2066l-.2078-.6235c-.2568-.7704-.3852-1.1555-.4098-1.5449a3 3 0 0 1 .1123-1.0234c.1085-.3747.3174-.7229.7352-1.4192L5 10m14 0 .4173-1.4604c.1978-.6924.2967-1.0386.219-1.3125a1 1 0 0 0-.4353-.5771c-.242-.15-.602-.15-1.3221-.15H6.1212c-.7201 0-1.0801 0-1.3222.15a1 1 0 0 0-.4353.577c-.0777.274.0212.6202.219 1.3125L5 10m7-3.5H8.4643c-.521 0-1.0206-.2107-1.389-.5858C6.707 5.5392 6.5 5.0304 6.5 4.5s.207-1.0391.5754-1.4142c.3683-.375.868-.5858 1.389-.5858C11.2142 2.5 12 6.5 12 6.5m0 0h3.5357c.521 0 1.0206-.2107 1.389-.5858S17.5 5.0304 17.5 4.5s-.2069-1.0391-.5753-1.4142-.868-.5858-1.389-.5858c-2.75 0-3.5357 4-3.5357 4"
    />
  </svg>
);

export const Activity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 12h-4l-3 9L9 3l-3 9H2"
    />
  </svg>
);

export const ActivityHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.5 11.5h-1l-1.5 3-2-6-1.5 3h-1m3.4932-6.3642C9.9938 2.7984 6.6598 2.1696 4.1547 4.31s-2.8577 5.719-.8905 8.2504c1.4859 1.912 5.707 5.7506 7.6838 7.5145.3634.3242.5451.4864.7578.5502.1847.0554.39.0554.5747 0 .2127-.0638.3944-.226.7578-.5502 1.9767-1.7639 6.1979-5.6025 7.6838-7.5145 1.9672-2.5314 1.6576-6.1325-.8905-8.2504-2.5481-2.1178-5.8391-1.5116-7.8384.8258"
    />
  </svg>
);

export const Anchor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 8c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3432-3 3 1.3431 3 3 3m0 0v14m0 0A10.0003 10.0003 0 0 1 2 12h3m7 10a10.0003 10.0003 0 0 0 10-10h-3"
    />
  </svg>
);

export const Archive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 7.9966c-.164-.0042-.2831-.0137-.3902-.035a2 2 0 0 1-1.5714-1.5714C2 6.197 2 5.9647 2 5.5s0-.697.0384-.8902a2 2 0 0 1 1.5714-1.5714C3.803 3 4.0353 3 4.5 3h15c.4647 0 .697 0 .8902.0384a2 2 0 0 1 1.5714 1.5714C22 4.803 22 5.0353 22 5.5s0 .697-.0384.8902a2 2 0 0 1-1.5714 1.5714c-.1071.0213-.2262.0308-.3902.035M10 13h4M4 8h16v8.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 21 16.8802 21 15.2 21H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 18.7202 4 17.8802 4 16.2z"
    />
  </svg>
);

export const Asterisk01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 2v20m7.0711-17.071L4.9289 19.071M22 12H2m17.0711 7.0711L4.9289 4.9289"
    />
  </svg>
);

export const Asterisk02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 4v16m6-14L6 18m14-6H4m14 6L6 6"
    />
  </svg>
);

export const AtSign = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94M16 12c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const Bookmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C7.2798 3 8.1198 3 9.8 3h4.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C19 5.2798 19 6.1198 19 7.8V21l-7-4-7 4z"
    />
  </svg>
);

export const BookmarkAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 13V7m-3 3h6m4 11V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C16.7202 3 15.8802 3 14.2 3H9.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C5 5.2798 5 6.1198 5 7.8V21l7-4z"
    />
  </svg>
);

export const BookmarkCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 10.5 2 2L15.5 8M19 21V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C16.7202 3 15.8802 3 14.2 3H9.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C5 5.2798 5 6.1198 5 7.8V21l7-4z"
    />
  </svg>
);

export const BookmarkMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 10h6m4 11V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C16.7202 3 15.8802 3 14.2 3H9.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C5 5.2798 5 6.1198 5 7.8V21l7-4z"
    />
  </svg>
);

export const BookmarkX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9.5 7.5 5 5m0-5-5 5M19 21V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C16.7202 3 15.8802 3 14.2 3H9.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C5 5.2798 5 6.1198 5 7.8V21l7-4z"
    />
  </svg>
);

export const Building01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 21v-5.4c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C14.2401 14 13.9601 14 13.4 14h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 14.7599 9 15.0399 9 15.6V21m10 0V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C17.4802 3 16.9201 3 15.8 3H8.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C5 4.5198 5 5.08 5 6.2V21m16 0H3M9.5 8h.01m4.99 0h.01M10 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);

export const Building02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 21v-5.4c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C14.2401 14 13.9601 14 13.4 14h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 14.7599 9 15.0399 9 15.6V21M3 7c0 1.6569 1.3431 3 3 3s3-1.3431 3-3c0 1.6569 1.3431 3 3 3s3-1.3431 3-3c0 1.6569 1.3431 3 3 3s3-1.3431 3-3M6.2 21h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.4802 21 18.9201 21 17.8V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C19.4802 3 18.9201 3 17.8 3H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 4.5198 3 5.08 3 6.2v11.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 21 5.08 21 6.2 21"
    />
  </svg>
);

export const Building03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.5 7h2.75M7.5 11h2.75M7.5 15h2.75m3.5-8h2.75m-2.75 4h2.75m-2.75 4h2.75m3.5 6V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C18.4802 3 17.9201 3 16.8 3H7.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C4 4.5198 4 5.08 4 6.2V21m18 0H2"
    />
  </svg>
);

export const Building04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.5 7h5m-5 4h5m-5 4h5m3.5 6V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C16.4802 3 15.9201 3 14.8 3H9.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C6 4.5198 6 5.08 6 6.2V21m14 0H4"
    />
  </svg>
);

export const Building05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13 11h4.8c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874.218.4278.218.9879.218 2.108V21m-8 0V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C11.4802 3 10.9201 3 9.8 3H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 4.5198 3 5.08 3 6.2V21m19 0H2M6.5 7h3m-3 4h3m-3 4h3"
    />
  </svg>
);

export const Building06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11 11H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 12.5198 3 13.0799 3 14.2V21m18 0V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C19.4802 3 18.9201 3 17.8 3h-3.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C11 4.5198 11 5.08 11 6.2V21m11 0H2M14.5 7h3m-3 4h3m-3 4h3"
    />
  </svg>
);

export const Building07 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.5 11H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 11.7599 3 12.0399 3 12.6V21m13.5-10h2.9c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054V21m-4.5 0V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C14.9802 3 14.4201 3 13.3 3h-2.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C7.5 4.5198 7.5 5.08 7.5 6.2V21M22 21H2m9-14h2m-2 4h2m-2 4h2"
    />
  </svg>
);

export const Building08 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 21h18M6 18v-8m4 8v-8m4 8v-8m4 8v-8m2-3-7.576-4.735c-.1538-.0962-.2307-.1442-.3132-.163a.5.5 0 0 0-.2216 0c-.0825.0188-.1594.0668-.3132.163L4 7z"
    />
  </svg>
);

export const Check = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 6 9 17l-5-5"
    />
  </svg>
);

export const CheckCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m7.5 12 3 3 6-6m5.5 3c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const CheckCircleBroken = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 11.0857v.92a10 10 0 0 1-1.9907 5.9818 9.999 9.999 0 0 1-11.4748 3.3928A10 10 0 1 1 16.07 2.8657M22 4 12 14.01l-3-3"
    />
  </svg>
);

export const CheckDone01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m6 15 2 2 4.5-4.5M8 8V5.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C9.5198 2 10.08 2 11.2 2h7.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C22 3.5198 22 4.08 22 5.2v7.6c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C20.4802 16 19.9201 16 18.8 16H16M5.2 22h7.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C16 20.4802 16 19.9201 16 18.8v-7.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C14.4802 8 13.9201 8 12.8 8H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 9.5198 2 10.08 2 11.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 22 4.08 22 5.2 22"
    />
  </svg>
);

export const CheckDone02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 8V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C14.4802 2 13.9201 2 12.8 2H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 3.5198 2 4.08 2 5.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 16 4.08 16 5.2 16H8m4-1 2 2 4.5-4.5M11.2 22h7.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.4802 22 19.9201 22 18.8v-7.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 8 19.9201 8 18.8 8h-7.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C8 9.5198 8 10.08 8 11.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C9.5198 22 10.08 22 11.2 22"
    />
  </svg>
);

export const CheckHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 11 2 2 4.5-4.5m-3.5068-3.3642C9.9938 2.7984 6.6598 2.1696 4.1547 4.31s-2.8577 5.719-.8905 8.2504c1.4859 1.912 5.707 5.7506 7.6838 7.5145.3634.3242.5451.4864.7578.5502.1847.0554.39.0554.5747 0 .2127-.0638.3944-.226.7578-.5502 1.9767-1.7639 6.1979-5.6025 7.6838-7.5145 1.9672-2.5314 1.6576-6.1325-.8905-8.2504-2.5481-2.1178-5.8391-1.5116-7.8384.8258"
    />
  </svg>
);

export const CheckSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m7.5 12 3 3 6-6M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const CheckSquareBroken = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 11 3 3L22 4m-6-1H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V12"
    />
  </svg>
);

export const CheckVerified01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 12 2 2 4.5-4.5M7.3338 3.8187a3.832 3.832 0 0 0 2.1807-.9033c1.4322-1.2205 3.5388-1.2205 4.971 0a3.832 3.832 0 0 0 2.1807.9033c1.8759.1497 3.3654 1.6392 3.5151 3.515a3.832 3.832 0 0 0 .9033 2.1808c1.2205 1.4322 1.2205 3.5388 0 4.971a3.832 3.832 0 0 0-.9033 2.1807c-.1497 1.8759-1.6392 3.3654-3.5151 3.5151a3.832 3.832 0 0 0-2.1807.9033c-1.4322 1.2205-3.5388 1.2205-4.971 0a3.832 3.832 0 0 0-2.1807-.9033c-1.8759-.1497-3.3654-1.6392-3.5151-3.5151a3.832 3.832 0 0 0-.9033-2.1807c-1.2205-1.4322-1.2205-3.5388 0-4.971a3.832 3.832 0 0 0 .9033-2.1807c.1497-1.8759 1.6392-3.3654 3.515-3.5151"
    />
  </svg>
);

export const CheckVerified02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 12 2 2 4.5-4.5m2.4012-4.5015c.2059.498.6012.8939 1.0989 1.1006l1.7451.7229a2.0326 2.0326 0 0 1 1.1001 2.6558l-.7224 1.744a2.03 2.03 0 0 0 .0007 1.5565l.7211 1.7435a2.033 2.033 0 0 1-1.1004 2.6567l-1.7439.7224a2.033 2.033 0 0 0-1.1006 1.0989l-.7229 1.7452a2.0323 2.0323 0 0 1-2.6557 1.1001l-1.7439-.7224a2.032 2.032 0 0 0-1.5552.0012l-1.7452.7219a2.033 2.033 0 0 1-2.654-1.0994l-.7232-1.7458A2.033 2.033 0 0 0 5.0008 17.9l-1.7451-.7229a2.033 2.033 0 0 1-1.1006-2.6546l.7224-1.7439a2.033 2.033 0 0 0-.0012-1.5553L2.155 9.4768A2.0326 2.0326 0 0 1 3.2554 6.82l1.7439-.7224a2.033 2.033 0 0 0 1.1-1.0976l.7229-1.7453a2.0326 2.0326 0 0 1 2.6557-1.1l1.7439.7223a2.033 2.033 0 0 0 1.5553-.0011l1.7459-.7201a2.0325 2.0325 0 0 1 2.6553 1.0999l.7231 1.7457z"
    />
  </svg>
);

export const CheckVerified03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 12 2 2 4.5-4.5M9.2019 20.6009a1.24 1.24 0 0 1 .9199.2466l1.2033.9233a1.105 1.105 0 0 0 1.3476 0l1.2488-.9588a1.105 1.105 0 0 1 .8188-.2189l1.5621.2055a1.108 1.108 0 0 0 1.1677-.6744l.6011-1.4533a1.103 1.103 0 0 1 .5999-.6l1.4532-.6011c.4633-.1911.74-.671.6744-1.1677l-.1977-1.5055a1.24 1.24 0 0 1 .2466-.92l.9233-1.2033a1.1054 1.1054 0 0 0 0-1.3477l-.9589-1.2489a1.105 1.105 0 0 1-.2188-.8189l.2055-1.5621a1.108 1.108 0 0 0-.6744-1.1678l-1.4532-.601a1.103 1.103 0 0 1-.5999-.6l-.6011-1.4533a1.107 1.107 0 0 0-1.1677-.6745l-1.5621.2056a1.1 1.1 0 0 1-.8177-.2167l-1.2488-.9588a1.105 1.105 0 0 0-1.3476 0l-1.2488.9588a1.115 1.115 0 0 1-.8188.219l-1.5621-.2056a1.108 1.108 0 0 0-1.1677.6744l-.6 1.4533a1.117 1.117 0 0 1-.6.6l-1.4531.6c-.4633.1922-.74.671-.6744 1.1677l.2055 1.5622a1.11 1.11 0 0 1-.2188.8177l-.9588 1.2489a1.1054 1.1054 0 0 0 0 1.3477l.9588 1.2489a1.105 1.105 0 0 1 .2188.8188l-.2055 1.5622c-.0656.4967.211.9755.6744 1.1678l1.4532.6011c.2722.1122.4877.3277.6.5999l.601 1.4533c.1911.4634.671.74 1.1677.6745z"
    />
  </svg>
);

export const CloudBlank01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.5 19C4.0147 19 2 16.9853 2 14.5c0-2.3436 1.7915-4.2687 4.0797-4.4806C6.5478 7.1721 9.0202 5 12 5s5.4522 2.1721 5.9203 5.0194C20.2085 10.2313 22 12.1564 22 14.5c0 2.4853-2.0147 4.5-4.5 4.5z"
    />
  </svg>
);

export const CloudBlank02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.5 19C5.3579 19 2 15.6421 2 11.5S5.3579 4 9.5 4c2.8827 0 5.3855 1.6263 6.641 4.0115A5.6 5.6 0 0 1 16.5 8c3.0376 0 5.5 2.4624 5.5 5.5S19.5376 19 16.5 19z"
    />
  </svg>
);

export const Copy01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 15c-.9319 0-1.3978 0-1.7654-.1522a2 2 0 0 1-1.0824-1.0824C2 13.3978 2 12.9319 2 12V5.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 2 4.08 2 5.2 2H12c.9319 0 1.3978 0 1.7654.1522.49.203.8794.5924 1.0824 1.0824C15 3.6022 15 4.0681 15 5m-2.8 17h6.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.4802 22 19.9201 22 18.8v-6.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 9 19.9201 9 18.8 9h-6.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C9 10.5198 9 11.0799 9 12.2v6.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218"
    />
  </svg>
);

export const Copy02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 8V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C14.4802 2 13.9201 2 12.8 2H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 3.5198 2 4.08 2 5.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 16 4.08 16 5.2 16H8m3.2 6h7.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.4802 22 19.9201 22 18.8v-7.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 8 19.9201 8 18.8 8h-7.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C8 9.5198 8 10.08 8 11.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C9.5198 22 10.08 22 11.2 22"
    />
  </svg>
);

export const Copy03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 8V5.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C9.5198 2 10.08 2 11.2 2h7.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C22 3.5198 22 4.08 22 5.2v7.6c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C20.4802 16 19.9201 16 18.8 16H16M5.2 22h7.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C16 20.4802 16 19.9201 16 18.8v-7.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C14.4802 8 13.9201 8 12.8 8H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 9.5198 2 10.08 2 11.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 22 4.08 22 5.2 22"
    />
  </svg>
);

export const Copy04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 16v2.8c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C14.4802 22 13.9201 22 12.8 22H5.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C2 20.4802 2 19.9201 2 18.8v-7.6c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 8 4.08 8 5.2 8H8m3.2 8h7.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 14.4802 22 13.9201 22 12.8V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 2 19.9201 2 18.8 2h-7.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C8 3.5198 8 4.08 8 5.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C9.5198 16 10.08 16 11.2 16"
    />
  </svg>
);

export const Copy05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 16v2.8c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C9.5198 22 10.08 22 11.2 22h7.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 20.4802 22 19.9201 22 18.8v-7.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 8 19.9201 8 18.8 8H16M5.2 16h7.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C16 14.4802 16 13.9201 16 12.8V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C14.4802 2 13.9201 2 12.8 2H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 3.5198 2 4.08 2 5.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 16 4.08 16 5.2 16"
    />
  </svg>
);

export const Copy06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.5 3h7.1c2.2402 0 3.3603 0 4.216.436a4 4 0 0 1 1.748 1.748C21 6.0397 21 7.1598 21 9.4v7.1M6.2 21h8.1c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.4278.218-.9879.218-2.108V9.7c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C15.9802 6.5 15.4201 6.5 14.3 6.5H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 8.0198 3 8.58 3 9.7v8.1c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 21 5.08 21 6.2 21"
    />
  </svg>
);

export const Copy07 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.5 2.0028c-.675.0091-1.0803.0482-1.408.2152a2 2 0 0 0-.874.874c-.167.3277-.206.733-.2152 1.408M19.5 2.0028c.6751.0091 1.0803.0482 1.408.2152.3763.1917.6823.4977.874.874.167.3277.2061.733.2152 1.408m0 9c-.0091.675-.0482 1.0803-.2152 1.408a2 2 0 0 1-.874.874c-.3277.167-.7329.2061-1.408.2152M22 8v2m-7.9999-8H16M5.2 22h7.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C16 20.4802 16 19.9201 16 18.8v-7.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C14.4802 8 13.9201 8 12.8 8H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 9.5198 2 10.08 2 11.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 22 4.08 22 5.2 22"
    />
  </svg>
);

export const Divide01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 12h16m-7-6c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1m0 12c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const Divide02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 12h16m-6-6c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m0 12c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2"
    />
  </svg>
);

export const Divide03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 8h.01M12 16h.01M7 12h10m-4.5-4a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 8a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 12.5 16m9.5-4c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const DotsGrid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 6c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1M12 13c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1M12 20c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1M19 6c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1M19 13c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1M19 20c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1M5 6c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1M5 13c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1M5 20c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1"
    />
  </svg>
);

export const DotsHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 13c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1M19 13c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1M5 13c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1"
    />
  </svg>
);

export const DotsVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 13c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1M12 6c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1M12 20c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1"
    />
  </svg>
);

export const Download01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 15v1.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V15m4-5 5 5 5-5m-5 5V3"
    />
  </svg>
);

export const Download02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 21H3m3-10 6 6 6-6m-6 6V3"
    />
  </svg>
);

export const Download03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 12-4 4-4-4m4 4V8m10 4c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const Share04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 3h6v6m0-6-8 8m-3-6H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 7.2798 3 8.1198 3 9.8v6.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 18.7202 19 17.8802 19 16.2V14"
    />
  </svg>
);

export const Share05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 6h-3.2c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C13 8.2798 13 9.1198 13 10.8V12m5-3 3-3-3-3m-8 0H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V14"
    />
  </svg>
);

export const Share06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20.7914 12.6074c.2441-.2093.3661-.3139.4109-.4384a.5.5 0 0 0 0-.338c-.0448-.1245-.1668-.2292-.4109-.4384L12.3206 4.132c-.4202-.3602-.6303-.5403-.8082-.5447a.5.5 0 0 0-.4.184C11 3.909 11 4.1858 11 4.7392v4.2953a9.6657 9.6657 0 0 0-8 9.5164v.6119a11.4 11.4 0 0 1 8-4.0924v4.1901c0 .5535 0 .8302.1124.9682a.5.5 0 0 0 .4.1839c.1779-.0044.388-.1845.8082-.5447z"
    />
  </svg>
);

export const Share07 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m8.59 13.51 6.83 3.98m-.01-10.98-6.82 3.98M21 5c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3432 3 3M9 12c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3m12 7c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
    />
  </svg>
);

export const SlashCircle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m4.93 4.93 14.14 14.14M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const SlashCircle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m4.93 4.93 14.14 14.14m-.0001-14.14-14.14 14.14M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const SlashDivider = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7 22 17 2"
    />
  </svg>
);

export const SlashOctagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m4.93 4.93 14.14 14.14M2 8.5227v6.9546c0 .2445 0 .3668.0276.4819a1 1 0 0 0 .1198.2891c.0618.1009.1483.1874.3212.3603l4.9228 4.9228c.173.1729.2594.2594.3603.3212a1 1 0 0 0 .289.1198C8.156 22 8.2783 22 8.5228 22h6.9546c.2445 0 .3668 0 .4819-.0276a1 1 0 0 0 .2891-.1198c.1009-.0618.1874-.1483.3603-.3212l4.9228-4.9228c.1729-.1729.2594-.2594.3212-.3603a1 1 0 0 0 .1198-.2891C22 15.8441 22 15.7218 22 15.4773V8.5227c0-.2446 0-.3668-.0276-.482a1 1 0 0 0-.1198-.289c-.0618-.1009-.1483-.1874-.3212-.3603l-4.9228-4.9228c-.1729-.173-.2594-.2594-.3603-.3212a1 1 0 0 0-.2891-.1198C15.8441 2 15.7218 2 15.4773 2H8.5227c-.2446 0-.3668 0-.482.0276a1 1 0 0 0-.289.1198c-.1009.0618-.1874.1483-.3603.3212L2.4686 7.3914c-.173.173-.2594.2594-.3212.3603a1 1 0 0 0-.1198.289C2 8.156 2 8.2783 2 8.5228"
    />
  </svg>
);

export const Speedometer01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 2v2.5M12 2C6.4772 2 2 6.4772 2 12M12 2c5.5228 0 10 4.4772 10 10m-10 7.5V22m0 0c5.5228 0 10-4.4772 10-10M12 22C6.4772 22 2 17.5228 2 12m2.5 0H2m20 0h-2.5m-.4216 7.0784-1.7737-1.7737m-12.383 1.7737 1.7754-1.7755M4.9217 5l1.7365 1.7364M19.0784 5l-5.5785 5.5M14 12c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2"
    />
  </svg>
);

export const Speedometer02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12m20 0c0-5.5228-4.4772-10-10-10m10 10h-2.5M2 12C2 6.4772 6.4772 2 12 2M2 12h2.5M12 2v2.5m7.0784.5-5.5785 5.5m5.5785 8.5784-.2039-.2039c-.6918-.6918-1.0377-1.0377-1.4414-1.2851a4 4 0 0 0-1.1562-.4789C15.8166 17 15.3274 17 14.349 17H9.651c-.9784 0-1.4676 0-1.928.1106a4 4 0 0 0-1.1561.4789c-.4037.2474-.7496.5933-1.4414 1.2851l-.2039.2038M4.9216 5l1.7365 1.7364M14 12c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2"
    />
  </svg>
);

export const Speedometer03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 12c0-3.866 3.134-7 7-7m4.4999 2.5-4.5 4.5M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10m-9 0c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const Speedometer04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.7453 16C18.5362 14.8661 19 13.4872 19 12a7.03 7.03 0 0 0-.1611-1.5M6.2547 16C5.4638 14.8662 5 13.4872 5 12c0-3.866 3.134-7 7-7 .4221 0 .8355.0374 1.2371.109M16.4999 7.5l-4.5 4.5M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10m-9 0c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const Target01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 12c0 5.5228-4.4772 10-10 10m10-10c0-5.5228-4.4772-10-10-10m10 10h-4m-6 10C6.4772 22 2 17.5228 2 12m10 10v-4M2 12C2 6.4772 6.4772 2 12 2M2 12h4m6-10v4"
    />
  </svg>
);

export const Target02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 12h-4M6 12H2m10-6V2m0 20v-4m8-6c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8 3.5817-8 8-8 8 3.5817 8 8"
    />
  </svg>
);

export const Target03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 12h-4M6 12H2m10-6V2m0 20v-4m8-6c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8 3.5817-8 8-8 8 3.5817 8 8m-5 0c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
    />
  </svg>
);

export const Target04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 8V5l3-3 1 2 2 1-3 3zm0 0-4 3.9999M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2m5 10c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5"
    />
  </svg>
);

export const Target05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 18c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6-6 2.6863-6 6 2.6863 6 6 6"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 14c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2"
    />
  </svg>
);

export const Toggle01Left = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 17h10c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5H7m0 10c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5m0 10c2.7614 0 5-2.2386 5-5S9.7614 7 7 7"
    />
  </svg>
);

export const Toggle01Right = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 17H7c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5h10m0 10c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5m0 10c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5"
    />
  </svg>
);

export const Toggle02Left = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.0005 16H18c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4h-7.9995M12 12c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5"
    />
  </svg>
);

export const Toggle02Right = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13.9995 16H6c-2.2091 0-4-1.7909-4-4s1.7909-4 4-4h7.9995m8 4c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5"
    />
  </svg>
);

export const Toggle03Left = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 12c0-3.3137 2.6863-6 6-6h8c3.3137 0 6 2.6863 6 6s-2.6863 6-6 6H8c-3.3137 0-6-2.6863-6-6"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 14.5c1.3807 0 2.5-1.1193 2.5-2.5S9.3807 9.5 8 9.5 5.5 10.6193 5.5 12s1.1193 2.5 2.5 2.5"
    />
  </svg>
);

export const Toggle03Right = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 12c0-3.3137 2.6863-6 6-6h8c3.3137 0 6 2.6863 6 6s-2.6863 6-6 6H8c-3.3137 0-6-2.6863-6-6"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 14.5c1.3807 0 2.5-1.1193 2.5-2.5S17.3807 9.5 16 9.5s-2.5 1.1193-2.5 2.5 1.1193 2.5 2.5 2.5"
    />
  </svg>
);

export const Tool01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.6314 7.6314c-.3961-.396-.5941-.594-.6683-.8224a1 1 0 0 1 0-.618c.0742-.2283.2722-.4264.6683-.8224l2.8383-2.8383C17.7165 2.1896 16.8804 2 16 2c-3.3137 0-6 2.6863-6 6 0 .491.059.9683.1702 1.425.1192.4892.1788.7338.1682.8883-.0111.1618-.0352.2479-.1098.3918-.0712.1375-.2078.274-.4808.5471L3.5 17.5c-.8284.8284-.8284 2.1716 0 3s2.1716.8284 3 0l6.2478-6.2478c.273-.2731.4096-.4096.5471-.4808.1439-.0746.23-.0987.3918-.1098.1545-.0106.399.049.8882.1681.4568.1113.934.1703 1.4251.1703 3.3137 0 6-2.6863 6-6 0-.8804-.1896-1.7165-.5303-2.4697l-2.8383 2.8383c-.3961.396-.5941.594-.8224.6682a1 1 0 0 1-.618 0c-.2284-.0741-.4264-.2721-.8224-.6682z"
    />
  </svg>
);

export const Tool02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m6 6 4.5 4.5M6 6H3L2 3l1-1 3 1zm13.259-3.259-2.6276 2.6276c-.396.396-.5941.594-.6682.8224a1 1 0 0 0 0 .618c.0741.2283.2722.4264.6682.8224l.2372.2372c.396.396.5941.594.8224.6682a1 1 0 0 0 .618 0c.2283-.0741.4264-.2721.8224-.6682l2.4579-2.4579A5.48 5.48 0 0 1 22 7.5c0 3.0376-2.4624 5.5-5.5 5.5a5.52 5.52 0 0 1-1.0702-.1041c-.4862-.0958-.7293-.1438-.8766-.1291-.1567.0156-.2339.0391-.3727.1134-.1306.0699-.2615.2008-.5235.4628L6.5 20.5c-.8284.8284-2.1716.8284-3 0s-.8284-2.1716 0-3l7.157-7.157c.262-.262.3929-.393.4628-.5235.0743-.1388.0978-.216.1134-.3727.0147-.1473-.0333-.3904-.1291-.8766A5.53 5.53 0 0 1 11 7.5C11 4.4624 13.4624 2 16.5 2c1.0055 0 1.948.2698 2.759.741M12.0001 15l5.4999 5.5c.8284.8284 2.1716.8284 3 0s.8284-2.1716 0-3l-4.5247-4.5246a5.5 5.5 0 0 1-.9345-.171c-.3891-.1068-.8159-.0292-1.1011.256z"
    />
  </svg>
);

export const Translate01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.913 17h7.174m-7.174 0L11 21m1.913-4 2.8653-5.991c.2309-.4827.3463-.7241.5043-.8004a.5.5 0 0 1 .4348 0c.158.0763.2734.3177.5043.8004L20.087 17m0 0L22 21M2 5h6m0 0h3.5M8 5V3m3.5 2H14m-2.5 0c-.4961 2.9573-1.6474 5.6362-3.3344 7.8844M10 14c-.6125-.2752-1.2373-.6579-1.8345-1.1156m0 0C6.813 11.8478 5.6029 10.4266 5 9m3.1655 3.8844C6.561 15.0229 4.4716 16.7718 2 18"
    />
  </svg>
);

export const Translate02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m5 8 5 5m-6 1 6-6 2-3M2 5h12M7 2h1m4.913 15h7.174m-7.174 0L11 21m1.913-4 2.8653-5.991c.2309-.4827.3463-.7241.5043-.8004a.5.5 0 0 1 .4348 0c.158.0763.2734.3177.5043.8004L20.087 17m0 0L22 21"
    />
  </svg>
);

export const Trash01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 6v-.8c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C14.4802 2 13.9201 2 12.8 2h-1.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C8 3.5198 8 4.08 8 5.2V6m2 5.5v5m4-5v5M3 6h18m-2 0v11.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C16.7202 22 15.8802 22 14.2 22H9.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C5 19.7202 5 18.8802 5 17.2V6"
    />
  </svg>
);

export const Trash02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 6v-.8c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C14.4802 2 13.9201 2 12.8 2h-1.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C8 3.5198 8 4.08 8 5.2V6M3 6h18m-2 0v11.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C16.7202 22 15.8802 22 14.2 22H9.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C5 19.7202 5 18.8802 5 17.2V6"
    />
  </svg>
);

export const Trash03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 3h6M3 6h18m-2 0-.7013 10.5193c-.1052 1.5782-.1578 2.3674-.4987 2.9657a3 3 0 0 1-1.2983 1.2147C15.882 21 15.0911 21 13.5093 21h-3.0186c-1.5818 0-2.3727 0-2.9924-.3003A3 3 0 0 1 6.2 19.485c-.3409-.5983-.3935-1.3875-.4987-2.9657L5 6m5 4.5v5m4-5v5"
    />
  </svg>
);

export const Trash04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 3h6M3 6h18m-2 0-.7013 10.5193c-.1052 1.5782-.1578 2.3674-.4987 2.9657a3 3 0 0 1-1.2983 1.2147C15.882 21 15.0911 21 13.5093 21h-3.0186c-1.5818 0-2.3727 0-2.9924-.3003A3 3 0 0 1 6.2 19.485c-.3409-.5983-.3935-1.3875-.4987-2.9657L5 6"
    />
  </svg>
);

export const Upload01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 15v1.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V15m4-7 5-5 5 5m-5-5v12"
    />
  </svg>
);

export const Upload02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 3H3m3 10 6-6 6 6m-6-6v14"
    />
  </svg>
);

export const Upload03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m8 12 4-4 4 4m-4-4v8m10-4c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const Upload04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m8 12 4-4 4 4m-4-4v9.2c0 1.3907 0 2.0861.5505 2.8646.3658.5173 1.4189 1.1557 2.0467 1.2408.9449.128 1.3037-.0592 2.0214-.4335C19.8167 19.2036 22 15.8568 22 12c0-5.5228-4.4772-10-10-10S2 6.4772 2 12c0 3.7014 2.011 6.9331 5 8.6622"
    />
  </svg>
);

export const UploadCloud01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 16.2422c-1.206-.8072-2-2.182-2-3.7422 0-2.3436 1.7915-4.2687 4.0797-4.4806C6.5478 5.172 9.0202 3 12 3s5.4522 2.1721 5.9203 5.0194C20.2085 8.2313 22 10.1564 22 12.5c0 1.5602-.794 2.935-2 3.7422M16 16l-4-4-4 4m4-4v9"
    />
  </svg>
);

export const UploadCloud02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 16-4-4-4 4m4-4v9m8-4.2572c1.2215-1.0088 2-2.5349 2-4.2428C22 9.4624 19.5376 7 16.5 7c-.2185 0-.4229-.114-.5339-.3023C14.6621 4.4848 12.2544 3 9.5 3 5.3579 3 2 6.3579 2 10.5c0 2.0661.8354 3.9371 2.187 5.2935"
    />
  </svg>
);

export const Virus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 2v5m0-5c-.7133 0-1.4091.0747-2.08.2166M12 2a10.04 10.04 0 0 1 2.08.2166M12 7c-2.7614 0-5 2.2386-5 5m5-5c2.7614 0 5 2.2386 5 5m-5 5v5m0-5c2.7614 0 5-2.2386 5-5m-5 5c-2.7614 0-5-2.2386-5-5m5 10c.7122 0 1.407-.0745 2.077-.216M12 22c-.7149 0-1.4122-.075-2.0845-.2176M4.9289 4.9289l3.5355 3.5356m7.0711 7.071 3.5355 3.5356M2 12h5m-5 0c0 .7133.0747 1.4092.2166 2.0802M2 12c0-.7143.0749-1.4112.2173-2.0832M17 12h5m0 0c0-.7133-.0747-1.4092-.2167-2.0802M22 12c0 .7131-.0746 1.4086-.2165 2.0794M4.9289 19.0711l3.5355-3.5356m7.0711-7.071 3.5355-3.5356m-1.6244-1.3168a10.05 10.05 0 0 1 2.9422 2.9426m-.0028 10.8949a10.05 10.05 0 0 1-2.9415 2.9397m-10.8908-.0011a10.055 10.055 0 0 1-2.939-2.9374m-.003-10.897a10.05 10.05 0 0 1 2.941-2.9414"
    />
  </svg>
);

export const XCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m15 9-6 6m0-6 6 6m7-3c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const XClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 6 6 18M6 6l12 12"
    />
  </svg>
);

export const X = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17 7 7 17M7 7l10 10"
    />
  </svg>
);

export const XSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 9 6 6m0-6-6 6m-1.2 6h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const Zap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13 2 4.0934 12.6879c-.3488.4185-.5232.6278-.5258.8046a.5.5 0 0 0 .1856.3964c.1375.1111.41.1111.9548.1111H12l-1 8 8.9065-10.6879c.3488-.4185.5232-.6278.5259-.8046a.5.5 0 0 0-.1857-.3964C20.1092 10 19.8368 10 19.292 10H12z"
    />
  </svg>
);

export const ZapCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m12 5.5-4.6384 6.7468c-.2792.4061-.4188.6092-.4105.778a.5.5 0 0 0 .196.3727c.1344.1025.3808.1025.8737.1025H12v5l4.6384-6.7468c.2792-.4061.4189-.6092.4105-.778a.5.5 0 0 0-.1961-.3727c-.1343-.1025-.3807-.1025-.8736-.1025H12z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    />
  </svg>
);

export const ZapFast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 17.5H3.5m3-5.5H2m7-5.5H4M17 3l-6.5964 9.235c-.292.4088-.438.6131-.4317.7835a.5.5 0 0 0 .1942.3773c.135.1042.3861.1042.8885.1042H16L15 21l6.5964-9.235c.292-.4088.438-.6131.4317-.7835a.5.5 0 0 0-.1942-.3773c-.135-.1042-.3861-.1042-.8885-.1042H16z"
    />
  </svg>
);

export const ZapOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m8 8-3.9065 4.6879c-.3488.4185-.5233.6278-.526.8046a.5.5 0 0 0 .1858.3964C3.8908 14 4.1632 14 4.708 14H12l-1 8 5-6m-.35-6h3.642c.5448 0 .8173 0 .9547.1111a.5.5 0 0 1 .1857.3964c-.0026.1768-.177.3861-.5259.8046l-1.3563 1.6276m-7.9774-8.027L13 2l-.5998 4.7977M21 21 3 3"
    />
  </svg>
);

export const ZapSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m12 6-4.5664 6.2269c-.301.4105-.4516.6158-.4467.7873a.5.5 0 0 0 .1928.3805c.1354.1053.39.1053.899.1053H12V18l4.5664-6.2269c.301-.4105.4516-.6158.4467-.7873a.5.5 0 0 0-.1928-.3805c-.1354-.1053-.39-.1053-.899-.1053H12z"
    />
  </svg>
);

export const LinkBroken01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 4V2m6 18v2M4 9H2m18 6h2M4.9142 4.9142 3.5 3.5m15.5858 15.5858L20.5 20.5M12 17.6569l-2.1213 2.1213c-1.5621 1.5621-4.0948 1.5621-5.6569 0s-1.562-4.0948 0-5.6569L6.3431 12m11.3138 0 2.1213-2.1213c1.5621-1.5621 1.5621-4.0948 0-5.6569s-4.0948-1.562-5.6569 0L12 6.3431"
    />
  </svg>
);

export const LinkBroken02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m8.5 15.5 7-7M9 4V2m6 18v2M4 9H2m18 6h2M4.9142 4.9142 3.5 3.5m15.5858 15.5857L20.5 20.4999M12 17.6568l-2.1213 2.1213c-1.562 1.5621-4.0947 1.5621-5.6568 0s-1.5621-4.0948 0-5.6569l2.1213-2.1213m11.3137 0 2.1213-2.1213c1.5621-1.5621 1.5621-4.0948 0-5.6569s-4.0947-1.562-5.6568 0L12 6.3431"
    />
  </svg>
);

export const LinkExternal01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 3h6v6m0-6-8 8m-3-6H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 7.2798 3 8.1198 3 9.8v6.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 18.7202 19 17.8802 19 16.2V14"
    />
  </svg>
);

export const LinkExternal02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 3h6v6m0-6-9 9m-2-9H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V14"
    />
  </svg>
);

export const Loading01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 2.25v2.5M12 18v4M5.75 12h-3.5m19 0h-1.5m-1.2929 6.4571L17.75 17.75m.9142-12.3342L17.25 6.83M4.9216 19.0784 7.75 16.25M5.1287 5.2087 7.25 7.33"
    />
  </svg>
);

export const Loading02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 2v4m0 12v4M6 12H2m20 0h-4m1.0784 7.0784L16.25 16.25M19.0784 5 16.25 7.8283m-11.3284 11.25L7.75 16.25M4.9216 5 7.75 7.8283"
    />
  </svg>
);

export const Loading03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3.3403 16.9997c-1.2522-2.1699-.6156-4.9353 1.4577-6.3396l.0022-.0023c1.6654-1.1255 3.8576-1.0877 5.4841.0945l3.4321 2.4954c1.6254 1.1822 3.8175 1.2199 5.4841.0944l.0022-.0022c2.0744-1.4043 2.7121-4.172 1.4577-6.3396m-3.6584 13.659c-2.1699 1.2521-4.9353.6155-6.3397-1.4577l-.0022-.0022c-1.1255-1.6655-1.0878-3.8576.0944-5.4842l2.4954-3.432c1.1822-1.6255 1.22-3.8176.0945-5.4842l-.0045-.0022c-1.4043-2.0721-4.172-2.711-6.3396-1.4566M19.0705 4.929c3.9053 3.9054 3.9053 10.2361 0 14.1415-3.9054 3.9053-10.2361 3.9053-14.1415 0-3.9053-3.9054-3.9053-10.2361 0-14.1415 3.9054-3.9053 10.2361-3.9053 14.1415 0"
    />
  </svg>
);

export const LogIn01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 3h1.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H15m-5-4 5-5-5-5m5 5H3"
    />
  </svg>
);

export const LogIn02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 17c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C8.605 21 9.07 21 10 21h6.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H10c-.93 0-1.395 0-1.7765.1022a3 3 0 0 0-2.1213 2.1213C6 5.605 6 6.07 6 7m6 9 4-4-4-4m4 4H3"
    />
  </svg>
);

export const LogIn03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 17c0 .3513 0 .5269.0157.6796a3 3 0 0 0 2.2864 2.6115c.1492.0357.3234.0589.6716.1054l6.5919.8789c1.8764.2502 2.8147.3753 3.5428.0857a3 3 0 0 0 1.5084-1.3205C21 19.357 21 18.4105 21 16.5175v-9.035c0-1.8931 0-2.8396-.3832-3.5231a3 3 0 0 0-1.5084-1.3206c-.7281-.2895-1.6664-.1644-3.5428.0857l-6.592.879c-.3481.0464-.5222.0696-.6715.1053a3 3 0 0 0-2.2864 2.6115C6 6.473 6 6.6487 6 7m6 9 4-4-4-4m4 4H3"
    />
  </svg>
);

export const LogIn04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m12 16 4-4-4-4m4 4H3m.3378-5C5.0668 4.011 8.2986 2 12 2c5.5228 0 10 4.4772 10 10s-4.4772 10-10 10c-3.7014 0-6.9331-2.011-8.6622-5"
    />
  </svg>
);

export const LogOut01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 7 5 5-5 5m5-5H9m0-9H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21H9"
    />
  </svg>
);

export const LogOut02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 7 5 5-5 5m5-5H9m3 5c0 .93 0 1.395-.1022 1.7765a3 3 0 0 1-2.1213 2.1213C9.395 21 8.93 21 8 21h-.5c-1.3978 0-2.0967 0-2.648-.2284a3 3 0 0 1-1.6236-1.6235C3 18.5967 3 17.8978 3 16.5v-9c0-1.3978 0-2.0967.2284-2.648A3 3 0 0 1 4.852 3.2284C5.4033 3 6.1022 3 7.5 3H8c.93 0 1.395 0 1.7765.1022a3 3 0 0 1 2.1213 2.1213C12 5.605 12 6.07 12 7"
    />
  </svg>
);

export const LogOut03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 7 5 4.9999-5 5m5-5H9m3 5c0 .2956 0 .4434-.011.5714a3 3 0 0 1-2.404 2.6859c-.126.0251-.273.0414-.5667.074l-1.0214.1135c-1.5344.1705-2.3017.2558-2.9112.0607a3 3 0 0 1-1.8245-1.633C3 18.2881 3 17.5162 3 15.9722V8.0276c0-1.5439 0-2.3159.2612-2.9001a3 3 0 0 1 1.8245-1.633c.6095-.195 1.3768-.1098 2.9112.0607l1.0214.1134c.2938.0327.4407.049.5667.074a3 3 0 0 1 2.404 2.686c.011.128.011.2758.011.5713"
    />
  </svg>
);

export const LogOut04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m18 16 4-4-4-4m4 4H9m6-7.796C13.7252 3.4383 12.2452 3 10.6667 3 5.8802 3 2 7.0294 2 12s3.8802 9 8.6667 9c1.5785 0 3.0585-.4383 4.3333-1.204"
    />
  </svg>
);

export const MedicalCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13.8333 7.3c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185c-.1069-.0545-.2469-.0545-.527-.0545h-2.0666c-.2801 0-.4201 0-.527.0545a.5.5 0 0 0-.2185.2185c-.0545.107-.0545.247-.0545.527v2.0667c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185c-.107.0545-.247.0545-.527.0545H7.3c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185c-.0545.1069-.0545.2469-.0545.527v2.0666c0 .2801 0 .4201.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545h2.0667c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185c.0545.107.0545.247.0545.527V16.7c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.1069.0545.2469.0545.527.0545h2.0666c.2801 0 .4201 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527v-2.0667c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185c.107-.0545.247-.0545.527-.0545H16.7c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.1069.0545-.2469.0545-.527v-2.0666c0-.2801 0-.4201-.0545-.527a.5.5 0 0 0-.2185-.2185c-.107-.0545-.247-.0545-.527-.0545h-2.0667c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185c-.0545-.107-.0545-.247-.0545-.527z"
    />
  </svg>
);

export const MedicalCross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.2401 3 13.9601 3 13.4 3h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 3.76 9 4.04 9 4.6v2.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C8.24 9 7.96 9 7.4 9H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 9.76 3 10.04 3 10.6v2.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C3.76 15 4.04 15 4.6 15h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C9 15.7599 9 16.0399 9 16.6v2.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C9.76 21 10.04 21 10.6 21h2.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C15 20.2401 15 19.9601 15 19.4v-2.8c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437C15.7599 15 16.0399 15 16.6 15h2.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 14.2401 21 13.9601 21 13.4v-2.8c0-.5601 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.2401 9 19.9601 9 19.4 9h-2.8c-.5601 0-.8401 0-1.054-.109a1 1 0 0 1-.437-.437C15 8.24 15 7.96 15 7.4z"
    />
  </svg>
);

export const MedicalSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13.8333 7.3c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185c-.1069-.0545-.2469-.0545-.527-.0545h-2.0666c-.2801 0-.4201 0-.527.0545a.5.5 0 0 0-.2185.2185c-.0545.107-.0545.247-.0545.527v2.0667c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185c-.107.0545-.247.0545-.527.0545H7.3c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185c-.0545.1069-.0545.2469-.0545.527v2.0666c0 .2801 0 .4201.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545h2.0667c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185c.0545.107.0545.247.0545.527V16.7c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.1069.0545.2469.0545.527.0545h2.0666c.2801 0 .4201 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527v-2.0667c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185c.107-.0545.247-.0545.527-.0545H16.7c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.1069.0545-.2469.0545-.527v-2.0666c0-.2801 0-.4201-.0545-.527a.5.5 0 0 0-.2185-.2185c-.107-.0545-.247-.0545-.527-.0545h-2.0667c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185c-.0545-.107-.0545-.247-.0545-.527z"
    />
  </svg>
);

export const Menu01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 12h18M3 6h18M3 18h18"
    />
  </svg>
);

export const Menu02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 12h12M3 6h18M3 18h18"
    />
  </svg>
);

export const Menu03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 12h18M3 6h18M3 18h12"
    />
  </svg>
);

export const Menu04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 12h18M3 6h18M9 18h12"
    />
  </svg>
);

export const Menu05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 8.5h18m-18 7h18"
    />
  </svg>
);

export const Minus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 12h14"
    />
  </svg>
);

export const MinusCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 12h8m6 0c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const MinusSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 12h8m-8.2 9h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const Percent01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 5 5 19M7.5 6.5c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1m11 11c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const Percent02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 5 5 19M9 7c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m10 10c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2"
    />
  </svg>
);

export const Percent03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 9h.01M15 15h.01M16 8l-8 8m1.5-7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m6 6a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 15.5 15m6.5-3c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const Pin01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.0004 15v7m-4-14.6919v2.1307c0 .208 0 .312-.0204.4115a1 1 0 0 1-.089.2539c-.0463.0904-.1112.1716-.2412.3341L6.08 12.4005c-.6657.8322-.9986 1.2482-.999 1.5984a1 1 0 0 0 .3762.7826C5.7309 15 6.2637 15 7.3294 15h9.342c1.0657 0 1.5986 0 1.8723-.2185a1 1 0 0 0 .3761-.7826c-.0004-.3502-.3332-.7662-.999-1.5984l-1.5698-1.9622c-.1299-.1625-.1949-.2437-.2411-.3341a1 1 0 0 1-.0891-.254c-.0204-.0994-.0204-.2034-.0204-.4114V7.308c0-.115 0-.1727.0065-.2294a1 1 0 0 1 .0288-.1493c.015-.0552.0364-.1086.0792-.2155l1.0078-2.5197c.2941-.735.4411-1.1026.3798-1.3977a1 1 0 0 0-.4266-.63C16.8247 2 16.4289 2 15.6372 2H8.3637c-.7917 0-1.1876 0-1.4388.1665a1 1 0 0 0-.4265.63c-.0613.295.0857.6626.3797 1.3977L7.886 6.714c.0427.1069.0641.1603.0792.2155a1 1 0 0 1 .0287.1493c.0065.0567.0065.1143.0065.2294"
    />
  </svg>
);

export const Pin02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m8.3767 15.6163-5.6568 5.6569m8.9745-14.6314-1.5609 1.5609c-.1273.1273-.191.191-.2635.2416a1 1 0 0 1-.207.1107c-.0822.0323-.1705.05-.347.0853l-3.6646.7329c-.9522.1904-1.4284.2856-1.6512.5367a1 1 0 0 0-.2425.801c.0461.3325.3895.6758 1.0762 1.3626l7.0857 7.0857c.6867.6867 1.0301 1.0301 1.3625 1.0762a1 1 0 0 0 .8011-.2426c.251-.2227.3462-.6989.5367-1.6512l.7329-3.6645c.0353-.1765.053-.2648.0853-.3471a1 1 0 0 1 .1107-.2069c.0506-.0726.1142-.1362.2416-.2635l1.5608-1.5609c.0814-.0814.1222-.1221.1669-.1577a1 1 0 0 1 .1259-.0852c.0496-.0284.1025-.051.2083-.0964l2.4944-1.069c.7277-.3119 1.0916-.4678 1.2568-.7198a1 1 0 0 0 .1439-.7471c-.0599-.2954-.3398-.5753-.8996-1.1351l-5.1431-5.1431c-.5599-.5599-.8398-.8398-1.1351-.8997a1 1 0 0 0-.7471.144c-.252.1652-.408.529-.7198 1.2568l-1.069 2.4943c-.0454.1058-.0681.1587-.0964.2084a1 1 0 0 1-.0853.1259c-.0355.0447-.0762.0854-.1576.1668"
    />
  </svg>
);

export const Placeholder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    />
  </svg>
);

export const Plus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 5v14m-7-7h14"
    />
  </svg>
);

export const PlusCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 8v8m-4-4h8m6 0c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const PlusSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 8v8m-4-4h8m-8.2 9h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const Save01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 3v3.4c0 .56 0 .84.109 1.054.0959.1882.2489.3411.437.437C7.76 8 8.04 8 8.6 8h6.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C17 7.24 17 6.96 17 6.4V4m0 17v-6.4c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C16.2401 13 15.9601 13 15.4 13H8.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7 13.7599 7 14.0399 7 14.6V21M21 9.3255V16.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h6.8745c.4892 0 .7338 0 .964.0553.204.049.3991.1298.5781.2394.2018.1237.3748.2966.7207.6426l3.1254 3.1254c.3459.346.5189.5189.6426.7207.1096.179.1904.374.2394.5781.0553.2302.0553.4748.0553.964"
    />
  </svg>
);

export const Save02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 8H8.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C7 7.24 7 6.96 7 6.4V3m10 18v-6.4c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C16.2401 13 15.9601 13 15.4 13H8.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7 13.7599 7 14.0399 7 14.6V21M21 9.3255V16.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h6.8745c.4892 0 .7338 0 .964.0553.204.049.3991.1298.5781.2394.2018.1237.3748.2966.7207.6426l3.1254 3.1254c.3459.346.5189.5189.6426.7207.1096.179.1904.374.2394.5781.0553.2302.0553.4748.0553.964"
    />
  </svg>
);

export const Save03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 3h7.6745c.4892 0 .7338 0 .964.0553.204.049.3991.1298.5781.2394.2018.1237.3748.2966.7207.6426l3.1254 3.1254c.3459.346.5189.5189.6426.7207.1096.179.1904.374.2394.5781.0553.2302.0553.4748.0553.964V17m-8.5-7H8.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C7 9.24 7 8.96 7 8.4V6.5M13.5 21v-4.4c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C12.7401 15 12.4601 15 11.9 15H8.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7 15.7599 7 16.0399 7 16.6V21m10.5-10.8373V17.8c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C15.9802 21 15.4201 21 14.3 21H6.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.4802 3 18.9201 3 17.8V9.7c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C4.5198 6.5 5.08 6.5 6.2 6.5h7.6373c.2445 0 .3668 0 .4819.0276a1 1 0 0 1 .2891.1198c.1009.0618.1874.1483.3603.3212l2.0628 2.0628c.1729.173.2594.2594.3212.3603a1 1 0 0 1 .1198.289c.0276.1152.0276.2375.0276.482"
    />
  </svg>
);

export const SearchLg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m21 21-3.4999-3.5M20 11.5c0 4.6944-3.8056 8.5-8.5 8.5S3 16.1944 3 11.5 6.8056 3 11.5 3 20 6.8056 20 11.5"
    />
  </svg>
);

export const SearchMd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m21 21-4.35-4.35M19 11c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8 3.5817-8 8-8 8 3.5817 8 8"
    />
  </svg>
);

export const SearchRefraction = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m21 21-4.35-4.35M11 6c2.7614 0 5 2.2386 5 5m3 0c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8 3.5817-8 8-8 8 3.5817 8 8"
    />
  </svg>
);

export const SearchSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m21 21-5.9999-6M17 10c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7"
    />
  </svg>
);

export const Settings01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18.7273 14.7273a1.5 1.5 0 0 0 .3 1.6545l.0545.0546a1.818 1.818 0 0 1 0 2.5727 1.8184 1.8184 0 0 1-2.5727 0l-.0546-.0546a1.5 1.5 0 0 0-1.6545-.3 1.5 1.5 0 0 0-.9091 1.3728v.1545a1.8182 1.8182 0 1 1-3.6364 0V20.1a1.5 1.5 0 0 0-.9818-1.3727 1.5002 1.5002 0 0 0-1.6545.3l-.0546.0545a1.818 1.818 0 0 1-1.9826.3947 1.82 1.82 0 0 1-.59-.3947 1.818 1.818 0 0 1-.5333-1.2863 1.818 1.818 0 0 1 .5332-1.2864l.0545-.0546a1.5 1.5 0 0 0 .3-1.6545 1.5 1.5 0 0 0-1.3727-.9091h-.1545a1.818 1.818 0 0 1-1.2857-3.1038 1.818 1.818 0 0 1 1.2857-.5326H3.9a1.5 1.5 0 0 0 1.3727-.9818 1.5 1.5 0 0 0-.3-1.6545l-.0545-.0546a1.818 1.818 0 0 1 0-2.5727 1.818 1.818 0 0 1 2.5727 0l.0545.0545a1.5 1.5 0 0 0 1.6546.3h.0727a1.5 1.5 0 0 0 .9091-1.3727v-.1545a1.8182 1.8182 0 0 1 3.6364 0V3.9a1.4997 1.4997 0 0 0 .9091 1.3727 1.5 1.5 0 0 0 1.6545-.3l.0546-.0545a1.817 1.817 0 0 1 1.2863-.5333 1.818 1.818 0 0 1 1.2864.5333 1.819 1.819 0 0 1 .3946 1.9826 1.82 1.82 0 0 1-.3946.5901l-.0546.0545a1.501 1.501 0 0 0-.3 1.6546v.0727a1.5 1.5 0 0 0 1.3728.9091h.1545a1.8183 1.8183 0 0 1 0 3.6364H20.1a1.4995 1.4995 0 0 0-1.3727.9091"
    />
  </svg>
);

export const Settings02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9.3951 19.3711.5845 1.3145A2.212 2.212 0 0 0 12.0018 22a2.212 2.212 0 0 0 2.0222-1.3144l.5844-1.3145a2.426 2.426 0 0 1 1-1.1111 2.433 2.433 0 0 1 1.47-.3122l1.43.1522a2.212 2.212 0 0 0 2.1489-1.0944 2.21 2.21 0 0 0 .2938-1.2227 2.21 2.21 0 0 0-.4204-1.1851l-.8467-1.1634A2.43 2.43 0 0 1 19.224 12a2.43 2.43 0 0 1 .4644-1.4289l.8467-1.1633A2.211 2.211 0 0 0 20.6618 7a2.212 2.212 0 0 0-2.1489-1.0944l-1.43.1522a2.433 2.433 0 0 1-1.47-.3122 2.426 2.426 0 0 1-1-1.1167l-.5889-1.3145A2.212 2.212 0 0 0 12.0018 2a2.212 2.212 0 0 0-2.0222 1.3144L9.395 4.629a2.426 2.426 0 0 1-1 1.1167 2.433 2.433 0 0 1-1.47.3122l-1.4344-.1522A2.212 2.212 0 0 0 3.3417 7a2.211 2.211 0 0 0 .1267 2.4078l.8467 1.1633c.302.4153.4645.9155.4645 1.4289a2.43 2.43 0 0 1-.4645 1.4289l-.8467 1.1633A2.211 2.211 0 0 0 3.3418 17a2.214 2.214 0 0 0 2.1489 1.0944l1.43-.1522a2.434 2.434 0 0 1 1.47.3122 2.426 2.426 0 0 1 1.0044 1.1167"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 15c1.6568 0 3-1.3431 3-3s-1.3432-3-3-3-3 1.3431-3 3 1.3431 3 3 3"
    />
  </svg>
);

export const Settings03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.0505 9H5.5C4.1193 9 3 7.8807 3 6.5S4.1193 4 5.5 4h9.5505m-6.101 16H18.5c1.3807 0 2.5-1.1193 2.5-2.5S19.8807 15 18.5 15H8.9495M3 17.5C3 19.433 4.567 21 6.5 21s3.5-1.567 3.5-3.5S8.433 14 6.5 14 3 15.567 3 17.5m18-11c0 1.933-1.567 3.5-3.5 3.5S14 8.433 14 6.5 15.567 3 17.5 3 21 4.567 21 6.5"
    />
  </svg>
);

export const Settings04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 8h12m0 0c0 1.6569 1.3431 3 3 3s3-1.3431 3-3-1.3431-3-3-3-3 1.3431-3 3m-6 8h12M9 16c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
    />
  </svg>
);

export const Share01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 12v4.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V12m5-5 4-4 4 4m-4-4v12"
    />
  </svg>
);

export const Share02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 11c-.93 0-1.395 0-1.7765.1022a3 3 0 0 0-2.1213 2.1213C3 13.605 3 14.07 3 15v1.2c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V15c0-.93 0-1.395-.1022-1.7765a3 3 0 0 0-2.1213-2.1213C18.395 11 17.93 11 17 11M8 7l4-4 4 4m-4-4v12"
    />
  </svg>
);

export const Share03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 3h6v6m0-6-9 9m-2-9H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V14"
    />
  </svg>
);

export const Download04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 12-4 4-4-4m4 4V6.8c0-1.3907 0-2.086-.5505-2.8646-.3658-.5173-1.4189-1.1557-2.0467-1.2408-.945-.128-1.3037.0592-2.0214.4335C4.1834 4.7964 2 8.1432 2 12c0 5.5228 4.4772 10 10 10s10-4.4772 10-10c0-3.7014-2.011-6.9331-5-8.6622"
    />
  </svg>
);

export const DownloadCloud01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 16.2422c-1.206-.8072-2-2.182-2-3.7422 0-2.3436 1.7915-4.2687 4.0797-4.4806C6.5478 5.172 9.0202 3 12 3s5.4522 2.1721 5.9203 5.0194C20.2085 8.2313 22 10.1564 22 12.5c0 1.5602-.794 2.935-2 3.7422M16 17l-4 4-4-4m4 4v-9"
    />
  </svg>
);

export const DownloadCloud02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 17-4 4-4-4m4 4v-9m8 4.7428c1.2215-1.0088 2-2.5349 2-4.2428C22 9.4624 19.5376 7 16.5 7c-.2185 0-.4229-.114-.5339-.3023C14.6621 4.4848 12.2544 3 9.5 3 5.3579 3 2 6.3579 2 10.5c0 2.0661.8354 3.9371 2.187 5.2935"
    />
  </svg>
);

export const Edit01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2.876 18.1156c.046-.4135.069-.6202.1315-.8134a2 2 0 0 1 .2331-.4851c.1118-.1696.259-.3166.5531-.6108L17 3c1.1046-1.1046 2.8954-1.1046 4 0s1.1046 2.8954 0 4L7.7937 20.2063c-.2942.2942-.4413.4412-.6108.5531a2 2 0 0 1-.485.2331c-.1933.0625-.4.0855-.8136.1315L2.5 21.5z"
    />
  </svg>
);

export const Edit02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m18 10-4-4M2.5 21.5l3.3843-.376c.4135-.046.6203-.069.8135-.1315a2 2 0 0 0 .485-.2331c.1696-.1119.3167-.2589.6109-.5531L21 7c1.1046-1.1046 1.1046-2.8954 0-4s-2.8954-1.1046-4 0L3.7937 16.2063c-.2942.2942-.4413.4412-.553.6108a2 2 0 0 0-.2332.4851c-.0626.1932-.0856.3999-.1315.8134z"
    />
  </svg>
);

export const Edit03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 20h9M3 20h1.6746c.4892 0 .7338 0 .964-.0553.204-.049.399-.1298.578-.2394.2019-.1237.3748-.2967.7207-.6426L19.5001 6.5c.8284-.8284.8284-2.1716 0-3s-2.1716-.8284-3 0L3.9373 16.0627c-.346.3459-.5189.5189-.6425.7207a2 2 0 0 0-.2395.5781C3 17.5917 3 17.8363 3 18.3255z"
    />
  </svg>
);

export const Edit04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m21 18-1.0001 1.094c-.5304.5801-1.2497.906-1.9997.906s-1.4694-.3259-1.9998-.906c-.5311-.5789-1.2504-.9039-2.0002-.9039s-1.469.325-2.0002.9039M3 20h1.6746c.4892 0 .7338 0 .964-.0553.204-.049.399-.1298.578-.2394.2019-.1237.3748-.2967.7207-.6426L19.5001 6.5c.8284-.8284.8284-2.1716 0-3s-2.1716-.8284-3 0L3.9373 16.0627c-.346.3459-.5189.5189-.6425.7207a2 2 0 0 0-.2395.5781C3 17.5917 3 17.8363 3 18.3255z"
    />
  </svg>
);

export const Edit05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11 4H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.2798 2 7.1198 2 8.8v8.4c0 1.6801 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 22 5.1198 22 6.8 22h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8801 20 17.2V13M8 16h1.6745c.4892 0 .7338 0 .964-.0553a2 2 0 0 0 .5781-.2394c.2018-.1237.3748-.2967.7207-.6426L21.5 5.5c.8284-.8284.8284-2.1716 0-3s-2.1716-.8284-3 0l-9.5628 9.5627c-.3459.3459-.5188.5189-.6425.7207a2 2 0 0 0-.2395.5781C8 13.5917 8 13.8363 8 14.3255z"
    />
  </svg>
);

export const Equal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 9h14M5 15h14"
    />
  </svg>
);

export const EqualNot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 9h14M5 15h14m0-10L5 19"
    />
  </svg>
);

export const Eye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2.4201 12.7132c-.1362-.2157-.2043-.3235-.2424-.4898-.0286-.1249-.0286-.3219 0-.4468.0381-.1663.1062-.2741.2424-.4898C3.5455 9.5048 6.8954 5 12.0004 5s8.4549 4.5048 9.5803 6.2868c.1362.2157.2043.3235.2424.4898.0286.1249.0286.3219 0 .4468-.0381.1663-.1062.2741-.2424.4898C20.4553 14.4952 17.1054 19 12.0004 19s-8.4549-4.5048-9.5803-6.2868"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.0004 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3"
    />
  </svg>
);

export const EyeOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.7429 5.0923A8.6 8.6 0 0 1 12.0004 5c5.105 0 8.4549 4.5048 9.5803 6.2868.1362.2157.2043.3235.2424.4899.0287.1249.0286.322 0 .4469-.0382.1663-.1067.2749-.2439.492a17.5 17.5 0 0 1-1.3627 1.8649M6.7243 6.715c-2.162 1.4667-3.6298 3.5044-4.3032 4.5703-.1368.2166-.2052.3249-.2434.4912-.0286.1249-.0286.3219 0 .4469.0381.1663.1062.2741.2424.4898C3.5455 14.4952 6.8954 19 12.0004 19c2.0584 0 3.8315-.7324 5.2884-1.7234M3.0004 3l18 18M9.8791 9.8787c-.5429.5429-.8787 1.2929-.8787 2.1213 0 1.6569 1.3432 3 3 3 .8284 0 1.5784-.3358 2.1213-.8787"
    />
  </svg>
);

export const FilterFunnel01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 3 3.04 3 3.6 3h16.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437C22 3.76 22 4.04 22 4.6v.6694c0 .2688 0 .4032-.0328.5282a1 1 0 0 1-.1417.3102c-.0729.1066-.1745.1947-.3776.3707l-6.3958 5.543c-.2031.176-.3047.2641-.3776.3707a1 1 0 0 0-.1417.3102c-.0328.125-.0328.2594-.0328.5282v5.2278c0 .1955 0 .2933-.0315.3779a.5.5 0 0 1-.1322.1952c-.0668.0607-.1576.097-.3392.1697l-3.4 1.36c-.3675.147-.5513.2205-.6988.1898a.5.5 0 0 1-.315-.2133C9.5 20.4122 9.5 20.2142 9.5 19.8184v-6.5878c0-.2688 0-.4032-.0328-.5282a1 1 0 0 0-.1417-.3102c-.073-.1066-.1745-.1947-.3776-.3707L2.552 6.4785c-.2031-.176-.3047-.264-.3776-.3707a1 1 0 0 1-.1417-.3102C2 5.6726 2 5.5382 2 5.2694z"
    />
  </svg>
);

export const FilterFunnel02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3.3859 5.6669c-.7563-.8453-1.1345-1.268-1.1488-1.6272a1 1 0 0 1 .3625-.8108C2.8768 3 3.444 3 4.5783 3h14.8429c1.1343 0 1.7015 0 1.9787.2289a1 1 0 0 1 .3625.8108c-.0143.3592-.3925.7819-1.1488 1.6272l-5.7062 6.3775c-.1508.1685-.2262.2528-.2799.3487a1 1 0 0 0-.1039.2717c-.0239.1073-.0239.2204-.0239.4465v5.3471c0 .1955 0 .2933-.0315.3779a.5.5 0 0 1-.1322.1952c-.0668.0607-.1576.097-.3391.1697l-3.4 1.36c-.3676.147-.5514.2205-.6989.1898a.5.5 0 0 1-.315-.2133c-.0832-.1255-.0832-.3235-.0832-.7193v-6.7071c0-.2261 0-.3392-.024-.4465a1 1 0 0 0-.1038-.2717c-.0537-.0959-.1291-.1802-.2799-.3487z"
    />
  </svg>
);

export const FilterLines = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 12h12M3 6h18M9 18h6"
    />
  </svg>
);

export const GoogleChrome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 8c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4 4-1.7909 4-4-1.7909-4-4-4m0 0h9.17M3.95 6.06 8.54 14m2.34 7.94L15.46 14M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const Hash01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 8h16M4 16h16M8 3v18m8-18v18"
    />
  </svg>
);

export const Hash02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9.5 3-3 18m11-18-3 18m6-13h-17m16 8h-17"
    />
  </svg>
);

export const Heart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.9932 5.1358C9.9938 2.7984 6.6598 2.1696 4.1547 4.31s-2.8577 5.719-.8905 8.2504c1.6356 2.1047 6.5856 6.5437 8.2079 7.9804.1815.1608.2723.2411.3781.2727a.504.504 0 0 0 .2859 0c.1058-.0316.1966-.1119.3781-.2727 1.6223-1.4367 6.5723-5.8757 8.2079-7.9804 1.9672-2.5314 1.6576-6.1325-.8905-8.2504-2.5481-2.1178-5.8391-1.5116-7.8384.8258"
      clipRule="evenodd"
    />
  </svg>
);

export const HeartCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.9966 9.068c-.9997-1.1688-2.6667-1.4832-3.9193-.413s-1.4288 2.8595-.4452 4.1252c.63.8107 2.2435 2.314 3.3221 3.2902.3585.3243.5377.4865.7524.5516a1.024 1.024 0 0 0 .58 0c.2146-.0651.3939-.2273.7523-.5516 1.0787-.9762 2.6921-2.4795 3.3222-3.2902.9836-1.2657.8288-3.0663-.4453-4.1252s-2.9195-.7558-3.9192.413"
      clipRule="evenodd"
    />
  </svg>
);

export const HeartHand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 20.0872h2.6103c.3403 0 .6786.0405 1.0085.1215l2.7581.6702a4.274 4.274 0 0 0 1.8266.0425l3.0495-.5933c.8055-.1569 1.5466-.5426 2.1273-1.1076l2.1576-2.0988c.6161-.5983.6161-1.5693 0-2.1686-.5547-.5396-1.4332-.6004-2.0608-.1428l-2.5145 1.8346c-.3601.2632-.7983.4049-1.2489.4049h-2.4282 1.5456c.8711 0 1.5768-.6865 1.5768-1.5339v-.3067c0-.7037-.4923-1.3172-1.1938-1.4873l-2.3855-.5801A5.03 5.03 0 0 0 11.6431 13c-.9648 0-2.7112.7988-2.7112.7988L6 15.0249M2 14.6v5.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 22 3.04 22 3.6 22h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 21.2401 6 20.9601 6 20.4v-5.8c0-.56 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C5.24 13 4.96 13 4.4 13h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 13.7599 2 14.04 2 14.6M17.1914 3.5923c-.5968-1.2489-1.9728-1.9105-3.311-1.272-1.3381.6387-1.9082 2.1531-1.3479 3.4825.3462.8217 1.3382 2.4172 2.0456 3.5163.2613.406.392.609.5829.7278.1637.1019.3687.1568.5614.1505.2247-.0075.4394-.118.8687-.339 1.1621-.598 2.819-1.4838 3.5297-2.0223 1.1499-.8712 1.4348-2.4725.5739-3.6898-.861-1.2174-2.362-1.3372-3.5033-.554"
    />
  </svg>
);

export const HeartHexagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.223 2.4316c.2836-.1575.4254-.2363.5755-.2672.133-.0273.27-.0273.403 0 .1501.031.2919.1097.5755.2672l7.4 4.1112c.2996.1664.4493.2496.5584.3679a1 1 0 0 1 .2141.364c.0505.1527.0505.324.0505.6667v8.1171c0 .3427 0 .514-.0505.6668a1 1 0 0 1-.2141.3639c-.1091.1184-.2588.2016-.5584.368l-7.4 4.1111c-.2836.1575-.4254.2363-.5755.2672-.133.0273-.27.0273-.403 0-.1501-.0309-.2919-.1097-.5755-.2672l-7.4-4.1111c-.2995-.1664-.4493-.2496-.5584-.368a1 1 0 0 1-.2141-.3639C3 16.5725 3 16.4012 3 16.0585v-8.117c0-.3427 0-.514.0505-.6669a1 1 0 0 1 .2141-.3639c.109-.1183.2588-.2015.5584-.368z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.9966 9.0679c-.9997-1.1687-2.6667-1.4831-3.9193-.413s-1.4288 2.8596-.4452 4.1253c.63.8107 2.2435 2.314 3.3221 3.2901.3585.3244.5377.4866.7524.5516.1845.056.3954.056.58 0 .2146-.065.3939-.2272.7523-.5516 1.0787-.9761 2.6921-2.4794 3.3222-3.2901.9836-1.2657.8288-3.0663-.4453-4.1252s-2.9195-.7558-3.9192.4129"
      clipRule="evenodd"
    />
  </svg>
);

export const HeartOctagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.3914 2.4686c.173-.173.2594-.2594.3603-.3212a1 1 0 0 1 .289-.1198C8.156 2 8.2783 2 8.5228 2h6.9546c.2445 0 .3668 0 .4819.0276a1 1 0 0 1 .2891.1198c.1009.0618.1874.1483.3603.3212l4.9228 4.9228c.1729.173.2594.2594.3212.3603a1 1 0 0 1 .1198.289C22 8.156 22 8.2783 22 8.5228v6.9546c0 .2445 0 .3668-.0276.4819a1 1 0 0 1-.1198.2891c-.0618.1009-.1483.1874-.3212.3603l-4.9228 4.9228c-.1729.1729-.2594.2594-.3603.3212a1 1 0 0 1-.2891.1198C15.8441 22 15.7218 22 15.4773 22H8.5227c-.2446 0-.3668 0-.482-.0276a1 1 0 0 1-.289-.1198c-.1009-.0618-.1874-.1483-.3603-.3212l-4.9228-4.9228c-.173-.1729-.2594-.2594-.3212-.3603a1 1 0 0 1-.1198-.2891C2 15.8441 2 15.7218 2 15.4773V8.5227c0-.2446 0-.3668.0276-.482a1 1 0 0 1 .1198-.289c.0618-.1009.1483-.1874.3212-.3603z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.9966 9.068c-.9997-1.1688-2.6667-1.4832-3.9193-.413s-1.4288 2.8595-.4452 4.1252c.63.8107 2.2435 2.314 3.3221 3.2902.3585.3243.5377.4865.7524.5516a1.024 1.024 0 0 0 .58 0c.2146-.0651.3939-.2273.7523-.5516 1.0787-.9762 2.6921-2.4795 3.3222-3.2902.9836-1.2657.8288-3.0663-.4453-4.1252s-2.9195-.7558-3.9192.413"
      clipRule="evenodd"
    />
  </svg>
);

export const HeartRounded = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.1111 3C19.6333 3 22 6.3525 22 9.48 22 15.8138 12.1778 21 12 21S2 15.8138 2 9.48C2 6.3525 4.3667 3 7.8889 3 9.911 3 11.2333 4.0237 12 4.9238 12.7667 4.0238 14.0889 3 16.1111 3"
    />
  </svg>
);

export const HeartSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.9966 9.068c-.9997-1.1688-2.6667-1.4832-3.9193-.413s-1.4288 2.8595-.4452 4.1252c.63.8107 2.2435 2.314 3.3221 3.2902.3585.3243.5377.4865.7524.5516a1.024 1.024 0 0 0 .58 0c.2146-.0651.3939-.2273.7523-.5516 1.0787-.9762 2.6921-2.4795 3.3222-3.2902.9836-1.2657.8288-3.0663-.4453-4.1252s-2.9195-.7558-3.9192.413"
      clipRule="evenodd"
    />
  </svg>
);

export const Hearts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.5455 9.9254c.374-.6644.6858-1.2639.8781-1.7202.9337-2.2157.0104-4.7644-2.2467-5.804-2.257-1.0397-4.5235.0383-5.5182 2.1197-1.9021-1.3052-4.4395-1.1135-5.8388.9233-1.3993 2.0369-.9601 4.6978.9564 6.1498.8698.659 2.59 1.6302 4.2097 2.4944m8.3112-2.3385c-.4221-2.2679-2.3518-3.9266-4.7816-3.4757-2.4297.4508-4.0007 2.6429-3.6722 5.0248.2639 1.9137 1.7205 6.4037 2.283 8.095.0768.2308.1151.3462.1911.4266a.505.505 0 0 0 .248.1432c.1077.0256.2268.0011.4651-.0478 1.7459-.3585 6.3627-1.342 8.152-2.0703 2.227-.9065 3.3763-3.3616 2.5155-5.6927s-3.2258-3.1715-5.4009-2.4031"
    />
  </svg>
);

export const HelpCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.09 9a2.9999 2.9999 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const HelpHexagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M3 7.9414v8.1171c0 .3427 0 .514.0505.6668a1 1 0 0 0 .2141.3639c.109.1184.2588.2016.5584.368l7.4 4.1111c.2836.1575.4254.2363.5755.2672.133.0273.27.0273.403 0 .1501-.0309.2919-.1097.5755-.2672l7.4-4.1111c.2996-.1664.4493-.2496.5584-.368a1 1 0 0 0 .2141-.3639C21 16.5725 21 16.4012 21 16.0585v-8.117c0-.3427 0-.514-.0505-.6669a1 1 0 0 0-.2141-.3639c-.1091-.1183-.2588-.2015-.5584-.368l-7.4-4.111c-.2836-.1576-.4254-.2364-.5755-.2673a1 1 0 0 0-.403 0c-.1501.031-.2919.1097-.5755.2672l-7.4 4.1112c-.2995.1664-.4493.2496-.5584.3679a1 1 0 0 0-.2141.364C3 7.4273 3 7.5986 3 7.9413"
    />
  </svg>
);

export const HelpOctagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M2 8.5227v6.9546c0 .2445 0 .3668.0276.4819a1 1 0 0 0 .1198.2891c.0618.1009.1483.1874.3212.3603l4.9228 4.9228c.173.1729.2594.2594.3603.3212a1 1 0 0 0 .289.1198C8.156 22 8.2783 22 8.5228 22h6.9546c.2445 0 .3668 0 .4819-.0276a1 1 0 0 0 .2891-.1198c.1009-.0618.1874-.1483.3603-.3212l4.9228-4.9228c.1729-.1729.2594-.2594.3212-.3603a1 1 0 0 0 .1198-.2891C22 15.8441 22 15.7218 22 15.4773V8.5227c0-.2446 0-.3668-.0276-.482a1 1 0 0 0-.1198-.289c-.0618-.1009-.1483-.1874-.3212-.3603l-4.9228-4.9228c-.1729-.173-.2594-.2594-.3603-.3212a1 1 0 0 0-.2891-.1198C15.8441 2 15.7218 2 15.4773 2H8.5227c-.2446 0-.3668 0-.482.0276a1 1 0 0 0-.289.1198c-.1009.0618-.1874.1483-.3603.3212L2.4686 7.3914c-.173.173-.2594.2594-.3212.3603a1 1 0 0 0-.1198.289C2 8.156 2 8.2783 2 8.5228"
    />
  </svg>
);

export const HelpSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.09 9a2.9999 2.9999 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const Home01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 10.5651c0-.5744 0-.8616.074-1.126a2 2 0 0 1 .318-.6502c.1633-.2208.39-.3971.8434-.7498l6.7823-5.2751c.3513-.2732.527-.4099.721-.4624a1 1 0 0 1 .5226 0c.194.0525.3697.1891.721.4624l6.7823 5.2751c.4534.3527.6801.529.8434.7498.1446.1955.2524.4159.318.6502.074.2644.074.5516.074 1.126V17.8c0 1.1201 0 1.6801-.218 2.108a2 2 0 0 1-.874.874C19.4802 21 18.9201 21 17.8 21H6.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.4801 3 18.9201 3 17.8z"
    />
  </svg>
);

export const Home02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 21v-7.4c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437C9.76 12 10.04 12 10.6 12h2.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054V21M11.0177 2.764 4.2354 8.0391c-.4534.3527-.68.529-.8434.7498a2 2 0 0 0-.318.6502C3 9.7035 3 9.9907 3 10.565V17.8c0 1.1201 0 1.6801.218 2.108.1917.3763.4977.6823.874.874C4.5198 21 5.08 21 6.2 21h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.4801 21 18.9201 21 17.8v-7.2349c0-.5744 0-.8616-.074-1.126a2 2 0 0 0-.318-.6502c-.1633-.2208-.39-.3971-.8434-.7498L12.9823 2.764c-.3513-.2732-.527-.4099-.721-.4624a1 1 0 0 0-.5226 0c-.194.0525-.3697.1891-.721.4624"
    />
  </svg>
);

export const Home03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 21v-7.4c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437C9.76 12 10.04 12 10.6 12h2.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054V21M2 9.5l9.04-6.78c.3443-.2582.5164-.3873.7054-.437.1669-.044.3423-.044.5092 0 .189.0497.3611.1788.7054.437L22 9.5M4 8v9.8c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C5.52 21 6.08 21 7.2 21h9.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C20 19.4802 20 18.9201 20 17.8V8l-6.08-4.56c-.6885-.5164-1.0328-.7746-1.4109-.8741a2 2 0 0 0-1.0182 0c-.3781.0995-.7224.3577-1.4109.8741z"
    />
  </svg>
);

export const Home04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 16c1.6569 0 3-1.3432 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 10.5651c0-.5744 0-.8616.074-1.126a2 2 0 0 1 .318-.6502c.1633-.2208.39-.3971.8434-.7498l6.7823-5.2751c.3513-.2732.527-.4099.721-.4624a1 1 0 0 1 .5226 0c.194.0525.3697.1891.721.4624l6.7823 5.2751c.4534.3527.6801.529.8434.7498.1446.1955.2524.4159.318.6502.074.2644.074.5516.074 1.126V17.8c0 1.1201 0 1.6801-.218 2.108a2 2 0 0 1-.874.874C19.4802 21 18.9201 21 17.8 21H6.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C3 19.4801 3 18.9201 3 17.8z"
    />
  </svg>
);

export const Home05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.9823 2.764c-.3513-.2732-.527-.4099-.721-.4624a1 1 0 0 0-.5226 0c-.194.0525-.3697.1891-.721.4624L4.2354 8.0391c-.4534.3527-.68.529-.8434.7498a2 2 0 0 0-.318.6502C3 9.7035 3 9.9907 3 10.565V17.8c0 1.1201 0 1.6801.218 2.108.1917.3763.4977.6823.874.874C4.5198 21 5.08 21 6.2 21h2c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C9 20.62 9 20.48 9 20.2v-6.6c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437C9.76 12 10.04 12 10.6 12h2.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054v6.6c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C15.38 21 15.52 21 15.8 21h2c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.4801 21 18.9201 21 17.8v-7.2349c0-.5744 0-.8616-.074-1.126a2 2 0 0 0-.318-.6502c-.1633-.2208-.39-.3971-.8434-.7498z"
    />
  </svg>
);

export const HomeLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 17h8M11.0177 2.764 4.2354 8.0391c-.4534.3527-.68.529-.8434.7498a2 2 0 0 0-.318.6502C3 9.7035 3 9.9907 3 10.565V17.8c0 1.1201 0 1.6801.218 2.108.1917.3763.4977.6823.874.874C4.5198 21 5.08 21 6.2 21h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.4801 21 18.9201 21 17.8v-7.2349c0-.5744 0-.8616-.074-1.126a2 2 0 0 0-.318-.6502c-.1633-.2208-.39-.3971-.8434-.7498L12.9823 2.764c-.3513-.2732-.527-.4099-.721-.4624a1 1 0 0 0-.5226 0c-.194.0525-.3697.1891-.721.4624"
    />
  </svg>
);

export const HomeSmile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.126 14c.444 1.7252 2.0102 3 3.874 3s3.4299-1.2748 3.874-3M11.0177 2.764 4.2354 8.0391c-.4534.3527-.68.529-.8434.7498a2 2 0 0 0-.318.6502C3 9.7035 3 9.9907 3 10.565V17.8c0 1.1201 0 1.6801.218 2.108.1917.3763.4977.6823.874.874C4.5198 21 5.08 21 6.2 21h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.4801 21 18.9201 21 17.8v-7.2349c0-.5744 0-.8616-.074-1.126a2 2 0 0 0-.318-.6502c-.1633-.2208-.39-.3971-.8434-.7498L12.9823 2.764c-.3513-.2732-.527-.4099-.721-.4624a1 1 0 0 0-.5226 0c-.194.0525-.3697.1891-.721.4624"
    />
  </svg>
);

export const InfoCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 16v-4m0-4h.01M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const InfoHexagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 16.0001v-4m0-4h.01M3 7.9415v8.1171c0 .3427 0 .514.0505.6668a1 1 0 0 0 .2141.3639c.109.1184.2588.2016.5584.368l7.4 4.1111c.2836.1576.4254.2363.5755.2672.133.0274.27.0274.403 0 .1501-.0309.2919-.1096.5755-.2672l7.4-4.1111c.2996-.1664.4493-.2496.5584-.368a1 1 0 0 0 .2141-.3639C21 16.5726 21 16.4013 21 16.0586v-8.117c0-.3427 0-.514-.0505-.6668a1 1 0 0 0-.2141-.364c-.1091-.1183-.2588-.2015-.5584-.368l-7.4-4.111c-.2836-.1576-.4254-.2364-.5755-.2673a1 1 0 0 0-.403 0c-.1501.031-.2919.1097-.5755.2673l-7.4 4.111c-.2995.1665-.4493.2497-.5584.368a1 1 0 0 0-.2141.364C3 7.4276 3 7.5988 3 7.9415"
    />
  </svg>
);

export const InfoOctagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 16v-4m0-4h.01M2 8.5227v6.9546c0 .2445 0 .3668.0276.4819a1 1 0 0 0 .1198.2891c.0618.1009.1483.1874.3212.3603l4.9228 4.9228c.173.1729.2594.2594.3603.3212a1 1 0 0 0 .289.1198C8.156 22 8.2783 22 8.5228 22h6.9546c.2445 0 .3668 0 .4819-.0276a1 1 0 0 0 .2891-.1198c.1009-.0618.1874-.1483.3603-.3212l4.9228-4.9228c.1729-.1729.2594-.2594.3212-.3603a1 1 0 0 0 .1198-.2891C22 15.8441 22 15.7218 22 15.4773V8.5227c0-.2446 0-.3668-.0276-.482a1 1 0 0 0-.1198-.289c-.0618-.1009-.1483-.1874-.3212-.3603l-4.9228-4.9228c-.1729-.173-.2594-.2594-.3603-.3212a1 1 0 0 0-.2891-.1198C15.8441 2 15.7218 2 15.4773 2H8.5227c-.2446 0-.3668 0-.482.0276a1 1 0 0 0-.289.1198c-.1009.0618-.1874.1483-.3603.3212L2.4686 7.3914c-.173.173-.2594.2594-.3212.3603a1 1 0 0 0-.1198.289C2 8.156 2 8.2783 2 8.5228"
    />
  </svg>
);

export const InfoSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 16v-4m0-4h.01M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const LifeBuoy01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.1363 9.1363 4.9289 4.929m0 14.1421 4.239-4.239m5.6932.0317 4.2073 4.2073m0-14.1421-4.2397 4.2396M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10m-6 0c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const LifeBuoy02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.4645 8.4645 4.9288 4.929m0 14.1421 3.5356-3.5356m7.071 0 3.5356 3.5355m0-14.142-3.5356 3.5354M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10m-5 0c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5"
    />
  </svg>
);

export const Link01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m12.7076 18.3639-1.4143 1.4142c-1.9526 1.9527-5.1184 1.9527-7.071 0-1.9526-1.9526-1.9526-5.1184 0-7.071l1.4142-1.4142m12.7279 1.4142 1.4142-1.4142c1.9526-1.9527 1.9526-5.1185 0-7.0711s-5.1184-1.9526-7.071 0L11.2933 5.636m-2.7928 9.8639 7-7"
    />
  </svg>
);

export const Link02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 17H7c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5h2m6 10h2c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5h-2m-8 5h10"
    />
  </svg>
);

export const Link03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 13a5 5 0 0 0 7.54.54l3-3a5.0002 5.0002 0 0 0-3.553-8.4734A5 5 0 0 0 13.47 3.47l-1.72 1.71M14 11a4.9997 4.9997 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
    />
  </svg>
);

export const Link04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.5 7H7c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5h2c2.7614 0 5-2.2386 5-5m2.5 5h.5c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5h-2c-2.7614 0-5 2.2386-5 5"
    />
  </svg>
);

export const Link05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 17H7c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5h2m-1 5h10m-2.2222 5H17c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5h-1.2222A.778.778 0 0 0 15 7.7778v8.4444c0 .4296.3482.7778.7778.7778"
    />
  </svg>
);

export const AlertCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 8v4m0 4h.01M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const AlertHexagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 8v4.0001m0 4h.01M3 7.9415v8.1171c0 .3427 0 .514.0505.6668a1 1 0 0 0 .2141.3639c.109.1184.2588.2016.5584.368l7.4 4.1111c.2836.1576.4254.2363.5755.2672.133.0274.27.0274.403 0 .1501-.0309.2919-.1096.5755-.2672l7.4-4.1111c.2996-.1664.4493-.2496.5584-.368a1 1 0 0 0 .2141-.3639C21 16.5726 21 16.4013 21 16.0586v-8.117c0-.3427 0-.514-.0505-.6668a1 1 0 0 0-.2141-.364c-.1091-.1183-.2588-.2015-.5584-.368l-7.4-4.111c-.2836-.1576-.4254-.2364-.5755-.2673a1 1 0 0 0-.403 0c-.1501.031-.2919.1097-.5755.2673l-7.4 4.111c-.2995.1665-.4493.2497-.5584.368a1 1 0 0 0-.2141.364C3 7.4276 3 7.5988 3 7.9415"
    />
  </svg>
);

export const AlertOctagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 8v4m0 4h.01M2 8.5227v6.9546c0 .2445 0 .3668.0276.4819a1 1 0 0 0 .1198.2891c.0618.1009.1483.1874.3212.3603l4.9228 4.9228c.173.1729.2594.2594.3603.3212a1 1 0 0 0 .289.1198C8.156 22 8.2783 22 8.5228 22h6.9546c.2445 0 .3668 0 .4819-.0276a1 1 0 0 0 .2891-.1198c.1009-.0618.1874-.1483.3603-.3212l4.9228-4.9228c.1729-.1729.2594-.2594.3212-.3603a1 1 0 0 0 .1198-.2891C22 15.8441 22 15.7218 22 15.4773V8.5227c0-.2446 0-.3668-.0276-.482a1 1 0 0 0-.1198-.289c-.0618-.1009-.1483-.1874-.3212-.3603l-4.9228-4.9228c-.1729-.173-.2594-.2594-.3603-.3212a1 1 0 0 0-.2891-.1198C15.8441 2 15.7218 2 15.4773 2H8.5227c-.2446 0-.3668 0-.482.0276a1 1 0 0 0-.289.1198c-.1009.0618-.1874.1483-.3603.3212L2.4686 7.3914c-.173.173-.2594.2594-.3212.3603a1 1 0 0 0-.1198.289C2 8.156 2 8.2783 2 8.5228"
    />
  </svg>
);

export const AlertSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 8v4m0 4h.01M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const AlertTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.9998 9v4m0 4h.01M10.6151 3.8917l-8.225 14.2066c-.4561.788-.6842 1.182-.6505 1.5054.0294.282.1772.5383.4065.7051.263.1912.7182.1912 1.6288.1912h16.4497c.9106 0 1.3658 0 1.6288-.1912a1 1 0 0 0 .4065-.7051c.0337-.3234-.1944-.7174-.6506-1.5054L13.3844 3.8917c-.4545-.7852-.6818-1.1777-.9783-1.3096a1 1 0 0 0-.8126 0c-.2966.1319-.5239.5244-.9784 1.3096"
    />
  </svg>
);

export const Announcement01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 8v3.9999m-11.75-6.5H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 7.7797 2 8.6198 2 10.3v1.2c0 .9319 0 1.3978.1522 1.7654.203.49.5924.8794 1.0824 1.0824.3676.1522.8335.1522 1.7654.1522v4.25c0 .2322 0 .3483.0096.446a2 2 0 0 0 1.7944 1.7944c.0977.0096.2138.0096.446.0096s.3483 0 .446-.0096a2 2 0 0 0 1.7944-1.7944c.0096-.0977.0096-.2138.0096-.446v-4.25h.75c1.7664 0 3.9272.9469 5.5943 1.8557.9725.5301 1.4588.7952 1.7773.7562.2953-.0362.5186-.1688.6917-.4108.1867-.2609.1867-.7831.1867-1.8274V5.1262c0-1.0443 0-1.5664-.1867-1.8274-.1731-.242-.3964-.3746-.6917-.4108-.3185-.039-.8048.2261-1.7773.7563-1.6671.9087-3.8279 1.8556-5.5943 1.8556"
    />
  </svg>
);

export const Announcement02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m4 13.9999 1.5747 6.2986c.0442.1771.0664.2657.0926.343a2 2 0 0 0 1.7312 1.3518c.0814.0066.1727.0066.3553.0066.2286 0 .343 0 .4393-.0093a2 2 0 0 0 1.7976-1.7976C10 20.0967 10 19.9823 10 19.7537V5.4999m8.5 8c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5m-8.25-1H6.5C4.0147 5.5 2 7.5146 2 10s2.0147 4.5 4.5 4.5h3.75c1.7664 0 3.9272.9469 5.5943 1.8557.9725.5301 1.4588.7952 1.7773.7562.2953-.0362.5186-.1688.6917-.4108.1867-.2609.1867-.7831.1867-1.8274V5.1262c0-1.0443 0-1.5664-.1867-1.8274-.1731-.242-.3964-.3746-.6917-.4108-.3185-.039-.8048.2261-1.7773.7563-1.6671.9087-3.8279 1.8556-5.5943 1.8556"
    />
  </svg>
);

export const Announcement03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18.5 16c1.933 0 3.5-2.9101 3.5-6.5C22 5.9102 20.433 3 18.5 3m0 13c-1.933 0-3.5-2.9101-3.5-6.5C15 5.9102 16.567 3 18.5 3m0 13L5.4435 13.6261c-.9275-.1686-1.3912-.253-1.7662-.4371a3 3 0 0 1-1.5632-1.8731C2 10.914 2 10.4427 2 9.5s0-1.414.1141-1.816a3 3 0 0 1 1.5632-1.873c.375-.1841.8388-.2685 1.7662-.4371L18.5 3M5 14l.3939 5.514c.0374.5236.056.7855.17.9839a1 1 0 0 0 .4324.4026c.206.0995.4685.0995.9935.0995h1.7824c.6001 0 .9002 0 1.1223-.1197a1 1 0 0 0 .4397-.4748c.1023-.2306.0793-.5298.0333-1.1282L10 14.5"
    />
  </svg>
);

export const Bell01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.3542 21c.7051.6224 1.6314 1 2.6458 1a3.984 3.984 0 0 0 2.6458-1M18 8A6 6 0 1 0 6 8c0 3.0902-.7795 5.206-1.6503 6.6054-.7346 1.1805-1.1018 1.7707-1.0884 1.9354.015.1823.0536.2518.2005.3608C3.5945 17 4.1926 17 5.3888 17h13.2224c1.1962 0 1.7944 0 1.927-.0984.147-.109.1856-.1785.2005-.3608.0135-.1647-.3538-.7549-1.0883-1.9354C18.7795 13.206 18 11.0902 18 8"
    />
  </svg>
);

export const Bell02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 21h-4m8-13A6 6 0 1 0 6 8c0 3.0902-.7795 5.206-1.6503 6.6054-.7346 1.1805-1.1018 1.7707-1.0884 1.9354.015.1823.0536.2518.2005.3608C3.5945 17 4.1926 17 5.3888 17h13.2224c1.1962 0 1.7944 0 1.927-.0984.147-.109.1856-.1785.2005-.3608.0135-.1647-.3538-.7549-1.0883-1.9354C18.7795 13.206 18 11.0902 18 8"
    />
  </svg>
);

export const Bell03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14.9997 19c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3m4.7965-12.7614c.4355-.45.7035-1.063.7035-1.7386 0-1.3807-1.1193-2.5-2.5-2.5s-2.5 1.1193-2.5 2.5c0 .6756.268 1.2886.7035 1.7386M17.9997 11.2c0-1.3791-.6321-2.7018-1.7573-3.677C15.1171 6.548 13.591 6 11.9997 6s-3.1174.5479-4.2426 1.523C6.6319 8.4982 5.9997 9.821 5.9997 11.2c0 2.2818-.5659 3.9506-1.272 5.1447-.8046 1.3609-1.207 2.0414-1.1911 2.2039.0182.186.0516.2447.2025.355C3.8709 19 4.5332 19 5.8579 19h12.2836c1.3247 0 1.9871 0 2.1189-.0964.1508-.1103.1843-.169.2025-.355.0158-.1625-.3865-.843-1.1912-2.2039-.7061-1.1941-1.272-2.8629-1.272-5.1447"
    />
  </svg>
);

export const Bell04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14.391 18.015c.4288 1.6004-.5209 3.2454-2.1213 3.6743-1.6004.4288-3.2454-.521-3.6743-2.1214m2.2961-13.8268a2.492 2.492 0 0 0 .2296-1.8614c-.3574-1.3337-1.7282-2.1251-3.0619-1.7678S5.9341 3.8401 6.2914 5.1738A2.492 2.492 0 0 0 7.421 6.671m8.815 2.7745c-.3569-1.3321-1.3099-2.446-2.6491-3.0968-1.3393-.6507-2.9552-.785-4.4923-.373-1.537.4118-2.8694 1.336-3.7039 2.5692s-1.1028 2.6743-.7458 4.0065c.5906 2.204.4759 3.9624.103 5.2985-.4251 1.5229-.6377 2.2843-.5802 2.4372.0656.1749.1132.223.2874.2905.1523.059.792-.1125 2.0716-.4553l11.8651-3.1792c1.2795-.3429 1.9193-.5143 2.0217-.6416.1171-.1456.1342-.2109.1037-.3952-.0267-.1612-.5915-.7143-1.7211-1.8206-.991-.9707-1.9695-2.4361-2.5601-4.6402"
    />
  </svg>
);

export const BellMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.3542 21c.7051.6224 1.6314 1 2.6458 1a3.984 3.984 0 0 0 2.6458-1M15 5h6m-8-2.9161a6 6 0 0 0-5.2426 1.6735A6 6 0 0 0 6 8c0 3.0902-.7795 5.206-1.6503 6.6054-.7346 1.1805-1.1018 1.7707-1.0884 1.9354.015.1823.0536.2518.2005.3608C3.5945 17 4.1926 17 5.3888 17h13.2224c1.1963 0 1.7944 0 1.9271-.0984.1469-.109.1856-.1785.2005-.3609.0134-.1646-.3538-.7547-1.0883-1.935-.7735-1.2431-1.4751-3.0513-1.6222-5.6057"
    />
  </svg>
);

export const BellOff01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.633 3.0337A6.0001 6.0001 0 0 1 18 8c0 2.1008.2702 3.7512.6484 5.0324M6.2587 6.2572A6 6 0 0 0 6 8c0 3.0902-.7795 5.206-1.6503 6.6054-.7346 1.1805-1.1018 1.7707-1.0884 1.9354.015.1823.0536.2518.2005.3608C3.5945 17 4.1926 17 5.3888 17H17m-7.6458 4c.7051.6224 1.6314 1 2.6458 1a3.985 3.985 0 0 0 2.6458-1M21 21 3 3"
    />
  </svg>
);

export const BellOff02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 21h-4M8.633 3.0337A6.0001 6.0001 0 0 1 18 8c0 2.1008.2702 3.7512.6484 5.0324M6.2587 6.2572A6 6 0 0 0 6 8c0 3.0902-.7795 5.206-1.6503 6.6054-.7346 1.1805-1.1018 1.7707-1.0884 1.9354.015.1823.0536.2518.2005.3608C3.5945 17 4.1926 17 5.3888 17H17m4 4L3 3"
    />
  </svg>
);

export const BellOff03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 19c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3M7.3775 7.8848C6.4909 8.8133 6 9.9847 6 11.2c0 2.2818-.5659 3.9506-1.272 5.1447-.8047 1.3609-1.207 2.0414-1.1911 2.2039.0181.186.0516.2447.2024.355C3.8712 19 4.5335 19 5.8582 19H19.88M12 6c-.2929 0-.5836.0186-.87.055-.3815.0484-.5723.0726-.7638.0206-.1378-.0375-.3456-.1583-.4464-.2596-.14-.1406-.1706-.2148-.2318-.3631A2.49 2.49 0 0 1 9.5 4.5C9.5 3.1193 10.6193 2 12 2s2.5 1.1193 2.5 2.5c0 .6756-.268 1.2886-.7035 1.7386A6.85 6.85 0 0 0 12 6m0 0c1.5913 0 3.1174.5479 4.2426 1.523C17.3679 8.4982 18 9.821 18 11.2c0 .3348.0091.6563.0264.9652M21 20 3 4"
    />
  </svg>
);

export const BellPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.3542 21c.7051.6224 1.6314 1 2.6458 1a3.984 3.984 0 0 0 2.6458-1M18 8V2m-3 3h6m-8-2.9161a6 6 0 0 0-5.2426 1.6735A6 6 0 0 0 6 8c0 3.0902-.7795 5.206-1.6503 6.6054-.7346 1.1805-1.1018 1.7707-1.0884 1.9354.015.1823.0536.2518.2005.3608C3.5945 17 4.1926 17 5.3888 17h13.2224c1.1962 0 1.7943 0 1.927-.0984.1469-.109.1855-.1785.2004-.3608.0135-.1647-.3538-.755-1.0884-1.9356-.492-.7908-.9549-1.8104-1.2645-3.1052"
    />
  </svg>
);

export const BellRinging01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.3544 21c.7052.6224 1.6314 1 2.6458 1a3.985 3.985 0 0 0 2.6459-1M2.2941 5.8199C2.2798 4.3685 3.0623 3.0133 4.3264 2.3m17.376 3.5199c.0143-1.4513-.7682-2.8066-2.0322-3.5199m-1.67 5.7a6 6 0 1 0-12 0c0 3.0902-.7795 5.206-1.6503 6.6054-.7345 1.1805-1.1018 1.7707-1.0883 1.9354.0149.1823.0535.2518.2004.3608C3.5947 17 4.1928 17 5.3891 17h13.2223c1.1963 0 1.7944 0 1.9271-.0984.1469-.109.1855-.1785.2004-.3608.0135-.1647-.3538-.7549-1.0883-1.9354-.8708-1.3994-1.6504-3.5152-1.6504-6.6054"
    />
  </svg>
);

export const BellRinging02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14.0003 21h-4M2.2941 5.8199C2.2798 4.3685 3.0623 3.0133 4.3264 2.3m17.3761 3.5199c.0144-1.4513-.7681-2.8066-2.0322-3.5199m-1.67 5.7a5.9997 5.9997 0 0 0-6-6 6 6 0 0 0-6 6c0 3.0902-.7795 5.206-1.6503 6.6054-.7346 1.1805-1.1018 1.7707-1.0884 1.9354.015.1823.0536.2518.2005.3608C3.5948 17 4.1929 17 5.389 17h13.2223c1.1963 0 1.7944 0 1.9271-.0984.1469-.109.1856-.1785.2005-.3608.0134-.1647-.3538-.7549-1.0884-1.9354-.8708-1.3994-1.6503-3.5152-1.6503-6.6054"
    />
  </svg>
);

export const BellRinging03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.0002 19c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3m4.7966-12.7614A2.492 2.492 0 0 0 14.5002 4.5c0-1.3807-1.1192-2.5-2.5-2.5s-2.5 1.1193-2.5 2.5c0 .6756.268 1.2886.7035 1.7386M2.5471 8.323c-.0144-1.4514.7681-2.8067 2.0322-3.52m16.8741 3.52c.0144-1.4514-.7681-2.8067-2.0322-3.52m-1.421 6.397c0-1.3791-.6321-2.7018-1.7573-3.677C15.1177 6.548 13.5915 6 12.0002 6s-3.1174.5479-4.2426 1.523C6.6324 8.4982 6.0003 9.821 6.0003 11.2c0 2.2818-.566 3.9506-1.272 5.1447-.8047 1.3609-1.207 2.0414-1.1912 2.2039.0182.186.0517.2447.2025.355C3.8714 19 4.5338 19 5.8584 19h12.2837c1.3246 0 1.987 0 2.1188-.0964.1508-.1103.1843-.169.2025-.355.0159-.1625-.3865-.843-1.1912-2.2039-.7061-1.1941-1.272-2.8629-1.272-5.1447"
    />
  </svg>
);

export const BellRinging04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.6459 18.0148c.4288 1.6004-.5209 3.2454-2.1213 3.6742s-3.2454-.5209-3.6742-2.1213m-7.7936-7.9544c-.3895-1.3982.0156-2.9098 1.052-3.926m9.0375-1.9464a2.492 2.492 0 0 0 .2296-1.8614c-.3574-1.3337-1.7282-2.1252-3.0619-1.7678S7.1889 3.8399 7.5462 5.1735a2.492 2.492 0 0 0 1.1295 1.4973M20.319 6.72c-.3618-1.4056-1.4684-2.5122-2.874-2.874m.0456 5.5993c-.3569-1.3322-1.3098-2.4461-2.6491-3.0968s-2.9552-.785-4.4923-.3731c-1.537.4118-2.8694 1.336-3.7039 2.5692s-1.1027 2.6744-.7458 4.0065c.5906 2.2041.476 3.9624.103 5.2986-.4251 1.5228-.6376 2.2843-.5802 2.4372.0657.1749.1132.2229.2874.2904.1523.059.792-.1124 2.0716-.4553l11.8651-3.1792c1.2795-.3429 1.9193-.5143 2.0217-.6415.1171-.1456.1343-.2109.1037-.3953-.0267-.1611-.5915-.7142-1.721-1.8205-.9911-.9707-1.9696-2.4362-2.5602-4.6402"
    />
  </svg>
);

export const NotificationBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8v7.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h7.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.7202 20 17.8802 20 16.2V13m.1213-9.1213c1.1716 1.1716 1.1716 3.071 0 4.2426s-3.071 1.1716-4.2426 0-1.1716-3.071 0-4.2426 3.071-1.1716 4.2426 0"
    />
  </svg>
);

export const NotificationMessage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8V14c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C5.605 18 6.07 18 7 18v2.3355c0 .5329 0 .7993.1092.9361a.5.5 0 0 0 .3913.1881c.1751-.0002.3832-.1666.7993-.4995l2.3854-1.9084c.4873-.3898.731-.5847 1.0023-.7233a3 3 0 0 1 .7617-.2672C12.7477 18 13.0597 18 13.6837 18H15.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 15.7202 20 14.8802 20 13.2V13m.1213-9.1213c1.1716 1.1716 1.1716 3.071 0 4.2426s-3.071 1.1716-4.2426 0-1.1716-3.071 0-4.2426 3.071-1.1716 4.2426 0"
    />
  </svg>
);

export const NotificationText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8v7.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h7.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.7202 20 17.8802 20 16.2V13m-7 4H7m8-4H7m13.1213-9.1213c1.1716 1.1716 1.1716 3.071 0 4.2426s-3.071 1.1716-4.2426 0-1.1716-3.071 0-4.2426 3.071-1.1716 4.2426 0"
    />
  </svg>
);

export const ThumbsDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.0001 2v11m5-3.2V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.8741-.874C20.4802 2 19.9202 2 18.8001 2H8.1181c-1.4615 0-2.1923 0-2.7825.2674a3 3 0 0 0-1.2743 1.0933c-.354.5427-.4652 1.265-.6874 2.7094l-.5231 3.4c-.2931 1.9052-.4397 2.8578-.157 3.599a3 3 0 0 0 1.3202 1.5388C4.7036 15 5.6674 15 7.595 15H8.4c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.1091.2139.1091.4939.1091 1.054v2.9342C10.0001 20.896 11.104 22 12.4659 22a.822.822 0 0 0 .7511-.4881l3.3608-7.5617c.1528-.344.2292-.5159.35-.642a1 1 0 0 1 .3832-.249C17.4753 13 17.6635 13 18.0398 13h.7603c1.1201 0 1.6801 0 2.1079-.218a2 2 0 0 0 .8741-.874c.218-.4278.218-.9879.218-2.108"
    />
  </svg>
);

export const ThumbsUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 22V11m-5 2v7c0 1.1046.8954 2 2 2h13.4262c1.4808 0 2.74-1.0803 2.9652-2.5438l1.0769-7C21.7479 10.6389 20.3418 9 18.5032 9H15c-.5523 0-1-.4477-1-1V4.4658C14 3.104 12.896 2 11.5342 2a.822.822 0 0 0-.7511.4881l-3.5192 7.918A1 1 0 0 1 6.3501 11H4c-1.1046 0-2 .8954-2 2"
    />
  </svg>
);

export const Circle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    />
  </svg>
);

export const Cube01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20.5 7.2778 12 12.0001m0 0L3.5 7.2778m8.5 4.7223v9.5m9-5.4415v-8.117c0-.3427 0-.514-.0505-.6668a1 1 0 0 0-.2141-.364c-.1091-.1183-.2588-.2015-.5584-.368l-7.4-4.111c-.2836-.1576-.4254-.2364-.5755-.2673a1 1 0 0 0-.4029 0c-.1502.031-.292.1097-.5756.2673l-7.4 4.111c-.2995.1665-.4493.2497-.5584.368a1 1 0 0 0-.2141.364C3 7.4276 3 7.5988 3 7.9415v8.1171c0 .3427 0 .514.0505.6668a1 1 0 0 0 .2141.3639c.109.1184.2588.2016.5584.368l7.4 4.1111c.2836.1576.4254.2363.5756.2672a1 1 0 0 0 .4029 0c.1501-.0309.2919-.1096.5755-.2672l7.4-4.1111c.2996-.1664.4493-.2496.5584-.368a1 1 0 0 0 .2141-.3639C21 16.5726 21 16.4013 21 16.0586"
    />
  </svg>
);

export const Cube02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 2.5v9.5001m0 0 8.5-4.7223M12 12 3.5 7.2778M12 12v9.5m8.5-4.7778-7.723-4.2905c-.2836-.1576-.4254-.2364-.5755-.2673a1 1 0 0 0-.4029 0c-.1502.0309-.292.1097-.5756.2673L3.5 16.7223m17.5-.6637v-8.117c0-.3427 0-.514-.0505-.6668a1 1 0 0 0-.2141-.364c-.1091-.1183-.2588-.2015-.5584-.368l-7.4-4.111c-.2836-.1576-.4254-.2364-.5755-.2673a1 1 0 0 0-.4029 0c-.1502.031-.292.1097-.5756.2673l-7.4 4.111c-.2995.1665-.4493.2497-.5584.368a1 1 0 0 0-.2141.364C3 7.4276 3 7.5988 3 7.9415v8.1171c0 .3427 0 .514.0505.6668a1 1 0 0 0 .2141.3639c.109.1184.2588.2016.5584.368l7.4 4.1111c.2836.1576.4254.2363.5756.2672a1 1 0 0 0 .4029 0c.1501-.0309.2919-.1096.5755-.2672l7.4-4.1111c.2996-.1664.4493-.2496.5584-.368a1 1 0 0 0 .2141-.3639C21 16.5726 21 16.4013 21 16.0586"
    />
  </svg>
);

export const Cube03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3.5 8H16m0 0v12.5M16 8l4.5-4.5m.5 11.8373V3.8c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C20.62 3 20.48 3 20.2 3H8.6627c-.2445 0-.3668 0-.482.0276a1 1 0 0 0-.289.1198c-.1009.0618-.1874.1483-.3603.3212L3.4686 7.5314c-.173.173-.2594.2594-.3212.3603a1 1 0 0 0-.1198.289C3 8.296 3 8.4183 3 8.6628V20.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C3.38 21 3.52 21 3.8 21h11.5373c.2445 0 .3668 0 .4819-.0276a1 1 0 0 0 .2891-.1198c.1009-.0618.1874-.1483.3603-.3212l4.0628-4.0628c.1729-.1729.2594-.2594.3212-.3603a1 1 0 0 0 .1198-.2891C21 15.7041 21 15.5818 21 15.3373"
    />
  </svg>
);

export const Cube04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20.5 16H8m0 0V3.5M8 16l-4.5 4.5M3.5 8H16m0 0v12.5M16 8l4.5-4.5m.5 11.8373V3.8c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C20.62 3 20.48 3 20.2 3H8.6627c-.2445 0-.3668 0-.482.0276a1 1 0 0 0-.289.1198c-.1009.0618-.1874.1483-.3603.3212L3.4686 7.5314c-.173.173-.2594.2594-.3212.3603a1 1 0 0 0-.1198.289C3 8.296 3 8.4183 3 8.6628V20.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C3.38 21 3.52 21 3.8 21h11.5373c.2445 0 .3668 0 .4819-.0276a1 1 0 0 0 .2891-.1198c.1009-.0618.1874-.1483.3603-.3212l4.0628-4.0628c.1729-.1729.2594-.2594.3212-.3603a1 1 0 0 0 .1198-.2891C21 15.7041 21 15.5818 21 15.3373"
    />
  </svg>
);

export const CubeOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9.75 20.7501 1.473.8183c.2836.1576.4254.2363.5756.2672a1 1 0 0 0 .4029 0c.1501-.0309.2919-.1096.5755-.2672l1.473-.8183m-9-2.5-1.427-.7928c-.2995-.1664-.4493-.2496-.5584-.368a1 1 0 0 1-.2141-.3639C3 16.5726 3 16.4013 3 16.0586v-1.5585m0-5V7.9415c0-.3426 0-.514.0505-.6667a1 1 0 0 1 .2141-.364c.109-.1183.2588-.2015.5584-.368l1.427-.7927m4.5-2.5 1.473-.8183c.2836-.1576.4254-.2364.5756-.2673a1 1 0 0 1 .4029 0c.1501.031.2919.1097.5755.2673l1.473.8183m4.5 2.5 1.427.7928c.2996.1664.4493.2496.5584.368a1 1 0 0 1 .2141.3639c.0505.1528.0505.324.0505.6667v1.5586m0 5v1.5585c0 .3427 0 .514-.0505.6668a1 1 0 0 1-.2141.3639c-.1091.1184-.2588.2016-.5584.368l-1.427.7928m-9-7.5 2.25 1.25m0 0 2.25-1.25m-2.25 1.25v2.5m-9-7.5 2.25 1.25m13.5 0L21 7m-9 12.5v2.5"
    />
  </svg>
);

export const Dice1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 12h.005M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21m4.45-9a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
    />
  </svg>
);

export const Dice2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.25 8.75h.005m-6.505 6.5h.005M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21m7.7-12.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M9 15.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
    />
  </svg>
);

export const Dice4 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.25 7.75h.005m-.005 8.5h.005M7.75 7.75h.005m-.005 8.5h.005M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21m8.7-13.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 8.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M8 7.75a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 8.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
    />
  </svg>
);

export const Dice3 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.25 7.75h.005M12 12h.005M7.75 16.25h.005M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21m8.7-13.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M12.25 12a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M8 16.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
    />
  </svg>
);

export const Dice5 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.25 7.75h.005m-.005 8.5h.005M7.75 7.75h.005M12 12h.005M7.75 16.25h.005M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21m8.7-13.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 8.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M8 7.75a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M12.25 12a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M8 16.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
    />
  </svg>
);

export const Dice6 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.25 7.75h.005m-.005 4h.005m-.005 4.5h.005M7.75 7.75h.005m-.005 4h.005m-.005 4.5h.005M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21m8.7-13.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 4a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 4.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M8 7.75a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 4a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 4.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
    />
  </svg>
);

export const Hexagon01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.223 2.4318c.2836-.1576.4254-.2364.5755-.2673.133-.0273.27-.0273.403 0 .1501.031.2919.1097.5755.2673l7.4 4.111c.2996.1665.4493.2497.5584.368a1 1 0 0 1 .2141.364c.0505.1528.0505.324.0505.6667v8.1171c0 .3427 0 .514-.0505.6668a1 1 0 0 1-.2141.3639c-.1091.1184-.2588.2016-.5584.368l-7.4 4.1111c-.2836.1576-.4254.2363-.5755.2672a1 1 0 0 1-.403 0c-.1501-.0309-.2919-.1096-.5755-.2672l-7.4-4.1111c-.2995-.1664-.4493-.2496-.5584-.368a1 1 0 0 1-.2141-.3639C3 16.5726 3 16.4013 3 16.0586v-8.117c0-.3427 0-.514.0505-.6668a1 1 0 0 1 .2141-.364c.109-.1183.2588-.2015.5584-.368z"
    />
  </svg>
);

export const Hexagon02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21.5679 11.223c.1576.2836.2363.4254.2672.5755a1 1 0 0 1 0 .403c-.0309.1501-.1096.2919-.2672.5755l-4.1111 7.4c-.1664.2996-.2496.4493-.3679.5584a1 1 0 0 1-.364.2141C16.5721 21 16.4008 21 16.0582 21H7.941c-.3426 0-.514 0-.6667-.0505a1 1 0 0 1-.364-.2141c-.1183-.1091-.2015-.2588-.368-.5584l-4.111-7.4c-.1576-.2836-.2364-.4254-.2672-.5755a1 1 0 0 1 0-.403c.0308-.1501.1096-.2919.2672-.5755l4.111-7.4c.1665-.2995.2497-.4493.368-.5584a1 1 0 0 1 .364-.2141C7.427 3 7.5984 3 7.941 3h8.1172c.3426 0 .5139 0 .6667.0505.1352.0446.2593.1177.364.2141.1183.109.2015.2588.3679.5584z"
    />
  </svg>
);

export const Octagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.3914 2.4686c.173-.173.2594-.2594.3603-.3212a1 1 0 0 1 .289-.1198C8.156 2 8.2783 2 8.5228 2h6.9546c.2445 0 .3668 0 .4819.0276a1 1 0 0 1 .2891.1198c.1009.0618.1874.1483.3603.3212l4.9228 4.9228c.1729.173.2594.2594.3212.3603a1 1 0 0 1 .1198.289C22 8.156 22 8.2783 22 8.5228v6.9546c0 .2445 0 .3668-.0276.4819a1 1 0 0 1-.1198.2891c-.0618.1009-.1483.1874-.3212.3603l-4.9228 4.9228c-.1729.1729-.2594.2594-.3603.3212a1 1 0 0 1-.2891.1198C15.8441 22 15.7218 22 15.4773 22H8.5227c-.2446 0-.3668 0-.482-.0276a1 1 0 0 1-.289-.1198c-.1009-.0618-.1874-.1483-.3603-.3212l-4.9228-4.9228c-.173-.1729-.2594-.2594-.3212-.3603a1 1 0 0 1-.1198-.2891C2 15.8441 2 15.7218 2 15.4773V8.5227c0-.2446 0-.3668.0276-.482a1 1 0 0 1 .1198-.289c.0618-.1009.1483-.1874.3212-.3603z"
    />
  </svg>
);

export const Pentagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.0605 2.932c.3378-.2451.5067-.3677.6913-.415.163-.0419.334-.0419.497 0 .1846.0473.3535.1699.6913.415l8.1185 5.892c.3384.2456.5077.3683.61.5295a1 1 0 0 1 .1538.4733c.012.1906-.0527.3894-.182.787l-3.1003 9.5311c-.1292.3972-.1938.5958-.3154.7427a1 1 0 0 1-.4023.2922c-.1773.0702-.3862.0702-.8038.0702H6.982c-.4176 0-.6265 0-.8038-.0702a1 1 0 0 1-.4023-.2922c-.1216-.1469-.1862-.3455-.3154-.7427l-3.1003-9.5311c-.1293-.3976-.194-.5964-.182-.787a1 1 0 0 1 .1538-.4733c.1023-.1612.2715-.284.61-.5295z"
    />
  </svg>
);

export const Square = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2z"
    />
  </svg>
);

export const Star01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.2827 3.4533c.2304-.467.3457-.7004.5021-.775a.5.5 0 0 1 .4304 0c.1565.0746.2717.308.5022.775l2.1867 4.43c.068.1378.102.2068.1517.2603a.5.5 0 0 0 .1555.113c.0663.0308.1423.042.2944.0642l4.8913.715c.5151.0752.7726.1128.8918.2386a.5.5 0 0 1 .1327.4094c-.0227.1718-.2091.3534-.582.7166l-3.5381 3.446c-.1102.1074-.1654.1612-.201.2251a.5.5 0 0 0-.0595.183c-.0088.0726.0042.1485.0302.3002l.8349 4.8674c.088.5134.132.7701.0493.9224a.5.5 0 0 1-.3482.253c-.1705.0316-.401-.0897-.862-.3321l-4.3727-2.2996c-.1363-.0716-.2044-.1074-.2762-.1215a.5.5 0 0 0-.1924 0c-.0718.0141-.1399.0499-.2761.1215l-4.3728 2.2996c-.461.2424-.6915.3637-.862.3321a.5.5 0 0 1-.3482-.253c-.0827-.1523-.0387-.409.0494-.9224l.8348-4.8674c.026-.1517.039-.2276.0302-.3002a.5.5 0 0 0-.0595-.183c-.0356-.0639-.0907-.1177-.201-.2251l-3.538-3.446c-.373-.3632-.5594-.5448-.582-.7166a.5.5 0 0 1 .1327-.4094c.1191-.1258.3767-.1634.8917-.2387l4.8913-.715c.1521-.0222.2282-.0333.2944-.064a.5.5 0 0 0 .1555-.1131c.0497-.0535.0837-.1225.1518-.2603z"
    />
  </svg>
);

export const Star02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.3063 3.207c.2275-.396.3413-.5938.4899-.6602a.5.5 0 0 1 .4075 0c.1487.0663.2624.2643.4899.6601l1.9551 3.4024c.0843.1465.1264.2198.1854.273a.5.5 0 0 0 .1807.1044c.0757.0245.1602.0243.3292.024l3.9241-.008c.4565-.001.6848-.0014.8166.0942a.5.5 0 0 1 .2037.3529c.0169.162-.0976.3594-.3267.7543l-1.9689 3.3944c-.0848.1462-.1272.2193-.1438.297a.5.5 0 0 0 0 .2088c.0166.0777.059.1508.1438.297l1.9689 3.3944c.2291.3949.3436.5924.3267.7543a.5.5 0 0 1-.2037.3529c-.1318.0956-.3601.0951-.8166.0942l-3.9241-.008c-.169-.0003-.2535-.0005-.3292.024a.5.5 0 0 0-.1807.1044c-.059.0532-.1011.1265-.1854.273l-1.9551 3.4024c-.2275.3958-.3412.5938-.4899.6601a.5.5 0 0 1-.4075 0c-.1486-.0663-.2624-.2643-.4899-.6601l-1.9551-3.4024c-.0843-.1465-.1264-.2198-.1854-.273a.5.5 0 0 0-.1807-.1044c-.0757-.0245-.1602-.0243-.3292-.024l-3.924.008c-.4566.0009-.685.0014-.8167-.0942a.5.5 0 0 1-.2037-.3529c-.017-.1619.0976-.3594.3267-.7543l1.969-3.3944c.0847-.1462.1271-.2193.1437-.297a.5.5 0 0 0 0-.2088c-.0166-.0777-.059-.1508-.1438-.297L4.0382 8.2041c-.229-.395-.3436-.5924-.3267-.7543a.5.5 0 0 1 .2037-.3529c.1318-.0956.36-.0951.8166-.0942l3.9241.008c.169.0003.2535.0005.3292-.024a.5.5 0 0 0 .1807-.1044c.059-.0532.1011-.1265.1854-.273z"
    />
  </svg>
);

export const Star03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.2896 3.3664c.2297-.4421.3446-.6632.4985-.735a.5.5 0 0 1 .4229 0c.1539.0718.2688.2929.4985.735l1.513 2.9122c.0991.1907.1486.286.2229.3494a.5.5 0 0 0 .2291.1104c.0959.0186.2013-.0022.4122-.0436l3.2202-.6328c.4889-.0961.7333-.1441.8854-.0686a.5.5 0 0 1 .2637.3307c.0398.1651-.0614.3927-.2638.848l-1.3336 2.9986c-.0873.1964-.131.2946-.1342.3921a.5.5 0 0 0 .0566.248c.0452.0865.1272.156.291.295l2.5026 2.1232c.3799.3223.5699.4834.6057.6495a.5.5 0 0 1-.0941.4123c-.1043.1341-.3454.1968-.8275.3224l-3.176.827c-.2079.0542-.3119.0813-.3902.1396a.5.5 0 0 0-.1585.1988c-.0395.0894-.0428.1968-.0493.4115l-.0996 3.2804c-.0151.498-.0227.747-.1302.8785a.5.5 0 0 1-.381.1835c-.1699.002-.3692-.1473-.768-.446l-2.6268-1.9674c-.172-.1288-.258-.1932-.3524-.218a.5.5 0 0 0-.2543 0c-.0944.0248-.1804.0892-.3524.218l-2.6268 1.9674c-.3988.2987-.5981.448-.768.446a.5.5 0 0 1-.381-.1835c-.1075-.1315-.115-.3805-.1302-.8785l-.0996-3.2804c-.0065-.2147-.0098-.3221-.0493-.4115a.5.5 0 0 0-.1585-.1988c-.0783-.0583-.1823-.0854-.3902-.1396l-3.176-.827c-.4821-.1256-.7232-.1883-.8275-.3224a.5.5 0 0 1-.094-.4123c.0357-.1661.2257-.3272.6056-.6495l2.5026-2.1232c.1638-.139.2458-.2085.291-.295a.5.5 0 0 0 .0566-.248c-.0032-.0975-.0469-.1957-.1342-.3921L4.8069 7.172c-.2024-.4552-.3036-.6828-.2638-.848a.5.5 0 0 1 .2637-.3306c.1521-.0755.3965-.0275.8854.0686l3.2203.6328c.2108.0415.3162.0622.412.0436a.5.5 0 0 0 .2292-.1104c.0743-.0633.1239-.1587.223-.3494z"
    />
  </svg>
);

export const Star04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m12 2 2.012 5.231c.282.7333.423 1.1.6422 1.4083.1944.2733.4332.5121.7065.7065.3084.2192.675.3602 1.4082.6422L22 12l-5.2311 2.012c-.7332.282-1.0998.423-1.4082.6422a3 3 0 0 0-.7065.7065c-.2192.3084-.3602.675-.6422 1.4082L12 22l-2.012-5.2311c-.282-.7332-.423-1.0998-.6422-1.4082a3 3 0 0 0-.7065-.7065c-.3084-.2192-.675-.3602-1.4082-.6422L2 12l5.231-2.012c.7333-.282 1.1-.423 1.4083-.6422a3 3 0 0 0 .7065-.7065c.2192-.3084.3602-.675.6422-1.4082z"
    />
  </svg>
);

export const Star05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m12 2-1.3015 5.206c-.254 1.0158-.3809 1.5238-.6454 1.937a3 3 0 0 1-.91.9101c-.4133.2645-.9213.3914-1.9371.6454L2 12l5.206 1.3015c1.0158.254 1.5238.3809 1.937.6454.3657.2339.6761.5444.9101.91.2645.4133.3914.9213.6454 1.9371L12 22l1.3015-5.206c.254-1.0158.3809-1.5238.6454-1.9371a3 3 0 0 1 .91-.91c.4133-.2645.9213-.3914 1.9371-.6454L22 12l-5.206-1.3015c-1.0158-.254-1.5238-.3809-1.9371-.6454a3 3 0 0 1-.91-.91c-.2645-.4133-.3914-.9213-.6454-1.9371z"
    />
  </svg>
);

export const Star06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4.5 22v-5m0-10V2M2 4.5h5m-5 15h5M13 3l-1.7342 4.5089c-.282.7332-.423 1.0998-.6423 1.4082a3 3 0 0 1-.7064.7064c-.3084.2193-.675.3603-1.4082.6423L4 12l4.5089 1.7342c.7332.282 1.0998.423 1.4082.6423.2733.1943.5121.4331.7064.7064.2193.3084.3603.675.6423 1.4082L13 21l1.7342-4.5089c.282-.7332.423-1.0998.6423-1.4082a3 3 0 0 1 .7064-.7064c.3084-.2193.675-.3603 1.4082-.6423L22 12l-4.5089-1.7342c-.7332-.282-1.0998-.423-1.4082-.6423a3 3 0 0 1-.7064-.7064c-.2193-.3084-.3603-.675-.6423-1.4082z"
    />
  </svg>
);

export const Star07 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 12h-2m-.929 7.0711-1.4143-1.4142M4 12H2m4.343-5.6568L4.9286 4.929M12 4V2m5.6567 4.3432L19.071 4.929M12 22v-2m-7.0713-.9289 1.4142-1.4142M12 7l1.545 3.13 3.455.505-2.5 2.435.59 3.44L12 14.885 8.91 16.51l.59-3.44L7 10.635l3.455-.505z"
    />
  </svg>
);

export const Triangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2.3902 18.0983 10.615 3.8917c.4545-.7852.6818-1.1777.9784-1.3096a1 1 0 0 1 .8126 0c.2965.1319.5238.5244.9783 1.3096l8.2249 14.2066c.4562.788.6843 1.182.6506 1.5054a1 1 0 0 1-.4065.7051c-.263.1912-.7182.1912-1.6288.1912H3.7749c-.9106 0-1.3658 0-1.6288-.1912a1 1 0 0 1-.4065-.7051c-.0337-.3234.1944-.7174.6506-1.5054"
    />
  </svg>
);

export const FaceContent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 14s1.5 2 4 2 4-2 4-2m1-4.76c-.395.485-.935.76-1.5.76s-1.09-.275-1.5-.76m-4 0c-.395.485-.935.76-1.5.76S7.41 9.725 7 9.24M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const FaceFrown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 16s-1.5-2-4-2-4 2-4 2m7-7h.01M9 9h.01M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10m-6.5-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-6 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);

export const FaceHappy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 9h.01M9 9h.01M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10m-6.5-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-6 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2.5 8.5c2.5005 0 4.5-1.833 4.5-3.5h-9c0 1.667 1.9995 3.5 4.5 3.5"
    />
  </svg>
);

export const FaceNeutral = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 15h8m-1-6h.01M9 9h.01M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10m-6.5-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-6 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);

export const FaceSad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 16s-1.5-2-4-2-4 2-4 2m9-6.76c-.395.485-.935.76-1.5.76s-1.09-.275-1.5-.76m-4 0c-.395.485-.935.76-1.5.76S7.41 9.725 7 9.24M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const FaceSmile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 14s1.5 2 4 2 4-2 4-2m-1-5h.01M9 9h.01M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10m-6.5-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-6 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);

export const FaceWink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 14s1.5 2 4 2 4-2 4-2m-1-5h.01M8 9h2m12 3c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10m-6.5-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);

export const User01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 21c0-1.3956 0-2.0933-.1722-2.6611a4 4 0 0 0-2.6667-2.6667C16.5933 15.5 15.8956 15.5 14.5 15.5h-5c-1.3956 0-2.0933 0-2.6611.1722a4 4 0 0 0-2.6667 2.6667C4 18.9067 4 19.6044 4 21M16.5 7.5c0 2.4853-2.0147 4.5-4.5 4.5S7.5 9.9853 7.5 7.5 9.5147 3 12 3s4.5 2.0147 4.5 4.5"
    />
  </svg>
);

export const User02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 15c-3.1701 0-5.9892 1.5306-7.784 3.906-.3863.5112-.5795.7668-.5732 1.1123.005.2669.1725.6036.3825.7684C4.2972 21 4.6738 21 5.4272 21h13.1455c.7534 0 1.1301 0 1.4019-.2133.21-.1648.3776-.5015.3825-.7684.0063-.3455-.1868-.6011-.5731-1.1123C17.9892 16.5306 15.17 15 12 15M12 12c2.4853 0 4.5-2.0147 4.5-4.5S14.4853 3 12 3 7.5 5.0147 7.5 7.5 9.5147 12 12 12"
    />
  </svg>
);

export const Users03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 15.8369c1.4559.7314 2.7041 1.9051 3.6152 3.3727.1804.2907.2706.436.3018.6372.0634.409-.2162.9117-.5971 1.0736C21.1325 21 20.9216 21 20.5 21M16 11.5322c1.4817-.7363 2.5-2.2653 2.5-4.0322S17.4817 4.2041 16 3.4678M14 7.5c0 2.4853-2.0148 4.5-4.5 4.5C7.0147 12 5 9.9853 5 7.5S7.0147 3 9.5 3C11.9852 3 14 5.0147 14 7.5M2.5592 18.9383C4.1535 16.5446 6.6693 15 9.5 15c2.8306 0 5.3464 1.5446 6.9407 3.9383.3493.5245.5239.7867.5038 1.1216-.0156.2608-.1866.5801-.395.7377C16.2819 21 15.9138 21 15.1776 21H3.8223c-.7362 0-1.1043 0-1.3719-.2024-.2084-.1576-.3794-.4769-.395-.7377-.0201-.3349.1545-.5971.5038-1.1216"
    />
  </svg>
);

export const User03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 20c2.3358-2.4774 5.507-4 9-4s6.6642 1.5226 9 4M16.5 7.5c0 2.4853-2.0147 4.5-4.5 4.5S7.5 9.9853 7.5 7.5 9.5147 3 12 3s4.5 2.0147 4.5 4.5"
    />
  </svg>
);

export const Users02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 3.4678c1.4817.7363 2.5 2.2653 2.5 4.0322s-1.0183 3.2959-2.5 4.0322m2 5.2342c1.5115.6839 2.8725 1.7986 4 3.2336M2 20c1.9465-2.4774 4.5892-4 7.5-4s5.5535 1.5226 7.5 4M14 7.5c0 2.4853-2.0147 4.5-4.5 4.5S5 9.9853 5 7.5 7.0147 3 9.5 3 14 5.0147 14 7.5"
    />
  </svg>
);

export const UserCheck01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 15.5H7.5c-1.3956 0-2.0933 0-2.6611.1722a4 4 0 0 0-2.6667 2.6667C2 18.9067 2 19.6044 2 21m14-3 2 2 4-4m-7.5-8.5c0 2.4853-2.0147 4.5-4.5 4.5S5.5 9.9853 5.5 7.5 7.5147 3 10 3s4.5 2.0147 4.5 4.5"
    />
  </svg>
);

export const UserCheck02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 21v-1.2c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C13.7202 15 12.8802 15 11.2 15H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.2798 2 18.1198 2 19.8V21M16 6l2 2 4-4m-9.5 3.5c0 1.933-1.567 3.5-3.5 3.5S5.5 9.433 5.5 7.5 7.067 4 9 4s3.5 1.567 3.5 3.5"
    />
  </svg>
);

export const UserCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5.3163 19.4384C5.9246 18.0052 7.3449 17 9 17h6c1.6551 0 3.0754 1.0052 3.6837 2.4384M16 9.5c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4m6 2.5c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const UserDown01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 15.5H7.5c-1.3956 0-2.0933 0-2.6611.1722a4 4 0 0 0-2.6667 2.6667C2 18.9067 2 19.6044 2 21m20-3-3 3-3-3m3 3v-6m-4.5-7.5c0 2.4853-2.0147 4.5-4.5 4.5S5.5 9.9853 5.5 7.5 7.5147 3 10 3s4.5 2.0147 4.5 4.5"
    />
  </svg>
);

export const UserDown02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 7-3 3-3-3m3 3V4m-3 17v-1.2c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C13.7202 15 12.8802 15 11.2 15H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5c0 1.933-1.567 3.5-3.5 3.5S5.5 9.433 5.5 7.5 7.067 4 9 4s3.5 1.567 3.5 3.5"
    />
  </svg>
);

export const UserEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 15.5H7.5c-1.3956 0-2.0933 0-2.6611.1722a4 4 0 0 0-2.6667 2.6667C2 18.9067 2 19.6044 2 21M14.5 7.5c0 2.4853-2.0147 4.5-4.5 4.5S5.5 9.9853 5.5 7.5 7.5147 3 10 3s4.5 2.0147 4.5 4.5M11 21l3.1014-.8861c.1485-.0424.2227-.0637.292-.0955a1 1 0 0 0 .1745-.1026c.0614-.0451.116-.0997.2253-.209L21.25 13.25c.6904-.6903.6904-1.8097 0-2.5-.6903-.6904-1.8096-.6904-2.5 0l-6.4568 6.4568c-.1093.1093-.1639.1639-.209.2253a1 1 0 0 0-.1026.1745c-.0319.0693-.0531.1435-.0955.2921z"
    />
  </svg>
);

export const UserLeft01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m19 15-3 3 3 3m-3-3h6m-10-2.5H7.5c-1.3956 0-2.0933 0-2.6611.1722a4 4 0 0 0-2.6667 2.6667C2 18.9067 2 19.6044 2 21M14.5 7.5c0 2.4853-2.0147 4.5-4.5 4.5S5.5 9.9853 5.5 7.5 7.5147 3 10 3s4.5 2.0147 4.5 4.5"
    />
  </svg>
);

export const UserLeft02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m19 3-3 3 3 3m-3-3h6m-6 15v-1.2c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C13.7202 15 12.8802 15 11.2 15H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5c0 1.933-1.567 3.5-3.5 3.5S5.5 9.433 5.5 7.5 7.067 4 9 4s3.5 1.567 3.5 3.5"
    />
  </svg>
);

export const UserMinus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 18h6m-10-2.5H7.5c-1.3956 0-2.0933 0-2.6611.1722a4 4 0 0 0-2.6667 2.6667C2 18.9067 2 19.6044 2 21M14.5 7.5c0 2.4853-2.0147 4.5-4.5 4.5S5.5 9.9853 5.5 7.5 7.5147 3 10 3s4.5 2.0147 4.5 4.5"
    />
  </svg>
);

export const UserMinus02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 7h6m-6 14v-1.2c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C13.7202 15 12.8802 15 11.2 15H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5c0 1.933-1.567 3.5-3.5 3.5S5.5 9.433 5.5 7.5 7.067 4 9 4s3.5 1.567 3.5 3.5"
    />
  </svg>
);

export const UserPlus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 15.5H7.5c-1.3956 0-2.0933 0-2.6611.1722a4 4 0 0 0-2.6667 2.6667C2 18.9067 2 19.6044 2 21m17 0v-6m-3 3h6M14.5 7.5c0 2.4853-2.0147 4.5-4.5 4.5S5.5 9.9853 5.5 7.5 7.5147 3 10 3s4.5 2.0147 4.5 4.5"
    />
  </svg>
);

export const UserPlus02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 10V4m-3 3h6m-6 14v-1.2c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C13.7202 15 12.8802 15 11.2 15H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5c0 1.933-1.567 3.5-3.5 3.5S5.5 9.433 5.5 7.5 7.067 4 9 4s3.5 1.567 3.5 3.5"
    />
  </svg>
);

export const UserRight01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m19 15 3 3-3 3m3-3h-6m-4-2.5H7.5c-1.3956 0-2.0933 0-2.6611.1722a4 4 0 0 0-2.6667 2.6667C2 18.9067 2 19.6044 2 21M14.5 7.5c0 2.4853-2.0147 4.5-4.5 4.5S5.5 9.9853 5.5 7.5 7.5147 3 10 3s4.5 2.0147 4.5 4.5"
    />
  </svg>
);

export const UserRight02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m19 3 3 3-3 3m3-3h-6m0 15v-1.2c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C13.7202 15 12.8802 15 11.2 15H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5c0 1.933-1.567 3.5-3.5 3.5S5.5 9.433 5.5 7.5 7.067 4 9 4s3.5 1.567 3.5 3.5"
    />
  </svg>
);

export const UserSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 21.8174C4.6026 22 5.4165 22 6.8 22h10.4c1.3835 0 2.1974 0 2.8-.1826m-16 0a2.2 2.2 0 0 1-.362-.1444 3 3 0 0 1-1.311-1.311C2 19.7202 2 18.8802 2 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 2 5.1198 2 6.8 2h10.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 4.2798 22 5.1198 22 6.8v10.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311 2.2 2.2 0 0 1-.362.1444m-16 0c.0004-.8093.0052-1.2375.0769-1.5978a4 4 0 0 1 3.1427-3.1427C7.606 17 8.0706 17 9 17h6c.9293 0 1.394 0 1.7804.0769a4 4 0 0 1 3.1427 3.1427c.0717.3603.0765.7885.0769 1.5978M16 9.5c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const UserUp01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 18-3-3-3 3m3-3v6m-7-5.5H7.5c-1.3956 0-2.0933 0-2.6611.1722a4 4 0 0 0-2.6667 2.6667C2 18.9067 2 19.6044 2 21M14.5 7.5c0 2.4853-2.0147 4.5-4.5 4.5S5.5 9.9853 5.5 7.5 7.5147 3 10 3s4.5 2.0147 4.5 4.5"
    />
  </svg>
);

export const UserUp02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 6-3-3-3 3m3-3v6m-3 12v-1.2c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C13.7202 15 12.8802 15 11.2 15H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5c0 1.933-1.567 3.5-3.5 3.5S5.5 9.433 5.5 7.5 7.067 4 9 4s3.5 1.567 3.5 3.5"
    />
  </svg>
);

export const UserX01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16.5 16 5 5m0-5-5 5M12 15.5H7.5c-1.3956 0-2.0933 0-2.6611.1722a4 4 0 0 0-2.6667 2.6667C2 18.9067 2 19.6044 2 21M14.5 7.5c0 2.4853-2.0147 4.5-4.5 4.5S5.5 9.9853 5.5 7.5 7.5147 3 10 3s4.5 2.0147 4.5 4.5"
    />
  </svg>
);

export const UserX02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16.5 4 5 5m0-5-5 5M16 21v-1.2c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C13.7202 15 12.8802 15 11.2 15H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5c0 1.933-1.567 3.5-3.5 3.5S5.5 9.433 5.5 7.5 7.067 4 9 4s3.5 1.567 3.5 3.5"
    />
  </svg>
);

export const Users01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 21v-2c0-1.8638-1.2748-3.4299-3-3.874M15.5 3.2908C16.9659 3.8842 18 5.3213 18 7s-1.0341 3.1159-2.5 3.7092M17 21c0-1.8638 0-2.7956-.3045-3.5307a4 4 0 0 0-2.1648-2.1648C13.7956 15 12.8638 15 11 15H8c-1.8638 0-2.7957 0-3.5307.3045a4 4 0 0 0-2.1648 2.1648C2 18.2044 2 19.1362 2 21M13.5 7c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const UsersCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 18 2 2 4-4m-10-1H8c-1.8638 0-2.7957 0-3.5307.3045a4 4 0 0 0-2.1648 2.1648C2 18.2044 2 19.1362 2 21M15.5 3.2908C16.9659 3.8842 18 5.3213 18 7s-1.0341 3.1159-2.5 3.7092M13.5 7c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const UsersDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 18-3 3-3-3m3 3v-6M15.5 3.2908C16.9659 3.8842 18 5.3213 18 7s-1.0341 3.1159-2.5 3.7092M12 15H8c-1.8638 0-2.7957 0-3.5307.3045a4 4 0 0 0-2.1648 2.1648C2 18.2044 2 19.1362 2 21M13.5 7c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const UsersEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11 15H8c-1.8638 0-2.7957 0-3.5307.3045a4 4 0 0 0-2.1648 2.1648C2 18.2044 2 19.1362 2 21M15.5 3.2908C16.9659 3.8842 18 5.3213 18 7m-6.0001 14.5 2.0251-.405c.1765-.0353.2648-.053.3471-.0853a1 1 0 0 0 .2069-.1107c.0726-.0506.1362-.1142.2636-.2416L21.5 14c.5524-.5523.5523-1.4477 0-2s-1.4477-.5523-2 0l-6.6575 6.6575c-.1273.1273-.1909.1909-.2415.2635a1 1 0 0 0-.1108.2068c-.0322.0824-.0499.1706-.0852.3472zM13.5 7c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const UsersLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m19 15-3 3 3 3m-3-3h6M15.5 3.2908C16.9659 3.8842 18 5.3213 18 7s-1.0341 3.1159-2.5 3.7092M12 15H8c-1.8638 0-2.7957 0-3.5307.3045a4 4 0 0 0-2.1648 2.1648C2 18.2044 2 19.1362 2 21M13.5 7c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const UsersMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 18h6M15.5 3.2908C16.9659 3.8842 18 5.3213 18 7s-1.0341 3.1159-2.5 3.7092M12 15H8c-1.8638 0-2.7957 0-3.5307.3045a4 4 0 0 0-2.1648 2.1648C2 18.2044 2 19.1362 2 21M13.5 7c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const UsersPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 21v-6m-3 3h6m-10-3H8c-1.8638 0-2.7957 0-3.5307.3045a4 4 0 0 0-2.1648 2.1648C2 18.2044 2 19.1362 2 21M15.5 3.2908C16.9659 3.8842 18 5.3213 18 7s-1.0341 3.1159-2.5 3.7092M13.5 7c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const UsersRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m19 15 3 3-3 3m3-3h-6m-.5-14.7092C16.9659 3.8842 18 5.3213 18 7s-1.0341 3.1159-2.5 3.7092M12 15H8c-1.8638 0-2.7957 0-3.5307.3045a4 4 0 0 0-2.1648 2.1648C2 18.2044 2 19.1362 2 21M13.5 7c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const UsersUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 18-3-3-3 3m3-3v6M15.5 3.2908C16.9659 3.8842 18 5.3213 18 7s-1.0341 3.1159-2.5 3.7092M12 15H8c-1.8638 0-2.7957 0-3.5307.3045a4 4 0 0 0-2.1648 2.1648C2 18.2044 2 19.1362 2 21M13.5 7c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const UsersX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16.5 16 5 5m0-5-5 5m-1-17.7092C16.9659 3.8842 18 5.3213 18 7s-1.0341 3.1159-2.5 3.7092M12 15H8c-1.8638 0-2.7957 0-3.5307.3045a4 4 0 0 0-2.1648 2.1648C2 18.2044 2 19.1362 2 21M13.5 7c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const Airplay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 18c-1.6568 0-3-1.3431-3-3V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 3 5.1198 3 6.8 3h10.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 5.2798 22 6.1198 22 7.8V15c0 1.6569-1.3431 3-3 3M8.708 21h6.584c.5448 0 .8173 0 .9547-.1111a.5.5 0 0 0 .1857-.3964c-.0026-.1768-.177-.3861-.5259-.8046l-3.2919-3.9504c-.2111-.2533-.3166-.3799-.443-.4261a.5.5 0 0 0-.3432 0c-.1264.0462-.2319.1728-.443.4261l-3.292 3.9504c-.3488.4185-.5232.6278-.5258.8046a.5.5 0 0 0 .1857.3964C7.8907 21 8.1632 21 8.708 21"
    />
  </svg>
);

export const Airpods = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 7.625c0 2.2782 1.8468 4.125 4.125 4.125.3059 0 .4588 0 .538.0273.1659.0572.2524.1438.3097.3096.0273.0793.0273.2034.0273.4517v6.3364c0 .8975.7275 1.625 1.625 1.625s1.625-.7275 1.625-1.625V7.625c0-2.2782-1.8468-4.125-4.125-4.125S2 5.3468 2 7.625M22 7.625c0 2.2782-1.8468 4.125-4.125 4.125-.3059 0-.4588 0-.5381.0273-.1658.0572-.2524.1438-.3096.3096-.0273.0793-.0273.2034-.0273.4517v6.3364c0 .8975-.7275 1.625-1.625 1.625s-1.625-.7275-1.625-1.625V7.625c0-2.2782 1.8468-4.125 4.125-4.125S22 5.3468 22 7.625"
    />
  </svg>
);

export const BatteryCharging01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.8333 15 12.5 12h-4l1.6667-3M22 13v-2M6.8 18h7.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 15.7202 19 14.8802 19 13.2v-2.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C16.7202 6 15.8802 6 14.2 6H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 8.2798 2 9.1198 2 10.8v2.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 18 5.1198 18 6.8 18"
    />
  </svg>
);

export const BatteryCharging02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9.5 18 4-6h-6l4-6M22 13v-2m-8 7h.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 15.7202 19 14.8802 19 13.2V10c0-.93 0-1.395-.1022-1.7765a3 3 0 0 0-2.1213-2.1213C16.395 6 15.93 6 15 6M7 6h-.2c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 8.2798 2 9.1198 2 10.8V14c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C4.605 18 5.07 18 6 18"
    />
  </svg>
);

export const BatteryEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 13v-2M6.8 18h7.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 15.7202 19 14.8802 19 13.2v-2.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C16.7202 6 15.8802 6 14.2 6H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 8.2798 2 9.1198 2 10.8v2.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 18 5.1198 18 6.8 18"
    />
  </svg>
);

export const BatteryFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.5 10v4m4-4v4m4-4v4m7.5-1v-2M6.8 18h7.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 15.7202 19 14.8802 19 13.2v-2.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C16.7202 6 15.8802 6 14.2 6H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 8.2798 2 9.1198 2 10.8v2.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 18 5.1198 18 6.8 18"
    />
  </svg>
);

export const BatteryLow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.5 10v4M22 13v-2M6.8 18h7.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 15.7202 19 14.8802 19 13.2v-2.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C16.7202 6 15.8802 6 14.2 6H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 8.2798 2 9.1198 2 10.8v2.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 18 5.1198 18 6.8 18"
    />
  </svg>
);

export const BatteryMid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.5 10v4m4-4v4M22 13v-2M6.8 18h7.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 15.7202 19 14.8802 19 13.2v-2.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C16.7202 6 15.8802 6 14.2 6H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 8.2798 2 9.1198 2 10.8v2.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 18 5.1198 18 6.8 18"
    />
  </svg>
);

export const BluetoothConnect = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m3 7 12 10-6 5V2l6 5L3 17m15-5h.01M15 12h.01M21 12h.01"
    />
  </svg>
);

export const BluetoothOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m6 17 6-5v10l5.4398-4.5332M12 7V2l6 5-2.9183 2.432M21 21 3 3"
    />
  </svg>
);

export const BluetoothOn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m6 7 12 10-6 5V2l6 5L6 17"
    />
  </svg>
);

export const BluetoothSignal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m2 7 12 10-6 5V2l6 5L2 17M20.1445 6.5c1.1136 1.548 1.7695 3.4474 1.7695 5.5s-.6559 3.952-1.7695 5.5M17 8.8572c.6214.891.9858 1.9743.9858 3.1429s-.3644 2.252-.9858 3.1429"
    />
  </svg>
);

export const ChromeCast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 12.05A9 9 0 0 1 9.95 20M2 16.1A5 5 0 0 1 5.9 20M2 20h.01M14 21h3.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.7202 22 17.8802 22 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 3 18.8802 3 17.2 3H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.2798 2 6.1198 2 7.8V8"
    />
  </svg>
);

export const Clapperboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 3 8 8m8-5-1 5m7 0H2m4.8 13h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.7202 22 17.8802 22 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 3 18.8802 3 17.2 3H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.2798 2 6.1198 2 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 21 5.1198 21 6.8 21"
    />
  </svg>
);

export const Disc01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3"
    />
  </svg>
);

export const Disc02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 5.6736c2.3649 1.1235 4 3.534 4 6.3264M8.3924 18C6.3596 16.7751 5 14.5463 5 12m17 0c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10m-7 0c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
    />
  </svg>
);

export const FastBackward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21.9997 16.437c0 1.13 0 1.6951-.2283 1.9721a1 1 0 0 1-.8091.3633c-.3587-.0134-.781-.3888-1.6256-1.1395l-4.9917-4.4371c-.4653-.4136-.6979-.6204-.7836-.8646a1 1 0 0 1 0-.6625c.0857-.2442.3183-.451.7836-.8646l4.9917-4.437c.8446-.7508 1.2669-1.1262 1.6256-1.1396a1 1 0 0 1 .8091.3634c.2283.277.2283.842.2283 1.972zM10.9997 16.437c0 1.13 0 1.6951-.2283 1.9721a1 1 0 0 1-.8091.3633c-.3587-.0134-.781-.3888-1.6256-1.1395L3.345 13.1958c-.4653-.4136-.698-.6204-.7837-.8646a1 1 0 0 1 0-.6625c.0858-.2442.3184-.451.7837-.8646l4.9917-4.437c.8446-.7508 1.2669-1.1262 1.6256-1.1396a1 1 0 0 1 .8091.3634c.2283.277.2283.842.2283 1.972z"
    />
  </svg>
);

export const FastForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13 16.437c0 1.13 0 1.6951.2283 1.9721a1 1 0 0 0 .8091.3633c.3587-.0134.781-.3888 1.6256-1.1395l4.9917-4.4371c.4653-.4136.6979-.6204.7836-.8646a1 1 0 0 0 0-.6625c-.0857-.2442-.3183-.451-.7836-.8646l-4.9917-4.437c-.8446-.7508-1.2669-1.1262-1.6256-1.1396a1 1 0 0 0-.8091.3634C13 5.8679 13 6.4329 13 7.5629zM2 16.437c0 1.13 0 1.6951.2283 1.9721a1 1 0 0 0 .8091.3633c.3587-.0134.781-.3888 1.6256-1.1395l4.9917-4.4371c.4653-.4136.6979-.6204.7836-.8646a1 1 0 0 0 0-.6625c-.0857-.2442-.3183-.451-.7836-.8646L4.663 6.3671c-.8446-.7508-1.267-1.1262-1.6256-1.1396a1 1 0 0 0-.8091.3634C2 5.8679 2 6.4329 2 7.5629z"
    />
  </svg>
);

export const Film01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 12h20M2 7h5m10 0h5M2 17h5m10 0h5M7 22V2m10 20V2M6.8 22h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 19.7202 22 18.8802 22 17.2V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 2 18.8802 2 17.2 2H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 4.2798 2 5.1198 2 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 22 5.1198 22 6.8 22"
    />
  </svg>
);

export const Film02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22V2M7 22v-5M7 7V2m10 20v-5m0-10V2M2 7h20M2 17h20m0 .2V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 2 18.8802 2 17.2 2H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 4.2798 2 5.1198 2 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 22 5.1198 22 6.8 22h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 19.7202 22 18.8802 22 17.2"
    />
  </svg>
);

export const Film03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 2v4m0 10v4M17 4v4m0 10v4M2 6h10M2 16h10m0-8h10M12 18h10m-10 2V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C11.2401 2 10.9601 2 10.4 2H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 4.2798 2 5.1198 2 6.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 20 5.1198 20 6.8 20zm0-16h5.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 6.2798 22 7.1198 22 8.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 22 18.8802 22 17.2 22h-3.6c-.5601 0-.8401 0-1.054-.109a1 1 0 0 1-.437-.437C12 21.2401 12 20.9601 12 20.4z"
    />
  </svg>
);

export const GamingPad01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5.9999 11h4m-2-2v4m7-1h.01m2.99-2h.01m-7.5611-5h3.1021c2.6249 0 3.9374 0 4.9675.4974a5 5 0 0 1 2.1621 2.0132c.5696.9921.6631 2.3012.8501 4.9194l.246 3.4445C21.8973 17.5634 20.5597 19 18.8664 19a2.917 2.917 0 0 1-2.2413-1.0498l-.3752-.4502c-.3431-.4118-.5148-.6177-.7101-.7841a3 3 0 0 0-1.4355-.6723C13.8514 16 13.5834 16 13.0473 16h-2.0948c-.5361 0-.8041 0-1.057.0436a3 3 0 0 0-1.4355.6723c-.1954.1664-.367.3723-.7101.7841l-.3752.4502A2.918 2.918 0 0 1 5.1334 19C3.44 19 2.1025 17.5634 2.223 15.8745l.246-3.4445c.187-2.6182.2806-3.9273.8502-4.9194a5 5 0 0 1 2.162-2.0132C6.5116 5 7.824 5 10.4489 5"
    />
  </svg>
);

export const GamingPad02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 12h4m-2-2v4m7-1h.01M18 11h.01M5.2 18h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 16.4802 22 15.9201 22 14.8V9.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 6 19.9201 6 18.8 6H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 7.5198 2 8.08 2 9.2v5.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 18 4.08 18 5.2 18"
    />
  </svg>
);

export const HardDrive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2.5 12h19M6 16h4M8.9666 4h6.0668c1.0769 0 1.6153 0 2.0907.164.4204.145.8033.3816 1.121.6928.3592.3518.6.8334 1.0816 1.7966l2.1665 4.3331c.189.378.2835.567.3502.765.0592.176.1019.357.1276.5408.029.2069.029.4182.029.8408V15.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 20 18.8802 20 17.2 20H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 17.7202 2 16.8802 2 15.2v-2.0669c0-.4226 0-.6339.029-.8408a3 3 0 0 1 .1276-.5408c.0667-.198.1612-.387.3501-.765l2.1666-4.3331c.4816-.9632.7224-1.4448 1.0816-1.7967a3 3 0 0 1 1.121-.6927C7.3513 4 7.8897 4 8.9666 4"
    />
  </svg>
);

export const Headphones01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 18v-6c0-4.9706-4.0294-9-9-9s-9 4.0294-9 9v6m2.5 3C4.1193 21 3 19.8807 3 18.5v-2C3 15.1193 4.1193 14 5.5 14S8 15.1193 8 16.5v2C8 19.8807 6.8807 21 5.5 21m13 0c-1.3807 0-2.5-1.1193-2.5-2.5v-2c0-1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5v2c0 1.3807-1.1193 2.5-2.5 2.5"
    />
  </svg>
);

export const Headphones02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 17v-4c0-5.5228-4.4772-10-10-10S2 7.4772 2 13v4m5.5 4C6.1193 21 5 19.8807 5 18.5v-3C5 14.1193 6.1193 13 7.5 13s2.5 1.1193 2.5 2.5v3c0 1.3807-1.1193 2.5-2.5 2.5m9 0c-1.3807 0-2.5-1.1193-2.5-2.5v-3c0-1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5v3c0 1.3807-1.1193 2.5-2.5 2.5"
    />
  </svg>
);

export const Keyboard01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 10h.01M8 14h.01M10 10h.01M12 14h.01M14 10h.01M16 14h.01M18 10h.01M5.2 18h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 16.4802 22 15.9201 22 14.8V9.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 6 19.9201 6 18.8 6H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 7.5198 2 8.08 2 9.2v5.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 18 4.08 18 5.2 18"
    />
  </svg>
);

export const Keyboard02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 14.5h10M6 10h.01M10 10h.01M14 10h.01M18 10h.01M5.2 18h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 16.4802 22 15.9201 22 14.8V9.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 6 19.9201 6 18.8 6H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 7.5198 2 8.08 2 9.2v5.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 18 4.08 18 5.2 18"
    />
  </svg>
);

export const Laptop01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 16V7.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C4.5198 4 5.08 4 6.2 4h11.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C21 5.5198 21 6.08 21 7.2V16h-5.3373c-.2445 0-.3668 0-.4819.0276a1 1 0 0 0-.2891.1198c-.1009.0618-.1874.1483-.3603.3212l-.0628.0628c-.1729.1729-.2594.2594-.3603.3212a1 1 0 0 1-.2891.1198C13.7041 17 13.5818 17 13.3373 17h-2.6746c-.2445 0-.3668 0-.4819-.0276a1 1 0 0 1-.289-.1198c-.101-.0618-.1875-.1483-.3604-.3212l-.0628-.0628c-.173-.1729-.2594-.2594-.3603-.3212a1 1 0 0 0-.289-.1198C8.704 16 8.5817 16 8.3372 16zm0 0c-.5523 0-1 .4477-1 1v.3333c0 .62 0 .93.0682 1.1843a2 2 0 0 0 1.4142 1.4143C3.7367 20 4.0467 20 4.6667 20h14.6666c.62 0 .93 0 1.1843-.0681a2 2 0 0 0 1.4143-1.4143C22 18.2633 22 17.9533 22 17.3333c0-.31 0-.465-.0341-.5921a1 1 0 0 0-.7071-.7071C21.1317 16 20.9767 16 20.6667 16H20"
    />
  </svg>
);

export const Laptop02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 16V7.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C19.4802 4 18.9201 4 17.8 4H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 5.5198 3 6.08 3 7.2V16m1.6667 4h14.6666c.62 0 .93 0 1.1843-.0681a2 2 0 0 0 1.4143-1.4143C22 18.2633 22 17.9533 22 17.3333c0-.31 0-.465-.0341-.5921a1 1 0 0 0-.7071-.7071C21.1317 16 20.9767 16 20.6667 16H3.3333c-.31 0-.465 0-.5921.0341a1 1 0 0 0-.7071.7071C2 16.8683 2 17.0233 2 17.3333c0 .62 0 .93.0682 1.1843a2 2 0 0 0 1.4142 1.4143C3.7367 20 4.0467 20 4.6667 20"
    />
  </svg>
);

export const Lightbulb01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 16.5V19c0 .9319 0 1.3978-.1522 1.7654-.203.49-.5924.8794-1.0824 1.0824C13.3978 22 12.9319 22 12 22s-1.3978 0-1.7654-.1522a2 2 0 0 1-1.0824-1.0824C9 20.3978 9 19.9319 9 19v-2.5m6 0c2.6489-1.1573 4.5-3.9245 4.5-7C19.5 5.3579 16.1421 2 12 2S4.5 5.3579 4.5 9.5c0 3.0755 1.8511 5.8427 4.5 7m6 0H9"
    />
  </svg>
);

export const Lightbulb02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 17.6586V20c0 1.1046.8954 2 2 2s2-.8954 2-2v-2.3414M12 2v1m-9 9H2m3.5-6.5-.6001-.6001M18.5 5.5l.6002-.6001M22 12h-1m-3 0c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6 2.6863-6 6-6 6 2.6863 6 6"
    />
  </svg>
);

export const Lightbulb03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.5 22h5m.5-6.6736c2.3649-1.1235 4-3.534 4-6.3264 0-3.866-3.134-7-7-7S5 5.134 5 9c0 2.7924 1.635 5.2029 4 6.3264V16c0 .9319 0 1.3978.1522 1.7654.203.49.5924.8794 1.0824 1.0824C10.6022 19 11.0681 19 12 19s1.3978 0 1.7654-.1522c.49-.203.8794-.5924 1.0824-1.0824C15 17.3978 15 16.9319 15 16z"
    />
  </svg>
);

export const Lightbulb04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.5 22h5M10 10h4m-2 0v6m3-.6736c2.3649-1.1235 4-3.534 4-6.3264 0-3.866-3.134-7-7-7S5 5.134 5 9c0 2.7924 1.635 5.2029 4 6.3264V16c0 .9319 0 1.3978.1522 1.7654.203.49.5924.8794 1.0824 1.0824C10.6022 19 11.0681 19 12 19s1.3978 0 1.7654-.1522c.49-.203.8794-.5924 1.0824-1.0824C15 17.3978 15 16.9319 15 16z"
    />
  </svg>
);

export const Lightbulb05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 2v1m-9 9H2m3.5-6.5-.6001-.6001M18.5 5.5l.6002-.6001M22 12h-1m-11 1.5h4m-2 0v5m3.5-1.626C17.0141 15.7848 18 14.0075 18 12c0-3.3137-2.6863-6-6-6s-6 2.6863-6 6c0 2.0075.986 3.7848 2.5 4.874V18.8c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218h.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.4278.218-.9879.218-2.108z"
    />
  </svg>
);

export const Microphone01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 10v2c0 3.866-3.134 7-7 7m-7-9v2c0 3.866 3.134 7 7 7m0 0v3m-4 0h8m-4-7c-1.6569 0-3-1.3431-3-3V5c0-1.6568 1.3431-3 3-3s3 1.3432 3 3v7c0 1.6569-1.3431 3-3 3"
    />
  </svg>
);

export const Microphone02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 12v1c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8v-1m8 5c-2.2091 0-4-1.7909-4-4V7c0-2.2091 1.7909-4 4-4s4 1.7909 4 4v6c0 2.2091-1.7909 4-4 4"
    />
  </svg>
);

export const MicrophoneOff01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 9.4V5c0-1.6568-1.3431-3-3-3-1.1776 0-2.1967.6785-2.6878 1.666M12 19v3m0-3c-3.866 0-7-3.134-7-7v-2m7 9c3.866 0 7-3.134 7-7v-2M8 22h8M2 2l20 20m-10-7c-1.6569 0-3-1.3431-3-3V9l5.1226 5.12c-.543.5437-1.2935.88-2.1226.88"
    />
  </svg>
);

export const MicrophoneOff02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 12v1c0 4.4183 3.5817 8 8 8 2.4653 0 4.6701-1.1151 6.1376-2.8684M2 2l20 20m-6-11.6V7c0-2.2091-1.7909-4-4-4a3.984 3.984 0 0 0-2.5291.9009M12 17c-2.2091 0-4-1.7909-4-4V8l7.2815 7.288C14.5585 16.323 13.3583 17 12 17"
    />
  </svg>
);

export const Modem01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.2427 4.7573c2.3431 2.3432 2.3431 6.1422 0 8.4853m-8.4854 0c-2.3431-2.3431-2.3431-6.1421 0-8.4853M4.8583 16C1.0236 12.0894 1.047 5.8106 4.9287 1.929m14.1426 0c3.8816 3.8816 3.9051 10.1604.0704 14.071M12 16V9M5 22h14c.9319 0 1.3978 0 1.7653-.1522a2 2 0 0 0 1.0824-1.0824C22 20.3978 22 19.9319 22 19s0-1.3978-.1523-1.7654a2 2 0 0 0-1.0824-1.0824C20.3978 16 19.9319 16 19 16H5c-.932 0-1.3978 0-1.7654.1522-.49.203-.8794.5924-1.0824 1.0824C2 17.6022 2 18.0681 2 19s0 1.3978.1522 1.7654c.203.49.5923.8794 1.0824 1.0824C3.6022 22 4.0681 22 5 22"
    />
  </svg>
);

export const Modem02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.2047 10.5578c-.479-1.7883-.1176-3.7547 1.084-5.2741m10.5065 5.274c.479-1.7882.1177-3.7547-1.0839-5.274M2.3418 11.5995c-.838-3.1248-.1364-6.5764 2.1047-9.1538m17.2082 9.1538c.8379-3.1248.1364-6.5764-2.1047-9.1538M12 15v-6m-6.5 9.5h4m-4.3 3.5h13.6c1.1201 0 1.6801 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.4278.218-.9879.218-2.108v-.6c0-1.1201 0-1.6801-.218-2.108a2 2 0 0 0-.874-.874c-.4279-.218-.9879-.218-2.108-.218H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 16.5198 2 17.0798 2 18.1999v.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218"
    />
  </svg>
);

export const Monitor01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 21h8m-4-4v4m-5.2-4h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 14.7202 22 13.8802 22 12.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 3 18.8802 3 17.2 3H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.2798 2 6.1198 2 7.8v4.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 17 5.1198 17 6.8 17"
    />
  </svg>
);

export const Monitor02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.5718 21C8.9066 20.3598 10.41 20 12 20s3.0934.3598 4.4282 1M6.8 17h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 14.7202 22 13.8802 22 12.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 3 18.8802 3 17.2 3H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.2798 2 6.1198 2 7.8v4.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 17 5.1198 17 6.8 17"
    />
  </svg>
);

export const Monitor03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 14h20M8 21h8m-9.2-3h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 15.7202 22 14.8802 22 13.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 3 18.8802 3 17.2 3H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.2798 2 6.1198 2 7.8v5.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 18 5.1198 18 6.8 18"
    />
  </svg>
);

export const Monitor04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 17v4H9v-4m-3.8 0h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 15.4802 22 14.9201 22 13.8V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 3 19.9201 3 18.8 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 17 4.08 17 5.2 17"
    />
  </svg>
);

export const Monitor05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5.5 20H8m9-11h.01M8 6H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 7.5198 2 8.08 2 9.2v3.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 16 4.08 16 5.2 16H8m7.2 4h3.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 18.4802 22 17.9201 22 16.8V7.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 4 19.9201 4 18.8 4h-3.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C12 5.5198 12 6.08 12 7.2v9.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218m2.8-5c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const Mouse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 9V6m0 16c-3.866 0-7-3.134-7-7V9c0-3.866 3.134-7 7-7s7 3.134 7 7v6c0 3.866-3.134 7-7 7"
    />
  </svg>
);

export const MusicNote01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 18V6.3554c0-.4816 0-.7223.0876-.9176a1 1 0 0 1 .3587-.4234c.1782-.1185.4157-.1581.8907-.2373l8.8-1.4666c.6409-.1069.9614-.1603 1.2112-.0675a1 1 0 0 1 .5192.4399C21 3.9139 21 4.2389 21 4.8887V16M9 18c0 1.6568-1.3431 3-3 3s-3-1.3432-3-3 1.3431-3 3-3 3 1.3431 3 3m12-2c0 1.6568-1.3431 3-3 3s-3-1.3432-3-3 1.3431-3 3-3 3 1.3431 3 3"
    />
  </svg>
);

export const MusicNote02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 18V5.5889c0-.8572 0-1.2858.1805-1.544a1 1 0 0 1 .6733-.4161c.3117-.046.695.1456 1.4617.529L18 6m-6 12c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3432 3 3"
    />
  </svg>
);

export const MusicNotePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14.5 18V5.5889c0-.8572 0-1.2858.1805-1.544a1 1 0 0 1 .6733-.4161c.3117-.046.695.1456 1.4617.529L20.5 6m-6 12c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3432 3 3m-8-8V4m-3 3h6"
    />
  </svg>
);

export const PauseCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.5 15V9m5 6V9m7.5 3c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const PauseSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.5 15V9m5 6V9M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const Phone01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 17.5h.01M8.2 22h7.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C19 20.4802 19 19.9201 19 18.8V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C17.4802 2 16.9201 2 15.8 2H8.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C5 3.5198 5 4.08 5 5.2v13.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C6.5198 22 7.08 22 8.2 22m4.3-4.5a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 12.5 17.5"
    />
  </svg>
);

export const Phone02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 2v1.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C14.2401 5 13.9601 5 13.4 5h-2.8c-.5601 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C9 4.24 9 3.96 9 3.4V2m-.8 20h7.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C19 20.4802 19 19.9201 19 18.8V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C17.4802 2 16.9201 2 15.8 2H8.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C5 3.5198 5 4.08 5 5.2v13.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C6.5198 22 7.08 22 8.2 22"
    />
  </svg>
);

export const Play = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 4.9895c0-.9711 0-1.4567.2025-1.7244a1 1 0 0 1 .7379-.395c.335-.02.739.2494 1.5471.7881l10.5156 7.0104c.6677.4451 1.0015.6677 1.1178.9482a1 1 0 0 1 0 .7662c-.1163.2805-.4501.503-1.1178.9482L7.4875 20.3415c-.808.5387-1.212.8081-1.5471.7881a1 1 0 0 1-.738-.3949C5 20.467 5 19.9814 5 19.0103z"
    />
  </svg>
);

export const PlayCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.5 8.9653c0-.4772 0-.7159.0997-.8491a.5.5 0 0 1 .3647-.1991c.166-.0118.3667.1172.7682.3753l4.7206 3.0347c.3484.2239.5226.3359.5827.4783a.5.5 0 0 1 0 .3892c-.0601.1424-.2343.2544-.5827.4783l-4.7206 3.0347c-.4015.2581-.6022.3872-.7682.3753a.5.5 0 0 1-.3647-.1991C9.5 15.7506 9.5 15.512 9.5 15.0347z"
    />
  </svg>
);

export const PlaySquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.5 8.9653c0-.4772 0-.7159.0997-.8491a.5.5 0 0 1 .3647-.1991c.166-.0118.3667.1172.7682.3753l4.7206 3.0347c.3484.2239.5226.3359.5827.4783a.5.5 0 0 1 0 .3892c-.0601.1424-.2343.2544-.5827.4783l-4.7206 3.0347c-.4015.2581-.6022.3872-.7682.3753a.5.5 0 0 1-.3647-.1991C9.5 15.7506 9.5 15.512 9.5 15.0347z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2z"
    />
  </svg>
);

export const Podcast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.1189 18C19.4623 16.4151 21 13.7779 21 10.785 21 5.9333 16.9704 2 12 2s-9 3.9333-9 8.785C3 13.7779 4.5377 16.4151 6.8811 18m1.4786-4C7.5187 13.15 7 12.0086 7 10.7505 7 8.1271 9.2388 6 12 6s5 2.1271 5 4.7505c0 1.259-.5187 2.3995-1.3597 3.2495M12 22c-1.1046 0-2-.8954-2-2v-2c0-1.1046.8954-2 2-2s2 .8954 2 2v2c0 1.1046-.8954 2-2 2m1-11c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const Power01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.0001 2v10m6.36-5.36a9 9 0 0 1 1.9497 9.8078 9.0005 9.0005 0 0 1-8.3147 5.5551A9 9 0 0 1 5.6301 6.64"
    />
  </svg>
);

export const Power02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 7v5M8 8.9995A4.978 4.978 0 0 0 7 12c0 2.7614 2.2386 5 5 5s5-2.2386 5-5a4.978 4.978 0 0 0-1-3.0005M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const Power03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 7v10m10-5c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const Printer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 7V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C16.4802 2 15.9201 2 14.8 2H9.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C6 3.5198 6 4.08 6 5.2V7m0 11c-.93 0-1.395 0-1.7765-.1022a3 3 0 0 1-2.1213-2.1213C2 15.395 2 14.93 2 14v-2.2c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 7 5.1198 7 6.8 7h10.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8V14c0 .93 0 1.395-.1022 1.7765a3 3 0 0 1-2.1213 2.1213C19.395 18 18.93 18 18 18m-3-7.5h3M9.2 22h5.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C18 20.4802 18 19.9201 18 18.8v-1.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C16.4802 14 15.9201 14 14.8 14H9.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C6 15.5198 6 16.0799 6 17.2v1.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C7.5198 22 8.08 22 9.2 22"
    />
  </svg>
);

export const Recording01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 10v4m4.5-8v12M12 3v18m4.5-15v12m4.5-8v4"
    />
  </svg>
);

export const Recording02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 10v4m4.5-3v2M12 6v12m4.5-15v18M21 10v4"
    />
  </svg>
);

export const Recording03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 11v2m4-4v6m4-8v10m4-6v2m4-1c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const Repeat01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m17 10 4-4-4-4m4 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 8.2798 3 9.1198 3 10.8v.2m0 7h13.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.7202 21 14.8802 21 13.2V13M7 14l-4 4 4 4"
    />
  </svg>
);

export const Repeat02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m11 8 3-3-3-3m3 3H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 7.2798 2 8.1198 2 9.8v5.7c0 .4644 0 .6966.0257.8916.1772 1.3462 1.2365 2.4055 2.5827 2.5827C4.8034 19 5.0356 19 5.5 19m4.5 0h7.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 16.7202 22 15.8802 22 14.2V8.5c0-.4644 0-.6966-.0257-.8916-.1772-1.3462-1.2365-2.4055-2.5827-2.5827C19.1966 5 18.9644 5 18.5 5M13 16l-3 3 3 3"
    />
  </svg>
);

export const Repeat03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13 16-3 3 3 3m-3-3h5c3.866 0 7-3.134 7-7 0-2.7924-1.6351-5.2029-4-6.3264M6 18.3264C3.635 17.2029 2 14.7924 2 12c0-3.866 3.134-7 7-7h5m-3 3 3-3-3-3"
    />
  </svg>
);

export const Repeat04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 20.5001c4.6944 0 8.5-3.8056 8.5-8.5 0-2.8255-1.3787-5.329-3.5-6.8746m-4 17.2746-2-2 2-2m-1-14.9c-4.6944 0-8.5 3.8056-8.5 8.5 0 2.8255 1.3787 5.3291 3.5 6.8746m4-13.2746 2-2-2-2"
    />
  </svg>
);

export const Rss01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 11a9 9 0 0 1 9 9M4 4a16 16 0 0 1 16 16M6 19c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const Rss02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3.0002 13.0225c5.185-.7796 8.7557 2.7921 7.9772 7.9771M3.0002 8.0378c7.9378-.7796 13.7415 5.0241 12.9619 12.9619M3.0002 3.0521c10.6917-.7785 18.7262 7.2561 17.9478 17.9477M5 21c-1.1043 0-2-.8957-2-2s.8957-2 2-2 2 .8957 2 2-.8957 2-2 2"
    />
  </svg>
);

export const Shuffle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m18 21 3-3-3-3m3 3h-2.4311c-.9392 0-1.4088 0-1.8351-.1295a3 3 0 0 1-1.0331-.5529c-.3442-.2828-.6047-.6736-1.1257-1.455l-.2417-.3626M18 9l3-3-3-3m3 3h-2.4311c-.9392 0-1.4088 0-1.8351.1295a3 3 0 0 0-1.0331.5529c-.3442.2828-.6047.6736-1.1257 1.455l-5.15 7.7252c-.521.7814-.7815 1.1722-1.1257 1.455a3 3 0 0 1-1.0331.5529C6.8399 18 6.3703 18 5.4312 18H3M3 6h2.4311c.9392 0 1.4088 0 1.8351.1295a3 3 0 0 1 1.0331.5529c.3442.2828.6047.6736 1.1257 1.455l.2417.3626"
    />
  </svg>
);

export const Shuffle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 21h5v-5m0 5-6-6M3 3l6 6m12-1V3h-5m5 0L3 21"
    />
  </svg>
);

export const Signal01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.2426 7.7574c2.3432 2.3431 2.3432 6.1421 0 8.4853m-8.4852-.0001c-2.3432-2.3431-2.3432-6.1421 0-8.4852M4.9289 19.071c-3.9052-3.9053-3.9052-10.2369 0-14.1421m14.1422 0c3.9052 3.9052 3.9052 10.2369 0 14.1421M14 12c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8955 2 2"
    />
  </svg>
);

export const Signal02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.2427 5.7573c2.3431 2.3432 2.3431 6.1422 0 8.4853m-8.4854 0c-2.3431-2.3431-2.3431-6.1421 0-8.4853M4.9287 17.0711c-3.9052-3.9053-3.9052-10.2369 0-14.1421m14.1426 0c3.9052 3.9052 3.9052 10.2368 0 14.1421M12 12c1.1045 0 2-.8954 2-2s-.8955-2-2-2-2 .8954-2 2 .8954 2 2 2m0 0v9"
    />
  </svg>
);

export const Signal03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.5858 13.4142c-.781-.781-.781-2.0474 0-2.8284s2.0474-.781 2.8284 0c.7811.781.7811 2.0474 0 2.8284m-5.6568 2.8284c-2.3432-2.3431-2.3432-6.1421 0-8.4852s6.1421-2.3432 8.4852 0 2.3432 6.1421 0 8.4852M4.9289 19.0711c-3.9052-3.9053-3.9052-10.237 0-14.1422 3.9053-3.9052 10.2369-3.9052 14.1422 0 3.9052 3.9053 3.9052 10.2369 0 14.1422"
    />
  </svg>
);

export const Simcard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C6.2798 2 7.1198 2 8.8 2h3.2118c.7337 0 1.1006 0 1.4459.0829.3061.0735.5987.1947.8672.3592.3027.1855.5621.445 1.081.9638l3.1882 3.1882c.5189.5189.7783.7783.9638 1.081.1645.2685.2857.5611.3592.8672C20 8.8876 20 9.2545 20 9.9883V17.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 13.8c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185C8.38 13 8.52 13 8.8 13h6.4c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185C16 13.38 16 13.52 16 13.8v3.4c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C15.62 18 15.48 18 15.2 18H8.8c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C8 17.62 8 17.48 8 17.2z"
    />
  </svg>
);

export const SkipBack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 19V5m11.4005 1.0796-5.8388 4.671c-.5338.4271-.8007.6406-.8974.8986a1 1 0 0 0 0 .7016c.0967.258.3636.4715.8974.8986l5.8388 4.671c.8322.6657 1.2482.9986 1.5984.999a1 1 0 0 0 .7826-.3762C19 18.2695 19 17.7367 19 16.671V7.329c0-1.0657 0-1.5985-.2185-1.8722a1 1 0 0 0-.7826-.3762c-.3502.0004-.7662.3333-1.5984.999"
    />
  </svg>
);

export const SkipForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 5v14M7.5995 17.9204l5.8388-4.671c.5338-.4271.8007-.6406.8974-.8986a1 1 0 0 0 0-.7016c-.0967-.258-.3636-.4715-.8974-.8986l-5.8388-4.671c-.8322-.6657-1.2482-.9986-1.5984-.999a1 1 0 0 0-.7826.3762C5 5.7304 5 6.2633 5 7.329v9.342c0 1.0657 0 1.5985.2185 1.8722.19.238.478.3765.7826.3762.3502-.0004.7662-.3333 1.5984-.999"
    />
  </svg>
);

export const Sliders01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 21v-7m0-4V3m7 18v-9m0-4V3m7 18v-5m0-4V3M2 14h6m1-6h6m1 8h6"
    />
  </svg>
);

export const Sliders02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 21v-6m0 0c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2m0-8V3m7 18v-6m0-8V3m0 4c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2m7 14v-4m0 0c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2m0-8V3"
    />
  </svg>
);

export const Sliders03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.0505 9H5.5C4.1193 9 3 7.8807 3 6.5S4.1193 4 5.5 4h9.5505m-6.101 16H18.5c1.3807 0 2.5-1.1193 2.5-2.5S19.8807 15 18.5 15H8.9495M3 17.5C3 19.433 4.567 21 6.5 21s3.5-1.567 3.5-3.5S8.433 14 6.5 14 3 15.567 3 17.5m18-11c0 1.933-1.567 3.5-3.5 3.5S14 8.433 14 6.5 15.567 3 17.5 3 21 4.567 21 6.5"
    />
  </svg>
);

export const Sliders04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 8h12m0 0c0 1.6569 1.3431 3 3 3s3-1.3431 3-3-1.3431-3-3-3-3 1.3431-3 3m-6 8h12M9 16c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
    />
  </svg>
);

export const Speaker01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 6h.01M8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22m3.7-16a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m3.5 8c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const Speaker02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 12h.01M18 6h.01M6 6h.01M18 18h.01M6 18h.01m.79 4h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 19.7202 22 18.8802 22 17.2V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 2 18.8802 2 17.2 2H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 4.2798 2 5.1198 2 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 22 5.1198 22 6.8 22m5.7-10a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 12.5 12m4.5 0c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5"
    />
  </svg>
);

export const Speaker03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 18v2.4c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437C17.2401 22 16.9601 22 16.4 22H7.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C6 21.2401 6 20.9601 6 20.4V18m6-8h.01M7.8 18h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.7202 21 14.8802 21 13.2V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 2 17.8802 2 16.2 2H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 4.2798 3 5.1198 3 6.8v6.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 18 6.1198 18 7.8 18m9.2-8c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5m-4.5 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 12.5 10"
    />
  </svg>
);

export const Stop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2z"
    />
  </svg>
);

export const StopCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 9.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C8.76 8 9.04 8 9.6 8h4.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437C16 8.76 16 9.04 16 9.6v4.8c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437C15.2401 16 14.9601 16 14.4 16H9.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C8 15.2401 8 14.9601 8 14.4z"
    />
  </svg>
);

export const StopSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 9.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C8.76 8 9.04 8 9.6 8h4.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437C16 8.76 16 9.04 16 9.6v4.8c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437C15.2401 16 14.9601 16 14.4 16H9.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C8 15.2401 8 14.9601 8 14.4z"
    />
  </svg>
);

export const Tablet01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 17.5h.01M7.2 22h9.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.4802 20 19.9201 20 18.8V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C18.4802 2 17.9201 2 16.8 2H7.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C4 3.5198 4 4.08 4 5.2v13.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C5.5198 22 6.08 22 7.2 22m5.3-4.5a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 12.5 17.5"
    />
  </svg>
);

export const Tablet02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 2v1.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C14.2401 5 13.9601 5 13.4 5h-2.8c-.5601 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C9 4.24 9 3.96 9 3.4V2M7.2 22h9.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.4802 20 19.9201 20 18.8V5.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C18.4802 2 17.9201 2 16.8 2H7.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C4 3.5198 4 4.08 4 5.2v13.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C5.5198 22 6.08 22 7.2 22"
    />
  </svg>
);

export const Tv01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 17v2.4c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437C17.2401 21 16.9601 21 16.4 21H7.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C6 20.2401 6 19.9601 6 19.4V17m.8 0h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 14.7202 22 13.8802 22 12.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 3 18.8802 3 17.2 3H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.2798 2 6.1198 2 7.8v4.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 17 5.1198 17 6.8 17"
    />
  </svg>
);

export const Tv02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m17 21-5-4-5 4m-.2-4h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 14.7202 22 13.8802 22 12.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 3 18.8802 3 17.2 3H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.2798 2 6.1198 2 7.8v4.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 17 5.1198 17 6.8 17"
    />
  </svg>
);

export const Tv03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m17 3-5 4-5-4m-.2 18h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.7202 22 17.8802 22 16.2v-4.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 7 18.8802 7 17.2 7H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 9.2798 2 10.1198 2 11.8v4.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 21 5.1198 21 6.8 21"
    />
  </svg>
);

export const UsbFlashDrive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 9V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C17.2401 2 16.9601 2 16.4 2H7.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C6 2.76 6 3.04 6 3.6V9m4-3V5m4 1V5M8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2v-5c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C18.4802 9 17.9201 9 16.8 9H7.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C4 10.5198 4 11.0799 4 12.2v5c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22"
    />
  </svg>
);

export const VideoRecorder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 8.9314c0-.6059 0-.9087-.1198-1.049a.5.5 0 0 0-.4194-.1738c-.1839.0145-.3981.2287-.8265.657L17 12l3.6343 3.6343c.4284.4284.6426.6426.8265.6571a.5.5 0 0 0 .4194-.1738C22 15.9774 22 15.6744 22 15.0686zM2 9.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 5 5.1198 5 6.8 5h5.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C17 7.2798 17 8.1198 17 9.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C14.7202 19 13.8802 19 12.2 19H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 16.7202 2 15.8802 2 14.2z"
    />
  </svg>
);

export const VideoRecorderOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 5C3.3432 5 2 6.3431 2 8v8c0 1.6569 1.3432 3 3 3h9c1.3527 0 2.4962-.8952 2.8705-2.1255M17 12l3.6343-3.6343c.4284-.4284.6426-.6426.8265-.657a.5.5 0 0 1 .4194.1737C22 8.0227 22 8.3256 22 8.9314v6.1372c0 .6058 0 .9088-.1198 1.049a.5.5 0 0 1-.4194.1738c-.1839-.0145-.3981-.2287-.8265-.6571zm0 0V9.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C14.7202 5 13.8802 5 12.2 5H9.5M2 2l20 20"
    />
  </svg>
);

export const Voicemail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 16h12M6 16c2.2091 0 4-1.7909 4-4S8.2091 8 6 8s-4 1.7909-4 4 1.7909 4 4 4m12 0c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4"
    />
  </svg>
);

export const VolumeMax = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19.7479 5C21.1652 6.9701 22 9.3875 22 11.9998s-.8348 5.0298-2.2521 7m-4.0026-11C16.5362 9.1338 17 10.5127 17 12s-.4638 2.8662-1.2547 4M9.6343 4.3656 6.4686 7.5313c-.173.173-.2594.2594-.3603.3213a1 1 0 0 1-.289.1197c-.1152.0276-.2374.0276-.482.0276H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 8.76 2 9.04 2 9.6v4.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109h1.7373c.2446 0 .3668 0 .482.0277.102.0245.1995.0649.289.1197.1009.0618.1874.1483.3603.3213l3.1657 3.1656c.4284.4284.6426.6426.8265.6571a.5.5 0 0 0 .4194-.1738C11 19.9773 11 19.6744 11 19.0686V4.9313c0-.6058 0-.9087-.1198-1.049a.5.5 0 0 0-.4194-.1737c-.1839.0145-.3981.2286-.8265.657"
    />
  </svg>
);

export const VolumeMin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18.2451 8c.7909 1.1338 1.2547 2.5127 1.2547 3.9999 0 1.4873-.4638 2.8662-1.2547 4M12.1343 4.3656 8.9686 7.5313c-.173.173-.2594.2594-.3603.3213a1 1 0 0 1-.289.1197c-.1152.0276-.2375.0276-.482.0276H6.1c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C4.5 8.76 4.5 9.04 4.5 9.6v4.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109h1.7373c.2445 0 .3668 0 .482.0277.102.0245.1995.0649.289.1197.1009.0618.1874.1483.3603.3213l3.1657 3.1656c.4284.4284.6426.6426.8265.6571a.5.5 0 0 0 .4194-.1738c.1198-.1402.1198-.4431.1198-1.0489V4.9313c0-.6058 0-.9087-.1198-1.049a.5.5 0 0 0-.4194-.1737c-.1839.0145-.3981.2286-.8265.657"
    />
  </svg>
);

export const VolumeMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 11.9999h7M9.6343 4.3656 6.4686 7.5313c-.173.173-.2594.2594-.3603.3213a1 1 0 0 1-.289.1197c-.1152.0276-.2374.0276-.482.0276H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 8.76 2 9.04 2 9.6v4.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109h1.7373c.2446 0 .3668 0 .482.0277.102.0245.1995.0649.289.1197.1009.0618.1874.1483.3603.3213l3.1657 3.1656c.4284.4284.6426.6426.8265.6571a.5.5 0 0 0 .4194-.1738C11 19.9773 11 19.6744 11 19.0686V4.9313c0-.6058 0-.9087-.1198-1.049a.5.5 0 0 0-.4194-.1737c-.1839.0145-.3981.2286-.8265.657"
    />
  </svg>
);

export const VolumePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18.5 15.4999v-7M15 12h7M9.6343 4.3656 6.4686 7.5313c-.173.173-.2594.2594-.3603.3213a1 1 0 0 1-.289.1197c-.1152.0276-.2374.0276-.482.0276H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 8.76 2 9.04 2 9.6v4.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109h1.7373c.2446 0 .3668 0 .482.0277.102.0245.1995.0649.289.1197.1009.0618.1874.1483.3603.3213l3.1657 3.1656c.4284.4284.6426.6426.8265.6571a.5.5 0 0 0 .4194-.1738C11 19.9773 11 19.6744 11 19.0686V4.9313c0-.6058 0-.9087-.1198-1.049a.5.5 0 0 0-.4194-.1737c-.1839.0145-.3981.2286-.8265.657"
    />
  </svg>
);

export const VolumeX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 9-6 5.9999m0-6 6 6M9.6343 4.3656 6.4686 7.5313c-.173.173-.2594.2594-.3603.3213a1 1 0 0 1-.289.1197c-.1152.0276-.2374.0276-.482.0276H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 8.76 2 9.04 2 9.6v4.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109h1.7373c.2446 0 .3668 0 .482.0277.102.0245.1995.0649.289.1197.1009.0618.1874.1483.3603.3213l3.1657 3.1656c.4284.4284.6426.6426.8265.6571a.5.5 0 0 0 .4194-.1738C11 19.9773 11 19.6744 11 19.0686V4.9313c0-.6058 0-.9087-.1198-1.049a.5.5 0 0 0-.4194-.1737c-.1839.0145-.3981.2286-.8265.657"
    />
  </svg>
);

export const Webcam01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 18c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8-8 3.5817-8 8 3.5817 8 8 8m0 0v4m0 0H7m5 0h5m-2-12c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
    />
  </svg>
);

export const Webcam02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 22h8m4.5-11.5c0 4.6944-3.8056 8.5-8.5 8.5s-8.5-3.8056-8.5-8.5S7.3056 2 12 2s8.5 3.8056 8.5 8.5m-5.3125 0c0 1.7604-1.4271 3.1875-3.1875 3.1875S8.8125 12.2604 8.8125 10.5 10.2396 7.3125 12 7.3125s3.1875 1.427 3.1875 3.1875"
    />
  </svg>
);

export const Wifi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 19.5h.01M22.8064 8.7008C19.9595 6.092 16.1656 4.5 11.9999 4.5S4.0402 6.092 1.1934 8.7008m3.5385 3.5422C6.6701 10.5357 9.2141 9.5 12 9.5s5.3299 1.0357 7.268 2.743m-3.5697 3.5321A5.974 5.974 0 0 0 11.9999 14.5a5.975 5.975 0 0 0-3.7445 1.3116"
    />
  </svg>
);

export const WifiOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.3119 10a11 11 0 0 1 3.7681 2.05m3.4999-3.55a16 16 0 0 0-12.3827-3.8955M8.5298 15.61a6 6 0 0 1 6.95 0M12 19.5h.01M1.1934 8.7008A16.01 16.01 0 0 1 5.7585 5.763M4.732 12.243c1.3974-1.231 3.1098-2.1128 5.0007-2.509m5.9657 6.0411A5.974 5.974 0 0 0 11.9999 14.5a5.975 5.975 0 0 0-3.7445 1.3116M3 3l18 18"
    />
  </svg>
);

export const Youtube = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21.5813 7.1999a2.528 2.528 0 0 0-1.7635-1.8181C18.2542 5 12 5 12 5s-6.2542 0-7.8178.4182a2.527 2.527 0 0 0-1.7635 1.818 26.36 26.36 0 0 0-.4182 4.8089 26.36 26.36 0 0 0 .4182 4.8452 2.527 2.527 0 0 0 1.7635 1.7454c1.5636.4181 7.8178.4181 7.8178.4181s6.2542 0 7.8178-.4181a2.5275 2.5275 0 0 0 1.7635-1.8181 26.36 26.36 0 0 0 .4182-4.7725 26.36 26.36 0 0 0-.4182-4.8452"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.75 9.4653c0-.4772 0-.7159.0997-.8491a.5.5 0 0 1 .3647-.1991c.166-.0118.3667.1172.7682.3753l3.9428 2.5347c.3484.2239.5226.3359.5828.4783a.5.5 0 0 1 0 .3892c-.0602.1424-.2344.2544-.5828.4783l-3.9428 2.5347c-.4015.2581-.6022.3872-.7682.3753a.5.5 0 0 1-.3647-.1991c-.0997-.1332-.0997-.3718-.0997-.8491z"
    />
  </svg>
);

export const Camera01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 8.3772c0-.3503 0-.5255.0146-.673.141-1.423 1.2667-2.5486 2.6896-2.6896C4.8517 5 5.0364 5 5.4056 5c.1423 0 .2134 0 .2738-.0037A2 2 0 0 0 7.414 3.746c.0226-.0561.0437-.1194.0859-.246s.0633-.1899.0859-.246a2 2 0 0 1 1.7347-1.2503C9.381 2 9.4477 2 9.5811 2h4.8378c.1334 0 .2001 0 .2605.0037a2 2 0 0 1 1.7347 1.2503c.0226.0561.0437.1194.0859.246s.0633.1899.0859.246a2 2 0 0 0 1.7347 1.2503C18.381 5 18.4521 5 18.5944 5c.3692 0 .5539 0 .7014.0146 1.4229.141 2.5486 1.2667 2.6896 2.6896.0146.1475.0146.3227.0146.673V16.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 16.5c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4"
    />
  </svg>
);

export const Camera02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 7.7018C2 6.2096 3.2096 5 4.7018 5a1.801 1.801 0 0 0 1.7087-1.2316L6.5 3.5c.0422-.1266.0633-.1899.0859-.246a2 2 0 0 1 1.7347-1.2503C8.381 2 8.4477 2 8.5811 2h6.8378c.1334 0 .2001 0 .2605.0037a2 2 0 0 1 1.7347 1.2503c.0226.0561.0437.1194.0859.246l.0895.2684A1.801 1.801 0 0 0 19.2982 5C20.7904 5 22 6.2096 22 7.7018V16.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 16.5c2.4853 0 4.5-2.0147 4.5-4.5S14.4853 7.5 12 7.5 7.5 9.5147 7.5 12s2.0147 4.5 4.5 4.5"
    />
  </svg>
);

export const Camera03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 3 5.1198 3 6.8 3h10.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 5.2798 22 6.1198 22 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 16c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4"
    />
  </svg>
);

export const CameraLens = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21.4155 15.3411c-2.8231 2.0084-6.526 2.2315-9.5385.6589M2.5845 8.6589c2.8299-2.0132 6.544-2.2325 9.5603-.6474m3.2289 6.1128c2.8867-1.8193 4.5582-5.1502 4.2273-8.612M8.5818 9.9036c-2.8595 1.8254-4.5122 5.1399-4.183 8.5841m11.1281-8.3508c-.133-3.4085-2.1819-6.5202-5.3448-7.9648M8.4756 13.9256c.1555 3.384 2.1987 6.4664 5.3421 7.9022M19.071 4.9289c3.9053 3.9053 3.9053 10.2369 0 14.1421-3.9052 3.9053-10.2368 3.9053-14.142 0-3.9053-3.9052-3.9053-10.2368 0-14.142 3.9052-3.9053 10.2368-3.9053 14.142 0m-4.2426 4.2427c1.5621 1.5621 1.5621 4.0947 0 5.6568s-4.0947 1.5621-5.6568 0-1.5621-4.0947 0-5.6568 4.0947-1.5621 5.6568 0"
    />
  </svg>
);

export const CameraOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 5h.4189c.1334 0 .2 0 .2605-.0037A2 2 0 0 0 7.414 3.746c.0226-.0561.0437-.1194.0859-.246s.0633-.1899.0859-.246a2 2 0 0 1 1.7347-1.2503C9.381 2 9.4477 2 9.5811 2h4.8378c.1334 0 .2001 0 .2605.0037a2 2 0 0 1 1.7347 1.2503c.0226.0561.0437.1194.0859.246s.0633.1899.0859.246a2 2 0 0 0 1.7347 1.2503C18.381 5 18.4521 5 18.5944 5c.3692 0 .5539 0 .7014.0146 1.4229.141 2.5486 1.2667 2.6896 2.6896.0146.1475.0146.3227.0146.673V18c0 1.0849-.5759 2.0353-1.4387 2.5622m-5.4972-5.4908A3.984 3.984 0 0 0 16 12.5c0-2.2091-1.7909-4-4-4a3.984 3.984 0 0 0-2.5699.9346M22 22 2 2m0 5.5v8.7c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 21 5.1198 21 6.8 21h8.7M12 16.5c-2.2091 0-4-1.7909-4-4"
    />
  </svg>
);

export const CameraPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 11.5v3.1c0 2.2402 0 3.3603-.436 4.216a4 4 0 0 1-1.748 1.748C18.9603 21 17.8402 21 15.6 21H8.4c-2.2402 0-3.3603 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 17.9603 2 16.8402 2 14.6V9.4c0-2.2402 0-3.3603.436-4.216a4 4 0 0 1 1.748-1.748C5.0397 3 6.1598 3 8.4 3h4.1M19 8V2m-3 3h6m-6 7c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const Colors = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 20.4722C13.0615 21.4223 14.4633 22 16 22c3.3137 0 6-2.6863 6-6 0-2.7669-1.8729-5.0964-4.4202-5.7898m-11.1596 0C3.8729 10.9036 2 13.2331 2 16c0 3.3137 2.6863 6 6 6s6-2.6863 6-6c0-.7805-.149-1.5262-.4202-2.2102M18 8c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6 2.6863-6 6-6 6 2.6863 6 6"
    />
  </svg>
);

export const Flash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13 2 4.0934 12.6879c-.3488.4185-.5232.6278-.5258.8046a.5.5 0 0 0 .1856.3964c.1375.1111.41.1111.9548.1111H12l-1 8 8.9065-10.6879c.3488-.4185.5232-.6278.5259-.8046a.5.5 0 0 0-.1857-.3964C20.1092 10 19.8368 10 19.292 10H12z"
    />
  </svg>
);

export const FlashOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m8 8-3.9065 4.6879c-.3488.4185-.5233.6278-.526.8046a.5.5 0 0 0 .1858.3964C3.8908 14 4.1632 14 4.708 14H12l-1 8 5-6m-.35-6h3.642c.5448 0 .8173 0 .9547.1111a.5.5 0 0 1 .1857.3964c-.0026.1768-.177.3861-.5259.8046l-1.3563 1.6276m-7.9774-8.027L13 2l-.5998 4.7977M21 21 3 3"
    />
  </svg>
);

export const Image01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.2 21H6.9314c-.6059 0-.9088 0-1.049-.1198a.5.5 0 0 1-.1738-.4194c.0145-.1839.2287-.3981.657-.8265l8.503-8.5029c.396-.396.5941-.5941.8224-.6682a1 1 0 0 1 .618 0c.2283.0741.4264.2722.8224.6682L21 15v1.2M16.2 21c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2M16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4M10.5 8.5c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2"
    />
  </svg>
);

export const Image02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m5.9996 20.0004 8.869-8.869c.396-.396.5941-.5941.8224-.6682a1 1 0 0 1 .618 0c.2283.0741.4264.2722.8224.6682l4.2739 4.2739M10.5 8.5c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const Image03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m4.272 20.7279 6.5966-6.5965c.396-.396.5941-.5941.8224-.6682a1 1 0 0 1 .618 0c.2283.0741.4264.2722.8224.6682l6.5525 6.5525M14 15l2.8686-2.8686c.396-.396.5941-.5941.8224-.6682a1 1 0 0 1 .618 0c.2283.0741.4264.2722.8224.6682L22 15M10 9c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2M6.8 21h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.7202 22 17.8802 22 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 3 18.8802 3 17.2 3H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.2798 2 6.1198 2 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 21 5.1198 21 6.8 21"
    />
  </svg>
);

export const Image04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 9.5 6 15h12l-4.5-7.5L11 11z"
    />
  </svg>
);

export const Image05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 21h1.0104c.9712 0 1.4567 0 1.7244-.2025a1 1 0 0 0 .3949-.7379c.02-.335-.2493-.7391-.788-1.5471l-3.0104-4.5156c-.4451-.6677-.6677-1.0015-.9482-1.1178a1 1 0 0 0-.7662 0c-.2805.1163-.503.4501-.9482 1.1178l-.7442 1.1163M19 21 11.3155 9.9002c-.4419-.6384-.6629-.9576-.9389-1.0698a1 1 0 0 0-.7532 0c-.276.1122-.497.4314-.9389 1.0698l-5.9463 8.5891c-.563.8132-.8445 1.2199-.8285 1.558a1 1 0 0 0 .3914.747C2.57 21 3.0646 21 4.0537 21zm2-15c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3432-3 3-3 3 1.3431 3 3"
    />
  </svg>
);

export const ImageCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 5 2 2 4-4m-9.5 0H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21H17c.93 0 1.395 0 1.7765-.1022a3 3 0 0 0 2.1213-2.1213C21 18.395 21 17.93 21 17M10.5 8.5c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m4.49 3.4181L6.5312 19.608c-.4758.4326-.7137.6488-.7348.8362a.5.5 0 0 0 .1668.4313C6.1048 21 6.4262 21 7.0692 21h9.3868c1.4391 0 2.1587 0 2.7239-.2418a3 3 0 0 0 1.5783-1.5783C21 18.6147 21 17.8951 21 16.456c0-.4843 0-.7264-.0529-.9518a2 2 0 0 0-.3738-.7778c-.143-.1822-.3321-.3335-.7102-.6359l-2.7973-2.2378c-.3784-.3028-.5676-.4542-.776-.5076a1 1 0 0 0-.5573.0176c-.2046.0664-.3839.2294-.7425.5554"
    />
  </svg>
);

export const ImageDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 5-3 3-3-3m3 3V2m-6.5 1H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21H17c.93 0 1.395 0 1.7765-.1022a3 3 0 0 0 2.1213-2.1213C21 18.395 21 17.93 21 17M10.5 8.5c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m4.49 3.4181L6.5312 19.608c-.4758.4326-.7137.6488-.7348.8362a.5.5 0 0 0 .1668.4313C6.1048 21 6.4262 21 7.0692 21h9.3868c1.4391 0 2.1587 0 2.7239-.2418a3 3 0 0 0 1.5783-1.5783C21 18.6147 21 17.8951 21 16.456c0-.4843 0-.7264-.0529-.9518a2 2 0 0 0-.3738-.7778c-.143-.1822-.3321-.3335-.7102-.6359l-2.7973-2.2378c-.3784-.3028-.5676-.4542-.776-.5076a1 1 0 0 0-.5573.0176c-.2046.0664-.3839.2294-.7425.5554"
    />
  </svg>
);

export const ImageLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m19 2-3 3 3 3m-3-3h6m-9.5-2H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21H17c.93 0 1.395 0 1.7765-.1022a3 3 0 0 0 2.1213-2.1213C21 18.395 21 17.93 21 17M10.5 8.5c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m4.49 3.4181L6.5312 19.608c-.4758.4326-.7137.6488-.7348.8362a.5.5 0 0 0 .1668.4313C6.1048 21 6.4262 21 7.0692 21h9.3868c1.4391 0 2.1587 0 2.7239-.2418a3 3 0 0 0 1.5783-1.5783C21 18.6147 21 17.8951 21 16.456c0-.4843 0-.7264-.0529-.9518a2 2 0 0 0-.3738-.7778c-.143-.1822-.3321-.3335-.7102-.6359l-2.7973-2.2378c-.3784-.3028-.5676-.4542-.776-.5076a1 1 0 0 0-.5573.0176c-.2046.0664-.3839.2294-.7425.5554"
    />
  </svg>
);

export const ImagePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.5 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21H17c.93 0 1.395 0 1.7765-.1022a3 3 0 0 0 2.1213-2.1213C21 18.395 21 17.93 21 17m-2-9V2m-3 3h6M10.5 8.5c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m4.49 3.4181L6.5312 19.608c-.4758.4326-.7137.6488-.7348.8362a.5.5 0 0 0 .1668.4313C6.1048 21 6.4262 21 7.0692 21h9.3868c1.4391 0 2.1587 0 2.7239-.2418a3 3 0 0 0 1.5783-1.5783C21 18.6147 21 17.8951 21 16.456c0-.4843 0-.7264-.0529-.9518a2 2 0 0 0-.3738-.7778c-.143-.1822-.3321-.3335-.7102-.6359l-2.7973-2.2378c-.3784-.3028-.5676-.4542-.776-.5076a1 1 0 0 0-.5573.0176c-.2046.0664-.3839.2294-.7425.5554"
    />
  </svg>
);

export const ImageRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m19 2 3 3-3 3m3-3h-6m-3.5-2H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21H17c.93 0 1.395 0 1.7765-.1022a3 3 0 0 0 2.1213-2.1213C21 18.395 21 17.93 21 17M10.5 8.5c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m4.49 3.4181L6.5312 19.608c-.4758.4326-.7137.6488-.7348.8362a.5.5 0 0 0 .1668.4313C6.1048 21 6.4262 21 7.0692 21h9.3868c1.4391 0 2.1587 0 2.7239-.2418a3 3 0 0 0 1.5783-1.5783C21 18.6147 21 17.8951 21 16.456c0-.4843 0-.7264-.0529-.9518a2 2 0 0 0-.3738-.7778c-.143-.1822-.3321-.3335-.7102-.6359l-2.7973-2.2378c-.3784-.3028-.5676-.4542-.776-.5076a1 1 0 0 0-.5573.0176c-.2046.0664-.3839.2294-.7425.5554"
    />
  </svg>
);

export const ImageUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 5-3-3-3 3m3-3v6m-6.5-5H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21H17c.93 0 1.395 0 1.7765-.1022a3 3 0 0 0 2.1213-2.1213C21 18.395 21 17.93 21 17M10.5 8.5c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m4.49 3.4181L6.5312 19.608c-.4758.4326-.7137.6488-.7348.8362a.5.5 0 0 0 .1668.4313C6.1048 21 6.4262 21 7.0692 21h9.3868c1.4391 0 2.1587 0 2.7239-.2418a3 3 0 0 0 1.5783-1.5783C21 18.6147 21 17.8951 21 16.456c0-.4843 0-.7264-.0529-.9518a2 2 0 0 0-.3738-.7778c-.143-.1822-.3321-.3335-.7102-.6359l-2.7973-2.2378c-.3784-.3028-.5676-.4542-.776-.5076a1 1 0 0 0-.5573.0176c-.2046.0664-.3839.2294-.7425.5554"
    />
  </svg>
);

export const ImageUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 21.8174C4.6026 22 5.4165 22 6.8 22h10.4c1.3835 0 2.1974 0 2.8-.1826m-16 0a2.2 2.2 0 0 1-.362-.1444 3 3 0 0 1-1.311-1.311C2 19.7202 2 18.8802 2 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 2 5.1198 2 6.8 2h10.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 4.2798 22 5.1198 22 6.8v10.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311 2.2 2.2 0 0 1-.362.1444m-16 0c.0004-.8093.0052-1.2375.0769-1.5978a4 4 0 0 1 3.1427-3.1427C7.606 17 8.0706 17 9 17h6c.9293 0 1.394 0 1.7804.0769a4 4 0 0 1 3.1427 3.1427c.0717.3603.0765.7885.0769 1.5978M16 9.5c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const ImageUserCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 5 2 2 4-4m0 9v5.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 22 18.8802 22 17.2 22H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.7202 2 18.8802 2 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 2 5.1198 2 6.8 2H12M2.1455 19.9263C2.6147 18.2386 4.1625 17 5.9998 17h7c.9293 0 1.3939 0 1.7803.0769a4 4 0 0 1 3.1428 3.1427c.0769.3864.0769.8511.0769 1.7804M14 9.5c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const ImageUserDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 5-3 3-3-3m3 3V2m3 10v5.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 22 18.8802 22 17.2 22H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.7202 2 18.8802 2 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 2 5.1198 2 6.8 2H12M2.1457 19.9263C2.615 18.2386 4.1628 17 6 17h7c.9293 0 1.394 0 1.7804.0769a4 4 0 0 1 3.1427 3.1427C18 20.606 18 21.0707 18 22M14 9.5c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const ImageUserLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m19 2-3 3 3 3m-3-3h6m0 7v5.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 22 18.8802 22 17.2 22H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.7202 2 18.8802 2 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 2 5.1198 2 6.8 2H12M2.1455 19.9263C2.6147 18.2386 4.1625 17 5.9998 17h7c.9293 0 1.3939 0 1.7803.0769a4 4 0 0 1 3.1428 3.1427c.0769.3864.0769.8511.0769 1.7804M14 9.5c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const ImageUserPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 8V2m-3 3h6m0 7v5.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 22 18.8802 22 17.2 22H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.7202 2 18.8802 2 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 2 5.1198 2 6.8 2H12M2.1457 19.9263C2.615 18.2386 4.1628 17 6 17h7c.9293 0 1.394 0 1.7804.0769a4 4 0 0 1 3.1427 3.1427C18 20.606 18 21.0707 18 22M14 9.5c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const ImageUserRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m19 2 3 3-3 3m3-3h-6m6 7v5.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 22 18.8802 22 17.2 22H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.7202 2 18.8802 2 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 2 5.1198 2 6.8 2H12M2.1455 19.9263C2.6147 18.2386 4.1625 17 5.9998 17h7c.9293 0 1.3939 0 1.7803.0769a4 4 0 0 1 3.1428 3.1427c.0769.3864.0769.8511.0769 1.7804M14 9.5c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const ImageUserUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22 5-3-3-3 3m3-3v6m3 4v5.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 22 18.8802 22 17.2 22H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.7202 2 18.8802 2 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 2 5.1198 2 6.8 2H12M2.1455 19.9263C2.6147 18.2386 4.1625 17 5.9998 17h7c.9293 0 1.3939 0 1.7803.0769a4 4 0 0 1 3.1428 3.1427c.0769.3864.0769.8511.0769 1.7804M14 9.5c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const ImageUserX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16.5 2.5 5 5m0-5-5 5M22 12v5.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 22 18.8802 22 17.2 22H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.7202 2 18.8802 2 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 2 5.1198 2 6.8 2H12M2.1455 19.9263C2.6147 18.2386 4.1625 17 5.9998 17h7c.9293 0 1.3939 0 1.7803.0769a4 4 0 0 1 3.1428 3.1427c.0769.3864.0769.8511.0769 1.7804M14 9.5c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const ImageX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16.5 2.5 5 5m0-5-5 5m-4-4.5H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21H17c.93 0 1.395 0 1.7765-.1022a3 3 0 0 0 2.1213-2.1213C21 18.395 21 17.93 21 17M10.5 8.5c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m4.49 3.4181L6.5312 19.608c-.4758.4326-.7137.6488-.7348.8362a.5.5 0 0 0 .1668.4313C6.1048 21 6.4262 21 7.0692 21h9.3868c1.4391 0 2.1587 0 2.7239-.2418a3 3 0 0 0 1.5783-1.5783C21 18.6147 21 17.8951 21 16.456c0-.4843 0-.7264-.0529-.9518a2 2 0 0 0-.3738-.7778c-.143-.1822-.3321-.3335-.7102-.6359l-2.7973-2.2378c-.3784-.3028-.5676-.4542-.776-.5076a1 1 0 0 0-.5573.0176c-.2046.0664-.3839.2294-.7425.5554"
    />
  </svg>
);

export const Annotation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v5.7c0 1.3978 0 2.0967-.2284 2.6481a3 3 0 0 1-1.6235 1.6235C18.5967 18 17.8978 18 16.5 18c-.4886 0-.7329 0-.9595.0535a2 2 0 0 0-.822.411c-.1788.1492-.3254.3446-.6185.7355l-1.46 1.9467c-.2171.2895-.3257.4342-.4588.486a.5.5 0 0 1-.3624 0c-.1331-.0518-.2417-.1965-.4588-.486L9.9 19.2c-.2932-.3909-.4397-.5863-.6185-.7355a2 2 0 0 0-.822-.411C8.233 18 7.9885 18 7.5 18c-1.3978 0-2.0967 0-2.648-.2284a3 3 0 0 1-1.6236-1.6235C3 15.5967 3 14.8978 3 13.5z"
    />
  </svg>
);

export const AnnotationAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 10.5V7m0 7h.01M9.9 19.2l1.46 1.9467c.2171.2895.3257.4342.4588.486a.5.5 0 0 0 .3624 0c.1331-.0518.2417-.1965.4588-.486L14.1 19.2c.2931-.3909.4397-.5863.6185-.7355a2 2 0 0 1 .822-.411C15.7671 18 16.0114 18 16.5 18c1.3978 0 2.0967 0 2.6481-.2284a3 3 0 0 0 1.6235-1.6235C21 15.5967 21 14.8978 21 13.5V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v5.7c0 1.3978 0 2.0967.2284 2.6481a3 3 0 0 0 1.6236 1.6235C5.4033 18 6.1022 18 7.5 18c.4886 0 .7329 0 .9595.0535.3022.0713.5836.2121.822.411.1788.1492.3254.3446.6185.7355"
    />
  </svg>
);

export const AnnotationCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 11 2 2 4.5-4.5M9.9 19.2l1.46 1.9467c.2171.2895.3257.4342.4588.486a.5.5 0 0 0 .3624 0c.1331-.0518.2417-.1965.4588-.486L14.1 19.2c.2931-.3909.4397-.5863.6185-.7355a2 2 0 0 1 .822-.411C15.7671 18 16.0114 18 16.5 18c1.3978 0 2.0967 0 2.6481-.2284a3 3 0 0 0 1.6235-1.6235C21 15.5967 21 14.8978 21 13.5V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v5.7c0 1.3978 0 2.0967.2284 2.6481a3 3 0 0 0 1.6236 1.6235C5.4033 18 6.1022 18 7.5 18c.4886 0 .7329 0 .9595.0535.3022.0713.5836.2121.822.411.1788.1492.3254.3446.6185.7355"
    />
  </svg>
);

export const AnnotationDots = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.5 10.5h.01m4.49 0h.01m4.49 0h.01M9.9 19.2l1.46 1.9467c.2171.2895.3257.4342.4588.486a.5.5 0 0 0 .3624 0c.1331-.0518.2417-.1965.4588-.486L14.1 19.2c.2931-.3909.4397-.5863.6185-.7355a2 2 0 0 1 .822-.411C15.7671 18 16.0114 18 16.5 18c1.3978 0 2.0967 0 2.6481-.2284a3 3 0 0 0 1.6235-1.6235C21 15.5967 21 14.8978 21 13.5V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v5.7c0 1.3978 0 2.0967.2284 2.6481a3 3 0 0 0 1.6236 1.6235C5.4033 18 6.1022 18 7.5 18c.4886 0 .7329 0 .9595.0535.3022.0713.5836.2121.822.411.1788.1492.3254.3446.6185.7355M8 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.5 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 12.5 10.5m4.5 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 17 10.5"
    />
  </svg>
);

export const AnnotationHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v5.7c0 1.3978 0 2.0967-.2284 2.6481a3 3 0 0 1-1.6235 1.6235C18.5967 18 17.8978 18 16.5 18c-.4886 0-.7329 0-.9595.0535a2 2 0 0 0-.822.411c-.1788.1492-.3254.3446-.6185.7355l-1.46 1.9467c-.2171.2895-.3257.4342-.4588.486a.5.5 0 0 1-.3624 0c-.1331-.0518-.2417-.1965-.4588-.486L9.9 19.2c-.2932-.3909-.4397-.5863-.6185-.7355a2 2 0 0 0-.822-.411C8.233 18 7.9885 18 7.5 18c-1.3978 0-2.0967 0-2.648-.2284a3 3 0 0 1-1.6236-1.6235C3 15.5967 3 14.8978 3 13.5z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.9973 8.3306c-.7998-.909-2.1334-1.1535-3.1354-.3212s-1.1431 2.2241-.3562 3.2085c.468.5854 1.614 1.6352 2.4662 2.39.3518.3116.5277.4674.7395.5306.1811.0541.3906.0541.5718 0 .2117-.0632.3876-.219.7394-.5306.8522-.7548 1.9983-1.8046 2.4662-2.39.7869-.9844.6631-2.3848-.3562-3.2085-1.0192-.8236-2.3356-.5878-3.1353.3212"
      clipRule="evenodd"
    />
  </svg>
);

export const AnnotationInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 14v-3.5M12 7h.01M9.9 19.2l1.46 1.9467c.2171.2895.3257.4342.4588.486a.5.5 0 0 0 .3624 0c.1331-.0518.2417-.1965.4588-.486L14.1 19.2c.2931-.3909.4397-.5863.6185-.7355a2 2 0 0 1 .822-.411C15.7671 18 16.0114 18 16.5 18c1.3978 0 2.0967 0 2.6481-.2284a3 3 0 0 0 1.6235-1.6235C21 15.5967 21 14.8978 21 13.5V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v5.7c0 1.3978 0 2.0967.2284 2.6481a3 3 0 0 0 1.6236 1.6235C5.4033 18 6.1022 18 7.5 18c.4886 0 .7329 0 .9595.0535.3022.0713.5836.2121.822.411.1788.1492.3254.3446.6185.7355"
    />
  </svg>
);

export const AnnotationPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 13.5v-6m-3 3h6m-5.1 8.7 1.46 1.9467c.2171.2895.3257.4342.4588.486a.5.5 0 0 0 .3624 0c.1331-.0518.2417-.1965.4588-.486L14.1 19.2c.2931-.3909.4397-.5863.6185-.7355a2 2 0 0 1 .822-.411C15.7671 18 16.0114 18 16.5 18c1.3978 0 2.0967 0 2.6481-.2284a3 3 0 0 0 1.6235-1.6235C21 15.5967 21 14.8978 21 13.5V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v5.7c0 1.3978 0 2.0967.2284 2.6481a3 3 0 0 0 1.6236 1.6235C5.4033 18 6.1022 18 7.5 18c.4886 0 .7329 0 .9595.0535.3022.0713.5836.2121.822.411.1788.1492.3254.3446.6185.7355"
    />
  </svg>
);

export const AnnotationQuestion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 8.5022a2.2485 2.2485 0 0 1 2.501-1.4698 2.248 2.248 0 0 1 1.8682 2.2193c0 1.4989-2.2483 2.2483-2.2483 2.2483m.029 3h.01M9.9 19.2l1.46 1.9467c.2171.2895.3257.4342.4588.486a.5.5 0 0 0 .3624 0c.1331-.0518.2417-.1965.4588-.486L14.1 19.2c.2931-.3909.4397-.5863.6185-.7355a2 2 0 0 1 .822-.411C15.7671 18 16.0114 18 16.5 18c1.3978 0 2.0967 0 2.6481-.2284a3 3 0 0 0 1.6235-1.6235C21 15.5967 21 14.8978 21 13.5V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v5.7c0 1.3978 0 2.0967.2284 2.6481a3 3 0 0 0 1.6236 1.6235C5.4033 18 6.1022 18 7.5 18c.4886 0 .7329 0 .9595.0535.3022.0713.5836.2121.822.411.1788.1492.3254.3446.6185.7355"
    />
  </svg>
);

export const AnnotationX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9.5 8 5 5m0-5-5 5m.4 6.2 1.46 1.9467c.2171.2895.3257.4342.4588.486a.5.5 0 0 0 .3624 0c.1331-.0518.2417-.1965.4588-.486L14.1 19.2c.2931-.3909.4397-.5863.6185-.7355a2 2 0 0 1 .822-.411C15.7671 18 16.0114 18 16.5 18c1.3978 0 2.0967 0 2.6481-.2284a3 3 0 0 0 1.6235-1.6235C21 15.5967 21 14.8978 21 13.5V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v5.7c0 1.3978 0 2.0967.2284 2.6481a3 3 0 0 0 1.6236 1.6235C5.4033 18 6.1022 18 7.5 18c.4886 0 .7329 0 .9595.0535.3022.0713.5836.2121.822.411.1788.1492.3254.3446.6185.7355"
    />
  </svg>
);

export const Inbox01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2.5 12h3.382A1.809 1.809 0 0 1 7.5 13c.3064.6129.9328 1 1.618 1h5.764a1.809 1.809 0 0 0 1.618-1c.3064-.6129.9328-1 1.618-1H21.5M8.9666 4h6.0668c1.0769 0 1.6153 0 2.0907.164.4204.145.8033.3816 1.121.6928.3592.3518.6.8334 1.0816 1.7966l2.1665 4.3331c.189.378.2835.567.3502.765.0592.176.1019.357.1276.5408.029.2069.029.4182.029.8408V15.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 20 18.8802 20 17.2 20H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 17.7202 2 16.8802 2 15.2v-2.0669c0-.4226 0-.6339.029-.8408a3 3 0 0 1 .1276-.5408c.0667-.198.1612-.387.3501-.765l2.1666-4.3331c.4816-.9632.7224-1.4448 1.0816-1.7967a3 3 0 0 1 1.121-.6927C7.3513 4 7.8897 4 8.9666 4"
    />
  </svg>
);

export const Inbox02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 12h3.882A1.809 1.809 0 0 1 7.5 13c.3064.6129.9328 1 1.618 1h5.764a1.809 1.809 0 0 0 1.618-1c.3064-.6129.9328-1 1.618-1H22M2 12V8.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 4 5.1198 4 6.8 4h10.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 6.2798 22 7.1198 22 8.8V12M2 12v3.2c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 20 5.1198 20 6.8 20h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.7202 22 16.8802 22 15.2V12"
    />
  </svg>
);

export const Mail01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m2 7 8.1649 5.7154c.6612.4629.9918.6943 1.3514.7839.3176.0792.6498.0792.9674 0 .3596-.0896.6902-.321 1.3514-.7839L22 7M6.8 20h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.7202 22 16.8802 22 15.2V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 4 18.8802 4 17.2 4H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.2798 2 7.1198 2 8.8v6.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 20 5.1198 20 6.8 20"
    />
  </svg>
);

export const Mail02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m21.5 18-6.6429-6m-5.7142 0L2.5 18M2 7l8.1649 5.7154c.6612.4629.9918.6943 1.3514.7839.3176.0792.6498.0792.9674 0 .3596-.0896.6902-.321 1.3514-.7839L22 7M6.8 20h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.7202 22 16.8802 22 15.2V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 4 18.8802 4 17.2 4H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.2798 2 7.1198 2 8.8v6.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 20 5.1198 20 6.8 20"
    />
  </svg>
);

export const Mail03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m2 7 5.1938 3.4626c.2997.1997.4495.2996.6116.3704.1439.0628.2946.1084.4492.136.174.031.3542.031.7143.031h6.0622c.3601 0 .5402 0 .7143-.031a2 2 0 0 0 .4492-.136c.1621-.0708.3119-.1707.6116-.3704L22 7M6.8 20h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.7202 22 16.8802 22 15.2V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 4 18.8802 4 17.2 4H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.2798 2 7.1198 2 8.8v6.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 20 5.1198 20 6.8 20"
    />
  </svg>
);

export const Mail04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.256 2.6335 3.032 7.329c-.344.2236-.516.3354-.5755.4771a.5.5 0 0 0 0 .3874c.0595.1417.2315.2535.5754.477l7.2241 4.6957c.6313.4103.9469.6155 1.287.6953.3006.0705.6134.0705.914 0 .3401-.0798.6557-.285 1.287-.6953l7.2241-4.6957c.3439-.2235.5159-.3353.5754-.477a.5.5 0 0 0 0-.3874c-.0595-.1417-.2315-.2535-.5754-.477L13.744 2.6334c-.6313-.4104-.9469-.6155-1.287-.6953a2 2 0 0 0-.914 0c-.3401.0798-.6557.285-1.287.6953L2.728 7.5267c-.266.1729-.399.2593-.4954.3746a1 1 0 0 0-.1884.3473C2 8.3924 2 8.551 2 8.8683v7.3317c0 1.6801 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311c.6418.327 1.4818.327 3.162.327h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.7201 22 17.88 22 16.1999V8.8682c0-.3173 0-.476-.0442-.6196a1 1 0 0 0-.1884-.3473c-.0964-.1153-.2294-.2017-.4954-.3746l-7.528-4.8932"
    />
  </svg>
);

export const Mail05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13.744 2.6336 7.528 4.8932c.266.1729.399.2594.4954.3747a1 1 0 0 1 .1884.3473C22 8.3924 22 8.551 22 8.8683V16.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2V8.8683c0-.3173 0-.4759.0442-.6195a1 1 0 0 1 .1885-.3473c.0963-.1154.2293-.2018.4953-.3747l7.528-4.8932m0 0L4.0639 6.6585c-.6879.4471-1.0318.6707-1.151.9541a1 1 0 0 0 0 .7748c.1192.2835.4631.507 1.151.9541l6.1921 4.0249c.6313.4103.9469.6155 1.287.6953.3006.0706.6134.0706.914 0 .3401-.0798.6557-.285 1.287-.6953l6.1921-4.0249c.6879-.447 1.0318-.6706 1.1509-.9541a1 1 0 0 0 0-.7748c-.1191-.2834-.463-.507-1.1509-.9541l-6.1921-4.025c-.6313-.4102-.9469-.6154-1.287-.6952a2 2 0 0 0-.914 0c-.3401.0798-.6557.285-1.287.6953M21.5 19l-6.6428-6m-5.7144 0L2.5 19"
    />
  </svg>
);

export const MessageAlertCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.4996 11V7.5m0 7h.01m-.01 5.5c4.6944 0 8.5-3.8056 8.5-8.5S17.194 3 12.4996 3s-8.5 3.8056-8.5 8.5c0 .95.1559 1.8636.4434 2.7166.1082.321.1623.4815.172.6048.0097.1218.0024.2072-.0277.3255-.0305.1199-.0979.2446-.2326.4939l-1.6356 3.0276c-.2334.4318-.35.6477-.3239.8144a.5.5 0 0 0 .2336.3494c.144.0879.3881.0626.8764.0122l5.121-.5294c.155-.016.2326-.024.3033-.0213a.9.9 0 0 1 .1864.0248c.0689.0159.1555.0493.3289.116.948.3653 1.978.5655 3.0548.5655"
    />
  </svg>
);

export const MessageAlertSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 10.5V7m0 7h.01M7 18v2.3355c0 .5329 0 .7993.1092.9361a.5.5 0 0 0 .3913.1881c.1751-.0002.3832-.1666.7993-.4995l2.3854-1.9084c.4873-.3898.731-.5847 1.0023-.7233a3 3 0 0 1 .7617-.2672C12.7477 18 13.0597 18 13.6837 18H16.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.7202 21 14.8802 21 13.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8V14c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C5.605 18 6.07 18 7 18"
    />
  </svg>
);

export const MessageChatCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.0944 11.2288A8 8 0 0 1 6 10c0-4.4183 3.6053-8 8.0526-8s8.0526 3.5817 8.0526 8c0 .9981-.1839 1.9535-.52 2.8345-.0698.183-.1048.2745-.1206.3459a.9.9 0 0 0-.0235.1931c-.0017.0731.0082.1537.0281.3148l.4025 3.2702c.0436.354.0654.531.0065.6597a.5.5 0 0 1-.2571.2513c-.13.0559-.3065.03-.6594-.0217l-3.1852-.4669c-.1664-.0244-.2495-.0366-.3253-.0361a.9.9 0 0 0-.2001.0213c-.0741.0156-.1688.0511-.3581.122-.8833.3309-1.8406.5119-2.8404.5119a8.2 8.2 0 0 1-1.2299-.0927M7.6316 22C10.5965 22 13 19.5376 13 16.5S10.5965 11 7.6316 11s-5.3684 2.4624-5.3684 5.5c0 .6106.097 1.1979.2764 1.7467.0757.232.1136.348.126.4272a.85.85 0 0 1 .0105.2128c-.0046.0801-.0247.1706-.0648.3516L2 22l2.9948-.409c.1635-.0223.2452-.0335.3166-.033a.84.84 0 0 1 .1887.0193c.07.0139.174.0506.3822.1241A5.25 5.25 0 0 0 7.6316 22"
    />
  </svg>
);

export const MessageChatSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m10 15-3.0753 3.1137c-.429.4343-.6434.6515-.8277.6668a.5.5 0 0 1-.421-.1729c-.1204-.1404-.1204-.4456-.1204-1.0561v-1.5599c0-.5476-.4485-.9439-.9904-1.0233a3 3 0 0 1-2.5335-2.5335C2 12.2186 2 11.9605 2 11.4444V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 2 5.1198 2 6.8 2h7.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C19 4.2798 19 5.1198 19 6.8V11m0 11-2.1764-1.5131c-.3059-.2127-.4589-.3191-.6254-.3945a2 2 0 0 0-.4626-.145c-.1798-.0331-.3661-.0331-.7387-.0331H13.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C10 18.3944 10 17.8344 10 16.7143V14.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C11.5198 11 12.0799 11 13.2 11h5.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874.218.4278.218.9879.218 2.108v2.7143c0 .9319 0 1.3978-.1522 1.7654a2 2 0 0 1-1.0824 1.0823c-.3676.1523-.8335.1523-1.7654.1523z"
    />
  </svg>
);

export const MessageCheckCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9.4996 11.5 2 2 4.5-4.5m-3.5 11c4.6944 0 8.5-3.8056 8.5-8.5S17.194 3 12.4996 3s-8.5 3.8056-8.5 8.5c0 .95.1559 1.8636.4434 2.7166.1082.321.1623.4815.172.6048.0097.1218.0024.2072-.0277.3255-.0305.1199-.0979.2446-.2326.4939l-1.6356 3.0276c-.2334.4318-.35.6477-.3239.8144a.5.5 0 0 0 .2336.3494c.144.0879.3881.0626.8764.0122l5.121-.5294c.155-.016.2326-.024.3033-.0213a.9.9 0 0 1 .1864.0248c.0689.0159.1555.0493.3289.116.948.3653 1.978.5655 3.0548.5655"
    />
  </svg>
);

export const MessageCheckSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 10.5 2 2L15.5 8M7 18v2.3355c0 .5329 0 .7993.1092.9361a.5.5 0 0 0 .3913.1881c.1751-.0002.3832-.1666.7993-.4995l2.3854-1.9084c.4873-.3898.731-.5847 1.0023-.7233a3 3 0 0 1 .7617-.2672C12.7477 18 13.0597 18 13.6837 18H16.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.7202 21 14.8802 21 13.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8V14c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C5.605 18 6.07 18 7 18"
    />
  </svg>
);

export const MessageCircle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20.9996 11.5c0 4.6944-3.8056 8.5-8.5 8.5-1.0768 0-2.1068-.2002-3.0548-.5655-.1734-.0667-.26-.1001-.329-.116a.9.9 0 0 0-.1863-.0248c-.0707-.0027-.1482.0053-.3033.0213l-5.121.5294c-.4883.0504-.7324.0757-.8764-.0122a.5.5 0 0 1-.2336-.3494c-.0261-.1667.0905-.3826.3239-.8144l1.6356-3.0276c.1347-.2493.202-.374.2326-.4939.0301-.1183.0374-.2037.0278-.3255-.0098-.1233-.064-.2838-.1721-.6048A8.49 8.49 0 0 1 3.9996 11.5c0-4.6944 3.8056-8.5 8.5-8.5s8.5 3.8056 8.5 8.5"
    />
  </svg>
);

export const MessageCircle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 12c0 4.9706-4.0294 9-9 9-1.1971 0-2.3397-.2337-3.3845-.6581-.2-.0812-.3-.1218-.3808-.1399a.9.9 0 0 0-.2186-.0242c-.0828 0-.173.015-.3534.0451l-3.558.593c-.3725.0621-.5588.0931-.6935.0353a.5.5 0 0 1-.2624-.2624c-.0578-.1347-.0268-.321.0353-.6936l.593-3.5578c.03-.1805.0451-.2707.0451-.3535a.9.9 0 0 0-.0242-.2186c-.0181-.0808-.0587-.1808-.14-.3808C3.2338 14.3397 3 13.1971 3 12c0-4.9706 4.0294-9 9-9s9 4.0294 9 9"
    />
  </svg>
);

export const MessageDotsCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.5 12h.01M12 12h.01m4.49 0h.01M12 21c4.9706 0 9-4.0294 9-9s-4.0294-9-9-9-9 4.0294-9 9c0 1.1971.2337 2.3397.658 3.3845.0813.2.1219.3.14.3808a.9.9 0 0 1 .0242.2186c0 .0828-.015.173-.045.3535l-.593 3.5578c-.0622.3726-.0932.5589-.0354.6936a.5.5 0 0 0 .2624.2624c.1347.0578.321.0268.6936-.0353l3.5579-.593c.1804-.0301.2706-.0451.3534-.0451.081 0 .1396.0065.2186.0242.0808.0181.1808.0587.3808.1399C9.6603 20.7663 10.8029 21 12 21m-4-9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.5 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 12.5 12m4.5 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 17 12"
    />
  </svg>
);

export const MessageDotsSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.5 10.5h.01m4.49 0h.01m4.49 0h.01M7 18v2.3355c0 .5329 0 .7993.1092.9361a.5.5 0 0 0 .3913.1881c.1751-.0002.3832-.1666.7993-.4995l2.3854-1.9084c.4873-.3898.731-.5847 1.0023-.7233a3 3 0 0 1 .7617-.2672C12.7477 18 13.0597 18 13.6837 18H16.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.7202 21 14.8802 21 13.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8V14c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C5.605 18 6.07 18 7 18m1-7.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.5 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 12.5 10.5m4.5 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 17 10.5"
    />
  </svg>
);

export const MessageHeartCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20.9996 11.5c0 4.6944-3.8056 8.5-8.5 8.5-1.0768 0-2.1068-.2002-3.0548-.5655-.1734-.0667-.26-.1001-.329-.116a.9.9 0 0 0-.1863-.0248c-.0707-.0027-.1482.0053-.3033.0213l-5.121.5294c-.4883.0504-.7324.0757-.8764-.0122a.5.5 0 0 1-.2336-.3494c-.0261-.1667.0905-.3826.3239-.8144l1.6356-3.0276c.1347-.2493.202-.374.2326-.4939.0301-.1183.0374-.2037.0278-.3255-.0098-.1233-.064-.2838-.1721-.6048A8.49 8.49 0 0 1 3.9996 11.5c0-4.6944 3.8056-8.5 8.5-8.5s8.5 3.8056 8.5 8.5"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.4965 8.9492c-.8997-1.0388-2.4-1.3182-3.5273-.367s-1.286 2.5418-.4007 3.6669c.5485.697 1.925 1.97 2.8931 2.8379.3556.3187.5334.4781.7468.5423.183.0551.3933.0551.5763 0 .2134-.0642.3912-.2236.7468-.5423.9681-.8679 2.3446-2.1409 2.8931-2.8379.8852-1.1251.7459-2.7256-.4008-3.6669s-2.6275-.6718-3.5273.367"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageHeartSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v5.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 18 17.8802 18 16.2 18h-2.5163c-.624 0-.936 0-1.2345.0613a3 3 0 0 0-.7617.2672c-.2713.1386-.515.3335-1.0023.7233l-2.3854 1.9084c-.4161.3329-.6242.4993-.7993.4995a.5.5 0 0 1-.3913-.1881C7 21.1348 7 20.8684 7 20.3355V18c-.93 0-1.395 0-1.7765-.1022a3 3 0 0 1-2.1213-2.1213C3 15.395 3 14.93 3 14z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.9969 7.6993c-.8997-1.0389-2.4-1.3183-3.5273-.367S7.1836 9.874 8.069 10.999c.5484.697 1.925 1.97 2.8931 2.8379.3556.3187.5333.4781.7467.5423.1831.0551.3934.0551.5764 0 .2134-.0642.3912-.2236.7468-.5423.968-.8679 2.3446-2.1409 2.893-2.8379.8853-1.1251.746-2.7256-.4007-3.6669s-2.6276-.6718-3.5273.367"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageNotificationCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.707 3.0365C7.3842 3.4362 3.9996 7.0728 3.9996 11.5c0 .95.1559 1.8636.4434 2.7166.1082.321.1623.4815.172.6048.0097.1218.0024.2072-.0277.3255-.0305.1199-.0979.2446-.2326.4939l-1.6356 3.0276c-.2334.4318-.35.6477-.3239.8144a.5.5 0 0 0 .2336.3494c.144.0879.3881.0626.8764.0122l5.121-.5294c.155-.016.2326-.024.3033-.0213a.9.9 0 0 1 .1864.0248c.0689.0159.1555.0493.3289.116.948.3653 1.978.5655 3.0548.5655 4.4308 0 8.0698-3.3902 8.4645-7.7181m-.8432-8.4032c1.1716 1.1716 1.1716 3.071 0 4.2426s-3.071 1.1716-4.2426 0-1.1716-3.071 0-4.2426 3.0711-1.1716 4.2426 0"
    />
  </svg>
);

export const MessageNotificationSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8V14c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C5.605 18 6.07 18 7 18v2.3355c0 .5329 0 .7993.1092.9361a.5.5 0 0 0 .3913.1881c.1751-.0002.3832-.1666.7993-.4995l2.3854-1.9084c.4873-.3898.731-.5847 1.0023-.7233a3 3 0 0 1 .7617-.2672C12.7477 18 13.0597 18 13.6837 18H15.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 15.7202 20 14.8802 20 13.2V13m.1213-9.1213c1.1716 1.1716 1.1716 3.071 0 4.2426s-3.071 1.1716-4.2426 0-1.1716-3.071 0-4.2426 3.071-1.1716 4.2426 0"
    />
  </svg>
);

export const MessagePlusCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.4996 14.5v-6m-3 3h6m-3 8.5c4.6944 0 8.5-3.8056 8.5-8.5S17.194 3 12.4996 3s-8.5 3.8056-8.5 8.5c0 .95.1559 1.8636.4434 2.7166.1082.321.1623.4815.172.6048.0097.1218.0024.2072-.0277.3255-.0305.1199-.0979.2446-.2326.4939l-1.6356 3.0276c-.2334.4318-.35.6477-.3239.8144a.5.5 0 0 0 .2336.3494c.144.0879.3881.0626.8764.0122l5.121-.5294c.155-.016.2326-.024.3033-.0213a.9.9 0 0 1 .1864.0248c.0689.0159.1555.0493.3289.116.948.3653 1.978.5655 3.0548.5655"
    />
  </svg>
);

export const MessagePlusSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 13.5v-6m-3 3h6M7 18v2.3355c0 .5329 0 .7993.1092.9361a.5.5 0 0 0 .3913.1881c.1751-.0002.3832-.1666.7993-.4995l2.3854-1.9084c.4873-.3898.731-.5847 1.0023-.7233a3 3 0 0 1 .7617-.2672C12.7477 18 13.0597 18 13.6837 18H16.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.7202 21 14.8802 21 13.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8V14c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C5.605 18 6.07 18 7 18"
    />
  </svg>
);

export const MessageQuestionCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.4996 9.0022a2.2482 2.2482 0 0 1 3.841-.7018c.3419.4062.5291.9203.5283 1.4513 0 1.4989-2.2484 2.2483-2.2484 2.2483m.029 3h.01m-.1599 5c4.6944 0 8.5-3.8056 8.5-8.5S17.194 3 12.4996 3s-8.5 3.8056-8.5 8.5c0 .95.1559 1.8636.4434 2.7166.1082.321.1623.4815.172.6048.0097.1218.0024.2072-.0277.3255-.0305.1199-.0979.2446-.2326.4939l-1.6356 3.0276c-.2334.4318-.35.6477-.3239.8144a.5.5 0 0 0 .2336.3494c.144.0879.3881.0626.8764.0122l5.121-.5294c.155-.016.2326-.024.3033-.0213a.9.9 0 0 1 .1864.0248c.0689.0159.1555.0493.3289.116.948.3653 1.978.5655 3.0548.5655"
    />
  </svg>
);

export const MessageQuestionSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 8.0022a2.2485 2.2485 0 0 1 2.501-1.4698 2.248 2.248 0 0 1 1.8682 2.2193c0 1.4989-2.2483 2.2483-2.2483 2.2483m.029 3h.01M7 18v2.3355c0 .5329 0 .7993.1092.9361a.5.5 0 0 0 .3913.1881c.1751-.0002.3832-.1666.7993-.4995l2.3854-1.9084c.4873-.3898.731-.5847 1.0023-.7233a3 3 0 0 1 .7617-.2672C12.7477 18 13.0597 18 13.6837 18H16.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.7202 21 14.8802 21 13.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8V14c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C5.605 18 6.07 18 7 18"
    />
  </svg>
);

export const MessageSmileCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.9996 14s1.3125 1.5 3.5 1.5 3.5-1.5 3.5-1.5m-.75-5h.01m-5.51 0h.01m2.74 11c4.6944 0 8.5-3.8056 8.5-8.5S17.194 3 12.4996 3s-8.5 3.8056-8.5 8.5c0 .95.1559 1.8636.4434 2.7166.1082.321.1623.4815.172.6048.0097.1218.0024.2072-.0277.3255-.0305.1199-.0979.2446-.2326.4939l-1.6356 3.0276c-.2334.4318-.35.6477-.3239.8144a.5.5 0 0 0 .2336.3494c.144.0879.3881.0626.8764.0122l5.121-.5294c.155-.016.2326-.024.3033-.0213a.9.9 0 0 1 .1864.0248c.0689.0159.1555.0493.3289.116.948.3653 1.978.5655 3.0548.5655m3.25-11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-5.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);

export const MessageSmileSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.5 12.5S9.8125 14 12 14s3.5-1.5 3.5-1.5m-.75-5h.01m-5.51 0h.01M7 18v2.3355c0 .5329 0 .7993.1092.9361a.5.5 0 0 0 .3913.1881c.1751-.0002.3832-.1666.7993-.4995l2.3854-1.9084c.4873-.3898.731-.5847 1.0023-.7233a3 3 0 0 1 .7617-.2672C12.7477 18 13.0597 18 13.6837 18H16.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.7202 21 14.8802 21 13.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8V14c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C5.605 18 6.07 18 7 18m8.25-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-5.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
  </svg>
);

export const MessageSquare01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v5.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 18 17.8802 18 16.2 18H9.6838c-.6241 0-.9361 0-1.2346.0613a3 3 0 0 0-.7617.2672c-.2713.1386-.515.3335-1.0023.7233l-2.3854 1.9084c-.4161.3329-.6242.4993-.7993.4995a.5.5 0 0 1-.3913-.1881C3 21.1348 3 20.8684 3 20.3355z"
    />
  </svg>
);

export const MessageSquare02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v5.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 18 17.8802 18 16.2 18h-2.5163c-.624 0-.936 0-1.2345.0613a3 3 0 0 0-.7617.2672c-.2713.1386-.515.3335-1.0023.7233l-2.3854 1.9084c-.4161.3329-.6242.4993-.7993.4995a.5.5 0 0 1-.3913-.1881C7 21.1348 7 20.8684 7 20.3355V18c-.93 0-1.395 0-1.7765-.1022a3 3 0 0 1-2.1213-2.1213C3 15.395 3 14.93 3 14z"
    />
  </svg>
);

export const MessageTextCircle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7.9996 9.5h4m-4 3.5h7m-2.5 7c4.6944 0 8.5-3.8056 8.5-8.5S17.194 3 12.4996 3s-8.5 3.8056-8.5 8.5c0 .95.1559 1.8636.4434 2.7166.1082.321.1623.4815.172.6048.0097.1218.0024.2072-.0277.3255-.0305.1199-.0979.2446-.2326.4939l-1.6356 3.0276c-.2334.4318-.35.6477-.3239.8144a.5.5 0 0 0 .2336.3494c.144.0879.3881.0626.8764.0122l5.121-.5294c.155-.016.2326-.024.3033-.0213a.9.9 0 0 1 .1864.0248c.0689.0159.1555.0493.3289.116.948.3653 1.978.5655 3.0548.5655"
    />
  </svg>
);

export const MessageTextCircle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 9.5h4M8 13h7m-3 8c4.9706 0 9-4.0294 9-9s-4.0294-9-9-9-9 4.0294-9 9c0 1.1971.2337 2.3397.658 3.3845.0813.2.1219.3.14.3808a.9.9 0 0 1 .0242.2186c0 .0828-.015.173-.045.3535l-.593 3.5578c-.0622.3726-.0932.5589-.0354.6936a.5.5 0 0 0 .2624.2624c.1347.0578.321.0268.6936-.0353l3.5579-.593c.1804-.0301.2706-.0451.3534-.0451.081 0 .1396.0065.2186.0242.0808.0181.1808.0587.3808.1399C9.6603 20.7663 10.8029 21 12 21"
    />
  </svg>
);

export const MessageTextSquare01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 8.5h5M7 12h8m-5.3162 6H16.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.7202 21 14.8802 21 13.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v12.5355c0 .5329 0 .7993.1092.9361a.5.5 0 0 0 .3913.1881c.1751-.0002.3832-.1666.7993-.4995l2.3854-1.9084c.4873-.3898.731-.5847 1.0023-.7233.2407-.123.497-.2129.7617-.2672C8.7477 18 9.0597 18 9.6838 18"
    />
  </svg>
);

export const MessageTextSquare02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 8.5h5M7 12h8m-8 6v2.3355c0 .5329 0 .7993.1092.9361a.5.5 0 0 0 .3913.1881c.1751-.0002.3832-.1666.7993-.4995l2.3854-1.9084c.4873-.3898.731-.5847 1.0023-.7233a3 3 0 0 1 .7617-.2672C12.7477 18 13.0597 18 13.6837 18H16.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.7202 21 14.8802 21 13.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8V14c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C5.605 18 6.07 18 7 18"
    />
  </svg>
);

export const MessageXCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9.9996 9 5 5m0-5-5 5m2.5 6c4.6944 0 8.5-3.8056 8.5-8.5S17.194 3 12.4996 3s-8.5 3.8056-8.5 8.5c0 .95.1559 1.8636.4434 2.7166.1082.321.1623.4815.172.6048.0097.1218.0024.2072-.0277.3255-.0305.1199-.0979.2446-.2326.4939l-1.6356 3.0276c-.2334.4318-.35.6477-.3239.8144a.5.5 0 0 0 .2336.3494c.144.0879.3881.0626.8764.0122l5.121-.5294c.155-.016.2326-.024.3033-.0213a.9.9 0 0 1 .1864.0248c.0689.0159.1555.0493.3289.116.948.3653 1.978.5655 3.0548.5655"
    />
  </svg>
);

export const MessageXSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9.5 8 5 5m0-5-5 5M7 18v2.3355c0 .5329 0 .7993.1092.9361a.5.5 0 0 0 .3913.1881c.1751-.0002.3832-.1666.7993-.4995l2.3854-1.9084c.4873-.3898.731-.5847 1.0023-.7233a3 3 0 0 1 .7617-.2672C12.7477 18 13.0597 18 13.6837 18H16.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.7202 21 14.8802 21 13.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8V14c0 .93 0 1.395.1022 1.7765a3 3 0 0 0 2.1213 2.1213C5.605 18 6.07 18 7 18"
    />
  </svg>
);

export const Phone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.3803 8.8534c.696 1.4496 1.6448 2.8082 2.8463 4.0098 1.2016 1.2016 2.5603 2.1504 4.0099 2.8464.1247.0598.187.0898.2659.1128.2804.0817.6246.023.862-.147.0669-.0479.124-.105.2383-.2193.3496-.3497.5244-.5245.7002-.6387a2 2 0 0 1 2.1804 0c.1758.1142.3506.289.7002.6387l.1948.1948c.5315.5315.7972.7972.9415 1.0826a2 2 0 0 1 0 1.8054c-.1443.2853-.41.5511-.9415 1.0825l-.1576.1576c-.5296.5297-.7944.7945-1.1545.9967-.3995.2244-1.02.3858-1.4782.3844-.4129-.0012-.6952-.0813-1.2596-.2415-3.0334-.861-5.8958-2.4854-8.2837-4.8734-2.388-2.388-4.0125-5.2504-4.8735-8.2838-.1602-.5644-.2403-.8466-.2415-1.2596-.0014-.4582.16-1.0787.3844-1.4782.2023-.36.467-.6248.9967-1.1545l.1576-.1576C5 3.1801 5.2656 2.9143 5.551 2.77a2 2 0 0 1 1.8054 0c.2853.1443.551.41 1.0825.9415l.1949.1949c.3496.3496.5244.5244.6387.7002a2 2 0 0 1 0 2.1803c-.1143.1758-.2891.3506-.6387.7002-.1143.1143-.1715.1715-.2193.2383-.17.2374-.2287.5817-.147.862.023.079.053.1413.1128.266"
    />
  </svg>
);

export const PhoneCall01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14.0497 6a5 5 0 0 1 3.95 3.95M14.0497 2a9 9 0 0 1 7.95 7.94m-11.7731 3.9231c-1.2015-1.2016-2.1503-2.5603-2.8463-4.0099-.0599-.1247-.0898-.187-.1128-.2659-.0817-.2804-.023-.6246.147-.862.0478-.0669.105-.124.2193-.2383.3496-.3496.5244-.5244.6387-.7002a2 2 0 0 0 0-2.1804c-.1143-.1757-.2891-.3506-.6387-.7002l-.1949-.1948c-.5314-.5315-.7972-.7972-1.0825-.9415a2 2 0 0 0-1.8054 0c-.2854.1443-.5511.41-1.0826.9415l-.1576.1576c-.5296.5296-.7944.7944-.9967 1.1545-.2244.3995-.3858 1.02-.3844 1.4782.0012.413.0813.6952.2415 1.2596.861 3.0334 2.4855 5.8958 4.8735 8.2837 2.388 2.388 5.2503 4.0125 8.2837 4.8735.5644.1602.8467.2403 1.2596.2415.4582.0014 1.0787-.16 1.4782-.3844.3601-.2023.6249-.4671 1.1545-.9967l.1576-.1576c.5315-.5315.7972-.7972.9415-1.0826a2 2 0 0 0 0-1.8054c-.1443-.2853-.41-.5511-.9415-1.0825l-.1948-.1949c-.3496-.3496-.5244-.5244-.7002-.6387a2 2 0 0 0-2.1804 0c-.1758.1143-.3506.2891-.7002.6387-.1143.1143-.1714.1715-.2383.2193-.2374.1701-.5816.2288-.862.147-.0789-.023-.1412-.0529-.2659-.1128-1.4496-.696-2.8083-1.6448-4.0099-2.8463"
    />
  </svg>
);

export const PhoneCall02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4.8586 6c1.815-1.8514 4.344-3 7.1415-3s5.3265 1.1486 7.1414 3m-2.6692 3C15.3736 7.7725 13.777 7 12 7s-3.3735.7725-4.4722 2M12 17c1.5105 0 2.9608.2576 4.3094.7313.0448.0157.0673.0236.1026.0392.3206.1413.5668.4886.5938.8379.003.0386.003.0727.003.141 0 .2327 0 .3491.0097.4471a2 2 0 0 0 1.7938 1.7938c.098.0097.2144.0097.4471.0097h.245c.4606 0 .6908 0 .8824-.0378a2 2 0 0 0 1.5754-1.5754C22 19.1952 22 18.965 22 18.5044v-.1982c0-.4752 0-.7129-.0507-.9853-.1135-.609-.556-1.3626-1.0327-1.7585-.2131-.177-.3577-.2576-.6468-.4189C17.822 13.7781 15.0019 13 12 13s-5.822.7781-8.2698 2.1435c-.2891.1613-.4337.2419-.6468.4189-.4767.3959-.9192 1.1495-1.0327 1.7585C2 17.5933 2 17.831 2 18.3062v.1982c0 .4606 0 .6908.0378.8824a2 2 0 0 0 1.5754 1.5754C3.8048 21 4.035 21 4.4956 21h.245c.2327 0 .3491 0 .4471-.0097a2 2 0 0 0 1.7938-1.7938c.0097-.098.0097-.2144.0097-.4471 0-.0683 0-.1024.003-.141.027-.3493.2732-.6966.5938-.8379a1.2 1.2 0 0 1 .1026-.0392C9.0392 17.2576 10.4895 17 12 17"
    />
  </svg>
);

export const PhoneHangUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5.4754 12.8631a19 19 0 0 1-2.3042-5.1018c-.1602-.5644-.2403-.8467-.2415-1.2596-.0014-.4582.16-1.0787.3844-1.4782.2023-.36.467-.6249.9967-1.1545l.1576-.1576c.5315-.5315.7972-.7972 1.0826-.9415a2 2 0 0 1 1.8054 0c.2853.1443.551.41 1.0825.9415l.1949.1949c.3496.3495.5244.5244.6387.7001a2 2 0 0 1 0 2.1804c-.1143.1758-.2891.3506-.6387.7002-.1143.1143-.1715.1715-.2193.2383-.17.2374-.2287.5817-.147.862.023.0789.053.1412.1128.266q.1813.3775.3853.7464m2.4161 3.2182.0449.0452c1.2016 1.2015 2.5603 2.1503 4.0099 2.8463.1247.0599.187.0898.2659.1128.2804.0818.6246.0231.862-.147.0669-.0478.124-.105.2383-.2193.3496-.3496.5244-.5244.7002-.6387a2 2 0 0 1 2.1804 0c.1758.1143.3506.2891.7002.6387l.1948.1949c.5315.5314.7972.7972.9415 1.0825a2 2 0 0 1 0 1.8054c-.1443.2854-.41.5511-.9415 1.0826l-.1576.1576c-.5296.5296-.7944.7944-1.1545.9967-.3995.2244-1.02.3858-1.4782.3844-.4129-.0012-.6952-.0813-1.2596-.2415-3.0334-.861-5.8958-2.4855-8.2837-4.8735L7.9997 16M20.9997 3l-18 18"
    />
  </svg>
);

export const PhoneIncoming01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19.9996 9h-5V4m0 5 6-6m-10.773 10.8631c-1.2015-1.2016-2.1503-2.5603-2.8463-4.0099-.0599-.1247-.0898-.187-.1128-.2659-.0817-.2804-.023-.6246.147-.862.0478-.0669.105-.124.2193-.2383.3496-.3496.5244-.5244.6387-.7002a2 2 0 0 0 0-2.1804c-.1143-.1757-.2891-.3506-.6387-.7002l-.1949-.1948c-.5314-.5315-.7972-.7972-1.0825-.9415a2 2 0 0 0-1.8054 0c-.2854.1443-.5511.41-1.0826.9415l-.1576.1576c-.5296.5296-.7944.7944-.9967 1.1545-.2244.3995-.3858 1.02-.3844 1.4782.0012.413.0813.6952.2415 1.2596.861 3.0334 2.4855 5.8958 4.8735 8.2837 2.388 2.388 5.2503 4.0125 8.2837 4.8735.5644.1602.8467.2403 1.2596.2415.4582.0014 1.0787-.16 1.4782-.3844.3601-.2023.6249-.4671 1.1545-.9967l.1576-.1576c.5315-.5315.7972-.7972.9415-1.0826a2 2 0 0 0 0-1.8054c-.1443-.2853-.41-.5511-.9415-1.0825l-.1948-.1949c-.3496-.3496-.5244-.5244-.7002-.6387a2 2 0 0 0-2.1804 0c-.1758.1143-.3506.2891-.7002.6387-.1143.1143-.1714.1715-.2383.2193-.2374.1701-.5816.2288-.862.147-.0789-.023-.1412-.0529-.2659-.1128-1.4496-.696-2.8083-1.6448-4.0099-2.8463"
    />
  </svg>
);

export const PhoneIncoming02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16.4996 10-3.5-3.5 3.5-3.5m-3.5 3.5h8m-10.773 7.3631c-1.2015-1.2016-2.1503-2.5603-2.8463-4.0099-.0599-.1247-.0898-.187-.1128-.2659-.0817-.2804-.023-.6246.147-.862.0478-.0669.105-.124.2193-.2383.3496-.3496.5244-.5244.6387-.7002a2 2 0 0 0 0-2.1804c-.1143-.1757-.2891-.3506-.6387-.7002l-.1949-.1948c-.5314-.5315-.7972-.7972-1.0825-.9415a2 2 0 0 0-1.8054 0c-.2854.1443-.5511.41-1.0826.9415l-.1576.1576c-.5296.5296-.7944.7944-.9967 1.1545-.2244.3995-.3858 1.02-.3844 1.4782.0012.413.0813.6952.2415 1.2596.861 3.0334 2.4855 5.8958 4.8735 8.2837 2.388 2.388 5.2503 4.0125 8.2837 4.8735.5644.1602.8467.2403 1.2596.2415.4582.0014 1.0787-.16 1.4782-.3844.3601-.2023.6249-.4671 1.1545-.9967l.1576-.1576c.5315-.5315.7972-.7972.9415-1.0826a2 2 0 0 0 0-1.8054c-.1443-.2853-.41-.5511-.9415-1.0825l-.1948-.1949c-.3496-.3496-.5244-.5244-.7002-.6387a2 2 0 0 0-2.1804 0c-.1758.1143-.3506.2891-.7002.6387-.1143.1143-.1714.1715-.2383.2193-.2374.1701-.5816.2288-.862.147-.0789-.023-.1412-.0529-.2659-.1128-1.4496-.696-2.8083-1.6448-4.0099-2.8463"
    />
  </svg>
);

export const PhoneOutgoing01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.9996 3h5v5m0-5-6 6m-4.773 4.8631c-1.2015-1.2016-2.1503-2.5603-2.8463-4.0099-.0599-.1247-.0898-.187-.1128-.2659-.0817-.2804-.023-.6246.147-.862.0478-.0669.105-.124.2193-.2383.3496-.3496.5244-.5244.6387-.7002a2 2 0 0 0 0-2.1804c-.1143-.1757-.2891-.3506-.6387-.7002l-.1949-.1948c-.5314-.5315-.7972-.7972-1.0825-.9415a2 2 0 0 0-1.8054 0c-.2854.1443-.5511.41-1.0826.9415l-.1576.1576c-.5296.5296-.7944.7944-.9967 1.1545-.2244.3995-.3858 1.02-.3844 1.4782.0012.413.0813.6952.2415 1.2596.861 3.0334 2.4855 5.8958 4.8735 8.2837 2.388 2.388 5.2503 4.0125 8.2837 4.8735.5644.1602.8467.2403 1.2596.2415.4582.0014 1.0787-.16 1.4782-.3844.3601-.2023.6249-.4671 1.1545-.9967l.1576-.1576c.5315-.5315.7972-.7972.9415-1.0826a2 2 0 0 0 0-1.8054c-.1443-.2853-.41-.5511-.9415-1.0825l-.1948-.1949c-.3496-.3496-.5244-.5244-.7002-.6387a2 2 0 0 0-2.1804 0c-.1758.1143-.3506.2891-.7002.6387-.1143.1143-.1714.1715-.2383.2193-.2374.1701-.5816.2288-.862.147-.0789-.023-.1412-.0529-.2659-.1128-1.4496-.696-2.8083-1.6448-4.0099-2.8463"
    />
  </svg>
);

export const PhoneOutgoing02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m17.4996 10 3.5-3.5-3.5-3.5m3.5 3.5h-8m-2.773 7.3631c-1.2015-1.2016-2.1503-2.5603-2.8463-4.0099-.0599-.1247-.0898-.187-.1128-.2659-.0817-.2804-.023-.6246.147-.862.0478-.0669.105-.124.2193-.2383.3496-.3496.5244-.5244.6387-.7002a2 2 0 0 0 0-2.1804c-.1143-.1757-.2891-.3506-.6387-.7002l-.1949-.1948c-.5314-.5315-.7972-.7972-1.0825-.9415a2 2 0 0 0-1.8054 0c-.2854.1443-.5511.41-1.0826.9415l-.1576.1576c-.5296.5296-.7944.7944-.9967 1.1545-.2244.3995-.3858 1.02-.3844 1.4782.0012.413.0813.6952.2415 1.2596.861 3.0334 2.4855 5.8958 4.8735 8.2837 2.388 2.388 5.2503 4.0125 8.2837 4.8735.5644.1602.8467.2403 1.2596.2415.4582.0014 1.0787-.16 1.4782-.3844.3601-.2023.6249-.4671 1.1545-.9967l.1576-.1576c.5315-.5315.7972-.7972.9415-1.0826a2 2 0 0 0 0-1.8054c-.1443-.2853-.41-.5511-.9415-1.0825l-.1948-.1949c-.3496-.3496-.5244-.5244-.7002-.6387a2 2 0 0 0-2.1804 0c-.1758.1143-.3506.2891-.7002.6387-.1143.1143-.1714.1715-.2383.2193-.2374.1701-.5816.2288-.862.147-.0789-.023-.1412-.0529-.2659-.1128-1.4496-.696-2.8083-1.6448-4.0099-2.8463"
    />
  </svg>
);

export const PhonePause = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19.9996 10V3m-5 7V3m-4.773 10.8631c-1.2015-1.2016-2.1503-2.5603-2.8463-4.0099-.0599-.1247-.0898-.187-.1128-.2659-.0817-.2804-.023-.6246.147-.862.0478-.0669.105-.124.2193-.2383.3496-.3496.5244-.5244.6387-.7002a2 2 0 0 0 0-2.1804c-.1143-.1757-.2891-.3506-.6387-.7002l-.1949-.1948c-.5314-.5315-.7972-.7972-1.0825-.9415a2 2 0 0 0-1.8054 0c-.2854.1443-.5511.41-1.0826.9415l-.1576.1576c-.5296.5296-.7944.7944-.9967 1.1545-.2244.3995-.3858 1.02-.3844 1.4782.0012.413.0813.6952.2415 1.2596.861 3.0334 2.4855 5.8958 4.8735 8.2837 2.388 2.388 5.2503 4.0125 8.2837 4.8735.5644.1602.8467.2403 1.2596.2415.4582.0014 1.0787-.16 1.4782-.3844.3601-.2023.6249-.4671 1.1545-.9967l.1576-.1576c.5315-.5315.7972-.7972.9415-1.0826a2 2 0 0 0 0-1.8054c-.1443-.2853-.41-.5511-.9415-1.0825l-.1948-.1949c-.3496-.3496-.5244-.5244-.7002-.6387a2 2 0 0 0-2.1804 0c-.1758.1143-.3506.2891-.7002.6387-.1143.1143-.1714.1715-.2383.2193-.2374.1701-.5816.2288-.862.147-.0789-.023-.1412-.0529-.2659-.1128-1.4496-.696-2.8083-1.6448-4.0099-2.8463"
    />
  </svg>
);

export const PhonePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.9996 11V3m-4 4h8m-10.773 6.8631c-1.2015-1.2016-2.1503-2.5603-2.8463-4.0099-.0599-.1247-.0898-.187-.1128-.2659-.0817-.2804-.023-.6246.147-.862.0478-.0669.105-.124.2193-.2383.3496-.3496.5244-.5244.6387-.7002a2 2 0 0 0 0-2.1804c-.1143-.1757-.2891-.3506-.6387-.7002l-.1949-.1948c-.5314-.5315-.7972-.7972-1.0825-.9415a2 2 0 0 0-1.8054 0c-.2854.1443-.5511.41-1.0826.9415l-.1576.1576c-.5296.5296-.7944.7944-.9967 1.1545-.2244.3995-.3858 1.02-.3844 1.4782.0012.413.0813.6952.2415 1.2596.861 3.0334 2.4855 5.8958 4.8735 8.2837 2.388 2.388 5.2503 4.0125 8.2837 4.8735.5644.1602.8467.2403 1.2596.2415.4582.0014 1.0787-.16 1.4782-.3844.3601-.2023.6249-.4671 1.1545-.9967l.1576-.1576c.5315-.5315.7972-.7972.9415-1.0826a2 2 0 0 0 0-1.8054c-.1443-.2853-.41-.5511-.9415-1.0825l-.1948-.1949c-.3496-.3496-.5244-.5244-.7002-.6387a2 2 0 0 0-2.1804 0c-.1758.1143-.3506.2891-.7002.6387-.1143.1143-.1714.1715-.2383.2193-.2374.1701-.5816.2288-.862.147-.0789-.023-.1412-.0529-.2659-.1128-1.4496-.696-2.8083-1.6448-4.0099-2.8463"
    />
  </svg>
);

export const PhoneX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m20.9996 3-6 6m0-6 6 6m-10.773 4.8631c-1.2015-1.2016-2.1503-2.5603-2.8463-4.0099-.0599-.1247-.0898-.187-.1128-.2659-.0817-.2804-.023-.6246.147-.862.0478-.0669.105-.124.2193-.2383.3496-.3496.5244-.5244.6387-.7002a2 2 0 0 0 0-2.1804c-.1143-.1757-.2891-.3506-.6387-.7002l-.1949-.1948c-.5314-.5315-.7972-.7972-1.0825-.9415a2 2 0 0 0-1.8054 0c-.2854.1443-.5511.41-1.0826.9415l-.1576.1576c-.5296.5296-.7944.7944-.9967 1.1545-.2244.3995-.3858 1.02-.3844 1.4782.0012.413.0813.6952.2415 1.2596.861 3.0334 2.4855 5.8958 4.8735 8.2837 2.388 2.388 5.2503 4.0125 8.2837 4.8735.5644.1602.8467.2403 1.2596.2415.4582.0014 1.0787-.16 1.4782-.3844.3601-.2023.6249-.4671 1.1545-.9967l.1576-.1576c.5315-.5315.7972-.7972.9415-1.0826a2 2 0 0 0 0-1.8054c-.1443-.2853-.41-.5511-.9415-1.0825l-.1948-.1949c-.3496-.3496-.5244-.5244-.7002-.6387a2 2 0 0 0-2.1804 0c-.1758.1143-.3506.2891-.7002.6387-.1143.1143-.1714.1715-.2383.2193-.2374.1701-.5816.2288-.862.147-.0789-.023-.1412-.0529-.2659-.1128-1.4496-.696-2.8083-1.6448-4.0099-2.8463"
    />
  </svg>
);

export const Send01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m10.4995 13.5001 10.5-10.5M10.6271 13.828l2.6281 6.758c.2315.5954.3473.893.5141.9799a.5.5 0 0 0 .4615.0003c.1669-.0867.2831-.3842.5153-.9793l6.5903-16.8877c.2097-.5372.3145-.8058.2571-.9775a.5.5 0 0 0-.3158-.3158c-.1716-.0573-.4402.0475-.9774.2571L3.4126 9.2536c-.5951.2322-.8926.3483-.9793.5152a.5.5 0 0 0 .0002.4616c.087.1668.3846.2825.98.5141l6.758 2.6281c.1208.047.1812.0705.2321.1068a.5.5 0 0 1 .1167.1167c.0363.0508.0598.1113.1068.2321"
    />
  </svg>
);

export const Send02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.0005 18.9998v-7m.2915 7.0847 6.9784 2.3362c.5469.1831.8204.2746.989.2089a.5.5 0 0 0 .3-.3309c.0488-.1743-.0691-.4374-.3049-.9638L12.766 3.6222c-.2306-.5147-.3459-.772-.5066-.8518a.5.5 0 0 0-.4432-.0007c-.1609.0792-.277.3362-.5093.8502l-7.5545 16.716c-.2377.526-.3565.7889-.3082.9634a.5.5 0 0 0 .299.3319c.1686.0662.4425-.0248.9903-.2066l7.0525-2.3408c.0939-.0311.1408-.0467.1889-.0529a.5.5 0 0 1 .1283.0002c.048.0063.0949.022.1888.0534"
    />
  </svg>
);

export const Send03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.5004 12h-5.5m-.0846.2915-2.335 6.9747c-.1834.548-.2751.8219-.2093.9907a.5.5 0 0 0 .3314.2998c.1745.0487.438-.0698.9649-.307l16.7114-7.5201c.5144-.2315.7715-.3472.851-.508a.5.5 0 0 0 0-.4432c-.0795-.1607-.3366-.2765-.851-.5079L3.6619 3.7478c-.5253-.2364-.788-.3546-.9622-.3062a.5.5 0 0 0-.3315.2992c-.066.1684.0247.4417.2062.9885l2.342 7.0563c.0312.0939.0468.1408.053.1888a.5.5 0 0 1-.0002.1284c-.0063.048-.022.0949-.0534.1887"
    />
  </svg>
);

export const AlignCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 10H6m15-4H3m18 8H3m15 4H6"
    />
  </svg>
);

export const AlignJustify = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 10H3m18 8H3M21 6H3m18 8H3"
    />
  </svg>
);

export const AlignLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 10H3m17-4H3m17 8H3m13 4H3"
    />
  </svg>
);

export const AlignRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 10H8m13-4H4m17 8H4m17 4H8"
    />
  </svg>
);

export const Attachment01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m21.1525 10.8995-9.0156 9.0156c-2.0503 2.0502-5.3744 2.0502-7.4246 0-2.0503-2.0503-2.0503-5.3744 0-7.4247l9.0156-9.0156c1.3668-1.3668 3.5829-1.3668 4.9497 0s1.3668 3.583 0 4.9498l-8.662 8.662c-.6835.6835-1.7915.6835-2.475 0-.6833-.6834-.6833-1.7914 0-2.4748l7.6015-7.6014"
    />
  </svg>
);

export const Attachment02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.5 5.2558V16.5c0 3.0376-2.4624 5.5-5.5 5.5s-5.5-2.4624-5.5-5.5V5.6667C6.5 3.6417 8.1416 2 10.1667 2c2.025 0 3.6666 1.6416 3.6666 3.6667v10.779c0 1.0126-.8208 1.8334-1.8333 1.8334s-1.8333-.8208-1.8333-1.8334V6.6512"
    />
  </svg>
);

export const BezierCurve01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 7H3m18 0h-7m0 .252c3.4505.888 6 4.0202 6 7.7479m-16 0c0-3.7277 2.5496-6.8599 6-7.748M3.6 19h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 18.2401 6 17.9601 6 17.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C5.24 15 4.96 15 4.4 15h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 15.7599 2 16.0399 2 16.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 19 3.04 19 3.6 19m8-10h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C14 8.24 14 7.96 14 7.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.2401 5 12.9601 5 12.4 5h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C10 5.76 10 6.04 10 6.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.7599 9 11.0399 9 11.6 9m8 10h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 18.2401 22 17.9601 22 17.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C21.2401 15 20.9601 15 20.4 15h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C18 15.7599 18 16.0399 18 16.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109M22 7c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1M4 7c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const BezierCurve02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.9998 20.2633c-3.088-.7448-5.5185-3.1754-6.2632-6.2634M20.2636 14c-.7448 3.0879-3.1753 5.5185-6.2632 6.2633m-.0002-16.5267c3.088.7447 5.5186 3.1753 6.2634 6.2633M3.7368 10c.7447-3.088 3.1754-5.5187 6.2634-6.2634M3.6 14h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 13.2401 6 12.9601 6 12.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C5.24 10 4.96 10 4.4 10h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 10.7599 2 11.0399 2 11.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 14 3.04 14 3.6 14m16 0h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 13.2401 22 12.9601 22 12.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C21.2401 10 20.9601 10 20.4 10h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C18 10.7599 18 11.0399 18 11.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109m-8-8h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C14 5.24 14 4.96 14 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.2401 2 12.9601 2 12.4 2h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C10 2.76 10 3.04 10 3.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.7599 6 11.0399 6 11.6 6m0 16h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C14 21.2401 14 20.9601 14 20.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C13.2401 18 12.9601 18 12.4 18h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C10 18.7599 10 19.0399 10 19.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109"
    />
  </svg>
);

export const BezierCurve03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.8571 7 5.1429 17M6 19h11.9998m.8573-2L13.1429 7M3.6 21h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 20.2401 6 19.9601 6 19.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C5.24 17 4.96 17 4.4 17h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 17.7599 2 18.0399 2 18.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 21 3.04 21 3.6 21m16 0h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 20.2401 22 19.9601 22 19.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C21.2401 17 20.9601 17 20.4 17h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C18 17.7599 18 18.0399 18 18.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109m-8-14h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C14 6.24 14 5.96 14 5.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.2401 3 12.9601 3 12.4 3h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C10 3.76 10 4.04 10 4.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.7599 7 11.0399 7 11.6 7"
    />
  </svg>
);

export const Bold01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 12h8c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4H6zm0 0h9c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4H6z"
    />
  </svg>
);

export const Bold02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 4v16M9.5 4h6c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4h-6 7c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4h-7m0-16v16m0-16H4m5.5 16H4"
    />
  </svg>
);

export const BoldSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.5 12H13c1.3807 0 2.5-1.1193 2.5-2.5S14.3807 7 13 7H8.5zm0 0H14c1.3807 0 2.5 1.1193 2.5 2.5S15.3807 17 14 17H8.5zm-.7 9h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const Brush01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m9 11.2224 3.7778 3.7778m-4.803 5.9748C6.608 22.3419 4 22.0002 2 22.0002c1.0251-2-.3417-4.6081 1.0251-5.9749s3.583-1.3668 4.9498 0 1.3668 3.5829 0 4.9497m3.9468-5.0502 9.1371-9.868c.8048-.8692.7788-2.219-.0588-3.0566s-2.1873-.8636-3.0565-.0588l-9.868 9.1371c-.51.4722-.765.7083-.9137.96a2 2 0 0 0-.0378 1.9672c.139.2574.3846.5031.876.9945s.7372.7371.9945.876a2 2 0 0 0 1.9672-.0378c.2518-.1487.4878-.4037.96-.9136"
    />
  </svg>
);

export const Brush02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 10V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C17.2401 2 16.9601 2 16.4 2H7.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C6 2.76 6 3.04 6 3.6V10m12 0H6m12 0v.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C15.7202 15 14.8802 15 13.2 15h-2.4c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C6 12.7202 6 11.8802 6 10.2V10m8.5 5v4.5c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5V15"
    />
  </svg>
);

export const Brush03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 10V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C19.2401 2 18.9601 2 18.4 2H5.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C4 2.76 4 3.04 4 3.6V10m16 0H4m16 0v.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 15 16.8802 15 15.2 15H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 12.7202 4 11.8802 4 10.2V10m10.5 5v4.5c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5V15"
    />
  </svg>
);

export const CircleCut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 20.6622c2.989-1.7291 5-4.9608 5-8.6622S9.989 5.0669 7 3.3378M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const CodeSnippet01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m16 18 6-6-6-6M8 6l-6 6 6 6"
    />
  </svg>
);

export const CodeSnippet02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m17 17 5-5-5-5M7 7l-5 5 5 5m7-14-4 18"
    />
  </svg>
);

export const Command = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 9V6c0-1.6569-1.3431-3-3-3S3 4.3431 3 6s1.3431 3 3 3zm0 0v6m0-6h6m-6 6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3zm0 0h6m0 0h3c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3zm0 0V9m0 0V6c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3z"
    />
  </svg>
);

export const Contrast01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 2c.5917 0 1.1713.0514 1.7348.15M12 2C6.4772 2 2 6.4772 2 12s4.4772 10 10 10m0-20v20m5.738-18.191a10.06 10.06 0 0 1 2.4554 2.4564m1.6567 4.0002C21.9486 10.8289 22 11.4085 22 12s-.0514 1.1711-.1499 1.7344m-1.6609 4.0062a10.06 10.06 0 0 1-2.4523 2.4511m-4.0041 1.6587A10.07 10.07 0 0 1 12 22"
    />
  </svg>
);

export const Contrast02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 18.5c3.5899 0 6.5-2.9101 6.5-6.5 0-3.5898-2.9101-6.5-6.5-6.5z"
    />
  </svg>
);

export const Contrast03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 8.5c0 4.1421-3.3579 7.5-7.5 7.5a7.52 7.52 0 0 1-1.7838-.2134C7.896 17.4297 9.823 18.5 12 18.5c3.5899 0 6.5-2.9101 6.5-6.5 0-2.177-1.0703-4.1041-2.7134-5.2838A7.52 7.52 0 0 1 16 8.5"
    />
  </svg>
);

export const Crop01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 6h12.8c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C18 7.5198 18 8.08 18 9.2V22m4-4H9.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C6 16.4802 6 15.9201 6 14.8V2"
    />
  </svg>
);

export const Crop02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 6h4.8c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C18 7.5198 18 8.08 18 9.2V14M2 6h4m12 12v4m4-4H9.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C6 16.4802 6 15.9201 6 14.8V2"
    />
  </svg>
);

export const Cursor01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m12.9999 12.9999 6 6m-1.0359-8.2487-5.0107 1.7019c-.137.0465-.2055.0698-.2625.1089a.5.5 0 0 0-.1288.1288c-.0391.057-.0624.1255-.1089.2625l-1.7019 5.0107c-.211.6214-.3166.932-.4816 1.026a.5.5 0 0 1-.465.0156c-.1709-.0826-.297-.3855-.5494-.9912L3.747 4.7931c-.2342-.562-.3512-.843-.2943-1.0188a.5.5 0 0 1 .3216-.3216c.1758-.057.4568.0601 1.0188.2943l13.2213 5.5082c.6057.2524.9086.3785.9912.5495a.5.5 0 0 1-.0156.4649c-.094.165-.4046.2706-1.026.4816"
    />
  </svg>
);

export const Cursor02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20.5056 10.7754c.6169-.2399.9254-.3599 1.012-.5295a.5.5 0 0 0-.0061-.4664c-.091-.1672-.4025-.279-1.0255-.5027L4.5963 3.5728c-.5097-.183-.7646-.2744-.9312-.2167a.5.5 0 0 0-.3088.3088c-.0577.1666.0338.4215.2167.9312l5.704 15.8897c.2236.623.3355.9345.5027 1.0255a.5.5 0 0 0 .4664.0061c.1696-.0866.2895-.3951.5295-1.012l2.5968-6.6776c.047-.1208.0705-.1812.1068-.2321a.5.5 0 0 1 .1167-.1167c.0509-.0363.1113-.0598.2321-.1068z"
    />
  </svg>
);

export const Cursor03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4.7115 3.6745c-.5405-.213-.8108-.3195-.983-.2622a.5.5 0 0 0-.3167.3166c-.0572.1723.0492.4425.2622.9831l5.3006 13.4555c.1715.4353.2573.653.397.7404a.5.5 0 0 0 .4083.0551c.1579-.0472.2983-.2344.579-.6088l2.1407-2.8541 3.4493 4.7428c.1896.2607.2845.3911.4053.4456a.5.5 0 0 0 .3376.0265c.1278-.035.2418-.149.4698-.377l3.176-3.1759c.2279-.228.3419-.342.3769-.4698a.5.5 0 0 0-.0265-.3376c-.0545-.1209-.1848-.2157-.4456-.4053l-4.7428-3.4493 2.8542-2.1407c.3743-.2807.5615-.4211.6087-.579a.5.5 0 0 0-.0551-.4083c-.0874-.1397-.305-.2255-.7404-.397z"
    />
  </svg>
);

export const Cursor04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4.407 3.414c-.4582-.1347-.6874-.2021-.8434-.144a.5.5 0 0 0-.2938.2939c-.0582.156.0092.3851.144.8434l4.2059 14.3c.1252.4259.1879.6388.3143.7376a.5.5 0 0 0 .3898.0994c.1583-.0262.3152-.1832.629-.497L12 16.0002l4.4344 4.4343c.198.198.297.297.4111.3341a.5.5 0 0 0 .3091 0c.1141-.0371.2131-.1361.4111-.3341l2.8687-2.8686c.198-.198.297-.297.3341-.4112a.5.5 0 0 0 0-.309c-.0371-.1142-.1361-.2132-.3341-.4112l-4.4344-4.4343 3.0471-3.047c.3139-.314.4708-.4709.4971-.6292a.5.5 0 0 0-.0994-.3898c-.0989-.1264-.3118-.189-.7376-.3143z"
    />
  </svg>
);

export const CursorBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 9.5V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h1.7m7.8862-3.2887-1.6983 3.154c-.2776.5155-.4164.7733-.5856.8406a.5.5 0 0 1-.4472-.0391c-.155-.0956-.247-.3735-.431-.9293l-2.7237-8.2262c-.1612-.4868-.2418-.7301-.1838-.8922a.5.5 0 0 1 .3025-.3025c.1621-.058.4054.0226.8922.1838l8.2261 2.7237c.5559.1841.8338.2761.9294.431a.5.5 0 0 1 .039.4473c-.0672.1691-.325.3079-.8406.5855l-3.1539 1.6983c-.0785.0423-.1178.0635-.1522.0906a.5.5 0 0 0-.0823.0823c-.0271.0344-.0483.0737-.0906.1522"
    />
  </svg>
);

export const CursorClick01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 3.5V2M5.0607 5.0607 4 4m1.0607 9L4 14.0607m9-9L14.0607 4M3.5 9H2m13.8645 7.1896-2.4918 4.6274c-.2846.5287-.427.793-.5982.8599a.5.5 0 0 1-.4505-.0441c-.1551-.0988-.2434-.3857-.4202-.9595L8.4452 9.4453c-.1444-.4688-.2166-.7032-.1585-.8615a.5.5 0 0 1 .2971-.2971c.1583-.058.3927.0141.8614.1585l11.228 3.4586c.5738.1768.8607.2652.9595.4202a.5.5 0 0 1 .0441.4505c-.0668.1713-.3312.3136-.8598.5983l-4.6274 2.4917c-.0786.0423-.1179.0634-.1522.0906a.5.5 0 0 0-.0823.0823c-.0272.0343-.0483.0736-.0906.1522"
    />
  </svg>
);

export const CursorClick02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 3.5V2M5.0607 5.0607 4 4m1.0607 9L4 14.0607m9-9L14.0607 4M3.5 9H2m6.5-.5 4.1111 12.7778L15.5 18.3889 19.1111 22 22 19.1111 18.3889 15.5l2.8889-2.8889z"
    />
  </svg>
);

export const Delete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m17 9-6 6m0-6 6 6M2.72 12.96l4.32 5.76c.352.4693.528.704.751.8732.1976.15.4213.2618.6598.3299C8.72 20 9.0133 20 9.6 20h7.6c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.7202 22 16.8802 22 15.2V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 4 18.8802 4 17.2 4H9.6c-.5867 0-.88 0-1.1492.0769a2 2 0 0 0-.6597.3298c-.2231.1693-.3991.404-.7511.8733l-4.32 5.76c-.2582.3443-.3873.5164-.437.7054a1 1 0 0 0 0 .5092c.0497.189.1788.3611.437.7054"
    />
  </svg>
);

export const Dotpoints01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 12H9m12-6H9m12 12H9m-4-6c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1m0-6c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1m0 12c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const Dotpoints02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 5H10m11 14H10m11-7H10M6 5c0 .8284-.6716 1.5-1.5 1.5S3 5.8284 3 5s.6716-1.5 1.5-1.5S6 4.1716 6 5m0 14c0 .8284-.6716 1.5-1.5 1.5S3 19.8284 3 19s.6716-1.5 1.5-1.5S6 18.1716 6 19m0-7c0 .8284-.6716 1.5-1.5 1.5S3 12.8284 3 12s.6716-1.5 1.5-1.5S6 11.1716 6 12"
    />
  </svg>
);

export const Drop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 14c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8c0-1.0609.2065-2.0736.5815-3C5.7683 8.0682 12 2 12 2s6.2317 6.0682 7.4185 9c.375.9264.5815 1.9391.5815 3"
    />
  </svg>
);

export const Dropper = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m10.5 6.4998 7 7m-15.5 8.5s4.5-.5 7-3l12-12c1.1046-1.1045 1.1046-2.8954 0-4s-2.8954-1.1046-4 0l-12 12c-2.5 2.5-3 7-3 7"
    />
  </svg>
);

export const Eraser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m17.9995 13-7-7m10 15h-13m2.9373-.9372 8.6686-8.6687c1.1881-1.188 1.7821-1.782 2.0047-2.467a3 3 0 0 0 0-1.8541c-.2226-.685-.8166-1.279-2.0047-2.467l-.2117-.2119c-1.1881-1.188-1.7821-1.782-2.4671-2.0046a3 3 0 0 0-1.8541 0c-.685.2226-1.279.8166-2.4671 2.0047l-8.2117 8.2117C3.2057 13.794 2.6116 14.388 2.389 15.073a3 3 0 0 0 0 1.8541c.2226.685.8166 1.279 2.0047 2.467l.6686.6687c.3459.3459.5188.5188.7207.6425.179.1097.374.1905.578.2395C6.5914 21 6.836 21 7.325 21h1.349c.4892 0 .7338 0 .964-.0552.204-.049.3992-.1298.5781-.2395.2019-.1237.3748-.2966.7207-.6425"
    />
  </svg>
);

export const Feather = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 8 2 22.0002m16-7H9m-2.4 4h6.7373c.2445 0 .3668 0 .4819-.0277a1 1 0 0 0 .2891-.1197c.1009-.0618.1874-.1483.3603-.3213L19.5 13.5001c.239-.239.3584-.3585.4546-.4643 2.0802-2.2884 2.0802-5.783 0-8.0715-.0962-.1058-.2156-.2253-.4546-.4642s-.3584-.3585-.4642-.4546c-2.2885-2.0802-5.7831-2.0802-8.0716 0-.1058.0961-.2252.2156-.4642.4546L5.4686 9.5314c-.173.173-.2594.2595-.3212.3604a1 1 0 0 0-.1198.289C5 10.2959 5 10.4182 5 10.6628v6.7373c0 .56 0 .84.109 1.054.0959.1881.2489.3411.437.437.214.109.494.109 1.054.109"
    />
  </svg>
);

export const Figma = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 1.5H8.5C6.567 1.5 5 3.067 5 5s1.567 3.5 3.5 3.5m3.5-7v7m0-7h3.5C17.433 1.5 19 3.067 19 5s-1.567 3.5-3.5 3.5m-3.5 0H8.5m3.5 0v7m0-7h3.5m-7 0C6.567 8.5 5 10.067 5 12s1.567 3.5 3.5 3.5m3.5 0H8.5m3.5 0V19c0 1.933-1.567 3.5-3.5 3.5S5 20.933 5 19s1.567-3.5 3.5-3.5m7-7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5S12 13.933 12 12s1.567-3.5 3.5-3.5"
    />
  </svg>
);

export const Framer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 8.5H5v7l7 7v-7m-7 0h14l-7-7m0 0h7v-7H5z"
    />
  </svg>
);

export const Hand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.9 11.4444v2.7778m0-2.7778V4.7778c0-.9205.7611-1.6667 1.7-1.6667s1.7.7462 1.7 1.6667m-3.4 6.6666c0-.9204-.7611-1.6666-1.7-1.6666s-1.7.7462-1.7 1.6666v2.2223C3.5 18.269 7.3056 22 12 22s8.5-3.731 8.5-8.3333V8.1111c0-.9205-.7611-1.6667-1.7-1.6667s-1.7.7462-1.7 1.6667m-6.8-3.3333v6.1111m0-6.1111V3.6667C10.3 2.7462 11.0611 2 12 2s1.7.7462 1.7 1.6667v1.111m0 0v6.1112m0-6.1111c0-.9205.7611-1.6667 1.7-1.6667s1.7.7462 1.7 1.6667V8.111m0 0v2.7778"
    />
  </svg>
);

export const Heading01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 4v16M18 4v16M8 4H4m14 8H6m2 8H4m16 0h-4m4-16h-4"
    />
  </svg>
);

export const Heading02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 4v16M18 4v16M9.5 4v16m2-16H4m14 8H9.5m2 8H4m16 0h-4m4-16h-4"
    />
  </svg>
);

export const HeadingSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 7v10m8-10v10m0-5H8m-.2 9h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const ImageIndentLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 9.25h-6M21 4H3m18 10.75h-6M21 20H3m1.6-4h4.8c.56 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C11 15.2401 11 14.9601 11 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.2401 8 9.96 8 9.4 8H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 8.76 3 9.04 3 9.6v4.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C3.76 16 4.04 16 4.6 16"
    />
  </svg>
);

export const ImageIndentRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 4H3m18 16H3M9 9.25H3m6 5.5H3M14.6 16h4.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 15.2401 21 14.9601 21 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.2401 8 19.9601 8 19.4 8h-4.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C13 8.76 13 9.04 13 9.6v4.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109"
    />
  </svg>
);

export const Italic01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 4h-9m4 16H5M15 4 9 20"
    />
  </svg>
);

export const Italic02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13.25 4-6 16m9.5-16-6 16M19.5 4h-10m5 16h-10"
    />
  </svg>
);

export const ItalicSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m14 7-4 10m-2.2 4h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const LeftIndent01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 9.25h-9M21 4H3m18 10.75h-9M21 20H3M4.28 8.56l3.8667 2.9c.2895.2171.4342.3257.486.4588a.5.5 0 0 1 0 .3624c-.0518.1331-.1965.2417-.486.4588L4.28 15.64c-.412.309-.618.4635-.7904.4599a.5.5 0 0 1-.3833-.1917C3 15.7725 3 15.515 3 15V9.2c0-.515 0-.7725.1063-.9082A.5.5 0 0 1 3.4896 8.1c.1724-.0036.3784.151.7904.4599"
    />
  </svg>
);

export const LeftIndent02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 9.25h-9M21 4h-9m9 10.75H3M21 20H3M4.28 2.96l3.8667 2.9c.2895.217.4342.3256.486.4587a.5.5 0 0 1 0 .3625c-.0518.133-.1965.2416-.486.4588L4.28 10.04c-.412.3089-.618.4634-.7904.4598a.5.5 0 0 1-.3833-.1916C3 10.1724 3 9.9149 3 9.4V3.6c0-.515 0-.7725.1063-.9083a.5.5 0 0 1 .3833-.1916c.1724-.0036.3784.1509.7904.4598"
    />
  </svg>
);

export const LetterSpacing01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 13h6m-8 4 4.2717-9.3977c.2314-.509.3471-.7636.5074-.8425a.5.5 0 0 1 .4418 0c.1603.079.276.3334.5074.8424L17 17m4-14v18M3 3v18"
    />
  </svg>
);

export const LetterSpacing02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 18h20M5 21l-3-3 3-3m14 6 3-3-3-3M7 3h10m-5 0v11"
    />
  </svg>
);

export const LineHeight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 13h6m-8 4 4.2717-9.3978c.2314-.509.3471-.7635.5074-.8424a.5.5 0 0 1 .4418 0c.1603.079.276.3334.5074.8424L17 17m4 4H3M21 3H3"
    />
  </svg>
);

export const MagicWand01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13.0001 14-3-3m5.0103-7.5V2m3.9394 3.0607L20.0104 4m-1.0606 9 1.0606 1.0607m-9-9L9.9498 4m10.5606 5h1.5M6.1314 20.8686l9.2373-9.2372c.396-.396.594-.5941.6682-.8224a1 1 0 0 0 0-.618c-.0742-.2284-.2722-.4264-.6682-.8224l-.7372-.7372c-.3961-.396-.5941-.594-.8224-.6682a1 1 0 0 0-.618 0c-.2284.0742-.4264.2722-.8224.6682l-9.2372 9.2372c-.396.396-.594.5941-.6682.8224a1 1 0 0 0 0 .618c.0741.2283.2722.4264.6682.8224l.7372.7372c.396.396.594.5941.8224.6682a1 1 0 0 0 .618 0c.2283-.0741.4264-.2722.8224-.6682"
    />
  </svg>
);

export const MagicWand02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 4V2m0 14v-2M8 9h2m10 0h2m-4.2 2.8L19 13m-1.2-6.8L19 5M3 21l9-9m.2-5.8L11 5"
    />
  </svg>
);

export const Move = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m5 15-3-3 3-3m-3 3h20m-7-7-3-3-3 3m3-3v20m-3-3 3 3 3-3m4-4 3-3-3-3"
    />
  </svg>
);

export const Paint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2.9996 13h16.9999m-8-9.5-1.5-1.5m1 1 8.8687 8.8686c.396.396.594.5941.6682.8224a1 1 0 0 1 0 .618c-.0742.2283-.2722.4264-.6682.8224l-5.4745 5.4745c-1.1881 1.188-1.7821 1.7821-2.4671 2.0046a3 3 0 0 1-1.8541 0c-.685-.2225-1.279-.8166-2.467-2.0046l-3.2118-3.2118c-1.188-1.188-1.7821-1.7821-2.0047-2.467a3 3 0 0 1 0-1.8542c.2226-.6849.8166-1.279 2.0047-2.467z"
    />
  </svg>
);

export const PaintPour = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.9997 11h-14m8-7-2-2m6 20h-12m20-6c0 1.1046-.8954 2-2 2s-2-.8954-2-2 2-3 2-3 2 1.8954 2 3m-13-13 6.8686 6.8686c.396.396.5941.5941.6682.8224a1 1 0 0 1 0 .618c-.0741.2283-.2722.4264-.6682.8224l-4.6059 4.6059c-.792.792-1.188 1.188-1.6447 1.3364a2 2 0 0 1-1.236 0c-.4567-.1484-.8527-.5444-1.6447-1.3364l-3.4746-3.4746c-.792-.792-1.188-1.188-1.3364-1.6447a2 2 0 0 1 0-1.236c.1484-.4567.5444-.8527 1.3364-1.6447z"
    />
  </svg>
);

export const Palette = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 12c0 5.5228 4.4772 10 10 10 1.6569 0 3-1.3431 3-3v-.5c0-.4644 0-.6966.0257-.8916.1772-1.3462 1.2365-2.4055 2.5827-2.5827C17.8034 15 18.0356 15 18.5 15h.5c1.6569 0 3-1.3431 3-3 0-5.5228-4.4772-10-10-10S2 6.4772 2 12"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 13c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1M16 9c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1M10 8c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1"
    />
  </svg>
);

export const ParagraphSpacing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 10h-8m8-4h-8m8 8h-8m8 4h-8m-7 2V4m3 13-3 3-3-3M9 7 6 4 3 7"
    />
  </svg>
);

export const ParagraphWrap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3 6h18M3 12h15a3 3 0 0 1 0 6h-4m2 2-2-2 2-2M3 18h7"
    />
  </svg>
);

export const PenTool01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13 18-6.4982-1.2996c-.363-.0726-.5445-.1089-.6923-.1972a1 1 0 0 1-.3249-.3124c-.094-.1442-.1375-.3241-.2243-.6839L2 2l13.5069 3.2603c.3598.0868.5397.1303.6839.2243a1 1 0 0 1 .3124.325c.0883.1477.1246.3292.1972.6922L18 13M2 2l7.586 7.586m6.5454 11.2826 4.7372-4.7372c.396-.396.5941-.5941.6682-.8224a1 1 0 0 0 0-.618c-.0741-.2283-.2722-.4264-.6682-.8224l-.7372-.7372c-.396-.396-.5941-.5941-.8224-.6682a1 1 0 0 0-.618 0c-.2283.0741-.4264.2722-.8224.6682l-4.7372 4.7372c-.396.396-.5941.5941-.6682.8224a1 1 0 0 0 0 .618c.0741.2283.2722.4264.6682.8224l.7372.7372c.396.396.5941.5941.8224.6682a1 1 0 0 0 .618 0c.2283-.0741.4264-.2722.8224-.6682M13 11c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2"
    />
  </svg>
);

export const PenTool02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m18 10.9998-1.2996 6.4982c-.0726.363-.1089.5445-.1972.6923a1 1 0 0 1-.3124.325c-.1442.094-.3241.1374-.6839.2243L2 21.9998 5.2603 8.493c.0868-.3599.1303-.5398.2243-.684a1 1 0 0 1 .325-.3124c.1477-.0882.3292-.1245.6922-.1971L13 5.9999M2 21.9998l7.586-7.586m11.2826-6.5453-4.7372-4.7373c-.396-.396-.5941-.594-.8224-.6682a1 1 0 0 0-.618 0c-.2283.0742-.4264.2722-.8224.6682l-.7372.7373c-.396.396-.5941.594-.6682.8223a1 1 0 0 0 0 .618c.0741.2284.2722.4264.6682.8224l4.7372 4.7373c.396.396.5941.594.8224.6682.2008.0652.4172.0652.618 0 .2283-.0742.4264-.2722.8224-.6682l.7372-.7373c.396-.396.5941-.594.6682-.8223a1 1 0 0 0 0-.618c-.0741-.2284-.2722-.4264-.6682-.8224M11 10.9998c1.1046 0 2 .8955 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2"
    />
  </svg>
);

export const PenToolMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 4.9999h6m11 5.9999-1.7616 6.1656c-.0871.3049-.1307.4573-.2125.5833a1 1 0 0 1-.2765.2821c-.1243.0844-.2758.131-.5789.2243L4 21.9998 7.7448 9.8293c.0932-.303.1399-.4546.2243-.5788a1 1 0 0 1 .282-.2765c.126-.0819.2785-.1255.5834-.2126L15 7M4 21.9998l6.586-6.586m11.2826-7.5453-3.7372-3.7373c-.396-.396-.5941-.594-.8224-.6682a1 1 0 0 0-.618 0c-.2283.0742-.4264.2722-.8224.6682l-.7372.7373c-.396.396-.5941.594-.6682.8223a1 1 0 0 0 0 .618c.0741.2284.2722.4264.6682.8224l3.7372 3.7373c.396.396.5941.594.8224.6682.2008.0652.4172.0652.618 0 .2283-.0742.4264-.2722.8224-.6682l.7372-.7373c.396-.396.5941-.594.6682-.8223a1 1 0 0 0 0-.618c-.0741-.2284-.2722-.4264-.6682-.8224M12 11.9998c1.1046 0 2 .8955 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2"
    />
  </svg>
);

export const PenToolPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m19 11-1.7616 6.1655c-.0871.3049-.1307.4574-.2125.5833a1 1 0 0 1-.2765.2821c-.1243.0844-.2758.1311-.5789.2243L4 22 7.7448 9.8295c.0932-.3031.1399-.4546.2243-.5789a1 1 0 0 1 .282-.2765c.126-.0818.2785-.1254.5834-.2125L15 7M4 22l6.586-6.5861M5 8V2M2 5h6m13.8686 2.8686-3.7372-3.7372c-.396-.396-.5941-.594-.8224-.6682a1 1 0 0 0-.618 0c-.2283.0741-.4264.2721-.8224.6682l-.7372.7372c-.396.396-.5941.594-.6682.8224a1 1 0 0 0 0 .618c.0741.2283.2722.4264.6682.8224l3.7372 3.7372c.396.396.5941.5941.8224.6682a1 1 0 0 0 .618 0c.2283-.0741.4264-.2722.8224-.6682l.7372-.7372c.396-.396.5941-.594.6682-.8224a1 1 0 0 0 0-.618c-.0741-.2284-.2722-.4264-.6682-.8224M12 12c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2"
    />
  </svg>
);

export const Pencil01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m2.5 21.4998 5.5493-2.1343c.355-.1365.5324-.2048.6984-.2939a3 3 0 0 0 .4203-.2732c.149-.1155.2834-.25.5523-.5189L21 6.9998c1.1046-1.1045 1.1046-2.8954 0-4s-2.8954-1.1046-4 0L5.7203 14.2795c-.269.2689-.4034.4034-.519.5523a3 3 0 0 0-.273.4203c-.0892.166-.1574.3435-.294.6985zm0 0 2.0581-5.351c.1473-.3829.221-.5744.3472-.6621a.5.5 0 0 1 .379-.0804c.151.0288.296.1739.5862.464l2.259 2.2591c.2902.2901.4352.4351.464.5861a.5.5 0 0 1-.0804.379c-.0876.1263-.2791.1999-.662.3472z"
    />
  </svg>
);

export const Pencil02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m18 2 4 4M2 22l1.2764-4.6801c.0833-.3054.125-.458.1888-.6004a2 2 0 0 1 .2081-.3586c.092-.1261.2038-.238.4276-.4618L14.4343 5.5657c.198-.198.297-.297.4112-.3341a.5.5 0 0 1 .309 0c.1142.037.2132.136.4112.334l2.8686 2.8687c.198.198.297.297.3341.4112a.5.5 0 0 1 0 .309c-.0371.1142-.1361.2132-.3341.4112L8.1009 19.899c-.2238.2238-.3357.3357-.4618.4276a2 2 0 0 1-.3586.2081c-.1423.0639-.295.1055-.6004.1888z"
    />
  </svg>
);

export const PencilLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 20.9998h-8m-10.5.5 5.5493-2.1343c.355-.1365.5324-.2048.6984-.2939a3 3 0 0 0 .4203-.2732c.149-.1155.2834-.25.5523-.5189L21 6.9998c1.1046-1.1045 1.1046-2.8954 0-4s-2.8954-1.1046-4 0L5.7203 14.2795c-.269.2689-.4034.4034-.519.5523a3 3 0 0 0-.273.4203c-.0892.166-.1574.3435-.294.6985zm0 0 2.0581-5.351c.1473-.3829.221-.5744.3472-.6621a.5.5 0 0 1 .379-.0804c.151.0288.296.1739.5862.464l2.259 2.2591c.2902.2901.4352.4351.464.5861a.5.5 0 0 1-.0804.379c-.0876.1263-.2791.1999-.662.3472z"
    />
  </svg>
);

export const Perspective01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 9v6M5 7v10M17 6.7143 7 5.2857m10 12L7 18.7143M4.6 7h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C7 6.24 7 5.96 7 5.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C6.24 3 5.96 3 5.4 3h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.76 3 4.04 3 4.6v.8c0 .56 0 .84.109 1.054.0959.1882.2489.3411.437.437C3.76 7 4.04 7 4.6 7m0 14h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C7 20.2401 7 19.9601 7 19.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C6.24 17 5.96 17 5.4 17h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 17.7599 3 18.0399 3 18.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21m14-12h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 8.24 21 7.96 21 7.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.2401 5 19.9601 5 19.4 5h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C17 5.76 17 6.04 17 6.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C17.7599 9 18.0399 9 18.6 9m0 10h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 18.2401 21 17.9601 21 17.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C20.2401 15 19.9601 15 19.4 15h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C17 15.7599 17 16.0399 17 16.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109"
    />
  </svg>
);

export const Perspective02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 5v14.0001m-6-15v16m-7-8h18M3 5.9892V18.011c0 1.364 0 2.046.2813 2.5188a2 2 0 0 0 1.093.8768c.5225.172 1.1883.0241 2.5199-.2718l11.6-2.5778c.8941-.1987 1.3412-.298 1.6749-.5384a2 2 0 0 0 .6686-.8336C21 16.807 21 16.3491 21 15.4331v-6.866c0-.916 0-1.374-.1623-1.7519a2 2 0 0 0-.6686-.8335c-.3337-.2404-.7808-.3398-1.6749-.5385l-11.6-2.5778c-1.3316-.2959-1.9973-.4438-2.5199-.2717a2 2 0 0 0-1.093.8768C3 3.9432 3 4.6252 3 5.9892"
    />
  </svg>
);

export const Pilcrow01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 4v16m0-16h2m-2 0h-5.5C8.0147 4 6 6.0147 6 8.5S8.0147 13 10.5 13H16zm-2 16h4"
    />
  </svg>
);

export const Pilcrow02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.5 4v16m2-16H9C6.7909 4 5 5.7909 5 8s1.7909 4 4 4h5m0-8v16m-2 0h7.5"
    />
  </svg>
);

export const PilcrowSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 17V7h-4c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3h4m-7.2 8h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const Reflect01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 3v3m0 4.5v3m0 4.5v3M3.2878 7.9906l4.3879 3.3753c.2805.2158.4207.3236.4711.4551a.5.5 0 0 1 0 .358c-.0504.1315-.1906.2393-.4711.4551l-4.388 3.3753c-.4135.3182-.6204.4773-.7938.4751a.5.5 0 0 1-.3864-.1902C2 16.1581 2 15.8971 2 15.3753V8.6247c0-.5218 0-.7828.1075-.919a.5.5 0 0 1 .3864-.1902c.1734-.0022.3803.157.7939.475m17.4244 0-4.3879 3.3753c-.2805.2158-.4207.3236-.4711.4551a.5.5 0 0 0 0 .358c.0504.1315.1906.2393.4711.4551l4.3879 3.3753c.4136.3182.6205.4773.7939.4751a.5.5 0 0 0 .3864-.1902c.1075-.1362.1075-.3972.1075-.919V8.6247c0-.5218 0-.7828-.1075-.919a.5.5 0 0 0-.3864-.1902c-.1734-.0022-.3803.157-.7939.475"
    />
  </svg>
);

export const Reflect02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 3v3m0 4.5v3m0 4.5v3m10-9h-6.5m4-4-4 4 4 4M2 12h6.5m-4-4 4 4-4 4"
    />
  </svg>
);

export const RightIndent01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 4H3m18 16H3m9-10.75H3m9 5.5H3m16.72-6.29-3.8667 2.9c-.2895.2171-.4342.3257-.486.4588a.5.5 0 0 0 0 .3624c.0518.1331.1965.2417.486.4588l3.8667 2.9c.412.309.618.4635.7904.4599a.5.5 0 0 0 .3833-.1917C21 15.6725 21 15.415 21 14.9V9.1c0-.515 0-.7725-.1063-.9082A.5.5 0 0 0 20.5104 8c-.1724-.0036-.3784.151-.7904.4599"
    />
  </svg>
);

export const RightIndent02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 9.25H3M12 4H3m18 10.75H3M21 20H3M19.72 2.96l-3.8667 2.9c-.2895.217-.4342.3256-.486.4587a.5.5 0 0 0 0 .3625c.0518.133.1965.2416.486.4588l3.8667 2.9c.412.3089.618.4634.7904.4598a.5.5 0 0 0 .3833-.1916C21 10.1724 21 9.9149 21 9.4V3.6c0-.515 0-.7725-.1063-.9083a.5.5 0 0 0-.3833-.1916c-.1724-.0036-.3784.1509-.7904.4598"
    />
  </svg>
);

export const RollerBrush = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 4.5c0 .4647 0 .697-.0384.8902a2 2 0 0 1-1.5714 1.5714C17.197 7 16.9647 7 16.5 7h-11c-.4647 0-.697 0-.8902-.0384a2 2 0 0 1-1.5714-1.5714C3 5.197 3 4.9647 3 4.5s0-.697.0384-.8902a2 2 0 0 1 1.5714-1.5714C4.803 2 5.0353 2 5.5 2h11c.4647 0 .697 0 .8902.0384a2 2 0 0 1 1.5714 1.5714C19 3.803 19 4.0353 19 4.5m0 0c.9319 0 1.3978 0 1.7654.1522.49.203.8794.5924 1.0824 1.0824C22 6.1022 22 6.5681 22 7.5v.3c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C20.4802 11 19.9201 11 18.8 11h-3.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C12 12.5198 12 13.0799 12 14.2v.8m-.4 7h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C14 21.2401 14 20.9601 14 20.4v-3.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C13.2401 15 12.9601 15 12.4 15h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C10 15.7599 10 16.0399 10 16.6v3.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109"
    />
  </svg>
);

export const Scale01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 22H6.8m0 0c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 19.7202 2 18.8802 2 17.2M6.8 22h.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C12 19.7202 12 18.8802 12 17.2v-.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C9.7202 12 8.8802 12 7.2 12h-.4c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 14.2798 2 15.1198 2 16.8v.4m0 0V10m8-8h4m8 8v4m-4 8c.93 0 1.395 0 1.7765-.1022a3 3 0 0 0 2.1213-2.1213C22 19.395 22 18.93 22 18m0-12c0-.93 0-1.395-.1022-1.7765a3 3 0 0 0-2.1213-2.1213C19.395 2 18.93 2 18 2M6 2c-.93 0-1.395 0-1.7765.1022a3 3 0 0 0-2.1213 2.1213C2 4.605 2 5.07 2 6"
    />
  </svg>
);

export const Scale02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 21h.2c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8V8m8.5 4.5L17 7m0 5V7h-5M6.2 21h2.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C12 19.4802 12 18.9201 12 17.8v-2.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C10.4802 12 9.9201 12 8.8 12H6.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 13.5198 3 14.0799 3 15.2v2.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 21 5.08 21 6.2 21"
    />
  </svg>
);

export const Scale03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8M16.2 3c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8M16.2 3h-1c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C12 4.5198 12 5.08 12 6.2v2.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218h2.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 10.4802 21 9.9201 21 8.8v-1m-8.5 3.7L7 17m0-5v5h5"
    />
  </svg>
);

export const Scissors01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 4 8.5 15.5m0-7L20 20M6 3c1.6569 0 3 1.3431 3 3S7.6569 9 6 9 3 7.6569 3 6s1.3431-3 3-3m0 12c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3 1.3431-3 3-3"
    />
  </svg>
);

export const Scissors02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4.5 8.6 21 17m0-10L4.5 15.4M6 3c1.6569 0 3 1.3431 3 3S7.6569 9 6 9 3 7.6569 3 6s1.3431-3 3-3m0 12c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3 1.3431-3 3-3"
    />
  </svg>
);

export const ScissorsCut01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 4 8.5 15.5m0-7L20 20m-2.5-8h.01M22 12h.01M6 3c1.6569 0 3 1.3431 3 3S7.6569 9 6 9 3 7.6569 3 6s1.3431-3 3-3m0 12c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3 1.3431-3 3-3"
    />
  </svg>
);

export const ScissorsCut02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4.5 8.6 21 17m0-10L4.5 15.4m13-3.4h.01M22 12h.01M6 3c1.6569 0 3 1.3431 3 3S7.6569 9 6 9 3 7.6569 3 6s1.3431-3 3-3m0 12c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3 1.3431-3 3-3"
    />
  </svg>
);

export const Skew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m19.7141 6.9999-1.4285 10M6.1429 7 4.357 17M18 5H8m8 14H6M5.6 7h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 6.24 8 5.96 8 5.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.24 3 6.96 3 6.4 3h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C4 3.76 4 4.04 4 4.6v.8c0 .56 0 .84.109 1.054.0959.1882.2489.3411.437.437C4.76 7 5.04 7 5.6 7m-2 14h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 20.2401 6 19.9601 6 19.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C5.24 17 4.96 17 4.4 17h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 17.7599 2 18.0399 2 18.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 21 3.04 21 3.6 21m16-14h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 6.24 22 5.96 22 5.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.2401 3 20.9601 3 20.4 3h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C18 3.76 18 4.04 18 4.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C18.7599 7 19.0399 7 19.6 7m-2 14h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C20 20.2401 20 19.9601 20 19.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C19.2401 17 18.9601 17 18.4 17h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C16 17.7599 16 18.0399 16 18.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109"
    />
  </svg>
);

export const Strikethrough01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 16c0 2.2091 1.7909 4 4 4h4c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4m4-4c0-2.2091-1.7909-4-4-4h-4C7.7909 4 6 5.7909 6 8m-3 4h18"
    />
  </svg>
);

export const Strikethrough02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 16c0 2.2091 1.7909 4 4 4h4c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4m-3.5 8c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4M18 8c0-2.2091-1.7909-4-4-4h-4C7.7909 4 6 5.7909 6 8m7.5-4c-2.2091 0-4 1.7909-4 4M3 12h18"
    />
  </svg>
);

export const StrikethroughSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 12h12m-7 0h2c1.3807 0 2.5 1.1193 2.5 2.5S14.3807 17 13 17h-2.1667c-.995 0-1.8446-.6229-2.18-1.5m6.6935-7c-.3355-.8771-1.1851-1.5-2.1801-1.5H11c-1.0252 0-1.9062.617-2.292 1.5M7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const Subscript = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m3 5 10 10m0-10L3 15m18 4.0001h-4c0-1.5.44-2 1.5-2.5s2.5-1.17 2.5-2.5c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07"
    />
  </svg>
);

export const TextInput = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13 7H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 8.5198 2 9.08 2 10.2v3.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 17 4.08 17 5.2 17H13m4-10h1.8c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C22 8.5198 22 9.08 22 10.2v3.6c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C20.4802 17 19.9201 17 18.8 17H17m0 4V3m2.5 0h-5m5 18h-5"
    />
  </svg>
);

export const Transform = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 7v10M5 7v10M17 5H7m10 14H7M4.6 7h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C7 6.24 7 5.96 7 5.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C6.24 3 5.96 3 5.4 3h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.76 3 4.04 3 4.6v.8c0 .56 0 .84.109 1.054.0959.1882.2489.3411.437.437C3.76 7 4.04 7 4.6 7m0 14h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C7 20.2401 7 19.9601 7 19.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C6.24 17 5.96 17 5.4 17h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 17.7599 3 18.0399 3 18.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C3.76 21 4.04 21 4.6 21m14-14h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 6.24 21 5.96 21 5.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.2401 3 19.9601 3 19.4 3h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C17 3.76 17 4.04 17 4.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C17.7599 7 18.0399 7 18.6 7m0 14h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 20.2401 21 19.9601 21 19.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C20.2401 17 19.9601 17 19.4 17h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C17 17.7599 17 18.0399 17 18.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109"
    />
  </svg>
);

export const Type01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 7c0-.9319 0-1.3978.1522-1.7654a2 2 0 0 1 1.0824-1.0824C5.6022 4 6.0681 4 7 4h10c.9319 0 1.3978 0 1.7654.1522.49.203.8794.5924 1.0824 1.0824C20 5.6022 20 6.0681 20 7M9 20h6M12 4v16"
    />
  </svg>
);

export const Type02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 7c0-.9319 0-1.3978.1522-1.7654a2 2 0 0 1 1.0824-1.0824C5.6022 4 6.0681 4 7 4h10c.9319 0 1.3978 0 1.7654.1522.49.203.8794.5924 1.0824 1.0824C20 5.6022 20 6.0681 20 7M8 20h8M10.25 4v16m3.5-16v16"
    />
  </svg>
);

export const TypeSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 7h8m-4 0v10m-4.2 4h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const TypeStrikethrough01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 7V6c0-.5412.215-1.0322.5642-1.3923M9 20h6m-3-8v8M3 3l18 18M9.5 4H17c.9319 0 1.3978 0 1.7654.1522.49.203.8794.5924 1.0824 1.0824C20 5.6022 20 6.0681 20 7m-8-3v2.5"
    />
  </svg>
);

export const TypeStrikethrough02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 20h8m-5.75-9.5V20m3.5-6v6M3 3l18 18M4 7V6c0-.5413.215-1.0323.5642-1.3923M9.5 4H17c.9319 0 1.3978 0 1.7654.1522.49.203.8794.5924 1.0824 1.0824C20 5.6022 20 6.0681 20 7m-9.75-3v1m3.5-1v4"
    />
  </svg>
);

export const Underline01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 4v7c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6V4M4 21h16"
    />
  </svg>
);

export const Underline02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 4v6c0 3.866-3.134 7-7 7s-7-3.134-7-7V4m3.5 0v6c0 3.2218 2.1766 5.9352 5.1395 6.7501M4 21h16M3 4h7.5M17 4h4"
    />
  </svg>
);

export const UnderlineSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15.5 7v3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5V7M8 17h8m-8.2 4h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const ZoomIn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m21 21-4.35-4.35M11 8v6m-3-3h6m5 0c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8 3.5817-8 8-8 8 3.5817 8 8"
    />
  </svg>
);

export const ZoomOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m21 21-4.35-4.35M8 11h6m5 0c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8 3.5817-8 8-8 8 3.5817 8 8"
    />
  </svg>
);

export const AlarmClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 3 2 6m20 0-3-3M6 19l-2 2m14-2 2 2M12 9v4l2 2m-2 6a8 8 0 0 0 5.6569-2.3431 8.0005 8.0005 0 0 0 0-11.3137A8.0001 8.0001 0 0 0 6.3432 18.6569 8 8 0 0 0 12 21"
    />
  </svg>
);

export const AlarmClockCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 3 2 6m20 0-3-3M6 19l-2 2m14-2 2 2M9 13.5l2 2 4.5-4.5M12 21a8 8 0 0 0 5.6569-2.3431 8.0005 8.0005 0 0 0 0-11.3137A8.0001 8.0001 0 0 0 6.3432 18.6569 8 8 0 0 0 12 21"
    />
  </svg>
);

export const AlarmClockMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 3 2 6m20 0-3-3M6 19l-2 2m14-2 2 2M9 13h6m-3 8a8 8 0 0 0 5.6569-2.3431 8.0005 8.0005 0 0 0 0-11.3137A8.0001 8.0001 0 0 0 6.3432 18.6569 8 8 0 0 0 12 21"
    />
  </svg>
);

export const AlarmClockOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.5 5.1419A8.0001 8.0001 0 0 1 19.8582 14.5m-1.7226 3.6336a8.0005 8.0005 0 0 1-11.7924.5232 8 8 0 0 1 .518-11.7883M4 4 2 6m20 0-3-3M6 19l-2 2m17 0L3 3"
    />
  </svg>
);

export const AlarmClockPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 3 2 6m20 0-3-3M6 19l-2 2m14-2 2 2m-8-5v-6m-3 3h6m-3 8a8 8 0 0 0 5.6569-2.3431 8.0005 8.0005 0 0 0 0-11.3137A8.0001 8.0001 0 0 0 6.3432 18.6569 8 8 0 0 0 12 21"
    />
  </svg>
);

export const Calendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 10H3m13-8v4M8 2v4m-.2 16h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.7202 21 18.8802 21 17.2V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 4 17.8802 4 16.2 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 22 6.1198 22 7.8 22"
    />
  </svg>
);

export const CalendarCheck01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 10H3m13-8v4M8 2v4m1 10 2 2 4.5-4.5M7.8 22h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.7202 21 18.8802 21 17.2V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 4 17.8802 4 16.2 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 22 6.1198 22 7.8 22"
    />
  </svg>
);

export const CalendarCheck02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 10H3m18 2.5V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 4 17.8802 4 16.2 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 22 6.1198 22 7.8 22H12m4-20v4M8 2v4m6.5 13 2 2 4.5-4.5"
    />
  </svg>
);

export const CalendarDate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 10H3m13-8v4M8 2v4m2.5 8 1.5-1v5m-1.25 0h2.5M7.8 22h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.7202 21 18.8802 21 17.2V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 4 17.8802 4 16.2 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 22 6.1198 22 7.8 22"
    />
  </svg>
);

export const CalendarHeart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 8H3m13-6v3M8 2v3m-.2 17h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.7202 21 18.8802 21 17.2V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 4 17.8802 4 16.2 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 22 6.1198 22 7.8 22m4.1973-9.6694c-.7998-.909-2.1334-1.1535-3.1354-.3212s-1.1431 2.2241-.3562 3.2085c.5713.7148 2.1536 2.1218 2.9776 2.839.1787.1555.268.2333.3727.2641a.51.51 0 0 0 .2826 0c.1046-.0308.1939-.1086.3726-.2641.8241-.7172 2.4063-2.1242 2.9776-2.839.7869-.9844.6631-2.3848-.3562-3.2085-1.0192-.8236-2.3356-.5878-3.1353.3212"
    />
  </svg>
);

export const CalendarHeart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 10H3m18 1.5V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 4 17.8802 4 16.2 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 22 6.1198 22 7.8 22h4.7M16 2v4M8 2v4m9.4976 9.7119c-.6998-.7791-1.8667-.9887-2.7435-.2752s-1.0002 1.9063-.3116 2.7501S17.4976 21 17.4976 21s2.3666-1.9694 3.0551-2.8132c.6886-.8438.5802-2.0442-.3116-2.7501s-2.0437-.5039-2.7435.2752"
    />
  </svg>
);

export const CalendarMinus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 15h6m6-7H3m13-6v3M8 2v3m-.2 17h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.7202 21 18.8802 21 17.2V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 4 17.8802 4 16.2 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 22 6.1198 22 7.8 22"
    />
  </svg>
);

export const CalendarMinus02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 18h6m0-6.5V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 4 17.8802 4 16.2 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 22 6.1198 22 7.8 22h4.7M21 10H3m13-8v4M8 2v4"
    />
  </svg>
);

export const CalendarPlus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 8H3m13-6v3M8 2v3m4 13v-6m-3 3h6m-7.2 7h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 19.7202 21 18.8802 21 17.2V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 4 17.8802 4 16.2 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 22 6.1198 22 7.8 22"
    />
  </svg>
);

export const CalendarPlus02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 11.5V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 4 17.8802 4 16.2 4H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.2798 3 7.1198 3 8.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 22 6.1198 22 7.8 22h4.7M21 10H3m13-8v4M8 2v4m10 15v-6m-3 3h6"
    />
  </svg>
);

export const Clock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 6v6l4 2m6-2c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const ClockCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m14.5 19 2 2 4.5-4.5m.9851-3.9501A10 10 0 0 0 22 12c0-5.5228-4.4772-10-10-10S2 6.4772 2 12c0 5.4354 4.3365 9.858 9.7385 9.9966M12 6v6l3.7384 1.8692"
    />
  </svg>
);

export const ClockFastForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22.7 11.5-1.9995 2-2.0005-2m2.2451 1.5A9.1 9.1 0 0 0 21 12c0-4.9706-4.0294-9-9-9s-9 4.0294-9 9 4.0294 9 9 9c2.8273 0 5.35-1.3037 7-3.3427M12 7v5l3 2"
    />
  </svg>
);

export const ClockPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21.9208 13.265C21.9731 12.8507 22 12.4285 22 12c0-5.5228-4.4772-10-10-10S2 6.4772 2 12s4.4772 10 10 10a10.1 10.1 0 0 0 1.285-.0818M12 6v6l3.7384 1.8692M19 22v-6m-3 3h6"
    />
  </svg>
);

export const ClockRewind = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m22.7 13.5-1.9995-2-2.0005 2M21 12c0 4.9706-4.0294 9-9 9s-9-4.0294-9-9 4.0294-9 9-9c3.3019 0 6.1885 1.7781 7.7545 4.429M12 7v5l3 2"
    />
  </svg>
);

export const ClockSnooze = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.5 17h5l-5 5h5m.4506-9q.0492-.4935.0494-1c0-5.5228-4.4772-10-10-10S2 6.4772 2 12s4.4772 10 10 10a10.1 10.1 0 0 0 1-.0494M12 6v6l3.7384 1.8692"
    />
  </svg>
);

export const ClockStopwatch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 9.5v4l2.5 1.5M12 5c-4.6944 0-8.5 3.8056-8.5 8.5S7.3056 22 12 22s8.5-3.8056 8.5-8.5S16.6944 5 12 5m0 0V2m-2 0h4m6.329 3.592-1.5-1.5.75.75m-15.908.75 1.5-1.5-.75.75"
    />
  </svg>
);

export const Hourglass01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 12 7.7271 8.4393c-.6348-.529-.9523-.7936-1.1805-1.1179a3 3 0 0 1-.4436-.9471C6 5.9913 6 5.5782 6 4.7518V2m6 10 4.2729-3.5607c.6348-.529.9523-.7936 1.1805-1.1179a3 3 0 0 0 .4436-.9471C18 5.9913 18 5.5782 18 4.7518V2m-6 10-4.2729 3.5607c-.6348.5291-.9523.7936-1.1805 1.1179a3 3 0 0 0-.4436.9471C6 18.0086 6 18.4218 6 19.2482V22m6-10 4.2729 3.5607c.6348.5291.9523.7936 1.1805 1.1179.2022.2873.3523.6079.4436.9471.103.3829.103.7961.103 1.6225V22M4 2h16M4 22h16"
    />
  </svg>
);

export const Hourglass02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18.1626 2H5.8374A.8374.8374 0 0 0 5 2.8374a10.05 10.05 0 0 0 2.9434 7.106l1.2192 1.2192c.121.121.1816.1816.2249.2397a1 1 0 0 1 0 1.1954c-.0433.0581-.1039.1187-.225.2397l-1.2191 1.2192A10.05 10.05 0 0 0 5 21.1626c0 .4625.375.8374.8374.8374h12.3252A.8374.8374 0 0 0 19 21.1626a10.05 10.05 0 0 0-2.9434-7.106l-1.2192-1.2192c-.121-.121-.1816-.1816-.2249-.2397a1 1 0 0 1 0-1.1954c.0433-.0581.1039-.1187.2249-.2397l1.2192-1.2192A10.05 10.05 0 0 0 19 2.8374.8374.8374 0 0 0 18.1626 2"
    />
  </svg>
);

export const Hourglass03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9 18.5h6M6.6 2h10.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437C19 2.76 19 3.04 19 3.6v2.0745c0 .4892 0 .7338-.0553.964a2 2 0 0 1-.2394.578c-.1237.2019-.2967.3749-.6426.7208l-2.9313 2.9313c-.396.396-.5941.5941-.6682.8224a1 1 0 0 0 0 .618c.0741.2283.2722.4264.6682.8224l2.9313 2.9313c.3459.3459.5189.5189.6426.7207a2 2 0 0 1 .2394.5781c.0553.2302.0553.4748.0553.964V20.4c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437C18.2401 22 17.9601 22 17.4 22H6.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C5 21.2401 5 20.9601 5 20.4v-2.0745c0-.4892 0-.7338.0553-.964.049-.204.1298-.3991.2394-.5781.1237-.2018.2967-.3748.6426-.7207l2.9313-2.9313c.396-.396.594-.5941.6682-.8224a1 1 0 0 0 0-.618c-.0741-.2283-.2722-.4264-.6682-.8224L5.9373 7.9373c-.346-.346-.5189-.5189-.6426-.7207a2 2 0 0 1-.2394-.5781C5 6.4083 5 6.1637 5 5.6745V3.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C5.76 2 6.04 2 6.6 2"
    />
  </svg>
);

export const ClockRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20.4532 12.8928c-.2778 2.6099-1.7565 5.0556-4.2035 6.4684-4.0655 2.3472-9.264.9543-11.6113-3.1112l-.25-.433m-.8422-4.7099c.2778-2.6099 1.7566-5.0556 4.2035-6.4684 4.0655-2.3472 9.2641-.9542 11.6113 3.1113l.25.433M3.4932 18.0659l.732-2.732 2.732.732m10.085-8.132 2.7321.7321.732-2.732M11.9997 7.5V12l2.5 1.5"
    />
  </svg>
);

export const WatchCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m7 17 .4855 2.4276c.1833.9163.275 1.3745.5141 1.7172a2 2 0 0 0 .839.6878C9.2217 22 9.689 22 10.6235 22h2.7532c.9345 0 1.4017 0 1.7847-.1674a2 2 0 0 0 .8391-.6878c.2392-.3427.3308-.8009.5141-1.7172L17 17M7 7l.4855-2.4276c.1833-.9163.275-1.3745.5141-1.7172a2 2 0 0 1 .839-.6878C9.2217 2 9.689 2 10.6235 2h2.7532c.9345 0 1.4017 0 1.7847.1674.3377.1476.6281.3856.8391.6878.2392.3427.3308.8009.5141 1.7172L17 7m-5 2v3l1.5 1.5M19 12c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7"
    />
  </svg>
);

export const WatchSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m17 18.5-.3369 1.1791c-.2377.8319-.3565 1.2479-.5992 1.5567a2 2 0 0 1-.8163.6157C14.8841 22 14.4515 22 13.5862 22h-3.1724c-.8653 0-1.2979 0-1.6614-.1485a2 2 0 0 1-.8163-.6157c-.2427-.3088-.3615-.7248-.5992-1.5567L7 18.5m10-13-.3369-1.1791c-.2377-.832-.3565-1.248-.5992-1.5567a2 2 0 0 0-.8163-.6157C14.8841 2 14.4515 2 13.5862 2h-3.1724c-.8653 0-1.2979 0-1.6614.1485a2 2 0 0 0-.8163.6157c-.2427.3088-.3615.7247-.5992 1.5567L7 5.5M12 9v3l1.5 1.5m-4.8 5h6.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.4278.218-.9879.218-2.108V8.7c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C16.9802 5.5 16.4201 5.5 15.3 5.5H8.7c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C5.5 7.0198 5.5 7.58 5.5 8.7v6.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218"
    />
  </svg>
);

export const File01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C6.2798 2 7.1198 2 8.8 2h6.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C20 4.2798 20 5.1198 20 6.8v10.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2z"
    />
  </svg>
);

export const File02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 11H8m2 4H8m8-8H8m12-.2v10.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C6.2798 2 7.1198 2 8.8 2h6.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C20 4.2798 20 5.1198 20 6.8"
    />
  </svg>
);

export const File03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 14v4m8-6v6M12 8v10m8-11.2v10.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C6.2798 2 7.1198 2 8.8 2h6.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C20 4.2798 20 5.1198 20 6.8"
    />
  </svg>
);

export const File04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 2.2695V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305M20 9.9882V17.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C6.2798 2 7.1198 2 8.8 2h3.2118c.7337 0 1.1006 0 1.4459.0829.3061.0735.5987.1947.8672.3592.3027.1855.5621.445 1.081.9638l3.1882 3.1882c.5189.5189.7783.7783.9638 1.081.1645.2685.2857.5611.3592.8672C20 8.8876 20 9.2545 20 9.9883"
    />
  </svg>
);

export const File05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 2.2695v4.1306c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305M14 17H8m8-4H8m12-3.0118V17.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C6.2798 2 7.1198 2 8.8 2h3.2118c.7337 0 1.1006 0 1.4459.0829.3061.0735.5987.1947.8672.3592.3027.1855.5621.445 1.081.9638l3.1882 3.1882c.5189.5189.7783.7783.9638 1.081.1645.2685.2857.5611.3592.8672C20 8.8876 20 9.2545 20 9.9883"
    />
  </svg>
);

export const File06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 2.2695v4.1306c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305M16 13H8m8 4H8m2-8H8m6-7H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2V8z"
    />
  </svg>
);

export const File07 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 2.2695v4.1306c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305M8 15v3m8-5v5m-4-7.5V18m8-8.0118V17.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C6.2798 2 7.1198 2 8.8 2h3.2118c.7337 0 1.1006 0 1.4459.0829.3061.0735.5987.1947.8672.3592.3027.1855.5621.445 1.081.9638l3.1882 3.1882c.5189.5189.7783.7783.9638 1.081.1645.2685.2857.5611.3592.8672C20 8.8876 20 9.2545 20 9.9883"
    />
  </svg>
);

export const FileAttachment01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 10V4.5C6 3.6716 6.6716 3 7.5 3S9 3.6716 9 4.5V10c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3V6m9.5-4h2.7c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C20 4.2798 20 5.1198 20 6.8v10.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2v-.7"
    />
  </svg>
);

export const FileAttachment02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.5 2h2.7c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C20 4.2798 20 5.1198 20 6.8v10.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2v-.7M16 13h-4.5M16 9h-3.5m3.5 8H8m-2-7V4.5C6 3.6716 6.6716 3 7.5 3S9 3.6716 9 4.5V10c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3V6"
    />
  </svg>
);

export const FileAttachment03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 7v-.2c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h3.7m5.5-4v-5.5c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5V18c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3v-4"
    />
  </svg>
);

export const FileAttachment04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 7v-.2c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h3.7m0-11H8m3.5 4H8m8-8H8m10 11v-5.5c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5V18c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3v-4"
    />
  </svg>
);

export const FileAttachment05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 14V8.5c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5V14c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3v-4m-.2 12h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22"
    />
  </svg>
);

export const FileCheck01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 12.5V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H12m2.5-3 2 2 4.5-4.5"
    />
  </svg>
);

export const FileCheck02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 12.5V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H12m2-11H8m2 4H8m8-8H8m6.5 12 2 2 4.5-4.5"
    />
  </svg>
);

export const FileCheck03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 2.2695v4.1306c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305M9 16l2 2 4.5-4.5M14 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2V8z"
    />
  </svg>
);

export const FileDownload01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 12.5V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H12.5m8.5-3-3 3-3-3m3 3v-6"
    />
  </svg>
);

export const FileDownload02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 12.5V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H12.5M14 11H8m2 4H8m8-8H8m13 12-3 3-3-3m3 3v-6"
    />
  </svg>
);

export const FileDownload03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 2.2695v4.1306c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305M15 15l-3 3-3-3m3 3v-6m2-10H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2V8z"
    />
  </svg>
);

export const FileHeart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 10V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H12m4.9973-7.1694c-.7998-.909-2.1334-1.1535-3.1354-.3212s-1.1431 2.2241-.3562 3.2085C14.2926 18.7024 16.9973 21 16.9973 21s2.7046-2.2976 3.4915-3.2821.6631-2.3848-.3562-3.2085c-1.0192-.8236-2.3356-.5878-3.1353.3212"
    />
  </svg>
);

export const FileHeart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 10V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H12m.5-11H8m1 4H8m8-8H8m8.9973 7.8306c-.7998-.909-2.1334-1.1535-3.1354-.3212s-1.1431 2.2241-.3562 3.2085C14.2926 18.7024 16.9973 21 16.9973 21s2.7046-2.2976 3.4915-3.2821.6631-2.3848-.3562-3.2085c-1.0192-.8236-2.3356-.5878-3.1353.3212"
    />
  </svg>
);

export const FileHeart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 2.2695v4.1306c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305M14 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2V8zm-2.0027 9.8306c-.7998-.909-2.1334-1.1535-3.1354-.3212s-1.1431 2.2241-.3562 3.2085C9.2926 15.7024 11.9973 18 11.9973 18s2.7046-2.2976 3.4915-3.2821.6631-2.3848-.3562-3.2085c-1.0192-.8236-2.3356-.5878-3.1353.3212"
    />
  </svg>
);

export const FileMinus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 11.9412V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H14m1-5h6"
    />
  </svg>
);

export const FileMinus02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 11.9412V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H14m0-11H8m2 4H8m8-8H8m7 10h6"
    />
  </svg>
);

export const FileMinus03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 2.2695v4.1306c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305M9 15h6M14 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2V8z"
    />
  </svg>
);

export const FilePlus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 10.5V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H12m6-1v-6m-3 3h6"
    />
  </svg>
);

export const FilePlus02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 10.5V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H12m2-11H8m2 4H8m8-8H8m10 14v-6m-3 3h6"
    />
  </svg>
);

export const FilePlus03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 2.2695v4.1306c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305M12 18v-6m-3 3h6M14 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2V8z"
    />
  </svg>
);

export const FileQuestion01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 9.5V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H14m2.5-6.9978a2.2486 2.2486 0 0 1 2.501-1.4698 2.248 2.248 0 0 1 1.8682 2.2193c0 1.4989-2.2483 2.2483-2.2483 2.2483m.0291 3h.01"
    />
  </svg>
);

export const FileQuestion02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 9.5V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H14m0-11H8m2 4H8m8-8H8m8.5 8.0022a2.2486 2.2486 0 0 1 2.501-1.4698 2.248 2.248 0 0 1 1.8682 2.2193c0 1.4989-2.2483 2.2483-2.2483 2.2483m.029 3h.01"
    />
  </svg>
);

export const FileQuestion03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 2.2695v4.1306c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305M9.85 12.0022a2.2483 2.2483 0 0 1 4.3692.7495c0 1.4989-2.2483 2.2483-2.2483 2.2483M12 18h.01M14 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2V8z"
    />
  </svg>
);

export const FileX01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 12V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H12m4-6 5 5m0-5-5 5"
    />
  </svg>
);

export const FileX02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 11H8m2 4H8m8-8H8m12 5V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22H12m4-6 5 5m0-5-5 5"
    />
  </svg>
);

export const FileX03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 2.2695v4.1306c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305M9.5 12l5 5m0-5-5 5M14 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2V8z"
    />
  </svg>
);

export const FileSearch01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 10.5V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h2.7M22 22l-1.5-1.5m1-2.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5 1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5"
    />
  </svg>
);

export const FileSearch02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 11H8m2 4H8m8-8H8m12 3.5V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h2.7M22 22l-1.5-1.5m1-2.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5 1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5"
    />
  </svg>
);

export const FileSearch03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 2.2695v4.1306c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305M16 18.5 14.5 17M14 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2V8zm1.5 12.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5S10.067 11 12 11s3.5 1.567 3.5 3.5"
    />
  </svg>
);

export const Folder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13 7-1.1155-2.231c-.3211-.6422-.4816-.9633-.7211-1.1978a2 2 0 0 0-.7473-.4619C10.0992 3 9.7402 3 9.0223 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2V7m0 0h15.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2z"
    />
  </svg>
);

export const FolderCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13 7-1.1155-2.231c-.3211-.6422-.4816-.9633-.7211-1.1978a2 2 0 0 0-.7473-.4619C10.0992 3 9.7402 3 9.0223 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2V7m0 0h15.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2zm7 7 2 2 4.5-4.5"
    />
  </svg>
);

export const FolderDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13 7-1.1155-2.231c-.3211-.6422-.4816-.9633-.7211-1.1978a2 2 0 0 0-.7473-.4619C10.0992 3 9.7402 3 9.0223 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2V7m0 0h15.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2zm13 7-3 3-3-3m3 3v-6"
    />
  </svg>
);

export const FolderLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13 7-1.1155-2.231c-.3211-.6422-.4816-.9633-.7211-1.1978a2 2 0 0 0-.7473-.4619C10.0992 3 9.7402 3 9.0223 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2V7m0 0h15.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2zm8.1 10.5h3.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.2139.109-.4939.109-1.054v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437c-.2139-.109-.4939-.109-1.054-.109h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437c-.109.2139-.109.4939-.109 1.054v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109m3.65-4v-1.75c0-.9665-.7835-1.75-1.75-1.75s-1.75.7835-1.75 1.75v1.75z"
    />
  </svg>
);

export const FolderMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13 7-1.1155-2.231c-.3211-.6422-.4816-.9633-.7211-1.1978a2 2 0 0 0-.7473-.4619C10.0992 3 9.7402 3 9.0223 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2V7m0 0h15.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2zm7 7h6"
    />
  </svg>
);

export const FolderPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13 7-1.1155-2.231c-.3211-.6422-.4816-.9633-.7211-1.1978a2 2 0 0 0-.7473-.4619C10.0992 3 9.7402 3 9.0223 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2V7m0 0h15.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2zm10 10v-6m-3 3h6"
    />
  </svg>
);

export const FolderQuestion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13 7-1.1155-2.231c-.3211-.6422-.4816-.9633-.7211-1.1978a2 2 0 0 0-.7473-.4619C10.0992 3 9.7402 3 9.0223 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2V7m0 0h15.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2zm7.8501 4.7522a2.2486 2.2486 0 0 1 2.501-1.4698 2.248 2.248 0 0 1 1.8682 2.2193c0 1.4989-2.2483 2.2483-2.2483 2.2483m.029 3h.01"
    />
  </svg>
);

export const FolderSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13 7-1.1155-2.231c-.3211-.6422-.4816-.9633-.7211-1.1978a2 2 0 0 0-.7473-.4619C10.0992 3 9.7402 3 9.0223 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2V7m0 0h15.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2zm13.5 10.5L14 16m1-2.5c0 1.933-1.567 3.5-3.5 3.5S8 15.433 8 13.5 9.567 10 11.5 10s3.5 1.567 3.5 3.5"
    />
  </svg>
);

export const FolderClosed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13 7-1.1155-2.231c-.3211-.6422-.4816-.9633-.7211-1.1978a2 2 0 0 0-.7473-.4619C10.0992 3 9.7402 3 9.0223 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2V7m0 0h15.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2zm7.5 4.5 5 5M16 14c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const FolderX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m13 7-1.1155-2.231c-.3211-.6422-.4816-.9633-.7211-1.1978a2 2 0 0 0-.7473-.4619C10.0992 3 9.7402 3 9.0223 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2V7m0 0h15.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2zm7.5 4.5 5 5m0-5-5 5"
    />
  </svg>
);

export const Paperclip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m21.1525 10.8995-9.0156 9.0156c-2.0503 2.0502-5.3744 2.0502-7.4246 0-2.0503-2.0503-2.0503-5.3744 0-7.4247l9.0156-9.0156c1.3668-1.3668 3.5829-1.3668 4.9497 0s1.3668 3.583 0 4.9498l-8.662 8.662c-.6835.6835-1.7915.6835-2.475 0-.6833-.6834-.6833-1.7914 0-2.4748l7.6015-7.6014"
    />
  </svg>
);

export const Clipboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 4c.93 0 1.395 0 1.7765.1022a3 3 0 0 1 2.1213 2.1213C20 6.605 20 7.07 20 8v9.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2V8c0-.93 0-1.395.1022-1.7765a3 3 0 0 1 2.1213-2.1213C6.605 4 7.07 4 8 4m1.6 2h4.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.2401 2 14.9601 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054.0959.1882.2488.3411.437.437C8.76 6 9.04 6 9.6 6"
    />
  </svg>
);

export const ClipboardAttachment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 4c.93 0 1.395 0 1.7765.1022a3 3 0 0 1 2.1213 2.1213C20 6.605 20 7.07 20 8v9.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2V8c0-.93 0-1.395.1022-1.7765a3 3 0 0 1 2.1213-2.1213C6.605 4 7.07 4 8 4m4 11.5V11c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5v4.5c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3v-4M9.6 6h4.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.2401 2 14.9601 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054.0959.1882.2488.3411.437.437C8.76 6 9.04 6 9.6 6"
    />
  </svg>
);

export const ClipboardDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 11v6m3-3-3 3-3-3m7-10c.93 0 1.395 0 1.7765.1022a3 3 0 0 1 2.1213 2.1213C20 6.605 20 7.07 20 8v9.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2V8c0-.93 0-1.395.1022-1.7765a3 3 0 0 1 2.1213-2.1213C6.605 4 7.07 4 8 4m1.6 2h4.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.2401 2 14.9601 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054.0959.1882.2488.3411.437.437C8.76 6 9.04 6 9.6 6"
    />
  </svg>
);

export const ClipboardCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 4c.93 0 1.395 0 1.7765.1022a3 3 0 0 1 2.1213 2.1213C20 6.605 20 7.07 20 8v9.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2V8c0-.93 0-1.395.1022-1.7765a3 3 0 0 1 2.1213-2.1213C6.605 4 7.07 4 8 4m1 11 2 2 4.5-4.5M9.6 6h4.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.2401 2 14.9601 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054.0959.1882.2488.3411.437.437C8.76 6 9.04 6 9.6 6"
    />
  </svg>
);

export const ClipboardX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 4c.93 0 1.395 0 1.7765.1022a3 3 0 0 1 2.1213 2.1213C20 6.605 20 7.07 20 8v9.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2V8c0-.93 0-1.395.1022-1.7765a3 3 0 0 1 2.1213-2.1213C6.605 4 7.07 4 8 4m1.5 8 5 5m0-5-5 5m.1-11h4.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.2401 2 14.9601 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054.0959.1882.2488.3411.437.437C8.76 6 9.04 6 9.6 6"
    />
  </svg>
);

export const ClipboardPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 4c.93 0 1.395 0 1.7765.1022a3 3 0 0 1 2.1213 2.1213C20 6.605 20 7.07 20 8v9.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2V8c0-.93 0-1.395.1022-1.7765a3 3 0 0 1 2.1213-2.1213C6.605 4 7.07 4 8 4m4 13v-6m-3 3h6M9.6 6h4.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.2401 2 14.9601 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054.0959.1882.2488.3411.437.437C8.76 6 9.04 6 9.6 6"
    />
  </svg>
);

export const ClipboardMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 4c.93 0 1.395 0 1.7765.1022a3 3 0 0 1 2.1213 2.1213C20 6.605 20 7.07 20 8v9.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2V8c0-.93 0-1.395.1022-1.7765a3 3 0 0 1 2.1213-2.1213C6.605 4 7.07 4 8 4m1 10h6M9.6 6h4.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C16 5.24 16 4.96 16 4.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.2401 2 14.9601 2 14.4 2H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C8 2.76 8 3.04 8 3.6v.8c0 .56 0 .84.109 1.054.0959.1882.2488.3411.437.437C8.76 6 9.04 6 9.6 6"
    />
  </svg>
);

export const StickerSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13 3.5v2.7c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C15.2798 11 16.1198 11 17.8 11h2.7m.5 1.9882V16.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2V7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h3.2118c.7337 0 1.1006 0 1.4459.0829.3061.0735.5987.1947.8672.3592.3027.1855.5621.445 1.081.9638l5.1882 5.1882c.5189.5189.7783.7783.9638 1.081.1645.2685.2857.5611.3592.8672.0829.3453.0829.7122.0829 1.4459"
    />
  </svg>
);

export const StickerCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22.0006 12.1171C22.0006 6.5296 17.471 2 11.8835 2c-4.535 0-8.3731 2.9839-9.6582 7.0954-.0823.2634-.1235.395-.1196.5597.0032.134.0439.2994.1032.4194.073.1477.1856.2604.411.4857l10.821 10.8205c.2253.2253.3379.338.4856.4109.1201.0593.2855.1.4194.1032.1647.0039.2964-.0373.5598-.1196 4.1113-1.2852 7.0949-5.1232 7.0949-9.6581"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3.4468 9.7341q.3608-.0257.7282-.0258c5.5875 0 10.1171 4.5296 10.1171 10.1171q0 .3674-.0258.7282c-.0299.4202-.0448.6303-.1673.7601-.0995.1054-.2692.1687-.4134.1543-.1776-.0178-.339-.1793-.662-.5022l-9.989-9.989c-.3229-.3229-.4844-.4844-.5021-.662-.0145-.1442.0489-.3139.1542-.4134.1298-.1225.34-.1374.7601-.1673"
    />
  </svg>
);

export const Box = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20.5 8v8.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.2202 21 17.3802 21 15.7 21H8.3c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3.5 18.7202 3.5 17.8802 3.5 16.2V8m.1-5h16.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437C22 3.76 22 4.04 22 4.6v1.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C21.2401 8 20.9601 8 20.4 8H3.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C2 7.24 2 6.96 2 6.4V4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 3 3.04 3 3.6 3m6 8.5h4.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054v.8c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437c-.2139.109-.4939.109-1.054.109H9.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C8 14.7401 8 14.4601 8 13.9v-.8c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437C8.76 11.5 9.04 11.5 9.6 11.5"
    />
  </svg>
);

export const Bus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.5 19v2.2c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C8.12 22 7.98 22 7.7 22H5.8c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C5 21.62 5 21.48 5 21.2V19m14 0v2.2c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C18.62 22 18.48 22 18.2 22h-1.9c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C15.5 21.62 15.5 21.48 15.5 21.2V19M3 12h18M3 5.5h18m-14.5 10H8m8 0h1.5M7.8 19h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 16.7202 21 15.8802 21 14.2V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 2 17.8802 2 16.2 2H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 4.2798 3 5.1198 3 6.8v7.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 19 6.1198 19 7.8 19"
    />
  </svg>
);

export const Car01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 13h3M2 9l2 1 1.2706-3.812c.2623-.7867.3934-1.1802.6367-1.471a2 2 0 0 1 .8022-.5782C7.0624 4 7.4771 4 8.3065 4h7.3871c.8294 0 1.244 0 1.5969.1388.3116.1225.5874.3213.8022.5782.2432.2908.3744.6843.6367 1.471L20 10l2-1m-6 4h3M6.8 10h10.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 12.2798 22 13.1198 22 14.8v2.7c0 .4647 0 .697-.0384.8902a2 2 0 0 1-1.5714 1.5714C20.197 20 19.9647 20 19.5 20H19c-1.1046 0-2-.8954-2-2a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5c0 1.1046-.8954 2-2 2h-.5c-.4647 0-.697 0-.8902-.0384a2 2 0 0 1-1.5714-1.5714C2 18.197 2 17.9647 2 17.5v-2.7c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 10 5.1198 10 6.8 10"
    />
  </svg>
);

export const Car02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 10V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C17.4802 3 16.9201 3 15.8 3H8.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C5 4.5198 5 5.08 5 6.2V10m0-1H2V8m17 1h3V8M6 13.5h.01m11.99 0h.01M6.8 10h10.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 12.2798 22 13.1198 22 14.8V18c0 .9319 0 1.3978-.1522 1.7654-.203.49-.5924.8794-1.0824 1.0824C20.3978 21 19.9319 21 19 21h-.6c-.3716 0-.5574 0-.7129-.0246a2 2 0 0 1-1.6625-1.6625C16 19.1574 16 18.9716 16 18.6c0-.0929 0-.1394-.0062-.1782a.5.5 0 0 0-.4156-.4156C15.5394 18 15.4929 18 15.4 18H8.6c-.0929 0-.1394 0-.1782.0062a.5.5 0 0 0-.4156.4156C8 18.4606 8 18.5071 8 18.6c0 .3716 0 .5574-.0246.7129a2 2 0 0 1-1.6625 1.6625C6.1574 21 5.9716 21 5.6 21H5c-.9319 0-1.3978 0-1.7654-.1522a2 2 0 0 1-1.0824-1.0824C2 19.3978 2 18.9319 2 18v-3.2c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 10 5.1198 10 6.8 10m-.3 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m12 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 18.5 13.5"
    />
  </svg>
);

export const Compass01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 12c0 5.5228-4.4772 10-10 10m10-10c0-5.5228-4.4772-10-10-10m10 10h-2m-8 10C6.4772 22 2 17.5228 2 12m10 10v-2M2 12C2 6.4772 6.4772 2 12 2M2 12h2m8-10v2m7.0711 15.0711-1.4142-1.4142M6.3432 6.3432 4.9289 4.9289m12.728 1.4143 1.4142-1.4143M4.9289 19.0711l1.4143-1.4142M8 12l2.5-1.5L12 8l1.5 2.5L16 12l-2.5 1.5L12 16l-1.5-2.5z"
    />
  </svg>
);

export const Compass02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 12h-2m2 0c0 5.5228-4.4772 10-10 10m10-10c0-5.5228-4.4772-10-10-10m7.0711 17.0711-1.4142-1.4142M4 12H2m0 0c0 5.5228 4.4772 10 10 10M2 12C2 6.4772 6.4772 2 12 2M6.3431 6.3431 4.929 4.929M12 4V2m5.6569 4.3431 1.4142-1.4142M12 22v-2m-7.071-.9289 1.4141-1.4142M12 8l4 4-4 4-4-4z"
    />
  </svg>
);

export const Compass03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14.7221 8.266c.4886-.1629.7328-.2443.8953-.1864a.5.5 0 0 1 .303.303c.0579.1625-.0235.4068-.1864.8953l-1.4875 4.4626c-.0464.1392-.0696.2087-.1091.2665a.5.5 0 0 1-.1304.1304c-.0578.0395-.1273.0627-.2665.1091L9.2779 15.734c-.4885.1629-.7328.2443-.8953.1864a.5.5 0 0 1-.303-.303c-.058-.1625.0235-.4067.1864-.8953l1.4875-4.4626c.0464-.1392.0696-.2087.1091-.2665a.5.5 0 0 1 .1304-.1304c.0578-.0395.1273-.0627.2665-.109z"
    />
  </svg>
);

export const Flag01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1v19"
    />
  </svg>
);

export const Flag02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V4s-1 1-4 1-5-2-8-2-4 1-4 1m0 18V2"
    />
  </svg>
);

export const Flag03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 13h15.587c.4625 0 .6938 0 .8258-.097a.5.5 0 0 0 .2019-.3566c.0153-.1631-.1037-.3614-.3417-.758l-2.026-3.3768c-.0898-.1496-.1347-.2245-.1523-.3044a.5.5 0 0 1 0-.2144c.0176-.08.0625-.1547.1523-.3044l2.026-3.3768c.238-.3966.357-.5949.3417-.758a.5.5 0 0 0-.2019-.3566C20.2808 3 20.0495 3 19.587 3H4v18"
    />
  </svg>
);

export const Flag04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13.5 6.5h6.2056c.4286 0 .6429 0 .772.0903a.5.5 0 0 1 .208.3366c.023.1558-.0728.3475-.2645.7309l-1.2523 2.5045c-.062.1241-.093.1862-.1062.2514a.5.5 0 0 0-.004.1754c.0102.0657.0384.1291.0947.2559L20.5 13.8751c.1667.3749.25.5623.2227.7137a.5.5 0 0 1-.2111.3248C20.3844 15 20.1793 15 19.769 15H12.1c-.5601 0-.8401 0-1.054-.109a1 1 0 0 1-.437-.437c-.109-.2139-.109-.4939-.109-1.054V11M3 21V3.5M3 11h8.9c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.2139.109-.494.109-1.054V4.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C12.7401 2.5 12.4601 2.5 11.9 2.5H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 3.26 3 3.54 3 4.1z"
    />
  </svg>
);

export const Flag05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14.1111 6.7222h6.0293c.4473 0 .671 0 .8018.094a.5.5 0 0 1 .2047.348c.0187.16-.0899.3555-.3071.7465l-1.4696 2.6452c-.0788.1418-.1182.2127-.1336.2878a.5.5 0 0 0 0 .2014c.0154.0751.0548.146.1336.2878l1.4696 2.6452c.2172.391.3258.5865.3071.7465a.5.5 0 0 1-.2047.348c-.1308.094-.3545.094-.8018.094h-7.5959c-.5601 0-.8401 0-1.054-.109a1 1 0 0 1-.437-.437c-.109-.2139-.109-.4939-.109-1.054v-2.6222M7.25 21.5002 3.0278 4.6113m1.5834 6.3331h7.9c.56 0 .84 0 1.0539-.1089a1 1 0 0 0 .4371-.4371c.109-.2139.109-.4939.109-1.054V4.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.4371-.437c-.2139-.109-.4939-.109-1.0539-.109h-7.962c-.6984 0-1.0477 0-1.2866.1447a1 1 0 0 0-.4372.56c-.0825.2669.0022.6057.1716 1.2834z"
    />
  </svg>
);

export const Flag06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 21V4m0 9h7.4c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C13 12.2401 13 11.9601 13 11.4V4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C12.2401 3 11.9601 3 11.4 3H5.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C4 3.76 4 4.04 4 4.6zm9-8h6.4c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437C21 5.76 21 6.04 21 6.6v6.8c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437C20.2401 15 19.9601 15 19.4 15h-4.8c-.5601 0-.8401 0-1.054-.109a1 1 0 0 1-.437-.437C13 14.2401 13 13.9601 13 13.4z"
    />
  </svg>
);

export const Globe01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 12h20M2 12c0 5.5228 4.4772 10 10 10M2 12C2 6.4772 6.4772 2 12 2m10 10c0 5.5228-4.4772 10-10 10m10-10c0-5.5228-4.4772-10-10-10m0 0a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10m0-20a15.3 15.3 0 0 0-4 10 15.3 15.3 0 0 0 4 10"
    />
  </svg>
);

export const Globe02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10m0-20a15.3 15.3 0 0 0-4 10 15.3 15.3 0 0 0 4 10m0-20C6.4772 2 2 6.4772 2 12s4.4772 10 10 10m0-20c5.5228 0 10 4.4772 10 10s-4.4772 10-10 10M2.5 9h19m-19 6h19"
    />
  </svg>
);

export const Globe03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 2c3 2 3.9228 6.292 4 10-.0772 3.708-1 8-4 10m0-20C9 4 8.0772 8.292 8 12c.0772 3.708 1 8 4 10m0-20C6.4772 2 2 6.4772 2 12M12 2c5.5228 0 10 4.4772 10 10M12 22c5.5229 0 10-4.4772 10-10M12 22C6.4772 22 2 17.5228 2 12m20 0c-2 3-6.292 3.9228-10 4-3.708-.0772-8-1-10-4m20 0c-2-3-6.292-3.9228-10-4-3.708.0772-8 1-10 4"
    />
  </svg>
);

export const Globe04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m3.076 7.4828 4.288 3.0629c.2232.1593.3347.239.4515.2574a.5.5 0 0 0 .301-.0466c.1057-.0528.188-.1625.3525-.3818l.9061-1.2082c.0465-.062.0698-.093.0971-.1198a.5.5 0 0 1 .0795-.0633c.0322-.0207.0677-.0364.1385-.068l3.8686-1.7193c.1604-.0713.2405-.107.301-.1626a.5.5 0 0 0 .1234-.1767c.0314-.0759.0372-.1634.0489-.3385l.2833-4.2489M13.5 13.5l2.616 1.1211c.3035.1301.4553.1952.5357.3032a.5.5 0 0 1 .0979.3294c-.0083.1344-.0999.2718-.2831.5465l-1.229 1.8436c-.0868.1302-.1303.1953-.1876.2425a.5.5 0 0 1-.1722.0921c-.071.0216-.1493.0216-.3058.0216h-1.9953c-.2073 0-.311 0-.3992-.0347a.5.5 0 0 1-.2006-.1445c-.0608-.0727-.0936-.1711-.1591-.3678l-.7129-2.1386c-.0387-.1161-.058-.1741-.0631-.233a.5.5 0 0 1 .0111-.1561c.0134-.0576.0407-.1123.0954-.2217l.5415-1.083c.11-.2201.165-.3301.2498-.3984a.5.5 0 0 1 .2604-.1079c.1082-.0116.2249.0273.4583.1051zM22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    />
  </svg>
);

export const Globe05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M15 2.4578A10 10 0 0 0 12 2C6.4772 2 2 6.4772 2 12s4.4772 10 10 10 10-4.4772 10-10c0-1.7153-.4319-3.3298-1.1929-4.7405M17 5.75h.005m-6.5049 16.1383.0001-2.2034a.5.5 0 0 1 .1203-.3253l2.4858-2.9002c.2043-.2383.141-.6038-.1315-.7595l-2.8563-1.6322a.5.5 0 0 1-.1862-.1863l-1.8618-3.2628a.5.5 0 0 0-.4787-.2502l-5.5276.4923M21 6c0 2.2091-2 4-4 6-2-2-4-3.7909-4-6s1.7909-4 4-4 4 1.7909 4 4m-3.75-.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
    />
  </svg>
);

export const Globe06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m2.6868 15.6451 1.9081-1.1016a.5.5 0 0 1 .342-.0584l3.7545.7027c.3086.0577.5934-.1798.592-.4937l-.0146-3.2896a.5.5 0 0 1 .0682-.2545l1.8947-3.2438a.5.5 0 0 0-.0226-.5396l-3.1902-4.541M19.0002 4.859C13.5002 7.5 16.5 11 17.5002 11.5c1.8771.9384 4.4874 1 4.4874 1q.0123-.2484.0124-.5c0-5.5228-4.4772-10-10-10S2 6.4772 2 12s4.4772 10 10 10q.2516 0 .5-.0123m4.2578-.0479L13.591 13.591l8.3488 3.1668-3.7022 1.4798z"
    />
  </svg>
);

export const Luggage01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 22v-2m1.5-5V7M16 22v-2m-1.5-5V7M8.8 20h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 17.7202 20 16.8802 20 15.2V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 20 7.1198 20 8.8 20"
    />
  </svg>
);

export const Luggage02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 7c0-.93 0-1.395-.1022-1.7765a3 3 0 0 0-2.1213-2.1213C13.395 3 12.93 3 12 3s-1.395 0-1.7765.1022a3 3 0 0 0-2.1213 2.1213C8 5.605 8 6.07 8 7m4.8 10.5h4.9c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527v-2.4c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C18.12 13.5 17.98 13.5 17.7 13.5h-4.9c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C12 13.88 12 14.02 12 14.3v2.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545m-6 3.5h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.7202 22 17.8802 22 16.2v-4.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 7 18.8802 7 17.2 7H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 9.2798 2 10.1198 2 11.8v4.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 21 5.1198 21 6.8 21"
    />
  </svg>
);

export const Luggage03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 21V7c0-.93 0-1.395.1022-1.7765a3 3 0 0 1 2.1213-2.1213C10.605 3 11.07 3 12 3s1.395 0 1.7765.1022a3 3 0 0 1 2.1213 2.1213C16 5.605 16 6.07 16 7v6.5m0 4V21m-9.2 0h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.7202 22 17.8802 22 16.2v-4.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 7 18.8802 7 17.2 7H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 9.2798 2 10.1198 2 11.8v4.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 21 5.1198 21 6.8 21m6-3.5h4.9c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527v-2.4c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C18.12 13.5 17.98 13.5 17.7 13.5h-4.9c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C12 13.88 12 14.02 12 14.3v2.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545"
    />
  </svg>
);

export const Map01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 6 9 2 2 6v16l7-4m7-12 6-4v16l-6 4-7-4m0 0V2m7 20V6"
    />
  </svg>
);

export const Map02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m8 3 8 18M3 17l9-5m-4.2 9h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21"
    />
  </svg>
);

export const Mark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 12c0 4.4183-3.5817 8-8 8m8-8c0-4.4183-3.5817-8-8-8m8 8h2m-10 8c-4.4183 0-8-3.5817-8-8m8 8v2M4 12c0-4.4183 3.5817-8 8-8m-8 8H2m10-8V2m3 10c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
    />
  </svg>
);

export const MarkerPin01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 13c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c4-4 8-7.5817 8-12s-3.5817-8-8-8-8 3.5817-8 8 4 8 8 12"
    />
  </svg>
);

export const MarkerPin02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 12.5c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c2-4 8-6.5817 8-12 0-4.4183-3.5817-8-8-8s-8 3.5817-8 8c0 5.4183 6 8 8 12"
    />
  </svg>
);

export const MarkerPin03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 22c1-5 8-5.5817 8-12 0-4.4183-3.5817-8-8-8s-8 3.5817-8 8c0 6.4183 7 7 8 12"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 13c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3"
    />
  </svg>
);

export const MarkerPin04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5 14.2864c-1.8514.8167-3 1.9548-3 3.2136C2 19.9853 6.4772 22 12 22s10-2.0147 10-4.5c0-1.2588-1.1486-2.3969-3-3.2136M18 8c0 4.0637-4.5 6-6 9-1.5-3-6-4.9363-6-9 0-3.3137 2.6863-6 6-6s6 2.6863 6 6m-5 0c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const MarkerPin05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 13.3744c3.5318.6944 6 2.2803 6 4.1256 0 2.4853-4.4772 4.5-10 4.5S2 19.9853 2 17.5c0-1.8453 2.4682-3.4312 6-4.1256M12 17V3l5.3177 3.2724c.3879.2387.5818.358.6437.5084a.5.5 0 0 1-.0117.407c-.0705.1465-.271.2544-.672.4703L12 10.5"
    />
  </svg>
);

export const MarkerPin06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 13.3744c3.5318.6944 6 2.2803 6 4.1256 0 2.4853-4.4772 4.5-10 4.5S2 19.9853 2 17.5c0-1.8453 2.4682-3.4312 6-4.1256M12 17V9m0 0c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3"
    />
  </svg>
);

export const NavigationPointer01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3.4135 10.7445c-.5954-.2315-.893-.3473-.98-.5141a.5.5 0 0 1-.0002-.4615c.0867-.167.3842-.283.9793-.5153l16.8877-6.5903c.5372-.2097.8058-.3145.9774-.2571a.5.5 0 0 1 .3158.3158c.0574.1716-.0474.4402-.2571.9774L14.7461 20.587c-.2322.5951-.3484.8926-.5153.9793a.5.5 0 0 1-.4615-.0002c-.1668-.0869-.2826-.3846-.5141-.98l-2.6281-6.758c-.047-.1208-.0705-.1812-.1068-.2321a.5.5 0 0 0-.1167-.1167c-.0509-.0363-.1113-.0598-.2321-.1068z"
    />
  </svg>
);

export const NavigationPointer02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M5.0369 21.3253c-.5847.2573-.877.3859-1.0565.3294a.5.5 0 0 1-.3265-.3262c-.0567-.1793.0715-.4718.3281-1.0568l7.2814-16.6015c.2316-.528.3474-.7921.5093-.873a.5.5 0 0 1 .4466 0c.1619.0809.2777.345.5094.873L20.01 20.2717c.2566.585.3849.8775.3282 1.0568a.5.5 0 0 1-.3266.3262c-.1794.0565-.4717-.0721-1.0564-.3294l-6.637-2.9203c-.1187-.0522-.178-.0783-.2397-.0886a.5.5 0 0 0-.165 0c-.0616.0103-.121.0364-.2397.0886z"
    />
  </svg>
);

export const NavigationPointerOff01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m11.337 6.1612 8.9633-3.498c.5372-.2096.8058-.3144.9774-.257a.5.5 0 0 1 .3158.3158c.0574.1716-.0474.4402-.2571.9774l-3.509 8.9919m-1.4417 3.6944-1.6396 4.2014c-.2322.5951-.3484.8926-.5153.9793a.5.5 0 0 1-.4615-.0002c-.1668-.0869-.2826-.3846-.5141-.98l-2.6281-6.758c-.047-.1208-.0705-.1812-.1068-.2321a.5.5 0 0 0-.1167-.1167c-.0509-.0363-.1113-.0598-.2321-.1068l-6.758-2.6281c-.5954-.2315-.893-.3473-.98-.5141a.5.5 0 0 1-.0002-.4615c.0867-.167.3842-.283.9793-.5153l4.2049-1.641m13.382 13.3876-18-18"
    />
  </svg>
);

export const NavigationPointerOff02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m10.4712 5.4758.7919-1.8054c.2316-.528.3474-.792.5093-.8729a.5.5 0 0 1 .4466 0c.1619.0808.2777.3449.5093.873l3.1723 7.2328m-6.954-1.9518L3.9817 20.272c-.2566.585-.3849.8775-.3282 1.0568a.5.5 0 0 0 .3266.3261c.1794.0565.4717-.0721 1.0564-.3293l6.637-2.9203c.1187-.0522.178-.0783.2397-.0887a.5.5 0 0 1 .165 0c.0616.0104.121.0365.2397.0887l6.6369 2.9203c.5847.2572.8771.3858 1.0565.3293a.5.5 0 0 0 .3265-.3261c.0567-.1793-.0716-.4718-.3281-1.0568l-.2042-.4654M22 22 2 2"
    />
  </svg>
);

export const Passport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 16h4m-5.2 6h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 2 16.8802 2 15.2 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22M15 9c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
    />
  </svg>
);

export const Rocket01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m12.9996 10.9999-9.5 9.5M14.0181 3.5384c1.218.8082 2.3887 1.761 3.4827 2.855 1.1034 1.1034 2.0632 2.285 2.8759 3.5143M9.2546 7.896l-2.8749-.9582a1 1 0 0 0-.9621.1853L2.5604 9.5406c-.585.495-.4187 1.4369.3002 1.7018l2.7072.9974m6.1129 6.1126.9974 2.7072c.2649.719 1.2068.8852 1.7017.3003l2.4176-2.8572a1 1 0 0 0 .1853-.9622l-.9583-2.8748m3.3238-12.395-4.9064.8177a2.443 2.443 0 0 0-1.3827.741L6.446 10.8984c-1.7141 1.8323-1.6665 4.6939.1078 6.4682 1.7742 1.7742 4.6358 1.8219 6.4682.1077l7.0691-6.613a2.443 2.443 0 0 0 .741-1.3827l.8177-4.9065c.2256-1.3536-.9479-2.5272-2.3016-2.3016"
    />
  </svg>
);

export const Plane = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17.7448 2.813c.9647-.9965 2.5588-1.0094 3.5395-.0286.9539.9538.9716 2.4948.04 3.4704l-2.7787 2.9098c-.2178.228-.3266.342-.3938.4756a1 1 0 0 0-.104.3791c-.0104.1491.025.3028.096.61l1.7279 7.4876c.0727.3154.1091.4731.0974.6257a1 1 0 0 1-.1109.3865c-.0709.1356-.1853.2501-.4142.4789l-.3708.3708c-.6061.6062-.9092.9092-1.2194.9641a1 1 0 0 1-.7703-.1819c-.2529-.1877-.3885-.5944-.6595-1.4076l-2.0098-6.0293-3.3453 3.3454c-.1997.1996-.2995.2995-.3663.4171a1 1 0 0 0-.118.3364c-.0213.1335-.0057.2738.0254.5545l.1837 1.6534c.0312.2807.0468.421.0255.5545a1 1 0 0 1-.118.3365c-.0668.1175-.1666.2174-.3663.4171l-.1975.1975c-.473.473-.7096.7096-.9724.7781-.2306.06-.475.0358-.6893-.0683-.2443-.1187-.4299-.397-.801-.9537l-1.5683-2.3525c-.0663-.0994-.0994-.1491-.138-.1942a1 1 0 0 0-.1115-.1116c-.045-.0385-.0948-.0716-.1942-.1379l-2.3525-1.5683c-.5567-.3711-.835-.5567-.9537-.801a1 1 0 0 1-.0683-.6893c.0685-.2628.305-.4993.7781-.9724l.1975-.1975c.1997-.1997.2996-.2995.4172-.3663a1 1 0 0 1 .3364-.118c.1335-.0213.2738-.0057.5545.0255l1.6534.1837c.2807.0311.421.0467.5545.0254a1 1 0 0 0 .3364-.118c.1176-.0668.2175-.1666.4172-.3663l3.3453-3.3453-6.0293-2.0098c-.8132-.271-1.2199-.4066-1.4076-.6595a1 1 0 0 1-.1819-.7703c.0549-.3102.358-.6133.964-1.2194l.3709-.3708c.2288-.2289.3433-.3433.4789-.4142a1 1 0 0 1 .3865-.1109c.1526-.0117.3103.0247.6257.0975l7.4591 1.7213c.31.0715.465.1073.6146.0966a1 1 0 0 0 .4118-.1217c.1314-.0724.242-.1867.4633-.4152z"
    />
  </svg>
);

export const Rocket02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m12 14.9998-3-3m3 3a22.36 22.36 0 0 0 4-2m-4 2v5s3.03-.55 4-2c1.08-1.62 0-5 0-5m-7-1a22 22 0 0 1 2-3.95 12.88 12.88 0 0 1 11-6.05c0 2.72-.78 7.5-6 11m-7-1H4s.55-3.03 2-4c1.62-1.08 5 0 5 0m-6.5 8.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09"
    />
  </svg>
);

export const Route = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.5 5h.4344c3.0472 0 4.5709 0 5.1492.5473.5.473.7215 1.17.5866 1.845-.1562.7807-1.4001 1.6605-3.8879 3.4202l-4.0646 2.875C7.23 15.4471 5.986 16.327 5.8298 17.1078a2 2 0 0 0 .5866 1.8449c.5783.5473 2.102.5473 5.1492.5473H12.5M8 5c0 1.6569-1.3431 3-3 3S2 6.6569 2 5s1.3432-3 3-3 3 1.3432 3 3m14 14c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
    />
  </svg>
);

export const Ticket01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10 8V7m0 5.5v-1m0 5.5v-1M5.2 4h13.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C22 5.5198 22 6.08 22 7.2v1.3c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5v1.3c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C20.4802 20 19.9201 20 18.8 20H5.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C2 18.4802 2 17.9201 2 16.8v-1.3c1.933 0 3.5-1.567 3.5-3.5S3.933 8.5 2 8.5V7.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 4 4.08 4 5.2 4"
    />
  </svg>
);

export const Ticket02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 8V7m0 5.5v-1M8 17v-1m-1.2 4h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.7202 22 16.8802 22 15.2V8.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 4 18.8802 4 17.2 4H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.2798 2 7.1198 2 8.8v6.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 20 5.1198 20 6.8 20"
    />
  </svg>
);

export const Train = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.5 22h5M8 2h8m-4 3V2M4 12h16m-3 7 1.5 3M7 19l-1.5 3m3-6.5h.01m6.99 0h.01M8.8 19h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 16.7202 20 15.8802 20 14.2V9.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 5 16.8802 5 15.2 5H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 7.2798 4 8.1198 4 9.8v4.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 19 7.1198 19 8.8 19m.2-3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m7 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 16 15.5"
    />
  </svg>
);

export const Tram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m18.5 3-.9865-.4933c-.378-.189-.567-.2834-.765-.35a3 3 0 0 0-.5408-.1277C16.0008 2 15.7895 2 15.3669 2H8.6331c-.4226 0-.6339 0-.8408.029a3 3 0 0 0-.5408.1276c-.198.0667-.387.1612-.765.3501L5.5 3M11 6 9 2m4 4 2-4M4 13h16m-3 7 1 2M7 20l-.9998 2M8.5 16.5h.01m6.99 0h.01M8.8 20h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 17.7202 20 16.8802 20 15.2v-4.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C17.7202 6 16.8802 6 15.2 6H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 8.2798 4 9.1198 4 10.8v4.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 20 7.1198 20 8.8 20m.2-3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m7 0a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 16 16.5"
    />
  </svg>
);

export const Truck01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14 7h2.3373c.2445 0 .3668 0 .4819.0276a1 1 0 0 1 .2891.1198c.1009.0618.1874.1483.3603.3212l4.0628 4.0628c.1729.1729.2594.2594.3212.3603a1 1 0 0 1 .1198.2891c.0276.1151.0276.2374.0276.4819V15.5c0 .4659 0 .6989-.0761.8827a1 1 0 0 1-.5412.5412C21.1989 17 20.9659 17 20.5 17m-5 0H14m0 0V7.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C12.4802 4 11.9201 4 10.8 4H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 5.5198 2 6.08 2 7.2V15c0 1.1046.8954 2 2 2m10 0h-4m0 0c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3m6 0c0-1.6569-1.3431-3-3-3s-3 1.3431-3 3m16.5.5c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5S16.6193 15 18 15s2.5 1.1193 2.5 2.5"
    />
  </svg>
);

export const Truck02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 16V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C14.4802 3 13.9201 3 12.8 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2v6.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 16 4.08 16 5.2 16zm0 0h4.4c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 15.2401 22 14.9601 22 14.4v-2.7373c0-.2445 0-.3668-.0276-.4819a1 1 0 0 0-.1198-.2891c-.0618-.1009-.1483-.1874-.3212-.3603l-2.0628-2.0628c-.1729-.173-.2594-.2594-.3603-.3212a1 1 0 0 0-.2891-.1198C18.7041 8 18.5818 8 18.3373 8H16M9 18.5C9 19.8807 7.8807 21 6.5 21S4 19.8807 4 18.5 5.1193 16 6.5 16 9 17.1193 9 18.5m11 0c0 1.3807-1.1193 2.5-2.5 2.5S15 19.8807 15 18.5s1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5"
    />
  </svg>
);

export const Cloud01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.5 19C4.0147 19 2 16.9853 2 14.5c0-2.3436 1.7915-4.2687 4.0797-4.4806C6.5478 7.1721 9.0202 5 12 5s5.4522 2.1721 5.9203 5.0194C20.2085 10.2313 22 12.1564 22 14.5c0 2.4853-2.0147 4.5-4.5 4.5z"
    />
  </svg>
);

export const Cloud02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6 19c-2.2091 0-4-1.7909-4-4 0-1.8642 1.2753-3.4306 3.0011-3.8743A7 7 0 0 1 5 11c0-3.866 3.134-7 7-7 3.6099 0 6.5815 2.7325 6.9594 6.2419C20.7284 10.8481 22 12.5255 22 14.5c0 2.4853-2.0147 4.5-4.5 4.5z"
    />
  </svg>
);

export const Cloud03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.5 19C5.3579 19 2 15.6421 2 11.5S5.3579 4 9.5 4c2.8827 0 5.3855 1.6263 6.641 4.0115A5.6 5.6 0 0 1 16.5 8c3.0376 0 5.5 2.4624 5.5 5.5S19.5376 19 16.5 19z"
    />
  </svg>
);

export const CloudLightning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19 15.7439c1.7478-.6177 3-2.2846 3-4.2439 0-2.3436-1.7915-4.2687-4.0797-4.4806C17.4522 4.172 14.9798 2 12 2S6.5478 4.1721 6.0797 7.0194C3.7915 7.2313 2 9.1564 2 11.5c0 1.9593 1.2522 3.6262 3 4.2439M13 10l-4 6h6l-4 6"
    />
  </svg>
);

export const CloudMoon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.5 13c2.5768 0 4.7397-1.772 5.3366-4.164a5.5 5.5 0 0 1-1.3366.1636c-3.0376 0-5.5-2.4624-5.5-5.5 0-.4608.0567-.9083.1634-1.336C12.7717 2.7606 11 4.9234 11 7.5c0 .9128.2223 1.7736.6158 2.5312M5 7V3M3 5h4M6 22c-2.2091 0-4-1.7909-4-4 0-1.9779 1.4355-3.6204 3.3215-3.9427C6.1288 11.697 8.3662 10 11 10c2.2882 0 4.2772 1.2809 5.2892 3.1648A4.5 4.5 0 0 1 17.5 13c2.4853 0 4.5 2.0147 4.5 4.5S19.9853 22 17.5 22z"
    />
  </svg>
);

export const CloudOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21.7003 16.1181A4.49 4.49 0 0 0 22 14.5c0-2.3436-1.7915-4.2687-4.0797-4.4806C17.4522 7.1721 14.9798 5 12 5c-.4466 0-.8817.0488-1.3005.1413m-3.412 2.1445a5.97 5.97 0 0 0-1.2078 2.7336C3.7915 10.2313 2 12.1564 2 14.5 2 16.9853 4.0147 19 6.5 19h11c.4561 0 .8963-.0678 1.3112-.194M3 3l18 18"
    />
  </svg>
);

export const CloudRaining01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 15.2422c1.206-.8072 2-2.182 2-3.7422 0-2.3436-1.7915-4.2687-4.0797-4.4806C17.4522 4.172 14.9798 2 12 2S6.5478 4.1721 6.0797 7.0194C3.7915 7.2313 2 9.1564 2 11.5c0 1.5602.794 2.935 2 3.7422M8 18v2m0-8v2m8 4v2m0-8v2m-4 6v2m0-8v2"
    />
  </svg>
);

export const CloudRaining02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 12v8m-8-8v8m4-6v8m8-6.7578c1.206-.8072 2-2.182 2-3.7422 0-2.3436-1.7915-4.2687-4.0797-4.4806C17.4522 4.172 14.9798 2 12 2S6.5478 4.1721 6.0797 7.0194C3.7915 7.2313 2 9.1564 2 11.5c0 1.5602.794 2.935 2 3.7422"
    />
  </svg>
);

export const CloudRaining03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 15.2422c1.206-.8072 2-2.182 2-3.7422 0-2.3436-1.7915-4.2687-4.0797-4.4806C17.4522 4.172 14.9798 2 12 2S6.5478 4.1721 6.0797 7.0194C3.7915 7.2313 2 9.1564 2 11.5c0 1.5602.794 2.935 2 3.7422M12.25 15l-2.8 7m7.6-9-2.8 7m-5.2-7-2.8 7"
    />
  </svg>
);

export const CloudRaining04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 18.5V21m-8-2.5V21m4-1.5V22m-5-7c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5q.0497 0 .0992.001C8.0094 3.2196 9.8622 2 12 2c2.5192 0 4.6429 1.6938 5.2943 4.0046A5 5 0 0 1 17.5 6c2.4853 0 4.5 2.0147 4.5 4.5S19.9853 15 17.5 15z"
    />
  </svg>
);

export const CloudRaining05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16 18.5 15 21m-7-2.5L7 21m5-2.5L11 21m-4-6c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5q.0497 0 .0992.001C8.0094 3.2196 9.8622 2 12 2c2.5192 0 4.6429 1.6938 5.2943 4.0046A5 5 0 0 1 17.5 6c2.4853 0 4.5 2.0147 4.5 4.5S19.9853 15 17.5 15z"
    />
  </svg>
);

export const CloudRaining06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13 21H6m13-3h-9m-3 0H5m13 3h-2m-9-6c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5q.0497 0 .0992.001C8.0094 3.2196 9.8622 2 12 2c2.5192 0 4.6429 1.6938 5.2943 4.0046A5 5 0 0 1 17.5 6c2.4853 0 4.5 2.0147 4.5 4.5S19.9853 15 17.5 15z"
    />
  </svg>
);

export const CloudSnowing01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20 15.2422c1.206-.8072 2-2.182 2-3.7422 0-2.3436-1.7915-4.2687-4.0797-4.4806C17.4522 4.172 14.9798 2 12 2S6.5478 4.1721 6.0797 7.0194C3.7915 7.2313 2 9.1564 2 11.5c0 1.5602.794 2.935 2 3.7422M8 15h.01M8 19h.01M12 17h.01M12 21h.01M16 15h.01M16 19h.01"
    />
  </svg>
);

export const CloudSnowing02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8 18h.01M8 21h.01M12 18.5h.01m-.01 3h.01M16 18h.01M16 21h.01M7 15c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5q.0497 0 .0992.001C8.0094 3.2196 9.8622 2 12 2c2.5192 0 4.6429 1.6938 5.2943 4.0046A5 5 0 0 1 17.5 6c2.4853 0 4.5 2.0147 4.5 4.5S19.9853 15 17.5 15z"
    />
  </svg>
);

export const CloudSun01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M19.368 12.4048C20.935 11.5606 22 9.9047 22 8c0-2.7614-2.2386-5-5-5s-5 2.2386-5 5m0 0c-2.1377 0-3.9906 1.2196-4.9008 3.001A5 5 0 0 0 7 11c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5h10.5c2.4853 0 4.5-2.0147 4.5-4.5S19.9853 12 17.5 12a5 5 0 0 0-.2057.0046C16.6429 9.6937 14.5192 8 12 8"
    />
  </svg>
);

export const CloudSun02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M10.5 1.5v1.6M3.6 10H2m3.4512-5.0486L4.3198 3.82m11.23 1.1314L16.6812 3.82M19 10h-1.6m-10.9.0001c0-2.2092 1.791-4 4.0001-4 1.506 0 2.8176.8323 3.5 2.062M6 22c-2.2091 0-4-1.7909-4-4s1.7909-4 4-4c.4642 0 .91.0791 1.3244.2245C8.0406 12.3396 9.864 11 12 11s3.9594 1.3396 4.6756 3.2245A4 4 0 0 1 18 14c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4z"
    />
  </svg>
);

export const CloudSun03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M3.15 11A7.54 7.54 0 0 1 3 9.5C3 5.3579 6.3579 2 10.5 2c3.8031 0 6.945 2.8306 7.4339 6.5M6 22c-2.2091 0-4-1.7909-4-4s1.7909-4 4-4q.17 0 .3365.014C7.1562 11.6763 9.3824 10 12 10c2.2248 0 4.1668 1.2109 5.2029 3.0097A4.6 4.6 0 0 1 17.5 13c2.4853 0 4.5 2.0147 4.5 4.5S19.9853 22 17.5 22z"
    />
  </svg>
);

export const Droplets01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 16c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6c0-4.3137 6-14 6-14s6 9.6863 6 14M8 9c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3c0-2.1569 3-7 3-7s3 4.8431 3 7"
    />
  </svg>
);

export const Droplets02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 21.5a7 7 0 0 0 4.9497-2.0503A7 7 0 0 0 19 14.5c0-2-1-3.9-3-5.5s-3.5-4-4-6.5C11.5 5 10 7.4 8 9s-3 3.5-3 5.5a7 7 0 0 0 7 7"
    />
  </svg>
);

export const Droplets03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12.56 6.08A10.97 10.97 0 0 0 14 2.5c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.9799 6.9799 0 0 1-11.91 4.97M7 15.78c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.23 7 4.78c-.29 1.45-1.14 2.84-2.29 3.76S3 10.58 3 11.73c0 2.22 1.8 4.05 4 4.05"
    />
  </svg>
);

export const Hurricane01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.5 20.5002C15.2465 20.814 13.6884 21 12 21s-3.2465-.186-4.5-.4998M18 16.4305c-1.4659.5537-3.6106.9028-6 .9028s-4.5341-.3491-6-.9028m-1.5-4.7626c1.4314.8919 4.2531 1.4988 7.5 1.4988s6.0686-.6069 7.5-1.4988M21 6c0 1.6569-4.0294 3-9 3S3 7.6569 3 6s4.0294-3 9-3 9 1.3431 9 3"
    />
  </svg>
);

export const Hurricane02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18 12c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6m12 0c0-3.3137-2.6863-6-6-6s-6 2.6863-6 6m12 0c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8m4 0c0-4.4183 3.5817-8 8-8s8 3.5817 8 8m-9 0c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const Hurricane03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 4H3m17 4H6m12 4H9m6 4H8m9 4h-5"
    />
  </svg>
);

export const Lightning01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M13 2 4.0934 12.6879c-.3488.4185-.5232.6278-.5258.8046a.5.5 0 0 0 .1856.3964c.1375.1111.41.1111.9548.1111H12l-1 8 8.9065-10.6879c.3488-.4185.5232-.6278.5259-.8046a.5.5 0 0 0-.1857-.3964C20.1092 10 19.8368 10 19.292 10H12z"
    />
  </svg>
);

export const Lightning02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14.2495 2H8.494c-.1795 0-.2693 0-.3485.0273a.5.5 0 0 0-.1868.1155c-.0599.0586-.1.1389-.1803.2994l-4.2 8.4c-.1917.3834-.2875.5751-.2645.7309a.5.5 0 0 0 .208.3366C3.651 12 3.8654 12 4.294 12h6.2056l-3 10L19.6926 9.3553c.4114-.4266.6171-.6399.6291-.8224a.5.5 0 0 0-.1763-.4149C20.0057 8 19.7094 8 19.1167 8h-7.1172z"
    />
  </svg>
);

export const Moon01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 15.8442c-1.3134.594-2.7714.9246-4.3065.9246-5.7782 0-10.4623-4.6841-10.4623-10.4623 0-1.5351.3306-2.9931.9246-4.3065C4.5258 3.6416 2 7.2947 2 11.5377 2 17.3159 6.6841 22 12.4623 22c4.243 0 7.8961-2.5258 9.5377-6.1558"
    />
  </svg>
);

export const Moon02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21.9548 12.9564c-1.3769 2.4153-3.9757 4.0437-6.9548 4.0437-4.4183 0-8-3.5817-8-8 0-2.9794 1.6287-5.5783 4.0443-6.9552C5.9698 2.5261 2 6.7994 2 11.9998c0 5.5229 4.4772 10 10 10 5.2002 0 9.4733-3.9693 9.9548-9.0434"
    />
  </svg>
);

export const MoonEclipse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M20.0017 6.0002c2.665 3.5448 2.6644 8.4576-.0017 12.0019M12 22c1.5711 0 3.0575-.3623 4.3803-1.0079A9 9 0 0 1 16 21c-4.9706 0-9-4.0294-9-9s4.0294-9 9-9a9 9 0 0 1 .3803.0079C15.0575 2.3623 13.5711 2 12 2 6.4772 2 2 6.4772 2 12s4.4772 10 10 10"
    />
  </svg>
);

export const MoonStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m18 2 .6178 1.2356c.2655.531.3982.7965.5756 1.0265.1573.2042.3403.3872.5445.5445.23.1774.4955.3101 1.0265.5756L22 6l-1.2356.6178c-.531.2655-.7965.3982-1.0265.5756a3 3 0 0 0-.5445.5445c-.1774.23-.3101.4955-.5756 1.0265L18 10l-.6178-1.2356c-.2655-.531-.3982-.7965-.5756-1.0265a3 3 0 0 0-.5445-.5445c-.23-.1774-.4955-.3101-1.0265-.5756L14 6l1.2356-.6178c.531-.2655.7965-.3982 1.0265-.5756a3 3 0 0 0 .5445-.5445c.1774-.23.3101-.4955.5756-1.0265zM21 13.3893c-1.311 2.2997-3.7855 3.8502-6.6221 3.8502-4.2068 0-7.6171-3.4103-7.6171-7.6172 0-2.8368 1.5507-5.3114 3.8507-6.6223C5.7798 3.4581 2 7.527 2 12.4785 2 17.7371 6.263 22 11.5215 22c4.9514 0 9.02-3.7794 9.4785-8.6107"
    />
  </svg>
);

export const Snowflake01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m18.0622 8.5-12.1244 7m12.1244-7 1.098-4.098M18.0622 8.5l4.098 1.098M5.9378 15.5l-4.098-1.0981M5.9377 15.5l-1.098 4.0981m13.2223-4.0982-12.1244-7m12.1244 7 4.0981-1.0981m-4.0981 1.0981 1.0981 4.0981M5.9377 8.4999 4.84 4.402M5.9377 8.5 1.84 9.5982M12 5v14m0-14L9 2m3 3 3-3m-3 17-3 3m3-3 3 3"
    />
  </svg>
);

export const Snowflake02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 8v8m0-8V2m0 6L7 3m5 5 5-5m-5 13v6m0-6-5 5m5-5 5 5m-1-9H8m8 0h6m-6 0 5-5m-5 5 5 5M8 12H2m6 0L3 7m5 5-5 5"
    />
  </svg>
);

export const Stars01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m6.5 13 .7845 1.5689c.2654.531.3982.7965.5755 1.0265a3 3 0 0 0 .5446.5446c.23.1773.4955.3101 1.0265.5755L11 17.5l-1.569.7845c-.5309.2654-.7964.3982-1.0264.5755a3 3 0 0 0-.5446.5446c-.1773.23-.31.4955-.5755 1.0265L6.5 22l-.7845-1.5689c-.2654-.531-.3982-.7965-.5755-1.0265a3 3 0 0 0-.5446-.5446c-.23-.1773-.4955-.3101-1.0265-.5755L2 17.5l1.569-.7845c.5309-.2654.7964-.3982 1.0264-.5755a3 3 0 0 0 .5446-.5446c.1773-.23.31-.4955.5755-1.0265zM15 2l1.1786 3.0644c.282.7333.423 1.0999.6423 1.4082.1944.2733.4331.5122.7065.7065.3083.2193.675.3603 1.4082.6423L22 9l-3.0644 1.1786c-.7332.282-1.0999.423-1.4082.6423a3 3 0 0 0-.7065.7065c-.2193.3083-.3603.675-.6423 1.4082L15 16l-1.1786-3.0644c-.282-.7332-.423-1.0999-.6423-1.4082a3 3 0 0 0-.7065-.7065c-.3083-.2193-.675-.3603-1.4082-.6423L8 9l3.0644-1.1786c.7332-.282 1.0999-.423 1.4082-.6423a3 3 0 0 0 .7065-.7065c.2193-.3083.3603-.675.6423-1.4082z"
    />
  </svg>
);

export const Stars02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4.5 22v-5m0-10V2M2 4.5h5m-5 15h5M13 3l-1.7342 4.5089c-.282.7332-.423 1.0998-.6423 1.4082a3 3 0 0 1-.7064.7064c-.3084.2193-.675.3603-1.4082.6423L4 12l4.5089 1.7342c.7332.282 1.0998.423 1.4082.6423.2733.1943.5121.4331.7064.7064.2193.3084.3603.675.6423 1.4082L13 21l1.7342-4.5089c.282-.7332.423-1.0998.6423-1.4082a3 3 0 0 1 .7064-.7064c.3084-.2193.675-.3603 1.4082-.6423L22 12l-4.5089-1.7342c-.7332-.282-1.0998-.423-1.4082-.6423a3 3 0 0 1-.7064-.7064c-.2193-.3084-.3603-.675-.6423-1.4082z"
    />
  </svg>
);

export const Stars03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18.5 8V3m-13 18v-5M16 5.5h5m-18 13h5M6.5 2l-.7845 1.569c-.2654.5309-.3982.7964-.5755 1.0264a3 3 0 0 1-.5446.5446c-.23.1773-.4955.31-1.0265.5755L2 6.5l1.569.7845c.5309.2654.7964.3982 1.0264.5755.2042.1574.3872.3404.5446.5446.1773.23.31.4955.5755 1.0265L6.5 11l.7845-1.569c.2654-.5309.3982-.7964.5755-1.0264a3 3 0 0 1 .5446-.5446c.23-.1773.4955-.31 1.0265-.5755L11 6.5l-1.569-.7845c-.5309-.2654-.7964-.3982-1.0264-.5755a3 3 0 0 1-.5446-.5446c-.1773-.23-.31-.4955-.5755-1.0265zM17 12l-.9511 1.9022c-.2655.531-.3983.7965-.5756 1.0266a3 3 0 0 1-.5445.5445c-.2301.1773-.4956.3101-1.0265.5756L12 17l1.9023.9511c.5309.2655.7964.3983 1.0265.5756.2041.1574.3871.3404.5445.5445.1773.2301.3101.4956.5756 1.0265L17 22l.9511-1.9022c.2655-.531.3983-.7965.5756-1.0266a3 3 0 0 1 .5445-.5445c.2301-.1773.4956-.3101 1.0265-.5756L22 17l-1.9023-.9511c-.5309-.2655-.7964-.3983-1.0265-.5756a3 3 0 0 1-.5445-.5445c-.1773-.2301-.3101-.4956-.5756-1.0265z"
    />
  </svg>
);

export const Sun = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 2v2m0 16v2M4 12H2m4.3141-5.6859L4.9 4.9m12.786 1.4142L19.1001 4.9M6.3141 17.69 4.9 19.1042m12.786-1.4142 1.4142 1.4142M22 12h-2m-3 0c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5"
    />
  </svg>
);

export const SunSetting01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 3v2M5.3141 7.3141 3.9 5.9m14.7859 1.4142L20.1 5.9M6 15c0-3.3137 2.6863-6 6-6s6 2.6863 6 6m4 0H2m17 4H5"
    />
  </svg>
);

export const SunSetting02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M22 16.5H2M20 20H4m8-17v2m-8 8H2m4.3141-5.6859L4.9 5.9m12.7856 1.4142L19.0998 5.9M22 13h-2M7 13c0-2.7614 2.2386-5 5-5s5 2.2386 5 5"
    />
  </svg>
);

export const SunSetting03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.06 20.9125c1.21.55 2.75.55 3.9601 0 1.21-.55 2.75-.55 3.96 0s2.75.55 3.96 0M12 3v2m-8 8H2m4.3141-5.6859L4.9 5.9m12.7856 1.4142L19.0998 5.9M22 13h-2M7 13c0-2.7614 2.2386-5 5-5s5 2.2386 5 5M2.1001 17.4125c1.21-.55 2.75-.55 3.96 0s2.75.55 3.96 0 2.75-.55 3.96 0 2.75.55 3.96 0 2.75-.55 3.96 0"
    />
  </svg>
);

export const Sunrise = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 18H2m4.3141-5.6859L4.9 10.8999m12.7859 1.4142L19.1 10.8999M22 18h-2M7 18c0-2.7614 2.2386-5 5-5s5 2.2386 5 5m5 4H2M8 6l4-4 4 4m-4-4v7"
    />
  </svg>
);

export const Sunset = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M4 18H2m4.3141-5.6859L4.9 10.8999m12.7859 1.4142L19.1 10.8999M22 18h-2M7 18c0-2.7614 2.2386-5 5-5s5 2.2386 5 5m5 4H2M8 5l4 4 4-4m-4 4V2"
    />
  </svg>
);

export const Thermometer01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14.5 4.5C14.5 3.1193 13.3807 2 12 2S9.5 3.1193 9.5 4.5v9.2578c-1.206.8072-2 2.182-2 3.7422 0 2.4853 2.0147 4.5 4.5 4.5s4.5-2.0147 4.5-4.5c0-1.5602-.794-2.935-2-3.7422z"
    />
  </svg>
);

export const Thermometer02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M14.5 4.5C14.5 3.1193 13.3807 2 12 2S9.5 3.1193 9.5 4.5v9.2578c-1.206.8072-2 2.182-2 3.7422 0 2.4853 2.0147 4.5 4.5 4.5s4.5-2.0147 4.5-4.5c0-1.5602-.794-2.935-2-3.7422z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 18.5c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1"
    />
  </svg>
);

export const Thermometer03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 3h-6m6 4h-6m6 4h-6m-9.5 2.7578V4.5C5.5 3.1193 6.6193 2 8 2s2.5 1.1193 2.5 2.5v9.2578c1.206.8072 2 2.182 2 3.7422 0 2.4853-2.0147 4.5-4.5 4.5s-4.5-2.0147-4.5-4.5c0-1.5602.794-2.935 2-3.7422M9 17.5c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    />
  </svg>
);

export const ThermometerCold = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 12h10M9 4v16M3 9l3 3-3 3m9-9L9 9 6 6m0 12 3-3 1.5 1.5m9.5-1.9649V4c0-1.1046-.8954-2-2-2s-2 .8954-2 2v10.5351c-1.1956.6916-2 1.9843-2 3.4649 0 2.2091 1.7909 4 4 4s4-1.7909 4-4c0-1.4806-.8044-2.7733-2-3.4649"
    />
  </svg>
);

export const ThermometerWarm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M12 9a4 4 0 0 0-2 7.5M12 3v2M6.6 18.4l-1.4 1.4M4 13H2m4.6-5.4L5.2 6.2M20 14.5351V4c0-1.1046-.8954-2-2-2s-2 .8954-2 2v10.5351c-1.1956.6916-2 1.9843-2 3.4649 0 2.2091 1.7909 4 4 4s4-1.7909 4-4c0-1.4806-.8044-2.7733-2-3.4649"
    />
  </svg>
);

export const Umbrella01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M17 19.4c0 1.4359-1.1193 2.6-2.5 2.6S12 20.8359 12 19.4V12m-9.8737-1.5937C2.8895 5.6409 7.0195 2 12 2s9.1104 3.641 9.8737 8.4063c.0745.4651.1117.6976.0182.946-.0744.1977-.2566.4113-.44.5161C21.2214 12 20.9476 12 20.4 12H3.6c-.5477 0-.8215 0-1.052-.1316-.1834-.1048-.3655-.3184-.44-.5161-.0935-.2484-.0562-.4809.0183-.946"
    />
  </svg>
);

export const Umbrella02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M7 19.4C7 20.8359 8.1193 22 9.5 22s2.5-1.1641 2.5-2.6V11m0 0c-1.6102 0-4 1-4 1s-1.3898-1-3-1-3 1-3 1C2 6.4772 6.4772 2 12 2s10 4.4772 10 10c0 0-1.3898-1-3-1s-3 1-3 1-2.3898-1-4-1"
    />
  </svg>
);

export const Umbrella03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.25 21.9595 12 12.0002M17 3.34C12.6868.8497 7.2896 1.9378 4.246 5.683c-.297.3656-.4456.5484-.4888.8103-.0344.2083.0165.4844.123.6668.1338.2293.371.3662.8452.64l14.5492 8.4c.4743.2738.7114.4107.9768.412.2112.001.4758-.093.6391-.2269.2052-.1684.2892-.3884.4572-.8285C23.0695 11.0483 21.3132 5.8302 17 3.3399m0 0c-1.9132-1.1046-5.7027 1.8773-8.4641 6.6602M17 3.34c1.9132 1.1045 1.2255 5.8773-1.5359 10.6602m6.5359 8H2"
    />
  </svg>
);

export const Waves = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
    />
  </svg>
);

export const Wind01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M21 18s-1.1904-.4695-2-.6979c-5.1203-1.4447-8.8797 2.8405-14 1.3958C4.1904 18.4695 3 18 3 18m18-6s-1.1904-.4695-2-.6979c-5.1203-1.4447-8.8797 2.8405-14 1.3958C4.1904 12.4695 3 12 3 12m18-6s-1.1904-.4695-2-.698c-5.1203-1.4446-8.8797 2.8406-14 1.396C4.1904 6.4694 3 6 3 6"
    />
  </svg>
);

export const Wind02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M9.5093 4.6667A1.995 1.995 0 0 1 11 4c1.1046 0 2 .8954 2 2s-.8954 2-2 2H2m10.5093 11.3333A1.995 1.995 0 0 0 14 20c1.1046 0 2-.8954 2-2s-.8954-2-2-2H2M16.764 7c.5493-.6137 1.3476-1 2.2361-1 1.6569 0 3 1.3431 3 3s-1.3431 3-3 3H2"
    />
  </svg>
);

export const Wind03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.7639 6.5c.5493-.6137 1.3476-1 2.2361-1 1.6569 0 3 1.3431 3 3s-1.3431 3-3 3h-6M6.7639 4C7.3132 3.3863 8.1115 3 9 3c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3H2m8.7639 11c.5493.6137 1.3476 1 2.2361 1 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3H2"
    />
  </svg>
);
